





// // // import React, { useState, useEffect, useRef } from 'react';
// // // import './Management2.css';
// // // import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
// // // import axios from 'axios';
// // // import { FaSave, FaSearch, FaTimes } from 'react-icons/fa';
// // // import * as XLSX from 'xlsx';
// // // import { useLoader } from "../../../../context/LoaderProvider.jsx";

// // // const StandardMenu = () => {
// // //     const [data, setData] = useState([]);
// // //     const [loading, setLoading] = useState(true);
// // //     const [error, setError] = useState(null);
// // //     const [addedItems, setAddedItems] = useState([]);
// // //     const [showEditModal, setShowEditModal] = useState(false);
// // //     const [editItem, setEditItem] = useState(null);
// // //     const [showPopup, setShowPopup] = useState(false);
// // //     const [image, setImage] = useState(null);
// // //     const [text, setText] = useState('');
// // //     const [isVegSelected, setIsVegSelected] = useState(null);
// // //     const [dishId, setDishId] = useState(null);
// // //     const [chefType, setChefType] = useState("Chef_All");
// // //     const [imageFile, setImageFile] = useState(null);
// // //     const { showLoader, hideLoader } = useLoader();
// // //     const [searchQuery, setSearchQuery] = useState("");
// // //     const [searchActive, setSearchActive] = useState(false);
// // //     const [showCategorySearchPopup, setShowCategorySearchPopup] = useState(false);
// // //     const [categorySearchQuery, setCategorySearchQuery] = useState('');
// // //     const [filteredCategories, setFilteredCategories] = useState([]);
// // //     const [selectedCategory, setSelectedCategory] = useState(null);

// // //     const normalizeForSearch = (text) => {
// // //         if (!text) return '';

// // //         // Convert to lowercase and replace multiple separators with space
// // //         return text
// // //             .toLowerCase()
// // //             .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
// // //             .trim();
// // //     };

// // //     const handleSearch = (query) => {
// // //         const searchTerm = normalizeForSearch(query);
// // //         setSearchQuery(query);

// // //         if (!searchTerm) {
// // //             setSearchActive(false);
// // //             applyFilter(data, isVegSelected);
// // //             return;
// // //         }

// // //         setSearchActive(true);

// // //         // Create search patterns:
// // //         // 1. Exact match (with spaces normalized)
// // //         // 2. Without spaces (for "vegmeals")
// // //         // 3. Individual words
// // //         const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
// // //         const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

// // //         const searchResults = data.map(category => {
// // //             // Normalize category
// // //             const normalizedCategory = normalizeForSearch(category.category);
// // //             const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

// // //             // Check category matches
// // //             const categoryMatches =
// // //                 normalizedCategory.includes(searchTerm) ||
// // //                 categoryWithoutSpaces.includes(searchWithoutSpaces) ||
// // //                 searchWords.every(word => normalizedCategory.includes(word));

// // //             // Filter subcategories
// // //             const filteredSubcategories = category.subcategories?.filter(sub => {
// // //                 // Normalize subcategory fields
// // //                 const normalizedSubName = normalizeForSearch(sub.subName);
// // //                 const normalizedDescription = normalizeForSearch(sub.description);
// // //                 const normalizedTag = normalizeForSearch(sub.tag);

// // //                 const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
// // //                 const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

// // //                 // Multiple matching strategies
// // //                 const nameMatches =
// // //                     normalizedSubName.includes(searchTerm) ||
// // //                     subNameWithoutSpaces.includes(searchWithoutSpaces) ||
// // //                     searchWords.every(word => normalizedSubName.includes(word));

// // //                 const descMatches =
// // //                     normalizedDescription.includes(searchTerm) ||
// // //                     descWithoutSpaces.includes(searchWithoutSpaces) ||
// // //                     searchWords.every(word => normalizedDescription.includes(word));

// // //                 const tagMatches =
// // //                     normalizedTag.includes(searchTerm) ||
// // //                     normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

// // //                 return nameMatches || descMatches || tagMatches;
// // //             });

// // //             // Include category if it matches or has matching subcategories
// // //             if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
// // //                 return {
// // //                     ...category,
// // //                     subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// // //                 };
// // //             }

// // //             return null;
// // //         }).filter(category => category !== null);

// // //         setFilteredData(searchResults);
// // //     };


// // //     const handleFilterClick = (tag) => {
// // //         const vegSelected = tag === 'Veg';
// // //         setIsVegSelected(vegSelected);
// // //         setSearchActive(false);
// // //         setSearchQuery("");
// // //         applyFilter(data, vegSelected);
// // //     };

// // //     const fileInputRef = useRef(null);
// // //     const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
// // //     const [subDishName, setSubDishName] = useState('');
// // //     const [price, setPrice] = useState('');
// // //     const [description, setDescription] = useState('');
// // //     const [stockQuantity, setStockQuantity] = useState('');
// // //     const [gst, setGst] = useState('');
// // //     const [discount, setdiscount] = useState('');
// // //     const [packingCharges, setPackingCharges] = useState('');
// // //     const [tag, setTag] = useState('Veg');
// // //     const [stock, setStock] = useState('In Stock');
// // //     const [menuStatus, setMenuStatus] = useState(true);
// // //     const [parentDishDetails, setParentDishDetails] = useState(null);
// // //     const [filteredData, setFilteredData] = useState([]);
// // //     const [showSubEditModal, setShowSubEditModal] = React.useState(false);
// // //     const [editSubItem, setEditSubItem] = React.useState({
// // //         dishId: '',
// // //         subName: '',
// // //         discount: '',
// // //         price: '',
// // //         // stockQuantity: '',
// // //         gst: '',
// // //         packingCharges: '',
// // //         image: '',
// // //         tag: 'Veg', // Add this line
// // //         chefType: '',
// // //         parentIndex: null,
// // //         subIndex: null,
// // //         description: '',
// // //     });

// // //     const [subCategoryData, setSubCategoryData] = React.useState({
// // //         dishImage: '',
// // //     });

// // //     // const applyFilter = (allData, vegOnly) => {
// // //     //     if (vegOnly === null) {
// // //     //         setFilteredData(allData);
// // //     //         return;
// // //     //     }

// // //     //     const filtered = allData.map(category => {
// // //     //         const filteredSubcategories = category.subcategories.filter(
// // //     //             sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// // //     //         );

// // //     //         return {
// // //     //             ...category,
// // //     //             subcategories: filteredSubcategories
// // //     //         };
// // //     //     }).filter(cat => cat.subcategories.length > 0);

// // //     //     setFilteredData(filtered);
// // //     // };
// // //     const applyFilter = (allData, vegOnly) => {
// // //         let filtered = allData;

// // //         // Apply category filter if selected
// // //         if (selectedCategory) {
// // //             filtered = filtered.filter(item => item.category === selectedCategory);
// // //         }

// // //         // Apply veg filter if selected
// // //         if (vegOnly !== null) {
// // //             filtered = filtered.map(category => {
// // //                 const filteredSubcategories = category.subcategories.filter(
// // //                     sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// // //                 );
// // //                 return {
// // //                     ...category,
// // //                     subcategories: filteredSubcategories
// // //                 };
// // //             }).filter(cat => cat.subcategories.length > 0);
// // //         }

// // //         // Apply search if active
// // //         if (searchActive && searchQuery) {
// // //             filtered = filtered.map(category => {
// // //                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
// // //                 const filteredSubcategories = category.subcategories.filter(sub =>
// // //                     sub.subName?.toLowerCase().includes(searchQuery) ||
// // //                     sub.description?.toLowerCase().includes(searchQuery)
// // //                 );

// // //                 if (categoryMatches || filteredSubcategories.length > 0) {
// // //                     return {
// // //                         ...category,
// // //                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// // //                     };
// // //                 }
// // //                 return null;
// // //             }).filter(category => category !== null);
// // //         }

// // //         setFilteredData(filtered);
// // //     };


// // //     const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
// // //         try {
// // //             setDishId(subDishId);
// // //             const token = localStorage.getItem("authToken");

// // //             const response = await axios.get(
// // //                 `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
// // //                 {
// // //                     headers: {
// // //                         Authorization: `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             const subDish = response.data;

// // //             setEditSubItem({
// // //                 dishId: subDish.dishId,
// // //                 subName: subDish.dishName || '',
// // //                 price: subDish.price || '',
// // //                 discount: subDish.discount || '',
// // //                 // stockQuantity: subDish.stockQuantity || '',
// // //                 gst: subDish.gst || '',
// // //                 packingCharges: subDish.packingCharges || '',
// // //                 image: subDish.dishImage || '',
// // //                 chefType: subDish.chefType || '',
// // //                 chefType: subDish.chefType || 'Chef_All', // Add this line
// // //                 tag: subDish.tag || 'Veg', // Add this line
// // //                 parentIndex,
// // //                 subIndex,
// // //                 description: subDish.description || '',
// // //             });

// // //             setShowSubEditModal(true);
// // //         } catch (error) {
// // //             alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
// // //             console.error(error);
// // //         }
// // //     };

// // //     const submitEditSubcategory = async () => {
// // //         if (!editSubItem || !editSubItem.dishId) {
// // //             alert("Subcategory Dish ID is missing!");
// // //             return;
// // //         }

// // //         try {
// // //             showLoader();
// // //             const token = localStorage.getItem("authToken");
// // //             if (!token) {
// // //                 alert("Authentication token not found!");
// // //                 return;
// // //             }

// // //             const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

// // //             const formData = new FormData();
// // //             const dishData = {
// // //                 dishName: editSubItem.subName,
// // //                 price: editSubItem.price,
// // //                 stockQuantity: editSubItem.stockQuantity,
// // //                 gst: editSubItem.gst,
// // //                 packingCharges: editSubItem.packingCharges,
// // //                 discount: editSubItem.discount,
// // //                 tag: editSubItem.tag || 'Veg', // Add this line
// // //                 chefType: editSubItem.chefType || 'Chef_All', // Add this line
// // //                 description: editSubItem.description,
// // //             };

// // //             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

// // //             if (editSubItem.newImageFile) {
// // //                 formData.append("image", editSubItem.newImageFile);
// // //             }

// // //             const response = await axios.put(url, formData, {
// // //                 headers: {
// // //                     "Authorization": `Bearer ${token}`,
// // //                     "Content-Type": "multipart/form-data",
// // //                 },
// // //             });

// // //             alert("Subcategory updated successfully!");
// // //             window.location.reload();
// // //         } catch (error) {
// // //             console.error("Error updating subcategory:", error);
// // //             if (error.response) {
// // //                 alert(`Failed to update subcategory: ${error.response.data.message || error.response.data}`);
// // //             } else {
// // //                 alert(`Failed to update subcategory: ${error.message}`);
// // //             }
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleAddSubCategory = async (dishId) => {
// // //         const token = localStorage.getItem("authToken");
// // //         if (!token) {
// // //             alert("Authentication token missing. Please log in again.");
// // //             return;
// // //         }

// // //         try {
// // //             showLoader();
// // //             const response = await fetch(
// // //                 `https://backend.maamaas.com/food/api/dish/get/${dishId}`,
// // //                 {
// // //                     method: 'GET',
// // //                     headers: {
// // //                         'Content-Type': 'application/json',
// // //                         'Authorization': `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             if (!response.ok) {
// // //                 throw new Error(`HTTP error! status: ${response.status}`);
// // //             }

// // //             const dishData = await response.json();
// // //             setParentDishDetails(dishData);
// // //             setShowSubcategoryPopup(true);

// // //         } catch (error) {
// // //             console.error("Failed to fetch dish data:", error);
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleSubImageChange = (e) => {
// // //         const file = e.target.files[0];
// // //         if (file) {
// // //             setImageFile(file);
// // //             const reader = new FileReader();
// // //             reader.onloadend = () => setImage(reader.result);
// // //             reader.readAsDataURL(file);
// // //         }
// // //     };

// // //     const handleSubcategorySubmit = async () => {
// // //         // if (!imageFile) {
// // //         //     alert("Please select an image.");
// // //         //     return;
// // //         // }

// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");

// // //         if (!vendorId) {
// // //             alert("Vendor ID not found. Please log in again.");
// // //             return;
// // //         }

// // //         if (!token) {
// // //             alert("Authentication token missing. Please log in again.");
// // //             return;
// // //         }

// // //         const formData = new FormData();
// // //         const dishData = {
// // //             dishId: 0,
// // //             price: parseFloat(price) || 0,
// // //             dishName: subDishName.trim() || "Unnamed Dish",
// // //             parentId: Number(parentDishDetails?.dishId) || 1,
// // //             stockQuantity: stockQuantity || 0,
// // //             gst: gst || 0,
// // //             packingCharges: packingCharges || 0,
// // //             discount: discount || 0,
// // //             tag: tag || "Veg",
// // //             stock: stock ? "In_Stock" : "Out_of_Stock",
// // //             menuStatus: menuStatus ? "Enable" : "Disable",
// // //             description: description?.trim() || "",
// // //             consumedQuantity: 0,
// // //             balanceQuantity: 0,
// // //             effectivePrice: 0,
// // //             chefType: chefType || "Chef_All"
// // //         };

// // //         formData.append(
// // //             "dishData",
// // //             new Blob([JSON.stringify(dishData)], { type: "application/json" })
// // //         );

// // //         formData.append("image", imageFile);

// // //         try {
// // //             showLoader();
// // //             const res = await axios.post(
// // //                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
// // //                 formData,
// // //                 {
// // //                     headers: {
// // //                         "Authorization": `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             alert("Dish added successfully!");
// // //             window.location.reload();

// // //             setSubDishName('');
// // //             setPrice('');
// // //             // setStockQuantity('');
// // //             setGst('');
// // //             setPackingCharges('');
// // //             setTag('Veg');
// // //             setStock('In Stock');
// // //             setMenuStatus(true);
// // //             setSubCategoryData({ dishImage: '' });
// // //             setdiscount('');
// // //             setImage(null);
// // //             setImageFile(null);

// // //             fetchData();
// // //         } catch (error) {
// // //             console.error("❌ Error response:", error.response?.data || error.message);
// // //             const message =
// // //                 error.response?.data?.error ||
// // //                 error.response?.data?.message ||
// // //                 error.message ||
// // //                 "Unknown error";
// // //             alert("Upload failed!\n" + message);
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleSave = async () => {
// // //         // if (!text.trim() || !imageFile) {
// // //         //     alert("Please provide both the dish name and image.");
// // //         //     return;
// // //         // }

// // //         if (!text.trim()) {
// // //             alert("Please provide the dish name.");
// // //             return;
// // //         }
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");

// // //         if (!vendorId) {
// // //             alert("Vendor ID not found. Please log in again.");
// // //             return;
// // //         }

// // //         if (!token) {
// // //             alert("Authentication token missing. Please log in again.");
// // //             return;
// // //         }

// // //         try {
// // //             showLoader();
// // //             const formData = new FormData();
// // //             const dishData = {
// // //                 dishId: 0,
// // //                 price: 0,
// // //                 dishName: text.trim(),
// // //                 parentId: 0,
// // //                 stockQuantity: 0,
// // //                 gst: 0,
// // //                 packingCharges: 0,
// // //             };

// // //             formData.append(
// // //                 "dishData",
// // //                 new Blob([JSON.stringify(dishData)], { type: "application/json" })
// // //             );

// // //             formData.append("image", imageFile);

// // //             const response = await axios.post(
// // //                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
// // //                 formData,
// // //                 {
// // //                     headers: {
// // //                         Authorization: `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             alert("Item added successfully!");
// // //             setShowPopup(false);
// // //             setText("");
// // //             setImage(null);
// // //             setImageFile(null);
// // //             window.location.reload();
// // //         } catch (error) {
// // //             console.error("Upload failed:", error.response?.data || error.message);
// // //             alert("Failed to add item: " + (error.response?.data?.message || "Please Uplode Documents"));
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleExport = () => {
// // //         if (!filteredData || filteredData.length === 0) {
// // //             alert("No data available to export.");
// // //             return;
// // //         }

// // //         const exportData = [];

// // //         filteredData.forEach((category, index) => {
// // //             exportData.push({
// // //                 "S.No": index + 1,
// // //                 "Category": category.category || "",
// // //                 "Subcategory": "",
// // //                 "Price": category.price || "",
// // //                 "GST": category.gst || "",
// // //                 "Packing": category.packingCharges || "",
// // //                 "Chef Type": category.chefType || "",
// // //                 "Description": category.description || "",
// // //             });

// // //             if (category.subcategories && category.subcategories.length > 0) {
// // //                 category.subcategories.forEach((sub) => {
// // //                     exportData.push({
// // //                         "S.No": "",
// // //                         "Category": category.categoryName || "",
// // //                         "Subcategory": sub.subName || "",
// // //                         "Price": sub.price ? `${sub.price}.Rs` : "",
// // //                         "GST": sub.gst ? `${sub.gst}%` : "",
// // //                         "Packing": sub.packingCharges ? `${sub.packingCharges}.Rs` : "",
// // //                         "Chef Type": sub.chefType || "",
// // //                         "Description": sub.description || "",
// // //                     });
// // //                 });
// // //             }
// // //         });

// // //         const worksheet = XLSX.utils.json_to_sheet(exportData);
// // //         const workbook = XLSX.utils.book_new();
// // //         XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

// // //         const colWidths = Object.keys(exportData[0]).map((key) => ({
// // //             wch: Math.max(
// // //                 key.length,
// // //                 ...exportData.map((row) => String(row[key] || "").length)
// // //             ),
// // //         }));
// // //         worksheet["!cols"] = colWidths;

// // //         XLSX.writeFile(workbook, "menu_data_export.xlsx");
// // //     };

// // //     const handleFileImport = async (e) => {
// // //         const file = e.target.files[0];
// // //         if (!file) return alert("Please choose a file.");

// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const authToken = localStorage.getItem("authToken");

// // //         if (!vendorId) return alert("Vendor ID not found in local storage.");
// // //         if (!authToken) return alert("No auth token found. Please log in first.");

// // //         const formData = new FormData();
// // //         formData.append("file", file);

// // //         try {
// // //             const response = await axios.post(
// // //                 `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
// // //                 formData,
// // //                 {
// // //                     headers: {
// // //                         "Content-Type": "multipart/form-data",
// // //                         Authorization: `Bearer ${authToken}`,
// // //                     },
// // //                 }
// // //             );

// // //             alert("✅ Categories imported successfully!");
// // //             setTimeout(() => window.location.reload(), 1000);

// // //         } catch (error) {
// // //             console.error("❌ Import failed:", error);
// // //             if (error.response) {
// // //                 alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
// // //             } else {
// // //                 alert("❌ Import failed: Network or unknown error.");
// // //             }
// // //         }
// // //     };

// // //     const handleEdit = async (id) => {
// // //         try {
// // //             setDishId(id);
// // //             const token = localStorage.getItem("authToken");
// // //             const vendorId = localStorage.getItem("vendorId");
// // //             if (!token) {
// // //                 alert("Authentication token missing. Please log in again.");
// // //                 return;
// // //             }
// // //             const response = await axios.get(
// // //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // //                 {
// // //                     headers: {
// // //                         "Authorization": `Bearer ${token}`,
// // //                         "Content-Type": "application/json",
// // //                     },
// // //                 }
// // //             );


// // //             const dishes = Array.isArray(response.data)
// // //                 ? response.data
// // //                 : response.data.data || [];

// // //             const dish = dishes.find((d) => d.dishId == id);

// // //             if (!dish) {
// // //                 alert(`Dish with ID ${id} not found`);
// // //                 return;
// // //             }

// // //             setEditItem({
// // //                 dishId: dish.dishId,
// // //                 dishName: dish.dishName || "",
// // //                 image: dish.dishImage || "",
// // //             });

// // //             setShowEditModal(true);
// // //         } catch (error) {
// // //             console.error("Error fetching dish details:", error);
// // //             alert(
// // //                 "Error fetching dish details:\n" +
// // //                 (error.response?.data?.message || error.message)
// // //             );
// // //         }
// // //     };

// // //     const submitEdit = async () => {
// // //         if (!editItem.dishId) {
// // //             alert("Dish ID is missing!");
// // //             return;
// // //         }

// // //         const token = localStorage.getItem("authToken");
// // //         if (!token) {
// // //             alert("Authentication token missing. Please log in again.");
// // //             return;
// // //         }

// // //         try {
// // //             showLoader();
// // //             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

// // //             const formData = new FormData();
// // //             const dishData = {
// // //                 dishName: editItem.dishName,
// // //             };
// // //             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

// // //             if (editItem.newImageFile) {
// // //                 formData.append("image", editItem.newImageFile);
// // //             }

// // //             const response = await axios.put(url, formData, {
// // //                 headers: {
// // //                     "Authorization": `Bearer ${token}`,
// // //                     "Content-Type": "multipart/form-data",
// // //                 },
// // //             });

// // //             alert('Dish updated successfully!');
// // //             window.location.reload();
// // //             setShowEditModal(false);

// // //         } catch (error) {
// // //             console.error("Error updating dish:", error);
// // //             if (error.response) {
// // //                 alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
// // //             } else {
// // //                 alert(`Failed to update dish: ${error.message}`);
// // //             }
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleEditImageChange = (e) => {
// // //         const file = e.target.files[0];
// // //         if (file) {
// // //             setEditItem(prev => ({
// // //                 ...prev,
// // //                 newImageFile: file,
// // //                 image: URL.createObjectURL(file)
// // //             }));
// // //         }
// // //     };

// // //     const fetchData = async () => {
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");

// // //         if (!vendorId) {
// // //             console.warn("⚠️ vendorId not found in localStorage");
// // //             setError(new Error("vendorId missing"));
// // //             setLoading(false);
// // //             return;
// // //         }

// // //         if (!token) {
// // //             console.warn("⚠️ authToken not found in localStorage");
// // //             setError(new Error("authToken missing"));
// // //             setLoading(false);
// // //             return;
// // //         }

// // //         try {
// // //             showLoader();
// // //             const response = await fetch(
// // //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // //                 {
// // //                     headers: {
// // //                         "Content-Type": "application/json",
// // //                         "Authorization": `Bearer ${token}`
// // //                     }
// // //                 }
// // //             );

// // //             if (!response.ok) {
// // //                 throw new Error(`HTTP error! status: ${response.status}`);
// // //             }

// // //             const dishData = await response.json();

// // //             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

// // //             const formattedData = parentCategories.map(category => {
// // //                 const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

// // //                 return {
// // //                     dishId: category.dishId,
// // //                     SNo: category.dishId,
// // //                     category: category.dishName,
// // //                     image: category.dishImage || '',
// // //                     isChecked: false,
// // //                     parentId: category.parentId,
// // //                     id: category.dishId,
// // //                     isAdded: true,
// // //                     menuStatus: category.menuStatus || "Enable", // Ensure this exists
// // //                     // Categories should NOT have tag/type and description
// // //                     subcategories: subcategories.map(sub => ({
// // //                         dishId: sub.dishId,
// // //                         subName: sub.subName || sub.dishName,
// // //                         price: sub.price || 0,
// // //                         description: sub.description || "",
// // //                         image: sub.dishImage,
// // //                         tag: sub.tag || "Veg", // Type only for subcategories
// // //                         gst: sub.gst || 0,
// // //                         packingCharges: sub.packingCharges || 0,
// // //                         discount: sub.discount || 0,
// // //                         chefType: sub.chefType || 0,
// // //                         menuStatus: sub.menuStatus || "Enable", // ADD THIS
// // //                     }))
// // //                 };
// // //             });

// // //             setData(formattedData);
// // //             applyFilter(formattedData, isVegSelected);

// // //             setData(formattedData);
// // //             setSearchQuery(""); // Clear search
// // //             setSearchActive(false); // Reset search state
// // //             applyFilter(formattedData, isVegSelected);

// // //         } catch (error) {
// // //             setError(error);
// // //         } finally {
// // //             setLoading(false);
// // //             hideLoader();
// // //         }
// // //     };

// // //     useEffect(() => {
// // //         fetchData();
// // //     }, []);

// // //     const handleCheckboxChange = (e, index) => {
// // //         const { checked } = e.target;
// // //         setData(prevData => {
// // //             const updatedData = [...prevData];
// // //             updatedData[index].isChecked = checked;
// // //             return updatedData;
// // //         });
// // //     };

// // //     const handleSelectAll = (e) => {
// // //         const isChecked = e.target.checked;
// // //         setData(prevData =>
// // //             prevData.map(item => ({
// // //                 ...item,
// // //                 isChecked: isChecked,
// // //             }))
// // //         );
// // //     };

// // //     const handleImageChange = (e) => {
// // //         const file = e.target.files[0];
// // //         if (file) {
// // //             const reader = new FileReader();
// // //             reader.onloadend = () => {
// // //                 setImage(reader.result);
// // //             };
// // //             reader.readAsDataURL(file);
// // //         }
// // //     };

// // //     // In StandardMenu.jsx, update the handleToggleStatus function:
// // //     const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const authToken = localStorage.getItem("authToken");

// // //         if (!vendorId || !authToken) {
// // //             alert("Authentication failed. Please login again.");
// // //             return;
// // //         }

// // //         const isCategory = (subIndex === null || subIndex === undefined);
// // //         const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

// // //         // ✅ FIX: Update local state IMMEDIATELY
// // //         if (isCategory) {
// // //             // For category: Update category and all its subcategories
// // //             setData(prevData => {
// // //                 const updatedData = [...prevData];
// // //                 updatedData[index] = {
// // //                     ...updatedData[index],
// // //                     menuStatus: newStatus,
// // //                     subcategories: updatedData[index].subcategories.map(sub => ({
// // //                         ...sub,
// // //                         menuStatus: newStatus
// // //                     }))
// // //                 };
// // //                 return updatedData;
// // //             });

// // //             // Also update filteredData immediately
// // //             setFilteredData(prevData => {
// // //                 const updatedData = [...prevData];
// // //                 updatedData[index] = {
// // //                     ...updatedData[index],
// // //                     menuStatus: newStatus,
// // //                     subcategories: updatedData[index].subcategories.map(sub => ({
// // //                         ...sub,
// // //                         menuStatus: newStatus
// // //                     }))
// // //                 };
// // //                 return updatedData;
// // //             });
// // //         } else {
// // //             // For subcategory
// // //             setData(prevData => {
// // //                 const updatedData = [...prevData];
// // //                 updatedData[index].subcategories[subIndex] = {
// // //                     ...updatedData[index].subcategories[subIndex],
// // //                     menuStatus: newStatus
// // //                 };
// // //                 return updatedData;
// // //             });

// // //             setFilteredData(prevData => {
// // //                 const updatedData = [...prevData];
// // //                 updatedData[index].subcategories[subIndex] = {
// // //                     ...updatedData[index].subcategories[subIndex],
// // //                     menuStatus: newStatus
// // //                 };
// // //                 return updatedData;
// // //             });
// // //         }

// // //         // Make API call
// // //         try {
// // //             const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
// // //             const payload = { menuStatus: newStatus };

// // //             await axios.put(url, payload, {
// // //                 headers: {
// // //                     'Content-Type': 'application/json',
// // //                     'Authorization': `Bearer ${authToken}`,
// // //                 },
// // //             });


// // //             // If category, update all subcategories too
// // //             if (isCategory) {
// // //                 const category = data[index];
// // //                 if (category.subcategories && category.subcategories.length > 0) {
// // //                     for (const sub of category.subcategories) {
// // //                         const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
// // //                         const subPayload = { menuStatus: newStatus };

// // //                         await axios.put(subUrl, subPayload, {
// // //                             headers: {
// // //                                 'Content-Type': 'application/json',
// // //                                 'Authorization': `Bearer ${authToken}`,
// // //                             },
// // //                         });
// // //                     }
// // //                 }
// // //             }

// // //             localStorage.setItem(`menuStatus-${dishId}`, newStatus);

// // //         } catch (error) {
// // //             console.error('❌ Failed to toggle menu visibility:', error);
// // //             alert('Failed to update menu visibility. Please refresh the page.');

// // //             // Revert on error
// // //             if (isCategory) {
// // //                 setData(prevData => {
// // //                     const updatedData = [...prevData];
// // //                     updatedData[index] = {
// // //                         ...updatedData[index],
// // //                         menuStatus: currentStatus,
// // //                         subcategories: updatedData[index].subcategories.map(sub => ({
// // //                             ...sub,
// // //                             menuStatus: sub.menuStatus
// // //                         }))
// // //                     };
// // //                     return updatedData;
// // //                 });
// // //             }
// // //         }
// // //     };

// // //     const handleDeleteRow = async (index, dishId) => {
// // //         if (!window.confirm("Are you sure you want to delete this dish?")) return;

// // //         const token = localStorage.getItem("authToken");

// // //         try {
// // //             showLoader();
// // //             const response = await fetch(
// // //                 `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
// // //                 {
// // //                     method: "DELETE",
// // //                     headers: {
// // //                         "Authorization": `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             if (response.ok) {
// // //                 alert("Dish deleted successfully!");
// // //                 const newData = data.filter(item => item.SNo !== dishId);
// // //                 setData(newData);
// // //             } else {
// // //                 const result = await response.json();
// // //                 alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
// // //             }
// // //         } catch (error) {
// // //             alert("An error occurred while deleting.");
// // //             console.error(error);
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
// // //         if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

// // //         const token = localStorage.getItem("authToken");

// // //         try {
// // //             showLoader();
// // //             const response = await fetch(
// // //                 `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
// // //                 {
// // //                     method: "DELETE",
// // //                     headers: {
// // //                         "Authorization": `Bearer ${token}`,
// // //                     },
// // //                 }
// // //             );

// // //             if (response.ok) {
// // //                 alert("Subcategory deleted successfully!");

// // //                 setData(prevData => {
// // //                     const newData = [...prevData];
// // //                     const updatedSubcategories = [...newData[parentIndex].subcategories];
// // //                     updatedSubcategories.splice(subIndex, 1);
// // //                     newData[parentIndex] = {
// // //                         ...newData[parentIndex],
// // //                         subcategories: updatedSubcategories,
// // //                     };
// // //                     return newData;
// // //                 });
// // //             } else {
// // //                 const result = await response.json();
// // //                 alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
// // //             }
// // //         } catch (error) {
// // //             alert("An error occurred while deleting the subcategory.");
// // //             console.error(error);
// // //         } finally {
// // //             hideLoader();
// // //         }
// // //     };

// // //     const handleInputChange = (e, index) => {
// // //         const { name, value } = e.target;
// // //         setData(prevData => {
// // //             const updatedData = [...prevData];
// // //             updatedData[index][name] = value;
// // //             return updatedData;
// // //         });
// // //     };
// // //     useEffect(() => {
// // //         const handleGlobalKeyDown = (e) => {
// // //             const isTypingInInput =
// // //                 e.target.tagName === 'INPUT' ||
// // //                 e.target.tagName === 'TEXTAREA' ||
// // //                 e.target.isContentEditable;

// // //             // Focus search when '/' is pressed
// // //             if (e.key === '/' && !isTypingInInput) {
// // //                 e.preventDefault();
// // //                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
// // //                 if (searchInput) {
// // //                     searchInput.focus();
// // //                     searchInput.select();
// // //                 }
// // //             }

// // //             // Clear search with Escape
// // //             if (e.key === 'Escape' && searchQuery) {
// // //                 e.preventDefault();
// // //                 setSearchQuery("");
// // //                 setSearchActive(false);
// // //                 applyFilter(data, isVegSelected);
// // //             }
// // //         };

// // //         window.addEventListener('keydown', handleGlobalKeyDown);
// // //         return () => {
// // //             window.removeEventListener('keydown', handleGlobalKeyDown);
// // //         };
// // //     }, [searchQuery, data, isVegSelected]);
// // //     // Responsive styles
// // //     const getResponsiveValue = (mobile, tablet, desktop) => {
// // //         const width = window.innerWidth;
// // //         if (width < 768) return mobile;
// // //         if (width < 1024) return tablet;
// // //         return desktop;
// // //     };

// // //     // Function to handle category column click
// // //     const handleCategoryColumnClick = () => {
// // //         // Extract all unique categories from data
// // //         const categories = Array.from(new Set(data.map(item => item.category)))
// // //             .filter(Boolean)
// // //             .map(category => ({
// // //                 name: category,
// // //                 count: data.filter(item => item.category === category).length
// // //             }));

// // //         setFilteredCategories(categories);
// // //         setShowCategorySearchPopup(true);
// // //         setCategorySearchQuery('');
// // //     };

// // //     // Function to filter categories based on search
// // //     const handleCategorySearch = (query) => {
// // //         setCategorySearchQuery(query);
// // //         const allCategories = Array.from(new Set(data.map(item => item.category)))
// // //             .filter(Boolean)
// // //             .map(category => ({
// // //                 name: category,
// // //                 count: data.filter(item => item.category === category).length
// // //             }));

// // //         if (!query.trim()) {
// // //             setFilteredCategories(allCategories);
// // //             return;
// // //         }

// // //         const filtered = allCategories.filter(category =>
// // //             category.name.toLowerCase().includes(query.toLowerCase())
// // //         );
// // //         setFilteredCategories(filtered);
// // //     };

// // //     // Function to select a category
// // //     // Function to select a category
// // //     const handleCategorySelect = (categoryName) => {
// // //         setSelectedCategory(categoryName);

// // //         let filtered = data;

// // //         // Apply category filter if selected
// // //         if (categoryName) {
// // //             filtered = filtered.filter(item => item.category === categoryName);
// // //         }

// // //         // Apply veg filter if selected
// // //         if (isVegSelected !== null) {
// // //             filtered = filtered.map(category => {
// // //                 const filteredSubcategories = category.subcategories.filter(
// // //                     sub => isVegSelected ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// // //                 );
// // //                 return {
// // //                     ...category,
// // //                     subcategories: filteredSubcategories
// // //                 };
// // //             }).filter(cat => cat.subcategories.length > 0);
// // //         }

// // //         // Apply search if active
// // //         if (searchActive && searchQuery) {
// // //             filtered = filtered.map(category => {
// // //                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
// // //                 const filteredSubcategories = category.subcategories.filter(sub =>
// // //                     sub.subName?.toLowerCase().includes(searchQuery) ||
// // //                     sub.description?.toLowerCase().includes(searchQuery)
// // //                 );

// // //                 if (categoryMatches || filteredSubcategories.length > 0) {
// // //                     return {
// // //                         ...category,
// // //                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// // //                     };
// // //                 }
// // //                 return null;
// // //             }).filter(category => category !== null);
// // //         }

// // //         applyFilter(data, isVegSelected);
// // //         setFilteredData(filtered);
// // //         setShowCategorySearchPopup(false);
// // //         setCategorySearchQuery('');
// // //     };

// // //     // Function to clear category filter
// // //     // Function to clear category filter
// // //     // Function to clear category filter
// // //     const clearCategoryFilter = () => {
// // //         setSelectedCategory(null);
// // //         // Reset to original data with current veg filter
// // //         setFilteredData(data);
// // //         // Re-apply all other active filters
// // //         applyFilter(data, isVegSelected);
// // //     };

// // //     // const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

// // //     const modalStyle = {
// // //         position: 'fixed',
// // //         top: '50%',
// // //         left: '50%',
// // //         transform: 'translate(-50%, -50%)',
// // //         backgroundColor: 'white',
// // //         padding: '20px',
// // //         borderRadius: '10px',
// // //         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
// // //         zIndex: 1000,
// // //         width: '400px',
// // //     };

// // //     const inputContainerStyle = {
// // //         marginBottom: '15px',
// // //     };

// // //     const inputFieldStyle = {
// // //         width: '100%',
// // //         padding: '8px',
// // //         fontSize: '14px',
// // //         borderRadius: '5px',
// // //         border: '1px solid #ddd',
// // //     };

// // //     const imagePreviewStyle = {
// // //         cursor: 'pointer',
// // //         display: 'flex',
// // //         justifyContent: 'center',
// // //         alignItems: 'center',
// // //         width: '100px',
// // //         height: '100px',
// // //         margin: '10px 0',
// // //         borderRadius: '10px',
// // //         border: '1px solid #ccc',
// // //         overflow: 'hidden',
// // //     };

// // //     const imageStyle = {
// // //         width: '100%',
// // //         height: '100%',
// // //         objectFit: 'cover',
// // //     };

// // //     const buttonContainerStyle = {
// // //         display: 'flex',
// // //         justifyContent: 'center',
// // //         marginTop: '20px',
// // //         textAlign: "center"
// // //     };

// // //     const closeButtonStyle = {
// // //         position: 'absolute',
// // //         top: '10px',
// // //         right: '10px',
// // //         cursor: 'pointer',
// // //     };

// // //     const closeIconStyle = {
// // //         fontSize: '24px',
// // //         fontWeight: 'bold',
// // //         marginBottom: '30px',
// // //         color: '#888',
// // //     };

// // //     const buttonStyle = {
// // //         height: "32px",
// // //         backgroundColor: '#b15cd6',
// // //         color: 'white',
// // //         border: 'none',
// // //         borderRadius: '5px',
// // //         cursor: 'pointer',
// // //         fontSize: '14px',
// // //         fontWeight: "bold",
// // //         marginTop: "10px"
// // //     };

// // //     const styles = {
// // //         overlay: {
// // //             position: 'fixed',
// // //             top: 0, left: 0, right: 0, bottom: 0,
// // //             backgroundColor: 'rgba(0,0,0,0.5)',
// // //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //             zIndex: 1000,
// // //             padding: '10px',
// // //         },
// // //         popup: {
// // //             background: '#fff',
// // //             padding: '20px',
// // //             borderRadius: '8px',
// // //             width: '300px',
// // //             maxWidth: '95vw',
// // //             boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
// // //             textAlign: 'center',
// // //             position: 'relative',
// // //         },
// // //         image: {
// // //             width: '100%',
// // //             marginTop: '10px',
// // //             borderRadius: '5px',
// // //         },
// // //         input: {
// // //             marginTop: '10px',
// // //             padding: '8px',
// // //             width: '100%',
// // //             borderRadius: '5px',
// // //             border: '1px solid #ccc',
// // //             fontSize: '14px',
// // //             boxSizing: 'border-box',
// // //         },
// // //         buttons: {
// // //             marginTop: '15px',
// // //             display: 'flex',
// // //             justifyContent: 'center'
// // //         },
// // //         saveBtn: {
// // //             padding: '8px 12px',
// // //             backgroundColor: '#4CAF50',
// // //             color: 'white',
// // //             border: 'none',
// // //             borderRadius: '5px',
// // //             cursor: 'pointer',
// // //             fontSize: '14px',
// // //         },
// // //         cancelBtn: {
// // //             padding: '8px 12px',
// // //             backgroundColor: '#f44336',
// // //             color: 'white',
// // //             border: 'none',
// // //             borderRadius: '5px',
// // //         }
// // //     };
// // //     const containerHeight = window.innerWidth < 768
// // //         ? '50vh'
// // //         : window.innerWidth < 850
// // //             ? '60vhpx'
// // //             : window.innerWidth < 1350
// // //                 ? '50vh'
// // //                 : '510px';

// // //     return (
// // //         <div style={{ marginTop: "0px" }}>
// // //             <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
// // //                 <style>
// // //                     {`
// // //                .custom-switch {
// // //             position: relative;
// // //             display: inline-block;
// // //             width: 100px;
// // //             height: 35px;
// // //             margin-top:11px;
// // //           }

// // //           .custom-switch input {
// // //             opacity: 0;
// // //             width: 0;
// // //             height: 0;
// // //           }

// // //           .custom-slider {
// // //             position: absolute;
// // //             cursor: pointer;
// // //             transition: 0.4s;
// // //             margin-left:-315px;
// // //             font-weight: bold;
// // //             font-size: 14px;
// // //             color: #000;
// // //             textAlign: center;
// // //             line-height: 35px;
// // //             width: 100px;
// // //             height: 40px;
// // //             border-radius:5px;
// // //             background-color: rgb(217, 217, 217);
// // //           }

// // //    .custom-slider::before {
// // //   content: "";
// // //   position: absolute;
// // //   height: 16px;
// // //   width: 16px;
// // //   left: 3px;
// // //   top: 10px;
// // //   background-color: #000; /* default */
// // //   transition: 0.4s;
// // //   border-radius: 50%;
// // // }

// // // .custom-slider.veg::before {
// // //   background-color: green;
// // // }

// // // .custom-slider.non-veg::before {
// // //   background-color: red;
// // // }
// // //   .scrollbar-w-auto::-webkit-scrollbar {
// // //     width: 16px !important;
// // //     height: 16px !important;
// // // }
// // //         `}
// // //                 </style>
// // //             </div>

// // //             <br></br>
// // //             <div style={{
// // //                 display: 'flex',
// // //                 flexDirection: 'column',
// // //                 marginBottom: '0px',
// // //                 width: '100%',
// // //                 padding: window.innerWidth < 768 ? '0px' : '0'
// // //             }}>
// // //                 {showPopup && (
// // //                     <div style={styles.overlay}>
// // //                         <div style={{
// // //                             ...styles.popup,
// // //                             width: window.innerWidth < 480 ? '280px' : '300px',
// // //                             padding: window.innerWidth < 480 ? '15px' : '20px'
// // //                         }}>
// // //                             <div
// // //                                 style={{
// // //                                     position: "absolute",
// // //                                     fontSize: window.innerWidth < 480 ? "18px" : "20px",
// // //                                     cursor: "pointer",
// // //                                     color: "#888",
// // //                                     fontWeight: "bold",
// // //                                     right: window.innerWidth < 480 ? "10px" : "10px",
// // //                                     top: window.innerWidth < 480 ? "10px" : "10px",
// // //                                     zIndex: 1
// // //                                 }}
// // //                                 onClick={() => setShowPopup(false)}
// // //                             >
// // //                                 ×
// // //                             </div>

// // //                             <h3 style={{
// // //                                 fontSize: window.innerWidth < 480 ? '16px' : '18px',
// // //                                 marginTop: window.innerWidth < 480 ? '5px' : '0'
// // //                             }}>Add Item</h3>

// // //                             <div
// // //                                 style={{
// // //                                     width: "100%",
// // //                                     maxWidth: window.innerWidth < 480 ? "150px" : "175px",
// // //                                     minHeight: window.innerWidth < 480 ? "120px" : "138px",
// // //                                     border: "2px dashed #bbb",
// // //                                     borderRadius: "10px",
// // //                                     margin: "15px auto",
// // //                                     display: "flex",
// // //                                     alignItems: "center",
// // //                                     justifyContent: "center",
// // //                                     cursor: "pointer",
// // //                                     backgroundColor: "#fafafa",
// // //                                     transition: "border-color 0.3s",
// // //                                 }}
// // //                                 onClick={() => fileInputRef.current?.click()}
// // //                                 onMouseEnter={(e) =>
// // //                                     (e.currentTarget.style.borderColor = "#00b894")
// // //                                 }
// // //                                 onMouseLeave={(e) =>
// // //                                     (e.currentTarget.style.borderColor = "#bbb")
// // //                                 }
// // //                             >
// // //                                 {image ? (
// // //                                     <img
// // //                                         src={image}
// // //                                         alt="Preview"
// // //                                         style={{
// // //                                             width: "100%",
// // //                                             height: "100%",
// // //                                             objectFit: "contain",
// // //                                             borderRadius: "10px",
// // //                                         }}
// // //                                     />
// // //                                 ) : (
// // //                                     <div
// // //                                         style={{
// // //                                             fontSize: window.innerWidth < 480 ? "40px" : "50px",
// // //                                             color: "#ccc",
// // //                                             fontWeight: "bold",
// // //                                             userSelect: "none",
// // //                                         }}
// // //                                     >
// // //                                         +
// // //                                     </div>
// // //                                 )}
// // //                             </div>

// // //                             <input
// // //                                 ref={fileInputRef}
// // //                                 type="file"
// // //                                 accept="image/*"
// // //                                 style={{ display: "none" }}
// // //                                 onClick={(e) => {
// // //                                     e.target.value = null;
// // //                                 }}
// // //                                 onChange={(e) => {
// // //                                     const file = e.target.files[0];
// // //                                     if (file) {
// // //                                         setImageFile(file);
// // //                                         const reader = new FileReader();
// // //                                         reader.onloadend = () => setImage(reader.result);
// // //                                         reader.readAsDataURL(file);
// // //                                     }
// // //                                 }}
// // //                             />

// // //                             <input
// // //                                 type="text"
// // //                                 placeholder="Enter Category"
// // //                                 value={text}
// // //                                 onChange={(e) => setText(e.target.value)}
// // //                                 style={{
// // //                                     ...styles.input,
// // //                                     fontSize: window.innerWidth < 480 ? '13px' : '14px',
// // //                                     padding: window.innerWidth < 480 ? '6px 10px' : '8px 12px',
// // //                                     marginTop: window.innerWidth < 480 ? '5px' : '10px'
// // //                                 }}
// // //                             />

// // //                             <div style={{
// // //                                 ...styles.buttons,
// // //                                 marginTop: window.innerWidth < 480 ? '10px' : '15px'
// // //                             }}>
// // //                                 <button onClick={handleSave} style={{
// // //                                     ...styles.saveBtn,
// // //                                     padding: window.innerWidth < 480 ? '6px 12px' : '8px 16px',
// // //                                     fontSize: window.innerWidth < 480 ? '13px' : '14px'
// // //                                 }}>
// // //                                     Save
// // //                                 </button>
// // //                             </div>
// // //                         </div>
// // //                     </div>
// // //                 )}

// // //                 {/* Main Controls Container */}
// // //                 <div style={{
// // //                     display: 'flex',
// // //                     flexDirection: window.innerWidth < 768 ? 'column' : 'row',
// // //                     justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
// // //                     alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
// // //                     marginBottom: window.innerWidth < 768 ? '15px' : '0px',
// // //                     gap: window.innerWidth < 768 ? '15px' : '10px',
// // //                     width: '100%',
// // //                     padding: window.innerWidth < 768 ? '0' : '0px',
// // //                     marginTop: "6px",
// // //                 }}>
// // //                     {/* Buttons Group */}
// // //                     <div style={{
// // //                         display: 'flex',
// // //                         flexDirection: 'row',
// // //                         gap: '10px',
// // //                         justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
// // //                         alignItems: 'center',
// // //                         flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
// // //                         width: window.innerWidth < 768 ? '100%' : 'auto',
// // //                         marginTop: window.innerWidth < 768 ? '0' : '-70px'
// // //                     }}>
// // //                         <input
// // //                             type="file"
// // //                             accept=".xlsx, .xls"
// // //                             ref={fileInputRef}
// // //                             onChange={handleFileImport}
// // //                             style={{ display: 'none' }}
// // //                         />

// // //                         <button
// // //                             style={{
// // //                                 ...importExportButton,
// // //                                 height: window.innerWidth < 480 ? '32px' : '35px',
// // //                                 padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// // //                                 fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// // //                                 marginTop: window.innerWidth < 768 ? '0' : '10px',
// // //                                 whiteSpace: 'nowrap'
// // //                             }}
// // //                             onClick={() => fileInputRef.current.click()}
// // //                         >
// // //                             Import
// // //                         </button>

// // //                         <button style={{
// // //                             ...importExportButton,
// // //                             height: window.innerWidth < 480 ? '32px' : '35px',
// // //                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// // //                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// // //                             marginTop: window.innerWidth < 768 ? '0' : '10px',
// // //                             whiteSpace: 'nowrap'
// // //                         }} onClick={handleExport}>
// // //                             Export
// // //                         </button>

// // //                         <button style={{
// // //                             ...importExportButton,
// // //                             height: window.innerWidth < 480 ? '32px' : '35px',
// // //                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// // //                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// // //                             marginTop: window.innerWidth < 768 ? '0' : '10px',
// // //                             whiteSpace: 'nowrap'
// // //                         }}
// // //                             onClick={() => setShowPopup(true)}
// // //                         >
// // //                             Add Category
// // //                         </button>
// // //                     </div>
// // //                     {/* Search Bar */}
// // //                     <div style={{
// // //                         position: 'relative',
// // //                         width: window.innerWidth < 768 ? '100%' : 'auto',
// // //                         minWidth: window.innerWidth < 480 ? '150px' : '200px',
// // //                         maxWidth: window.innerWidth < 768 ? '100%' : '300px',
// // //                         marginTop: window.innerWidth < 768 ? '0' : '-70px',
// // //                         marginRight: window.innerWidth < 768 ? '0' : '10px',
// // //                         order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
// // //                         zIndex: 1 // Ensure it's above other elements
// // //                     }}>
// // //                         <input
// // //                             type="text"
// // //                             placeholder="Search dishes or categories..."
// // //                             value={searchQuery}
// // //                             onChange={(e) => {
// // //                                 setSearchQuery(e.target.value);
// // //                                 // Optional: Add debounced search here
// // //                             }}
// // //                             onKeyDown={(e) => {
// // //                                 // Allow all key presses including space
// // //                                 if (e.key === 'Enter') {
// // //                                     handleSearch(searchQuery);
// // //                                 }
// // //                                 // Prevent any default behavior that might block typing
// // //                             }}
// // //                             onKeyUp={(e) => {
// // //                                 // Update search on every keyup (real-time search)
// // //                                 if (e.key !== 'Enter' && e.key !== 'Tab') {
// // //                                     handleSearch(searchQuery);
// // //                                 }
// // //                             }}
// // //                             style={{
// // //                                 width: '100%',
// // //                                 padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
// // //                                 borderRadius: '20px',
// // //                                 border: '2px solid #b15cd6',
// // //                                 fontSize: window.innerWidth < 480 ? '13px' : '14px',
// // //                                 outline: 'none',
// // //                                 transition: 'all 0.3s ease',
// // //                                 backgroundColor: '#fff',
// // //                                 height: window.innerWidth < 480 ? '32px' : '35px',
// // //                                 boxSizing: 'border-box',
// // //                                 fontFamily: 'inherit', // Ensure consistent font
// // //                             }}
// // //                             onFocus={(e) => {
// // //                                 e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
// // //                             }}
// // //                             onBlur={(e) => {
// // //                                 e.target.style.boxShadow = 'none';
// // //                             }}
// // //                         />
// // //                         <button
// // //                             onClick={() => handleSearch(searchQuery)}
// // //                             style={{
// // //                                 position: 'absolute',
// // //                                 right: window.innerWidth < 480 ? '6px' : '8px',
// // //                                 top: '50%',
// // //                                 transform: 'translateY(-50%)',
// // //                                 background: 'transparent',
// // //                                 border: 'none',
// // //                                 cursor: 'pointer',
// // //                                 padding: '4px',
// // //                                 display: 'flex',
// // //                                 alignItems: 'center',
// // //                                 justifyContent: 'center',
// // //                                 zIndex: 2
// // //                             }}
// // //                             type="button"
// // //                             aria-label="Search"
// // //                         >
// // //                             <svg
// // //                                 width={window.innerWidth < 480 ? "16" : "18"}
// // //                                 height={window.innerWidth < 480 ? "16" : "18"}
// // //                                 viewBox="0 0 24 24"
// // //                                 fill="none"
// // //                                 stroke="#b15cd6"
// // //                                 strokeWidth="2"
// // //                             >
// // //                                 <circle cx="11" cy="11" r="8" />
// // //                                 <path d="m21 21-4.3-4.3" />
// // //                             </svg>
// // //                         </button>

// // //                         {/* Add a clear button */}
// // //                         {/* {searchQuery && (
// // //                             <button
// // //                                 onClick={() => {
// // //                                     setSearchQuery("");
// // //                                     handleSearch("");
// // //                                 }}
// // //                                 style={{
// // //                                     position: 'absolute',
// // //                                     right: window.innerWidth < 480 ? '28px' : '32px',
// // //                                     top: '50%',
// // //                                     transform: 'translateY(-50%)',
// // //                                     background: 'transparent',
// // //                                     border: 'none',
// // //                                     cursor: 'pointer',
// // //                                     padding: '2px',
// // //                                     display: 'flex',
// // //                                     alignItems: 'center',
// // //                                     justifyContent: 'center',
// // //                                     color: '#888',
// // //                                     fontSize: '16px',
// // //                                     fontWeight: 'bold',
// // //                                     zIndex: 2
// // //                                 }}
// // //                                 type="button"
// // //                                 aria-label="Clear search"
// // //                             >
// // //                                 ×
// // //                             </button>
// // //                         )} */}
// // //                     </div>
// // //                 </div>
// // //             </div>

// // //             <div style={{
// // //                 height: window.innerHeight < 650 ? "auto" : containerHeight,
// // //                 maxHeight: window.innerHeight < 450 ? "45vh" : window.innerHeight < 500 ? "50vh" : window.innerHeight < 650 ? "55vh" : window.innerHeight < 700 ? "60vh" : "65vh",
// // //                 border: '0px solid #ddd',
// // //                 borderRadius: '0.375rem',
// // //                 backgroundColor: '#fff',
// // //                 width: '100%',
// // //                 maxWidth: '100%',
// // //                 boxSizing: 'border-box',
// // //                 overflow: window.innerWidth < 768 ? 'auto' : 'hidden',
// // //                 display: 'flex',
// // //                 flexDirection: 'column'
// // //             }} className="standard-table-data">

// // //                 {loading ? (
// // //                     <p>Loading data...</p>
// // //                 ) : error ? (
// // //                     <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
// // //                 ) : (
// // //                     <div style={{
// // //                         minWidth: window.innerWidth < 768 ? '900px' : '100%', // ← Increased min width for Chef Type column
// // //                         overflow: 'visible',
// // //                         height: window.innerWidth < 1300 ? '50vh' : '60vh',
// // //                         display: 'flex',
// // //                         flexDirection: 'column'
// // //                     }}>
// // //                         {/* Fixed Header */}
// // //                         <div style={{
// // //                             flexShrink: 0,
// // //                             backgroundColor: '#f2f2f2',
// // //                             borderBottom: '1px solid #ddd',
// // //                             minWidth: window.innerWidth < 768 ? '900px' : '100%', // ← Increased min width
// // //                         }}>
// // //                             <table style={{
// // //                                 width: '100%',
// // //                                 borderCollapse: 'collapse',
// // //                                 tableLayout: 'fixed'
// // //                             }}>
// // //                                 <thead>
// // //                                     <tr>
// // //                                         <th style={{ ...tableHeaderStyle, width: '5%', textAlign: 'center' }}>S.No</th>
// // //                                         <th
// // //                                             style={{
// // //                                                 ...tableHeaderStyle,
// // //                                                 width: '12%',
// // //                                                 textAlign: 'center',
// // //                                                 cursor: 'pointer',
// // //                                                 position: 'relative',
// // //                                             }}
// // //                                             onClick={handleCategoryColumnClick}
// // //                                         >
// // //                                             <div style={{
// // //                                                 display: 'flex',
// // //                                                 alignItems: 'center',
// // //                                                 justifyContent: 'space-around',
// // //                                                 gap: '5px',
// // //                                                 position: 'relative'
// // //                                             }}>
// // //                                                 <span>Category</span>

// // //                                                 {/* Show filter icon only when NO category is selected */}
// // //                                                 {!selectedCategory && (
// // //                                                     <svg
// // //                                                         width="14"
// // //                                                         height="14"
// // //                                                         viewBox="0 0 24 24"
// // //                                                         fill="white"
// // //                                                         stroke="white"
// // //                                                         strokeWidth="1.5"
// // //                                                         style={{ marginBottom: '1px' }}
// // //                                                     >
// // //                                                         <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
// // //                                                     </svg>
// // //                                                 )}

// // //                                                 {/* Show clear icon only when category IS selected */}
// // //                                                 {selectedCategory && (
// // //                                                     <span
// // //                                                         onClick={(e) => {
// // //                                                             e.stopPropagation();
// // //                                                             clearCategoryFilter();
// // //                                                         }}
// // //                                                         style={{
// // //                                                             background: '#ff6b6b',
// // //                                                             color: 'white',
// // //                                                             borderRadius: '50%',
// // //                                                             width: '18px',
// // //                                                             height: '18px',
// // //                                                             display: 'flex',
// // //                                                             alignItems: 'center',
// // //                                                             justifyContent: 'center',
// // //                                                             fontSize: '12px',
// // //                                                             cursor: 'pointer',
// // //                                                             marginBottom: '1px'
// // //                                                         }}
// // //                                                         title="Clear category filter"
// // //                                                         onMouseEnter={(e) => {
// // //                                                             e.currentTarget.style.backgroundColor = '#ff5252';
// // //                                                             e.currentTarget.style.transform = 'scale(1.1)';
// // //                                                         }}
// // //                                                         onMouseLeave={(e) => {
// // //                                                             e.currentTarget.style.backgroundColor = '#ff6b6b';
// // //                                                             e.currentTarget.style.transform = 'scale(1)';
// // //                                                         }}
// // //                                                     >
// // //                                                         ×
// // //                                                     </span>
// // //                                                 )}
// // //                                             </div>
// // //                                         </th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '7%', textAlign: 'center' }}>Type</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '15%', textAlign: 'center' }}>Description</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>Image</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '7%', textAlign: 'center' }}>Price</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '6%', textAlign: 'center' }}>Gst(%)</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>
// // //                                             Packing<br />(.Rs)
// // //                                         </th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '10%', textAlign: 'center' }}>Chef Type</th> {/* NEW COLUMN */}
// // //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>Status</th>
// // //                                         <th style={{ ...tableHeaderStyle, width: '10%', textAlign: 'center' }}>Actions</th>
// // //                                     </tr>
// // //                                 </thead>
// // //                             </table>
// // //                         </div>

// // //                         {/* Scrollable Body */}
// // //                         <div style={{
// // //                             flex: 1,
// // //                             overflowY: 'auto',
// // //                             overflowX: window.innerWidth < 768 ? 'auto' : 'hidden',
// // //                             scrollbarWidth: window.innerWidth < 768 ? 'thin' : 'none',
// // //                             minWidth: window.innerWidth < 768 ? '900px' : '100%' // ← Increased min width
// // //                         }}>
// // //                             <table style={{
// // //                                 width: '100%',
// // //                                 borderCollapse: 'collapse',
// // //                                 tableLayout: 'fixed',
// // //                                 minWidth: window.innerWidth < 768 ? '900px' : '100%' // ← Increased min width
// // //                             }}>
// // //                                 <tbody>
// // //                                     {filteredData.map((item, index) => (
// // //                                         <React.Fragment key={index}>
// // //                                             {/* Parent Category Row */}
// // //                                             <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
// // //                                                 <td style={{ ...tableCellStyle, width: '5%', textAlign: 'center' }}>{index + 1}</td>
// // //                                                 <td style={{ ...tableCellStyle, width: '12%', fontWeight: "bold" }}>
// // //                                                     {item.category}
// // //                                                 </td>
// // //                                                 <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>
// // //                                                     {item.tag ? item.tag : '-'}
// // //                                                 </td>
// // //                                                 <td style={{ ...tableCellStyle, width: '15%', textAlign: 'center' }}>-</td>
// // //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// // //                                                     <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
// // //                                                         <img
// // //                                                             src={item.image}
// // //                                                             alt="Dish"
// // //                                                             style={{ width: '36px', height: '28px', borderRadius: '8px' }}
// // //                                                         />
// // //                                                     </label>
// // //                                                     <input
// // //                                                         id={`fileInput-${index}`}
// // //                                                         type="file"
// // //                                                         accept="image/*"
// // //                                                         onChange={(e) => handleImageChange(e, index)}
// // //                                                         style={{ display: 'none' }}
// // //                                                     />
// // //                                                 </td>
// // //                                                 <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>-</td>
// // //                                                 <td style={{ ...tableCellStyle, width: '6%', textAlign: 'center' }}>-</td>
// // //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>-</td>
// // //                                                 <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>-</td> {/* Chef Type for Category */}
// // //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// // //                                                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
// // //                                                         <label className="switch">
// // //                                                             <input
// // //                                                                 type="checkbox"
// // //                                                                 checked={item.menuStatus === "Enable"}
// // //                                                                 onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
// // //                                                             />
// // //                                                             <span className="slider round"></span>
// // //                                                         </label>
// // //                                                         <span style={{ marginTop: '3px', fontSize: '0.75rem', fontWeight: '600' }}>
// // //                                                             {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
// // //                                                         </span>
// // //                                                     </div>
// // //                                                 </td>
// // //                                                 <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>
// // //                                                     <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
// // //                                                         <button
// // //                                                             style={{
// // //                                                                 backgroundColor: '#00b894',
// // //                                                                 color: 'white',
// // //                                                                 borderRadius: '4px',
// // //                                                                 padding: '4px 6px',
// // //                                                                 border: 'none',
// // //                                                                 cursor: 'pointer',
// // //                                                                 fontSize: '0.75rem',
// // //                                                                 minWidth: '40px'
// // //                                                             }}
// // //                                                             onClick={() => handleAddSubCategory(item.dishId)}
// // //                                                         >
// // //                                                             Add
// // //                                                         </button>
// // //                                                         <button
// // //                                                             style={{ ...addButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// // //                                                             onClick={() => item.isAdded ? handleEdit(item.SNo) : handleSave(item, index)}
// // //                                                         >
// // //                                                             {item.isAdded ? <FaEdit /> : <FaSave />}
// // //                                                         </button>
// // //                                                         <button
// // //                                                             style={{ ...deleteButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// // //                                                             onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
// // //                                                         >
// // //                                                             <FaTrash />
// // //                                                         </button>
// // //                                                     </div>
// // //                                                 </td>
// // //                                             </tr>

// // //                                             {/* Subcategories */}
// // //                                             {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => (
// // //                                                 <tr key={`sub-${sub.dishId}`} style={{ backgroundColor: '#f9f9f9' }}>
// // //                                                     <td style={{ ...tableCellStyle, width: '5%', textAlign: 'center', fontSize: '0.8rem' }}>
// // //                                                         {index + 1}.{subIndex + 1}
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '12%', fontSize: '0.8rem', paddingLeft: '0px' }}>
// // //                                                         ↳ {sub.subName}
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>
// // //                                                         {sub.tag === "Veg" ? (
// // //                                                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
// // //                                                                 <div style={{ width: '10px', height: '10px', border: '1px solid green', borderRadius: '1px' }}>
// // //                                                                     <div style={{ width: '5px', height: '5px', backgroundColor: 'green', borderRadius: '50%', margin: '2px auto' }}></div>
// // //                                                                 </div>
// // //                                                                 <span style={{ color: 'green', fontSize: '0.7rem' }}>Veg</span>
// // //                                                             </div>
// // //                                                         ) : sub.tag === "Non_Veg" ? (
// // //                                                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
// // //                                                                 <div style={{ width: '10px', height: '10px', border: '1px solid red', borderRadius: '1px' }}>
// // //                                                                     <div style={{ width: '5px', height: '5px', backgroundColor: 'red', borderRadius: '50%', margin: '2px auto' }}></div>
// // //                                                                 </div>
// // //                                                                 <span style={{ color: 'red', fontSize: '0.7rem' }}>Non-Veg</span>
// // //                                                             </div>
// // //                                                         ) : (sub.tag)}
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '15%', fontSize: '0.75rem', padding: '4px 6px' }}>
// // //                                                         {sub.description}
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// // //                                                         <img
// // //                                                             src={sub.image}
// // //                                                             alt="Sub Dish"
// // //                                                             style={{ width: '36px', height: '28px', borderRadius: '8px' }}
// // //                                                         />
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center', fontSize: '0.8rem' }}>₹{sub.price}</td>
// // //                                                     <td style={{ ...tableCellStyle, width: '6%', textAlign: 'center', fontSize: '0.8rem' }}>{sub.gst}</td>
// // //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center', fontSize: '0.8rem' }}>{sub.packingCharges}</td>
// // //                                                     <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center', fontSize: '0.8rem' }}>
// // //                                                         {(() => {
// // //                                                             if (!sub.chefType) return '-';

// // //                                                             let displayType = sub.chefType;

// // //                                                             // Remove "Chef_" prefix
// // //                                                             if (displayType.startsWith('Chef_')) {
// // //                                                                 displayType = displayType.substring(5); // Remove "Chef_"
// // //                                                             }

// // //                                                             // Handle specific cases
// // //                                                             if (displayType === 'Tea_stall') {
// // //                                                                 displayType = 'Tea Stall';
// // //                                                             } else if (displayType === 'All') {
// // //                                                                 displayType = 'All';
// // //                                                             } else if (displayType === 'North') {
// // //                                                                 displayType = 'North';
// // //                                                             } else if (displayType === 'South') {
// // //                                                                 displayType = 'South';
// // //                                                             } else if (displayType === 'Chinese') {
// // //                                                                 displayType = 'Chinese';
// // //                                                             } else if (displayType === 'Continental') {
// // //                                                                 displayType = 'Continental';
// // //                                                             } else if (displayType === 'Snacks') {
// // //                                                                 displayType = 'Snacks';
// // //                                                             } else if (displayType === 'Bakery') {
// // //                                                                 displayType = 'Bakery';
// // //                                                             }

// // //                                                             return displayType;
// // //                                                         })()}
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// // //                                                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
// // //                                                             <label className="switch">
// // //                                                                 <input
// // //                                                                     type="checkbox"
// // //                                                                     checked={sub.menuStatus === "Enable"}
// // //                                                                     onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
// // //                                                                     disabled={item.menuStatus === "Disable"}
// // //                                                                 />
// // //                                                                 <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
// // //                                                             </label>
// // //                                                             <span style={{
// // //                                                                 marginTop: '3px',
// // //                                                                 fontSize: '0.7rem',
// // //                                                                 color: item.menuStatus === "Disable" ? '#999' : 'black',
// // //                                                                 fontWeight: '500'
// // //                                                             }}>
// // //                                                                 {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
// // //                                                             </span>
// // //                                                         </div>
// // //                                                     </td>
// // //                                                     <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>
// // //                                                         <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
// // //                                                             <button
// // //                                                                 style={{ ...addButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// // //                                                                 onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
// // //                                                             >
// // //                                                                 <FaEdit />
// // //                                                             </button>
// // //                                                             <button
// // //                                                                 style={{ ...deleteButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// // //                                                                 onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
// // //                                                             >
// // //                                                                 <FaTrash />
// // //                                                             </button>
// // //                                                         </div>
// // //                                                     </td>
// // //                                                 </tr>
// // //                                             ))}
// // //                                         </React.Fragment>
// // //                                     ))}
// // //                                 </tbody>
// // //                             </table>
// // //                         </div>
// // //                     </div>
// // //                 )}
// // //             </div>

// // //             {showEditModal && editItem && (
// // //                 <div style={modalStyle}>
// // //                     <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
// // //                         <span style={closeIconStyle}>×</span>
// // //                     </div>
// // //                     <br></br>
// // //                     <div style={inputContainerStyle}>
// // //                         <input
// // //                             id="dishName"
// // //                             type="text"
// // //                             value={editItem.dishName}
// // //                             onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
// // //                             style={inputFieldStyle}
// // //                         />
// // //                     </div>

// // //                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
// // //                         <div style={imagePreviewStyle}>
// // //                             <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
// // //                                 <img
// // //                                     src={editItem.image || 'https://via.placeholder.com/100x100'}
// // //                                     alt="Preview"
// // //                                     style={imageStyle}
// // //                                 />
// // //                             </label>

// // //                             <input
// // //                                 id="dishImage"
// // //                                 type="file"
// // //                                 accept="image/*"
// // //                                 onChange={(e) => handleEditImageChange(e)}
// // //                                 style={{ display: 'none' }}
// // //                             />
// // //                         </div>
// // //                     </div>

// // //                     <div style={buttonContainerStyle}>
// // //                         <button onClick={submitEdit} style={buttonStyle}>Update</button>
// // //                     </div>
// // //                 </div>
// // //             )}

// // //             {showSubcategoryPopup && (
// // //                 <div
// // //                     style={{
// // //                         position: 'fixed',
// // //                         top: 63,
// // //                         left: 0,
// // //                         width: '100%',
// // //                         height: '100%',
// // //                         backgroundColor: 'rgba(0,0,0,0.6)',
// // //                         display: 'flex',
// // //                         justifyContent: 'center',
// // //                         alignItems: 'center',
// // //                         zIndex: 1000,
// // //                         padding: '20px',
// // //                         boxSizing: 'border-box',
// // //                     }}
// // //                 >
// // //                     <div
// // //                         style={{
// // //                             height: "77vh",
// // //                             overflow: "auto",
// // //                             position: 'relative',
// // //                             backgroundColor: '#fff',
// // //                             padding: '30px 25px',
// // //                             borderRadius: '12px',
// // //                             width: '400px',
// // //                             maxWidth: '95%',
// // //                             boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
// // //                             display: 'flex',
// // //                             flexDirection: 'column',
// // //                             gap: '15px',
// // //                             fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// // //                         }}
// // //                     >
// // //                         <div
// // //                             onClick={() => setShowSubcategoryPopup(false)}
// // //                             style={{
// // //                                 position: 'absolute',
// // //                                 top: '15px',
// // //                                 right: '15px',
// // //                                 fontSize: '22px',
// // //                                 fontWeight: '700',
// // //                                 color: '#999',
// // //                                 cursor: 'pointer',
// // //                                 userSelect: 'none',
// // //                                 transition: 'color 0.3s',
// // //                             }}
// // //                             onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
// // //                             onMouseLeave={e => (e.currentTarget.style.color = '#999')}
// // //                         >
// // //                             &times;
// // //                         </div>

// // //                         <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
// // //                             Add Subcategory for : <span style={{ color: '#00b894' }}>{parentDishDetails?.dishName}</span>
// // //                         </h3>

// // //                         <input
// // //                             type="text"
// // //                             value={subDishName}
// // //                             onChange={(e) => setSubDishName(e.target.value)}
// // //                             placeholder="Subcategory Dish Name"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         />

// // //                         <input
// // //                             type="number"
// // //                             value={price}
// // //                             onChange={(e) => setPrice(e.target.value)}
// // //                             placeholder="Price"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         />

// // //                         <input
// // //                             type="number"
// // //                             value={gst}
// // //                             onChange={(e) => setGst(e.target.value)}
// // //                             placeholder="GST"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         />

// // //                         {/* <input
// // //                             type="number"
// // //                             value={discount}
// // //                             onChange={(e) => setdiscount(e.target.value)}
// // //                             placeholder="Discount"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         /> */}

// // //                         <input
// // //                             type="number"
// // //                             value={packingCharges}
// // //                             onChange={(e) => setPackingCharges(e.target.value)}
// // //                             placeholder="Packing Charges"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         />

// // //                         <select
// // //                             value={tag}
// // //                             onChange={(e) => setTag(e.target.value)}
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                                 backgroundColor: '#fff',
// // //                                 cursor: 'pointer',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         >
// // //                             <option value="Veg">Veg</option>
// // //                             <option value="Non_Veg">Non Veg</option>
// // //                         </select>

// // //                         <select
// // //                             value={chefType}
// // //                             onChange={(e) => setChefType(e.target.value)} style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                                 backgroundColor: '#fff',
// // //                                 cursor: 'pointer',
// // //                             }} >
// // //                             <option value="Chef_All">Chef All</option>
// // //                             <option value="Chef_North">Chef North</option>
// // //                             <option value="Chef_South">Chef South</option>
// // //                             <option value="Chef_Chinese">Chef Chinese</option>
// // //                             <option value="Chef_Continental">Chef Continental</option>
// // //                             <option value="Tea_stall">Tea Stall</option>
// // //                             <option value="Snacks">Snacks</option>
// // //                             <option value="Bakery">Bakery</option>
// // //                         </select>

// // //                         <input
// // //                             type="text"
// // //                             value={description}
// // //                             onChange={(e) => setDescription(e.target.value)}
// // //                             placeholder="Description"
// // //                             style={{
// // //                                 padding: '10px 12px',
// // //                                 fontSize: '1rem',
// // //                                 borderRadius: '6px',
// // //                                 border: '1.8px solid #ccc',
// // //                                 outline: 'none',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// // //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// // //                         />



// // //                         <div
// // //                             style={{
// // //                                 width: '100%',
// // //                                 maxWidth: '175px',
// // //                                 minHeight: '138px',
// // //                                 border: '2px dashed #bbb',
// // //                                 borderRadius: '10px',
// // //                                 margin: '15px auto',
// // //                                 display: 'flex',
// // //                                 alignItems: 'center',
// // //                                 justifyContent: 'center',
// // //                                 cursor: 'pointer',
// // //                                 backgroundColor: '#fafafa',
// // //                                 overflow: 'visible',
// // //                                 transition: 'border-color 0.3s',
// // //                             }}
// // //                             onClick={() => document.getElementById('hiddenFileInput').click()}
// // //                             onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
// // //                             onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
// // //                         >
// // //                             {image ? (
// // //                                 <img
// // //                                     src={image}
// // //                                     alt="Preview"
// // //                                     style={{
// // //                                         width: '100%',
// // //                                         height: '100%',
// // //                                         objectFit: 'contain',
// // //                                         borderRadius: '10px',
// // //                                     }}
// // //                                 />
// // //                             ) : (
// // //                                 <div
// // //                                     style={{
// // //                                         fontSize: '50px',
// // //                                         color: '#ccc',
// // //                                         fontWeight: 'bold',
// // //                                         userSelect: 'none',
// // //                                     }}
// // //                                 >
// // //                                     +
// // //                                 </div>
// // //                             )}
// // //                         </div>

// // //                         <input
// // //                             id="hiddenFileInput"
// // //                             type="file"
// // //                             accept="image/*"
// // //                             onChange={handleSubImageChange}
// // //                             style={{ display: 'none' }}
// // //                         />

// // //                         <div
// // //                             style={{
// // //                                 display: 'flex',
// // //                                 justifyContent: 'center',
// // //                                 marginTop: '10px',
// // //                             }}
// // //                         >
// // //                             <button
// // //                                 onClick={handleSubcategorySubmit}
// // //                                 style={{
// // //                                     backgroundColor: '#00b894',
// // //                                     color: 'white',
// // //                                     padding: '10px 20px',
// // //                                     border: 'none',
// // //                                     borderRadius: '6px',
// // //                                     fontWeight: '600',
// // //                                     fontSize: '1rem',
// // //                                     cursor: 'pointer',
// // //                                     transition: 'background-color 0.3s',
// // //                                 }}
// // //                                 onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
// // //                                 onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
// // //                             >
// // //                                 Save
// // //                             </button>
// // //                         </div>
// // //                     </div>
// // //                 </div>
// // //             )}

// // //             {showSubEditModal && (
// // //                 <div style={modalOverlayStyle}>
// // //                     <div style={modalContentStyle}>
// // //                         <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
// // //                             <button
// // //                                 onClick={() => setShowSubEditModal(false)}
// // //                                 style={{
// // //                                     background: 'transparent',
// // //                                     border: 'none',
// // //                                     fontSize: '20px',
// // //                                     cursor: 'pointer',
// // //                                     color: '#888',
// // //                                 }}
// // //                             >
// // //                                 &times;
// // //                             </button>
// // //                         </div>

// // //                         <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

// // //                         {/* 1. Dish Name */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Dish Name :
// // //                             </label>
// // //                             <input
// // //                                 type="text"
// // //                                 value={editSubItem.subName}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                 }}
// // //                             />
// // //                         </div>

// // //                         {/* 2. Price */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Price :
// // //                             </label>
// // //                             <input
// // //                                 type="number"
// // //                                 value={editSubItem.price}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                 }}
// // //                             />
// // //                         </div>

// // //                         {/* 3. GST */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 GST :
// // //                             </label>
// // //                             <input
// // //                                 type="number"
// // //                                 value={editSubItem.gst}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                 }}
// // //                             />
// // //                         </div>

// // //                         {/* 4. Packing Charges */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Packing Charges :
// // //                             </label>
// // //                             <input
// // //                                 type="number"
// // //                                 value={editSubItem.packingCharges}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                 }}
// // //                             />
// // //                         </div>

// // //                         {/* 5. Dish Type */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Dish Type:
// // //                             </label>
// // //                             <select
// // //                                 value={editSubItem.tag || 'Veg'}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                     backgroundColor: '#fff',
// // //                                     cursor: 'pointer',
// // //                                 }}
// // //                             >
// // //                                 <option value="Veg">Veg</option>
// // //                                 <option value="Non_Veg">Non-Veg</option>
// // //                             </select>
// // //                         </div>

// // //                         {/* 6. Chef Type */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Chef Type:
// // //                             </label>
// // //                             <select
// // //                                 value={editSubItem.chefType || 'Chef_All'}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                     backgroundColor: '#fff',
// // //                                     cursor: 'pointer',
// // //                                 }}
// // //                             >
// // //                                 <option value="Chef_All">Chef All</option>
// // //                                 <option value="Chef_North">Chef North</option>
// // //                                 <option value="Chef_South">Chef South</option>
// // //                                 <option value="Chef_Chinese">Chef Chinese</option>
// // //                                 <option value="Chef_Continental">Chef Continental</option>
// // //                                 <option value="Tea_stall">Tea Stall</option>
// // //                                 <option value="Snacks">Snacks</option>
// // //                                 <option value="Bakery">Bakery</option>
// // //                             </select>
// // //                         </div>

// // //                         {/* 7. Description */}
// // //                         <div style={{ marginBottom: '15px' }}>
// // //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// // //                                 Description :
// // //                             </label>
// // //                             <input
// // //                                 type="text"
// // //                                 value={editSubItem.description}
// // //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
// // //                                 style={{
// // //                                     width: '100%',
// // //                                     padding: '10px',
// // //                                     borderRadius: '6px',
// // //                                     border: '1px solid #ccc',
// // //                                     fontSize: '14px',
// // //                                 }}
// // //                             />
// // //                         </div>

// // //                         {/* 8. Image */}
// // //                         <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
// // //                             <div style={imagePreviewStyle}>
// // //                                 <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
// // //                                     <img
// // //                                         src={editSubItem.image || 'https://via.placeholder.com/100x100'}
// // //                                         alt="Preview"
// // //                                         style={{
// // //                                             width: '100px',
// // //                                             height: '100px',
// // //                                             objectFit: 'cover',
// // //                                             borderRadius: '10px',
// // //                                             border: '1px solid #ccc',
// // //                                         }}
// // //                                     />
// // //                                 </label>
// // //                                 <input
// // //                                     id="subDishImage"
// // //                                     type="file"
// // //                                     accept="image/*"
// // //                                     onChange={(e) =>
// // //                                         setEditSubItem({
// // //                                             ...editSubItem,
// // //                                             newImageFile: e.target.files[0],
// // //                                             image: URL.createObjectURL(e.target.files[0]),
// // //                                         })
// // //                                     }
// // //                                     style={{ display: 'none' }}
// // //                                 />
// // //                             </div>
// // //                         </div>

// // //                         <div style={{ display: 'flex', justifyContent: 'center' }}>
// // //                             <button onClick={submitEditSubcategory} style={submitButtonStyle}>
// // //                                 Update
// // //                             </button>
// // //                         </div>
// // //                     </div>
// // //                 </div>
// // //             )}

// // //             {/* Category Search Popup */}
// // //             {showCategorySearchPopup && (
// // //                 <div style={{
// // //                     position: 'fixed',
// // //                     top: 0,
// // //                     left: 0,
// // //                     right: 0,
// // //                     bottom: 0,
// // //                     backgroundColor: 'rgba(0,0,0,0.5)',
// // //                     display: 'flex',
// // //                     justifyContent: 'center',
// // //                     alignItems: 'center',
// // //                     zIndex: 2000
// // //                 }}>
// // //                     <div style={{
// // //                         backgroundColor: 'white',
// // //                         borderRadius: '8px',
// // //                         width: '300px',
// // //                         maxWidth: '90vw',
// // //                         maxHeight: '80vh',
// // //                         overflow: 'hidden',
// // //                         boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
// // //                     }}>
// // //                         {/* Header */}
// // //                         <div style={{
// // //                             padding: '15px',
// // //                             borderBottom: '1px solid #eee',
// // //                             display: 'flex',
// // //                             justifyContent: 'space-between',
// // //                             alignItems: 'center'
// // //                         }}>
// // //                             <h3 style={{ margin: 0, fontSize: '16px' }}>Search Categories</h3>
// // //                             <button
// // //                                 onClick={() => setShowCategorySearchPopup(false)}
// // //                                 style={{
// // //                                     background: 'none',
// // //                                     border: 'none',
// // //                                     fontSize: '20px',
// // //                                     cursor: 'pointer',
// // //                                     color: '#666'
// // //                                 }}
// // //                             >
// // //                                 ×
// // //                             </button>
// // //                         </div>

// // //                         {/* Search Input */}
// // //                         <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
// // //                             <div style={{ position: 'relative' }}>
// // //                                 <FaSearch style={{
// // //                                     position: 'absolute',
// // //                                     left: '10px',
// // //                                     top: '50%',
// // //                                     transform: 'translateY(-50%)',
// // //                                     color: '#999'
// // //                                 }} />
// // //                                 <input
// // //                                     type="text"
// // //                                     placeholder="Type to search categories..."
// // //                                     value={categorySearchQuery}
// // //                                     onChange={(e) => handleCategorySearch(e.target.value)}
// // //                                     style={{
// // //                                         width: '100%',
// // //                                         padding: '8px 8px 8px 35px',
// // //                                         borderRadius: '4px',
// // //                                         border: '1px solid #ddd',
// // //                                         fontSize: '14px',
// // //                                         outline: 'none'
// // //                                     }}
// // //                                     autoFocus
// // //                                 />
// // //                                 {categorySearchQuery && (
// // //                                     <FaTimes
// // //                                         onClick={() => setCategorySearchQuery('')}
// // //                                         style={{
// // //                                             position: 'absolute',
// // //                                             right: '10px',
// // //                                             top: '50%',
// // //                                             transform: 'translateY(-50%)',
// // //                                             color: '#999',
// // //                                             cursor: 'pointer'
// // //                                         }}
// // //                                     />
// // //                                 )}
// // //                             </div>
// // //                         </div>

// // //                         {/* Categories List */}
// // //                         <div style={{
// // //                             maxHeight: '300px',
// // //                             overflowY: 'auto',
// // //                             padding: '5px 0'
// // //                         }}>
// // //                             {/* Show All option */}
// // //                             <div
// // //                                 onClick={() => handleCategorySelect(null)}
// // //                                 style={{
// // //                                     padding: '10px 15px',
// // //                                     cursor: 'pointer',
// // //                                     borderBottom: '1px solid #f5f5f5',
// // //                                     backgroundColor: selectedCategory === null ? '#f0f0f0' : 'white',
// // //                                     display: 'flex',
// // //                                     justifyContent: 'space-between',
// // //                                     alignItems: 'center'
// // //                                 }}
// // //                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
// // //                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === null ? '#f0f0f0' : 'white'}
// // //                             >
// // //                                 <span>Show All Categories</span>
// // //                                 <span style={{
// // //                                     color: '#666',
// // //                                     fontSize: '12px',
// // //                                     backgroundColor: '#e9ecef',
// // //                                     padding: '2px 6px',
// // //                                     borderRadius: '10px'
// // //                                 }}>
// // //                                     {data.length}
// // //                                 </span>
// // //                             </div>

// // //                             {/* Categories */}
// // //                             {filteredCategories.map((category, index) => (
// // //                                 <div
// // //                                     key={index}
// // //                                     onClick={() => handleCategorySelect(category.name)}
// // //                                     style={{
// // //                                         padding: '10px 15px',
// // //                                         cursor: 'pointer',
// // //                                         borderBottom: '1px solid #f5f5f5',
// // //                                         backgroundColor: selectedCategory === category.name ? '#f0f0f0' : 'white',
// // //                                         display: 'flex',
// // //                                         justifyContent: 'space-between',
// // //                                         alignItems: 'center'
// // //                                     }}
// // //                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
// // //                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === category.name ? '#f0f0f0' : 'white'}
// // //                                 >
// // //                                     <span>{category.name}</span>
// // //                                     <span style={{
// // //                                         color: '#666',
// // //                                         fontSize: '12px',
// // //                                         backgroundColor: '#e9ecef',
// // //                                         padding: '2px 6px',
// // //                                         borderRadius: '10px'
// // //                                     }}>
// // //                                         {category.count}
// // //                                     </span>
// // //                                 </div>
// // //                             ))}

// // //                             {filteredCategories.length === 0 && (
// // //                                 <div style={{
// // //                                     padding: '20px',
// // //                                     textAlign: 'center',
// // //                                     color: '#666'
// // //                                 }}>
// // //                                     No categories found
// // //                                 </div>
// // //                             )}
// // //                         </div>

// // //                         {/* Footer */}
// // //                         <div style={{
// // //                             padding: '10px 15px',
// // //                             borderTop: '1px solid #eee',
// // //                             textAlign: 'right'
// // //                         }}>
// // //                             <button
// // //                                 onClick={() => setShowCategorySearchPopup(false)}
// // //                                 style={{
// // //                                     padding: '6px 15px',
// // //                                     backgroundColor: '#6c757d',
// // //                                     color: 'white',
// // //                                     border: 'none',
// // //                                     borderRadius: '4px',
// // //                                     cursor: 'pointer',
// // //                                     fontSize: '14px'
// // //                                 }}
// // //                             >
// // //                                 Close
// // //                             </button>
// // //                         </div>
// // //                     </div>
// // //                 </div>
// // //             )}
// // //             <style>
// // //                 {`
// // //                /* ItemUpdates-style toggle - Fixed direction */
// // // .switch {
// // //     position: relative;
// // //     display: inline-block;
// // //     width: 40px;
// // //     height: 22px;
// // // }

// // // .switch input {
// // //     opacity: 0;
// // //     width: 0;
// // //     height: 0;
// // // }

// // // .slider {
// // //     position: absolute;
// // //     cursor: pointer;
// // //     top: 0;
// // //     left: 0;
// // //     right: 0;
// // //     bottom: 0;
// // //     background-color: #f44336; /* RED by default (Hide) */
// // //     transition: .4s;
// // //     border-radius: 34px;
// // // }

// // // .slider:before {
// // //     position: absolute;
// // //     content: "";
// // //     height: 16px;
// // //     width: 16px;
// // //     left: 3px;  /* LEFT position by default */
// // //     bottom: 3px;
// // //     background-color: white;
// // //     transition: .4s;
// // //     border-radius: 50%;
// // // }

// // // /* CHECKED state - Show (GREEN) */
// // // input:checked + .slider {
// // //     background-color: #4CAF50; /* GREEN when Show */
// // // }

// // // input:checked + .slider:before {
// // //     transform: translateX(18px); /* Move to RIGHT when Show */
// // // }

// // // .slider.round {
// // //     border-radius: 34px;
// // // }

// // // /* Disabled state - Grayed out */
// // // .slider.disabled {
// // //     background-color: #cccccc !important;
// // //     cursor: not-allowed;
// // // }

// // // .switch input:disabled + .slider {
// // //     background-color: #cccccc !important;
// // //     cursor: not-allowed;
// // // }

// // // .switch input:disabled + .slider:before {
// // //     background-color: #999999 !important;
// // // }
// // //     @media (max-width: 768px) {
// // //     .standard-table-data {
// // //         overflow-x: auto !important;
// // //         -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
// // //         width: 93vw !important;

// // //     }

// // //     .standard-table-data table {
// // //         min-width: 800px; /* Force horizontal scroll */
// // //         width: 100%;
// // //     }

// // //     /* Make table cells more readable on mobile */
// // //     .standard-table-data td,
// // //     .standard-table-data th {
// // //         min-width: 80px;
// // //         // white-space: nowrap;
// // //         padding: 4px !important;
// // //         font-size: 0.8rem !important;
// // //     }

// // //     /* Adjust button sizes on mobile */
// // //     .standard-table-data button {
// // //         padding: 3px 5px !important;
// // //         font-size: 0.7rem !important;
// // //         min-width: 35px !important;
// // //     }
// // // }
// // // `}
// // //             </style>
// // //         </div>
// // //     );
// // // };

// // // const modalOverlayStyle = {
// // //     position: 'fixed',
// // //     top: 0, left: 0, right: 0, bottom: 0,
// // //     backgroundColor: 'rgba(0,0,0,0.5)',
// // //     display: 'flex',
// // //     justifyContent: 'center',
// // //     alignItems: 'center',
// // //     zIndex: 1000,
// // //     marginTop: "50px",
// // // };

// // // const modalContentStyle = {
// // //     backgroundColor: 'white',
// // //     borderRadius: '8px',
// // //     padding: '20px',
// // //     width: '300px',
// // //     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
// // //     height: "500px",
// // //     overflow: "auto",
// // // };

// // // const cancelButtonStyle = {
// // //     backgroundColor: '#ccc',
// // //     border: 'none',
// // //     padding: '8px 16px',
// // //     borderRadius: '4px',
// // //     cursor: 'pointer',
// // // };

// // // const submitButtonStyle = {
// // //     backgroundColor: '#00b894',
// // //     color: 'white',
// // //     border: 'none',
// // //     padding: '8px 16px',
// // //     borderRadius: '4px',
// // //     cursor: 'pointer',
// // // };

// // // const buttonStyle = {
// // //     backgroundColor: '#b15cd6',
// // //     color: 'white',
// // //     border: 'none',
// // //     cursor: 'pointer',
// // //     borderRadius: '5px',
// // //     width: '100px',
// // //     fontWeight: "bold"
// // // };

// // // const tableHeaderStyle = {
// // //     border: '1px solid #ddd',
// // //     textAlign: 'center',
// // //     fontWeight: '500',
// // //     backgroundColor: '#b15cd6',
// // //     color: 'white',
// // //     fontSize: "1rem",
// // //     padding: "0.5rem",

// // // };

// // // const tableCellStyle = {
// // //     border: '1px solid #ddd',
// // //     textAlign: 'center',
// // // };

// // // const evenRowStyle = { backgroundColor: '#fff' };
// // // const oddRowStyle = { backgroundColor: '#fff' };

// // // const inputStyle = {
// // //     border: 'none',
// // //     backgroundColor: 'transparent',
// // //     textAlign: 'center',
// // // };

// // // const addButtonStyle = {
// // //     backgroundColor: '#fff',
// // //     color: 'green',
// // //     border: 'none',
// // //     cursor: 'pointer',
// // //     borderRadius: '5px',
// // //     marginRight: '10px',
// // //     fontSize: "20px"
// // // };

// // // const deleteButtonStyle = {
// // //     backgroundColor: '#fff',
// // //     color: 'red',
// // //     border: 'none',
// // //     cursor: 'pointer',
// // //     borderRadius: '5px',
// // //     fontSize: "20px"
// // // };

// // // const importExportButton = {
// // //     height: window.innerWidth < 480 ? '32px' : '35px',
// // //     marginTop: window.innerWidth <= 768 ? "0px" : "20px",
// // //     borderRadius: "4px",
// // //     border: "none",
// // //     backgroundColor: "#b15cd6",
// // //     color: "white",
// // //     fontWeight: 'bold',
// // //     fontSize: window.innerWidth < 480 ? "0.7rem" : "0.75rem",
// // //     padding: window.innerWidth < 480 ? "0 12px" : "0 15px",
// // //     cursor: "pointer",
// // //     whiteSpace: "nowrap",
// // //     minWidth: window.innerWidth < 480 ? "70px" : "80px"
// // // };

// // // export default StandardMenu;












// // import React, { useState, useEffect, useRef } from 'react';
// // import './Management2.css';
// // import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
// // import axios from 'axios';
// // import { FaSave, FaSearch, FaTimes } from 'react-icons/fa';
// // import * as XLSX from 'xlsx';
// // import { useLoader } from "../../../../context/LoaderProvider.jsx";

// // const StandardMenu = () => {
// //     const [data, setData] = useState([]);
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);
// //     const [addedItems, setAddedItems] = useState([]);
// //     const [showEditModal, setShowEditModal] = useState(false);
// //     const [editItem, setEditItem] = useState(null);
// //     const [showPopup, setShowPopup] = useState(false);
// //     const [image, setImage] = useState(null);
// //     const [text, setText] = useState('');
// //     const [isVegSelected, setIsVegSelected] = useState(null);
// //     const [dishId, setDishId] = useState(null);
// //     const [chefType, setChefType] = useState("Chef_All");
// //     const [imageFile, setImageFile] = useState(null);
// //     const { showLoader, hideLoader } = useLoader();
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const [searchActive, setSearchActive] = useState(false);
// //     const [showCategorySearchPopup, setShowCategorySearchPopup] = useState(false);
// //     const [categorySearchQuery, setCategorySearchQuery] = useState('');
// //     const [filteredCategories, setFilteredCategories] = useState([]);
// //     const [selectedCategory, setSelectedCategory] = useState(null);

// //     const normalizeForSearch = (text) => {
// //         if (!text) return '';

// //         // Convert to lowercase and replace multiple separators with space
// //         return text
// //             .toLowerCase()
// //             .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
// //             .trim();
// //     };

// //     const handleSearch = (query) => {
// //         const searchTerm = normalizeForSearch(query);
// //         setSearchQuery(query);

// //         if (!searchTerm) {
// //             setSearchActive(false);
// //             applyFilter(data, isVegSelected);
// //             return;
// //         }

// //         setSearchActive(true);

// //         // Create search patterns:
// //         // 1. Exact match (with spaces normalized)
// //         // 2. Without spaces (for "vegmeals")
// //         // 3. Individual words
// //         const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
// //         const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

// //         const searchResults = data.map(category => {
// //             // Normalize category
// //             const normalizedCategory = normalizeForSearch(category.category);
// //             const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

// //             // Check category matches
// //             const categoryMatches =
// //                 normalizedCategory.includes(searchTerm) ||
// //                 categoryWithoutSpaces.includes(searchWithoutSpaces) ||
// //                 searchWords.every(word => normalizedCategory.includes(word));

// //             // Filter subcategories
// //             const filteredSubcategories = category.subcategories?.filter(sub => {
// //                 // Normalize subcategory fields
// //                 const normalizedSubName = normalizeForSearch(sub.subName);
// //                 const normalizedDescription = normalizeForSearch(sub.description);
// //                 const normalizedTag = normalizeForSearch(sub.tag);

// //                 const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
// //                 const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

// //                 // Multiple matching strategies
// //                 const nameMatches =
// //                     normalizedSubName.includes(searchTerm) ||
// //                     subNameWithoutSpaces.includes(searchWithoutSpaces) ||
// //                     searchWords.every(word => normalizedSubName.includes(word));

// //                 const descMatches =
// //                     normalizedDescription.includes(searchTerm) ||
// //                     descWithoutSpaces.includes(searchWithoutSpaces) ||
// //                     searchWords.every(word => normalizedDescription.includes(word));

// //                 const tagMatches =
// //                     normalizedTag.includes(searchTerm) ||
// //                     normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

// //                 return nameMatches || descMatches || tagMatches;
// //             });

// //             // Include category if it matches or has matching subcategories
// //             if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
// //                 return {
// //                     ...category,
// //                     subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// //                 };
// //             }

// //             return null;
// //         }).filter(category => category !== null);

// //         setFilteredData(searchResults);
// //     };


// //     const handleFilterClick = (tag) => {
// //         const vegSelected = tag === 'Veg';
// //         setIsVegSelected(vegSelected);
// //         setSearchActive(false);
// //         setSearchQuery("");
// //         applyFilter(data, vegSelected);
// //     };

// //     const fileInputRef = useRef(null);
// //     const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
// //     const [subDishName, setSubDishName] = useState('');
// //     const [price, setPrice] = useState('');
// //     const [description, setDescription] = useState('');
// //     const [stockQuantity, setStockQuantity] = useState('');
// //     const [gst, setGst] = useState('');
// //     const [discount, setdiscount] = useState('');
// //     const [packingCharges, setPackingCharges] = useState('');
// //     const [tag, setTag] = useState('Veg');
// //     const [stock, setStock] = useState('In Stock');
// //     const [menuStatus, setMenuStatus] = useState(true);
// //     const [parentDishDetails, setParentDishDetails] = useState(null);
// //     const [filteredData, setFilteredData] = useState([]);
// //     const [showSubEditModal, setShowSubEditModal] = React.useState(false);
// //     const [editSubItem, setEditSubItem] = React.useState({
// //         dishId: '',
// //         subName: '',
// //         discount: '',
// //         price: '',
// //         // stockQuantity: '',
// //         gst: '',
// //         packingCharges: '',
// //         image: '',
// //         tag: 'Veg', // Add this line
// //         chefType: '',
// //         parentIndex: null,
// //         subIndex: null,
// //         description: '',
// //     });

// //     const [subCategoryData, setSubCategoryData] = React.useState({
// //         dishImage: '',
// //     });

// //     // const applyFilter = (allData, vegOnly) => {
// //     //     if (vegOnly === null) {
// //     //         setFilteredData(allData);
// //     //         return;
// //     //     }

// //     //     const filtered = allData.map(category => {
// //     //         const filteredSubcategories = category.subcategories.filter(
// //     //             sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// //     //         );

// //     //         return {
// //     //             ...category,
// //     //             subcategories: filteredSubcategories
// //     //         };
// //     //     }).filter(cat => cat.subcategories.length > 0);

// //     //     setFilteredData(filtered);
// //     // };
// //     const applyFilter = (allData, vegOnly) => {
// //         let filtered = allData;

// //         // Apply category filter if selected
// //         if (selectedCategory) {
// //             filtered = filtered.filter(item => item.category === selectedCategory);
// //         }

// //         // Apply veg filter if selected
// //         if (vegOnly !== null) {
// //             filtered = filtered.map(category => {
// //                 const filteredSubcategories = category.subcategories.filter(
// //                     sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// //                 );
// //                 return {
// //                     ...category,
// //                     subcategories: filteredSubcategories
// //                 };
// //             }).filter(cat => cat.subcategories.length > 0);
// //         }

// //         // Apply search if active
// //         if (searchActive && searchQuery) {
// //             filtered = filtered.map(category => {
// //                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
// //                 const filteredSubcategories = category.subcategories.filter(sub =>
// //                     sub.subName?.toLowerCase().includes(searchQuery) ||
// //                     sub.description?.toLowerCase().includes(searchQuery)
// //                 );

// //                 if (categoryMatches || filteredSubcategories.length > 0) {
// //                     return {
// //                         ...category,
// //                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// //                     };
// //                 }
// //                 return null;
// //             }).filter(category => category !== null);
// //         }

// //         setFilteredData(filtered);
// //     };


// //     const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
// //         try {
// //             setDishId(subDishId);
// //             const token = localStorage.getItem("authToken");

// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             const subDish = response.data;

// //             setEditSubItem({
// //                 dishId: subDish.dishId,
// //                 subName: subDish.dishName || '',
// //                 price: subDish.price || '',
// //                 discount: subDish.discount || '',
// //                 // stockQuantity: subDish.stockQuantity || '',
// //                 gst: subDish.gst || '',
// //                 packingCharges: subDish.packingCharges || '',
// //                 image: subDish.dishImage || '',
// //                 chefType: subDish.chefType || '',
// //                 chefType: subDish.chefType || 'Chef_All', // Add this line
// //                 tag: subDish.tag || 'Veg', // Add this line
// //                 parentIndex,
// //                 subIndex,
// //                 description: subDish.description || '',
// //             });

// //             setShowSubEditModal(true);
// //         } catch (error) {
// //             alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
// //             console.error(error);
// //         }
// //     };

// //     const submitEditSubcategory = async () => {
// //         if (!editSubItem || !editSubItem.dishId) {
// //             alert("Subcategory Dish ID is missing!");
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const token = localStorage.getItem("authToken");
// //             if (!token) {
// //                 alert("Authentication token not found!");
// //                 return;
// //             }

// //             const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

// //             const formData = new FormData();
// //             const dishData = {
// //                 dishName: editSubItem.subName,
// //                 price: editSubItem.price,
// //                 stockQuantity: editSubItem.stockQuantity,
// //                 gst: editSubItem.gst,
// //                 packingCharges: editSubItem.packingCharges,
// //                 discount: editSubItem.discount,
// //                 tag: editSubItem.tag || 'Veg', // Add this line
// //                 chefType: editSubItem.chefType || 'Chef_All', // Add this line
// //                 description: editSubItem.description,
// //             };

// //             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

// //             if (editSubItem.newImageFile) {
// //                 formData.append("image", editSubItem.newImageFile);
// //             }

// //             const response = await axios.put(url, formData, {
// //                 headers: {
// //                     "Authorization": `Bearer ${token}`,
// //                     "Content-Type": "multipart/form-data",
// //                 },
// //             });

// //             alert("Subcategory updated successfully!");
// //             window.location.reload();
// //         } catch (error) {
// //             console.error("Error updating subcategory:", error);
// //             if (error.response) {
// //                 alert(`Failed to update subcategory: ${error.response.data.message || error.response.data}`);
// //             } else {
// //                 alert(`Failed to update subcategory: ${error.message}`);
// //             }
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleAddSubCategory = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         if (!token) {
// //             alert("Authentication token missing. Please log in again.");
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/get/${dishId}`,
// //                 {
// //                     method: 'GET',
// //                     headers: {
// //                         'Content-Type': 'application/json',
// //                         'Authorization': `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             if (!response.ok) {
// //                 throw new Error(`HTTP error! status: ${response.status}`);
// //             }

// //             const dishData = await response.json();
// //             setParentDishDetails(dishData);
// //             setShowSubcategoryPopup(true);

// //         } catch (error) {
// //             console.error("Failed to fetch dish data:", error);
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleSubImageChange = (e) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             setImageFile(file);
// //             const reader = new FileReader();
// //             reader.onloadend = () => setImage(reader.result);
// //             reader.readAsDataURL(file);
// //         }
// //     };

// //     const handleSubcategorySubmit = async () => {
// //         // if (!imageFile) {
// //         //     alert("Please select an image.");
// //         //     return;
// //         // }

// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             alert("Vendor ID not found. Please log in again.");
// //             return;
// //         }

// //         if (!token) {
// //             alert("Authentication token missing. Please log in again.");
// //             return;
// //         }

// //         const formData = new FormData();
// //         const dishData = {
// //             dishId: 0,
// //             price: parseFloat(price) || 0,
// //             dishName: subDishName.trim() || "Unnamed Dish",
// //             parentId: Number(parentDishDetails?.dishId) || 1,
// //             stockQuantity: stockQuantity || 0,
// //             gst: gst || 0,
// //             packingCharges: packingCharges || 0,
// //             discount: discount || 0,
// //             tag: tag || "Veg",
// //             stock: stock ? "In_Stock" : "Out_of_Stock",
// //             menuStatus: menuStatus ? "Enable" : "Disable",
// //             description: description?.trim() || "",
// //             consumedQuantity: 0,
// //             balanceQuantity: 0,
// //             effectivePrice: 0,
// //             chefType: chefType || "Chef_All"
// //         };

// //         formData.append(
// //             "dishData",
// //             new Blob([JSON.stringify(dishData)], { type: "application/json" })
// //         );

// //         formData.append("image", imageFile);

// //         try {
// //             showLoader();
// //             const res = await axios.post(
// //                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
// //                 formData,
// //                 {
// //                     headers: {
// //                         "Authorization": `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             alert("Dish added successfully!");
// //             window.location.reload();

// //             setSubDishName('');
// //             setPrice('');
// //             // setStockQuantity('');
// //             setGst('');
// //             setPackingCharges('');
// //             setTag('Veg');
// //             setStock('In Stock');
// //             setMenuStatus(true);
// //             setSubCategoryData({ dishImage: '' });
// //             setdiscount('');
// //             setImage(null);
// //             setImageFile(null);

// //             fetchData();
// //         } catch (error) {
// //             console.error("❌ Error response:", error.response?.data || error.message);
// //             const message =
// //                 error.response?.data?.error ||
// //                 error.response?.data?.message ||
// //                 error.message ||
// //                 "Unknown error";
// //             alert("Upload failed!\n" + message);
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleSave = async () => {
// //         // if (!text.trim() || !imageFile) {
// //         //     alert("Please provide both the dish name and image.");
// //         //     return;
// //         // }

// //         if (!text.trim()) {
// //             alert("Please provide the dish name.");
// //             return;
// //         }
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             alert("Vendor ID not found. Please log in again.");
// //             return;
// //         }

// //         if (!token) {
// //             alert("Authentication token missing. Please log in again.");
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const formData = new FormData();
// //             const dishData = {
// //                 dishId: 0,
// //                 price: 0,
// //                 dishName: text.trim(),
// //                 parentId: 0,
// //                 stockQuantity: 0,
// //                 gst: 0,
// //                 packingCharges: 0,
// //             };

// //             formData.append(
// //                 "dishData",
// //                 new Blob([JSON.stringify(dishData)], { type: "application/json" })
// //             );

// //             formData.append("image", imageFile);

// //             const response = await axios.post(
// //                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
// //                 formData,
// //                 {
// //                     headers: {
// //                         Authorization: `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             alert("Item added successfully!");
// //             setShowPopup(false);
// //             setText("");
// //             setImage(null);
// //             setImageFile(null);
// //             window.location.reload();
// //         } catch (error) {
// //             console.error("Upload failed:", error.response?.data || error.message);
// //             alert("Failed to add item: " + (error.response?.data?.message || "Please Uplode Documents"));
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleExport = () => {
// //         if (!filteredData || filteredData.length === 0) {
// //             alert("No data available to export.");
// //             return;
// //         }

// //         const exportData = [];

// //         filteredData.forEach((category, index) => {
// //             exportData.push({
// //                 "S.No": index + 1,
// //                 "Category": category.category || "",
// //                 "Subcategory": "",
// //                 "Price": category.price || "",
// //                 "GST": category.gst || "",
// //                 "Packing": category.packingCharges || "",
// //                 "Chef Type": category.chefType || "",
// //                 "Description": category.description || "",
// //             });

// //             if (category.subcategories && category.subcategories.length > 0) {
// //                 category.subcategories.forEach((sub) => {
// //                     exportData.push({
// //                         "S.No": "",
// //                         "Category": category.categoryName || "",
// //                         "Subcategory": sub.subName || "",
// //                         "Price": sub.price ? `${sub.price}.Rs` : "",
// //                         "GST": sub.gst ? `${sub.gst}%` : "",
// //                         "Packing": sub.packingCharges ? `${sub.packingCharges}.Rs` : "",
// //                         "Chef Type": sub.chefType || "",
// //                         "Description": sub.description || "",
// //                     });
// //                 });
// //             }
// //         });

// //         const worksheet = XLSX.utils.json_to_sheet(exportData);
// //         const workbook = XLSX.utils.book_new();
// //         XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

// //         const colWidths = Object.keys(exportData[0]).map((key) => ({
// //             wch: Math.max(
// //                 key.length,
// //                 ...exportData.map((row) => String(row[key] || "").length)
// //             ),
// //         }));
// //         worksheet["!cols"] = colWidths;

// //         XLSX.writeFile(workbook, "menu_data_export.xlsx");
// //     };

// //     const handleFileImport = async (e) => {
// //         const file = e.target.files[0];
// //         if (!file) return alert("Please choose a file.");

// //         const vendorId = localStorage.getItem("vendorId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId) return alert("Vendor ID not found in local storage.");
// //         if (!authToken) return alert("No auth token found. Please log in first.");

// //         const formData = new FormData();
// //         formData.append("file", file);

// //         try {
// //             const response = await axios.post(
// //                 `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
// //                 formData,
// //                 {
// //                     headers: {
// //                         "Content-Type": "multipart/form-data",
// //                         Authorization: `Bearer ${authToken}`,
// //                     },
// //                 }
// //             );

// //             alert("✅ Categories imported successfully!");
// //             setTimeout(() => window.location.reload(), 1000);

// //         } catch (error) {
// //             console.error("❌ Import failed:", error);
// //             if (error.response) {
// //                 alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
// //             } else {
// //                 alert("❌ Import failed: Network or unknown error.");
// //             }
// //         }
// //     };

// //     const handleEdit = async (id) => {
// //         try {
// //             setDishId(id);
// //             const token = localStorage.getItem("authToken");
// //             const vendorId = localStorage.getItem("vendorId");
// //             if (!token) {
// //                 alert("Authentication token missing. Please log in again.");
// //                 return;
// //             }
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                 {
// //                     headers: {
// //                         "Authorization": `Bearer ${token}`,
// //                         "Content-Type": "application/json",
// //                     },
// //                 }
// //             );


// //             const dishes = Array.isArray(response.data)
// //                 ? response.data
// //                 : response.data.data || [];

// //             const dish = dishes.find((d) => d.dishId == id);

// //             if (!dish) {
// //                 alert(`Dish with ID ${id} not found`);
// //                 return;
// //             }

// //             setEditItem({
// //                 dishId: dish.dishId,
// //                 dishName: dish.dishName || "",
// //                 image: dish.dishImage || "",
// //             });

// //             setShowEditModal(true);
// //         } catch (error) {
// //             console.error("Error fetching dish details:", error);
// //             alert(
// //                 "Error fetching dish details:\n" +
// //                 (error.response?.data?.message || error.message)
// //             );
// //         }
// //     };

// //     const submitEdit = async () => {
// //         if (!editItem.dishId) {
// //             alert("Dish ID is missing!");
// //             return;
// //         }

// //         const token = localStorage.getItem("authToken");
// //         if (!token) {
// //             alert("Authentication token missing. Please log in again.");
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

// //             const formData = new FormData();
// //             const dishData = {
// //                 dishName: editItem.dishName,
// //             };
// //             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

// //             if (editItem.newImageFile) {
// //                 formData.append("image", editItem.newImageFile);
// //             }

// //             const response = await axios.put(url, formData, {
// //                 headers: {
// //                     "Authorization": `Bearer ${token}`,
// //                     "Content-Type": "multipart/form-data",
// //                 },
// //             });

// //             alert('Dish updated successfully!');
// //             window.location.reload();
// //             setShowEditModal(false);

// //         } catch (error) {
// //             console.error("Error updating dish:", error);
// //             if (error.response) {
// //                 alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
// //             } else {
// //                 alert(`Failed to update dish: ${error.message}`);
// //             }
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleEditImageChange = (e) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             setEditItem(prev => ({
// //                 ...prev,
// //                 newImageFile: file,
// //                 image: URL.createObjectURL(file)
// //             }));
// //         }
// //     };

// //     const fetchData = async () => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId) {
// //             console.warn("⚠️ vendorId not found in localStorage");
// //             setError(new Error("vendorId missing"));
// //             setLoading(false);
// //             return;
// //         }

// //         if (!token) {
// //             console.warn("⚠️ authToken not found in localStorage");
// //             setError(new Error("authToken missing"));
// //             setLoading(false);
// //             return;
// //         }

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                 {
// //                     headers: {
// //                         "Content-Type": "application/json",
// //                         "Authorization": `Bearer ${token}`
// //                     }
// //                 }
// //             );

// //             if (!response.ok) {
// //                 throw new Error(`HTTP error! status: ${response.status}`);
// //             }

// //             const dishData = await response.json();

// //             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

// //             const formattedData = parentCategories.map(category => {
// //                 const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

// //                 return {
// //                     dishId: category.dishId,
// //                     SNo: category.dishId,
// //                     category: category.dishName,
// //                     image: category.dishImage || '',
// //                     isChecked: false,
// //                     parentId: category.parentId,
// //                     id: category.dishId,
// //                     isAdded: true,
// //                     menuStatus: category.menuStatus || "Enable", // Ensure this exists
// //                     // Categories should NOT have tag/type and description
// //                     subcategories: subcategories.map(sub => ({
// //                         dishId: sub.dishId,
// //                         subName: sub.subName || sub.dishName,
// //                         price: sub.price || 0,
// //                         description: sub.description || "",
// //                         image: sub.dishImage,
// //                         tag: sub.tag || "Veg", // Type only for subcategories
// //                         gst: sub.gst || 0,
// //                         packingCharges: sub.packingCharges || 0,
// //                         discount: sub.discount || 0,
// //                         chefType: sub.chefType || 0,
// //                         menuStatus: sub.menuStatus || "Enable", // ADD THIS
// //                     }))
// //                 };
// //             });

// //             setData(formattedData);
// //             applyFilter(formattedData, isVegSelected);

// //             setData(formattedData);
// //             setSearchQuery(""); // Clear search
// //             setSearchActive(false); // Reset search state
// //             applyFilter(formattedData, isVegSelected);

// //         } catch (error) {
// //             setError(error);
// //         } finally {
// //             setLoading(false);
// //             hideLoader();
// //         }
// //     };

// //     useEffect(() => {
// //         fetchData();
// //     }, []);

// //     const handleCheckboxChange = (e, index) => {
// //         const { checked } = e.target;
// //         setData(prevData => {
// //             const updatedData = [...prevData];
// //             updatedData[index].isChecked = checked;
// //             return updatedData;
// //         });
// //     };

// //     const handleSelectAll = (e) => {
// //         const isChecked = e.target.checked;
// //         setData(prevData =>
// //             prevData.map(item => ({
// //                 ...item,
// //                 isChecked: isChecked,
// //             }))
// //         );
// //     };

// //     const handleImageChange = (e) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             const reader = new FileReader();
// //             reader.onloadend = () => {
// //                 setImage(reader.result);
// //             };
// //             reader.readAsDataURL(file);
// //         }
// //     };

// //     // In StandardMenu.jsx, update the handleToggleStatus function:
// //     const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

// //         const vendorId = localStorage.getItem("vendorId");
// //         const authToken = localStorage.getItem("authToken");

// //         if (!vendorId || !authToken) {
// //             alert("Authentication failed. Please login again.");
// //             return;
// //         }

// //         const isCategory = (subIndex === null || subIndex === undefined);
// //         const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

// //         // ✅ FIX: Update local state IMMEDIATELY
// //         if (isCategory) {
// //             // For category: Update category and all its subcategories
// //             setData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index] = {
// //                     ...updatedData[index],
// //                     menuStatus: newStatus,
// //                     subcategories: updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         menuStatus: newStatus
// //                     }))
// //                 };
// //                 return updatedData;
// //             });

// //             // Also update filteredData immediately
// //             setFilteredData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index] = {
// //                     ...updatedData[index],
// //                     menuStatus: newStatus,
// //                     subcategories: updatedData[index].subcategories.map(sub => ({
// //                         ...sub,
// //                         menuStatus: newStatus
// //                     }))
// //                 };
// //                 return updatedData;
// //             });
// //         } else {
// //             // For subcategory
// //             setData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index].subcategories[subIndex] = {
// //                     ...updatedData[index].subcategories[subIndex],
// //                     menuStatus: newStatus
// //                 };
// //                 return updatedData;
// //             });

// //             setFilteredData(prevData => {
// //                 const updatedData = [...prevData];
// //                 updatedData[index].subcategories[subIndex] = {
// //                     ...updatedData[index].subcategories[subIndex],
// //                     menuStatus: newStatus
// //                 };
// //                 return updatedData;
// //             });
// //         }

// //         // Make API call
// //         try {
// //             const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
// //             const payload = { menuStatus: newStatus };

// //             await axios.put(url, payload, {
// //                 headers: {
// //                     'Content-Type': 'application/json',
// //                     'Authorization': `Bearer ${authToken}`,
// //                 },
// //             });


// //             // If category, update all subcategories too
// //             if (isCategory) {
// //                 const category = data[index];
// //                 if (category.subcategories && category.subcategories.length > 0) {
// //                     for (const sub of category.subcategories) {
// //                         const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
// //                         const subPayload = { menuStatus: newStatus };

// //                         await axios.put(subUrl, subPayload, {
// //                             headers: {
// //                                 'Content-Type': 'application/json',
// //                                 'Authorization': `Bearer ${authToken}`,
// //                             },
// //                         });
// //                     }
// //                 }
// //             }

// //             localStorage.setItem(`menuStatus-${dishId}`, newStatus);

// //         } catch (error) {
// //             console.error('❌ Failed to toggle menu visibility:', error);
// //             alert('Failed to update menu visibility. Please refresh the page.');

// //             // Revert on error
// //             if (isCategory) {
// //                 setData(prevData => {
// //                     const updatedData = [...prevData];
// //                     updatedData[index] = {
// //                         ...updatedData[index],
// //                         menuStatus: currentStatus,
// //                         subcategories: updatedData[index].subcategories.map(sub => ({
// //                             ...sub,
// //                             menuStatus: sub.menuStatus
// //                         }))
// //                     };
// //                     return updatedData;
// //                 });
// //             }
// //         }
// //     };

// //     const handleDeleteRow = async (index, dishId) => {
// //         if (!window.confirm("Are you sure you want to delete this dish?")) return;

// //         const token = localStorage.getItem("authToken");

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
// //                 {
// //                     method: "DELETE",
// //                     headers: {
// //                         "Authorization": `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             if (response.ok) {
// //                 alert("Dish deleted successfully!");
// //                 const newData = data.filter(item => item.SNo !== dishId);
// //                 setData(newData);
// //             } else {
// //                 const result = await response.json();
// //                 alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
// //             }
// //         } catch (error) {
// //             alert("An error occurred while deleting.");
// //             console.error(error);
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
// //         if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

// //         const token = localStorage.getItem("authToken");

// //         try {
// //             showLoader();
// //             const response = await fetch(
// //                 `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
// //                 {
// //                     method: "DELETE",
// //                     headers: {
// //                         "Authorization": `Bearer ${token}`,
// //                     },
// //                 }
// //             );

// //             if (response.ok) {
// //                 alert("Subcategory deleted successfully!");

// //                 setData(prevData => {
// //                     const newData = [...prevData];
// //                     const updatedSubcategories = [...newData[parentIndex].subcategories];
// //                     updatedSubcategories.splice(subIndex, 1);
// //                     newData[parentIndex] = {
// //                         ...newData[parentIndex],
// //                         subcategories: updatedSubcategories,
// //                     };
// //                     return newData;
// //                 });
// //             } else {
// //                 const result = await response.json();
// //                 alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
// //             }
// //         } catch (error) {
// //             alert("An error occurred while deleting the subcategory.");
// //             console.error(error);
// //         } finally {
// //             hideLoader();
// //         }
// //     };

// //     const handleInputChange = (e, index) => {
// //         const { name, value } = e.target;
// //         setData(prevData => {
// //             const updatedData = [...prevData];
// //             updatedData[index][name] = value;
// //             return updatedData;
// //         });
// //     };
// //     useEffect(() => {
// //         const handleGlobalKeyDown = (e) => {
// //             const isTypingInInput =
// //                 e.target.tagName === 'INPUT' ||
// //                 e.target.tagName === 'TEXTAREA' ||
// //                 e.target.isContentEditable;

// //             // Focus search when '/' is pressed
// //             if (e.key === '/' && !isTypingInInput) {
// //                 e.preventDefault();
// //                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
// //                 if (searchInput) {
// //                     searchInput.focus();
// //                     searchInput.select();
// //                 }
// //             }

// //             // Clear search with Escape
// //             if (e.key === 'Escape' && searchQuery) {
// //                 e.preventDefault();
// //                 setSearchQuery("");
// //                 setSearchActive(false);
// //                 applyFilter(data, isVegSelected);
// //             }
// //         };

// //         window.addEventListener('keydown', handleGlobalKeyDown);
// //         return () => {
// //             window.removeEventListener('keydown', handleGlobalKeyDown);
// //         };
// //     }, [searchQuery, data, isVegSelected]);
// //     // Responsive styles
// //     const getResponsiveValue = (mobile, tablet, desktop) => {
// //         const width = window.innerWidth;
// //         if (width < 768) return mobile;
// //         if (width < 1024) return tablet;
// //         return desktop;
// //     };

// //     // Function to handle category column click
// //     const handleCategoryColumnClick = () => {
// //         // Extract all unique categories from data
// //         const categories = Array.from(new Set(data.map(item => item.category)))
// //             .filter(Boolean)
// //             .map(category => ({
// //                 name: category,
// //                 count: data.filter(item => item.category === category).length
// //             }));

// //         setFilteredCategories(categories);
// //         setShowCategorySearchPopup(true);
// //         setCategorySearchQuery('');
// //     };

// //     // Function to filter categories based on search
// //     const handleCategorySearch = (query) => {
// //         setCategorySearchQuery(query);
// //         const allCategories = Array.from(new Set(data.map(item => item.category)))
// //             .filter(Boolean)
// //             .map(category => ({
// //                 name: category,
// //                 count: data.filter(item => item.category === category).length
// //             }));

// //         if (!query.trim()) {
// //             setFilteredCategories(allCategories);
// //             return;
// //         }

// //         const filtered = allCategories.filter(category =>
// //             category.name.toLowerCase().includes(query.toLowerCase())
// //         );
// //         setFilteredCategories(filtered);
// //     };

// //     // Function to select a category
// //     // Function to select a category
// //     const handleCategorySelect = (categoryName) => {
// //         setSelectedCategory(categoryName);

// //         let filtered = data;

// //         // Apply category filter if selected
// //         if (categoryName) {
// //             filtered = filtered.filter(item => item.category === categoryName);
// //         }

// //         // Apply veg filter if selected
// //         if (isVegSelected !== null) {
// //             filtered = filtered.map(category => {
// //                 const filteredSubcategories = category.subcategories.filter(
// //                     sub => isVegSelected ? sub.tag === "Veg" : sub.tag === "Non_Veg"
// //                 );
// //                 return {
// //                     ...category,
// //                     subcategories: filteredSubcategories
// //                 };
// //             }).filter(cat => cat.subcategories.length > 0);
// //         }

// //         // Apply search if active
// //         if (searchActive && searchQuery) {
// //             filtered = filtered.map(category => {
// //                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
// //                 const filteredSubcategories = category.subcategories.filter(sub =>
// //                     sub.subName?.toLowerCase().includes(searchQuery) ||
// //                     sub.description?.toLowerCase().includes(searchQuery)
// //                 );

// //                 if (categoryMatches || filteredSubcategories.length > 0) {
// //                     return {
// //                         ...category,
// //                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
// //                     };
// //                 }
// //                 return null;
// //             }).filter(category => category !== null);
// //         }

// //         applyFilter(data, isVegSelected);
// //         setFilteredData(filtered);
// //         setShowCategorySearchPopup(false);
// //         setCategorySearchQuery('');
// //     };

// //     // Add this useEffect to your component
// //     useEffect(() => {
// //         // This will run whenever selectedCategory changes
// //         applyFilter(data, isVegSelected);
// //     }, [selectedCategory, data, isVegSelected]);

// //     // Update clearCategoryFilter to just set state
// //     const clearCategoryFilter = () => {
// //         setSelectedCategory(null);
// //         // Remove search query too
// //         setSearchQuery("");
// //         setSearchActive(false);
// //         // The useEffect above will handle the re-filtering
// //     };

// //     // const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

// //     const modalStyle = {
// //         position: 'fixed',
// //         top: '50%',
// //         left: '50%',
// //         transform: 'translate(-50%, -50%)',
// //         backgroundColor: 'white',
// //         padding: '20px',
// //         borderRadius: '10px',
// //         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
// //         zIndex: 1000,
// //         width: '400px',
// //     };

// //     const inputContainerStyle = {
// //         marginBottom: '15px',
// //     };

// //     const inputFieldStyle = {
// //         width: '100%',
// //         padding: '8px',
// //         fontSize: '14px',
// //         borderRadius: '5px',
// //         border: '1px solid #ddd',
// //     };

// //     const imagePreviewStyle = {
// //         cursor: 'pointer',
// //         display: 'flex',
// //         justifyContent: 'center',
// //         alignItems: 'center',
// //         width: '100px',
// //         height: '100px',
// //         margin: '10px 0',
// //         borderRadius: '10px',
// //         border: '1px solid #ccc',
// //         overflow: 'hidden',
// //     };

// //     const imageStyle = {
// //         width: '100%',
// //         height: '100%',
// //         objectFit: 'cover',
// //     };

// //     const buttonContainerStyle = {
// //         display: 'flex',
// //         justifyContent: 'center',
// //         marginTop: '20px',
// //         textAlign: "center"
// //     };

// //     const closeButtonStyle = {
// //         position: 'absolute',
// //         top: '10px',
// //         right: '10px',
// //         cursor: 'pointer',
// //     };

// //     const closeIconStyle = {
// //         fontSize: '24px',
// //         fontWeight: 'bold',
// //         marginBottom: '30px',
// //         color: '#888',
// //     };

// //     const buttonStyle = {
// //         height: "32px",
// //         backgroundColor: '#b15cd6',
// //         color: 'white',
// //         border: 'none',
// //         borderRadius: '5px',
// //         cursor: 'pointer',
// //         fontSize: '14px',
// //         fontWeight: "bold",
// //         marginTop: "10px"
// //     };

// //     const styles = {
// //         overlay: {
// //             position: 'fixed',
// //             top: 0, left: 0, right: 0, bottom: 0,
// //             backgroundColor: 'rgba(0,0,0,0.5)',
// //             display: 'flex', alignItems: 'center', justifyContent: 'center',
// //             zIndex: 1000,
// //             padding: '10px',
// //         },
// //         popup: {
// //             background: '#fff',
// //             padding: '20px',
// //             borderRadius: '8px',
// //             width: '300px',
// //             maxWidth: '95vw',
// //             boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
// //             textAlign: 'center',
// //             position: 'relative',
// //         },
// //         image: {
// //             width: '100%',
// //             marginTop: '10px',
// //             borderRadius: '5px',
// //         },
// //         input: {
// //             marginTop: '10px',
// //             padding: '8px',
// //             width: '100%',
// //             borderRadius: '5px',
// //             border: '1px solid #ccc',
// //             fontSize: '14px',
// //             boxSizing: 'border-box',
// //         },
// //         buttons: {
// //             marginTop: '15px',
// //             display: 'flex',
// //             justifyContent: 'center'
// //         },
// //         saveBtn: {
// //             padding: '8px 12px',
// //             backgroundColor: '#4CAF50',
// //             color: 'white',
// //             border: 'none',
// //             borderRadius: '5px',
// //             cursor: 'pointer',
// //             fontSize: '14px',
// //         },
// //         cancelBtn: {
// //             padding: '8px 12px',
// //             backgroundColor: '#f44336',
// //             color: 'white',
// //             border: 'none',
// //             borderRadius: '5px',
// //         }
// //     };
// //     const containerHeight = window.innerWidth < 768
// //         ? '50vh'
// //         : window.innerWidth < 850
// //             ? '60vhpx'
// //             : window.innerWidth < 1350
// //                 ? '50vh'
// //                 : '510px';

// //     return (
// //         <div style={{ marginTop: "0px" }}>
// //             <div style={{ position: 'relative', top: '-11px', }} className='standard-menu'>
// //                 <style>
// //                     {`
// //                .custom-switch {
// //             position: relative;
// //             display: inline-block;
// //             width: 100px;
// //             height: 35px;
// //             margin-top:11px;
// //           }

// //           .custom-switch input {
// //             opacity: 0;
// //             width: 0;
// //             height: 0;
// //           }

// //           .custom-slider {
// //             position: absolute;
// //             cursor: pointer;
// //             transition: 0.4s;
// //             margin-left:-315px;
// //             font-weight: bold;
// //             font-size: 14px;
// //             color: #000;
// //             textAlign: center;
// //             line-height: 35px;
// //             width: 100px;
// //             height: 40px;
// //             border-radius:5px;
// //             background-color: rgb(217, 217, 217);
// //           }

// //    .custom-slider::before {
// //   content: "";
// //   position: absolute;
// //   height: 16px;
// //   width: 16px;
// //   left: 3px;
// //   top: 10px;
// //   background-color: #000; /* default */
// //   transition: 0.4s;
// //   border-radius: 50%;
// // }

// // .custom-slider.veg::before {
// //   background-color: green;
// // }

// // .custom-slider.non-veg::before {
// //   background-color: red;
// // }
// //   .scrollbar-w-auto::-webkit-scrollbar {
// //     width: 16px !important;
// //     height: 16px !important;
// // }
// //         `}
// //                 </style>
// //             </div>

// //             {window.innerWidth < 768 ? null : (<br></br>)}
// //             <div style={{
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 marginBottom: '0px',
// //                 width: '100%',
// //                 padding: window.innerWidth < 768 ? '0px' : '0'
// //             }}>
// //                 {showPopup && (
// //                     <div style={styles.overlay}>
// //                         <div style={{
// //                             ...styles.popup,
// //                             width: window.innerWidth < 480 ? '280px' : '300px',
// //                             padding: window.innerWidth < 480 ? '15px' : '20px'
// //                         }}>
// //                             <div
// //                                 style={{
// //                                     position: "absolute",
// //                                     fontSize: window.innerWidth < 480 ? "18px" : "20px",
// //                                     cursor: "pointer",
// //                                     color: "#888",
// //                                     fontWeight: "bold",
// //                                     right: window.innerWidth < 480 ? "10px" : "10px",
// //                                     top: window.innerWidth < 480 ? "10px" : "10px",
// //                                     zIndex: 1
// //                                 }}
// //                                 onClick={() => setShowPopup(false)}
// //                             >
// //                                 ×
// //                             </div>

// //                             <h3 style={{
// //                                 fontSize: window.innerWidth < 480 ? '16px' : '18px',
// //                                 marginTop: window.innerWidth < 480 ? '5px' : '0'
// //                             }}>Add Item</h3>

// //                             <div
// //                                 style={{
// //                                     width: "100%",
// //                                     maxWidth: window.innerWidth < 480 ? "150px" : "175px",
// //                                     minHeight: window.innerWidth < 480 ? "120px" : "138px",
// //                                     border: "2px dashed #bbb",
// //                                     borderRadius: "10px",
// //                                     margin: "15px auto",
// //                                     display: "flex",
// //                                     alignItems: "center",
// //                                     justifyContent: "center",
// //                                     cursor: "pointer",
// //                                     backgroundColor: "#fafafa",
// //                                     transition: "border-color 0.3s",
// //                                 }}
// //                                 onClick={() => fileInputRef.current?.click()}
// //                                 onMouseEnter={(e) =>
// //                                     (e.currentTarget.style.borderColor = "#00b894")
// //                                 }
// //                                 onMouseLeave={(e) =>
// //                                     (e.currentTarget.style.borderColor = "#bbb")
// //                                 }
// //                             >
// //                                 {image ? (
// //                                     <img
// //                                         src={image}
// //                                         alt="Preview"
// //                                         style={{
// //                                             width: "100%",
// //                                             height: "100%",
// //                                             objectFit: "contain",
// //                                             borderRadius: "10px",
// //                                         }}
// //                                     />
// //                                 ) : (
// //                                     <div
// //                                         style={{
// //                                             fontSize: window.innerWidth < 480 ? "40px" : "50px",
// //                                             color: "#ccc",
// //                                             fontWeight: "bold",
// //                                             userSelect: "none",
// //                                         }}
// //                                     >
// //                                         +
// //                                     </div>
// //                                 )}
// //                             </div>

// //                             <input
// //                                 ref={fileInputRef}
// //                                 type="file"
// //                                 accept="image/*"
// //                                 style={{ display: "none" }}
// //                                 onClick={(e) => {
// //                                     e.target.value = null;
// //                                 }}
// //                                 onChange={(e) => {
// //                                     const file = e.target.files[0];
// //                                     if (file) {
// //                                         setImageFile(file);
// //                                         const reader = new FileReader();
// //                                         reader.onloadend = () => setImage(reader.result);
// //                                         reader.readAsDataURL(file);
// //                                     }
// //                                 }}
// //                             />

// //                             <input
// //                                 type="text"
// //                                 placeholder="Enter Category"
// //                                 value={text}
// //                                 onChange={(e) => setText(e.target.value)}
// //                                 style={{
// //                                     ...styles.input,
// //                                     fontSize: window.innerWidth < 480 ? '13px' : '14px',
// //                                     padding: window.innerWidth < 480 ? '6px 10px' : '8px 12px',
// //                                     marginTop: window.innerWidth < 480 ? '5px' : '10px'
// //                                 }}
// //                             />

// //                             <div style={{
// //                                 ...styles.buttons,
// //                                 marginTop: window.innerWidth < 480 ? '10px' : '15px'
// //                             }}>
// //                                 <button onClick={handleSave} style={{
// //                                     ...styles.saveBtn,
// //                                     padding: window.innerWidth < 480 ? '6px 12px' : '8px 16px',
// //                                     fontSize: window.innerWidth < 480 ? '13px' : '14px'
// //                                 }}>
// //                                     Save
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 )}

// //                 {/* Main Controls Container */}
// //                 <div style={{
// //                     display: 'flex',
// //                     flexDirection: window.innerWidth < 768 ? 'column-reverse' : 'row',
// //                     justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
// //                     alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
// //                     marginBottom: window.innerWidth < 768 ? '15px' : '0px',
// //                     gap: window.innerWidth < 768 ? '15px' : '10px',
// //                     width: '100%',
// //                     padding: window.innerWidth < 768 ? '0' : '0px',
// //                     marginTop: window.innerWidth < 768 ? "18px" : "6px",
// //                 }}>
// //                     {/* Buttons Group */}
// //                     <div style={{
// //                         display: 'flex',
// //                         flexDirection: 'row',
// //                         gap: '10px',
// //                         justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
// //                         alignItems: 'center',
// //                         flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
// //                         width: window.innerWidth < 768 ? '100%' : 'auto',
// //                         marginTop: window.innerWidth < 768 ? '0' : '-70px'
// //                     }}>
// //                         <input
// //                             type="file"
// //                             accept=".xlsx, .xls"
// //                             ref={fileInputRef}
// //                             onChange={handleFileImport}
// //                             style={{ display: 'none' }}
// //                         />

// //                         <button
// //                             style={{
// //                                 ...importExportButton,
// //                                 height: window.innerWidth < 480 ? '32px' : '35px',
// //                                 padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// //                                 fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// //                                 marginTop: window.innerWidth < 768 ? '0' : '10px',
// //                                 whiteSpace: 'nowrap'
// //                             }}
// //                             onClick={() => fileInputRef.current.click()}
// //                         >
// //                             Import
// //                         </button>

// //                         <button style={{
// //                             ...importExportButton,
// //                             height: window.innerWidth < 480 ? '32px' : '35px',
// //                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// //                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// //                             marginTop: window.innerWidth < 768 ? '0' : '10px',
// //                             whiteSpace: 'nowrap'
// //                         }} onClick={handleExport}>
// //                             Export
// //                         </button>

// //                         <button style={{
// //                             ...importExportButton,
// //                             height: window.innerWidth < 480 ? '32px' : '35px',
// //                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
// //                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
// //                             marginTop: window.innerWidth < 768 ? '0' : '10px',
// //                             whiteSpace: 'nowrap'
// //                         }}
// //                             onClick={() => setShowPopup(true)}
// //                         >
// //                             Add Category
// //                         </button>
// //                     </div>
// //                     {/* Search Bar */}
// //                     <div style={{
// //                         position: 'relative',
// //                         width: window.innerWidth < 768 ? '100%' : 'auto',
// //                         minWidth: window.innerWidth < 480 ? '150px' : '200px',
// //                         maxWidth: window.innerWidth < 768 ? '100%' : '300px',
// //                         marginTop: window.innerWidth < 768 ? '0' : '-70px',
// //                         marginRight: window.innerWidth < 768 ? '0' : '10px',
// //                         order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
// //                         zIndex: 1 // Ensure it's above other elements
// //                     }}>
// //                         <input
// //                             type="text"
// //                             placeholder="Search dishes or categories..."
// //                             value={searchQuery}
// //                             onChange={(e) => {
// //                                 setSearchQuery(e.target.value);
// //                                 // Optional: Add debounced search here
// //                             }}
// //                             onKeyDown={(e) => {
// //                                 // Allow all key presses including space
// //                                 if (e.key === 'Enter') {
// //                                     handleSearch(searchQuery);
// //                                 }
// //                                 // Prevent any default behavior that might block typing
// //                             }}
// //                             onKeyUp={(e) => {
// //                                 // Update search on every keyup (real-time search)
// //                                 if (e.key !== 'Enter' && e.key !== 'Tab') {
// //                                     handleSearch(searchQuery);
// //                                 }
// //                             }}
// //                             style={{
// //                                 width: '100%',
// //                                 padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
// //                                 borderRadius: '20px',
// //                                 border: '2px solid #b15cd6',
// //                                 fontSize: window.innerWidth < 480 ? '13px' : '14px',
// //                                 outline: 'none',
// //                                 transition: 'all 0.3s ease',
// //                                 backgroundColor: '#fff',
// //                                 height: window.innerWidth < 480 ? '32px' : '35px',
// //                                 boxSizing: 'border-box',
// //                                 fontFamily: 'inherit', // Ensure consistent font
// //                             }}
// //                             onFocus={(e) => {
// //                                 e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
// //                             }}
// //                             onBlur={(e) => {
// //                                 e.target.style.boxShadow = 'none';
// //                             }}
// //                         />
// //                         <button
// //                             onClick={() => handleSearch(searchQuery)}
// //                             style={{
// //                                 position: 'absolute',
// //                                 right: window.innerWidth < 480 ? '6px' : '8px',
// //                                 top: '50%',
// //                                 transform: 'translateY(-50%)',
// //                                 background: 'transparent',
// //                                 border: 'none',
// //                                 cursor: 'pointer',
// //                                 padding: '4px',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 zIndex: 2
// //                             }}
// //                             type="button"
// //                             aria-label="Search"
// //                         >
// //                             <svg
// //                                 width={window.innerWidth < 480 ? "16" : "18"}
// //                                 height={window.innerWidth < 480 ? "16" : "18"}
// //                                 viewBox="0 0 24 24"
// //                                 fill="none"
// //                                 stroke="#b15cd6"
// //                                 strokeWidth="2"
// //                             >
// //                                 <circle cx="11" cy="11" r="8" />
// //                                 <path d="m21 21-4.3-4.3" />
// //                             </svg>
// //                         </button>

// //                         {/* Add a clear button */}
// //                         {/* {searchQuery && (
// //                             <button
// //                                 onClick={() => {
// //                                     setSearchQuery("");
// //                                     handleSearch("");
// //                                 }}
// //                                 style={{
// //                                     position: 'absolute',
// //                                     right: window.innerWidth < 480 ? '28px' : '32px',
// //                                     top: '50%',
// //                                     transform: 'translateY(-50%)',
// //                                     background: 'transparent',
// //                                     border: 'none',
// //                                     cursor: 'pointer',
// //                                     padding: '2px',
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     justifyContent: 'center',
// //                                     color: '#888',
// //                                     fontSize: '16px',
// //                                     fontWeight: 'bold',
// //                                     zIndex: 2
// //                                 }}
// //                                 type="button"
// //                                 aria-label="Clear search"
// //                             >
// //                                 ×
// //                             </button>
// //                         )} */}
// //                     </div>
// //                 </div>
// //             </div>

// //             <div style={{
// //                 height: window.innerHeight < 650 ? "auto" : containerHeight,
// //                 maxHeight: window.innerHeight < 450 ? "45vh" : window.innerHeight < 500 ? "50vh" : window.innerHeight < 650 ? "55vh" : window.innerHeight < 700 ? "60vh" : "65vh",
// //                 border: '0px solid #ddd',
// //                 borderRadius: '0.375rem',
// //                 backgroundColor: '#fff',
// //                 width: '100%',
// //                 maxWidth: '100%',
// //                 boxSizing: 'border-box',
// //                 overflow: window.innerWidth < 768 ? 'auto' : 'hidden',
// //                 display: 'flex',
// //                 flexDirection: 'column'
// //             }} className="standard-table-data">

// //                 {loading ? (
// //                     <p>Loading data...</p>
// //                 ) : error ? (
// //                     <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
// //                 ) : (
// //                     <div style={{
// //                         minWidth: window.innerWidth < 768 ? '900px' : '100%', // ← Increased min width for Chef Type column
// //                         overflow: 'visible',
// //                         height: window.innerWidth < 1300 ? '50vh' : '60vh',
// //                         display: 'flex',
// //                         flexDirection: 'column'
// //                     }}>
// //                         {/* Fixed Header */}
// //                         <div style={{
// //                             flexShrink: 0,
// //                             backgroundColor: '#f2f2f2',
// //                             borderBottom: '1px solid #ddd',
// //                             minWidth: window.innerWidth < 768 ? '900px' : '100%', // ← Increased min width
// //                         }}>
// //                             <table style={{
// //                                 width: '100%',
// //                                 borderCollapse: 'collapse',
// //                                 tableLayout: 'fixed'
// //                             }}>
// //                                 <thead>
// //                                     <tr>
// //                                         <th style={{ ...tableHeaderStyle, width: '5%', textAlign: 'center' }}>S.No</th>
// //                                         <th
// //                                             style={{
// //                                                 ...tableHeaderStyle,
// //                                                 width: '12%',
// //                                                 textAlign: 'center',
// //                                                 cursor: 'pointer',
// //                                                 position: 'relative',
// //                                             }}
// //                                             onClick={handleCategoryColumnClick}
// //                                         >
// //                                             <div style={{
// //                                                 display: 'flex',
// //                                                 alignItems: 'center',
// //                                                 justifyContent: 'space-around',
// //                                                 gap: '5px',
// //                                                 position: 'relative',
// //                                                 minHeight: '24px' // Fixed height to prevent shifting
// //                                             }}>
// //                                                 <span>Category</span>

// //                                                 {/* Container that maintains same width for both icons */}
// //                                                 <div style={{
// //                                                     width: '20px', // Fixed width for both icons
// //                                                     height: '20px',
// //                                                     display: 'flex',
// //                                                     alignItems: 'center',
// //                                                     justifyContent: 'center',
// //                                                     marginBottom: '1px'
// //                                                 }}>
// //                                                     {/* Show filter icon only when NO category is selected */}
// //                                                     {!selectedCategory && (
// //                                                         <svg
// //                                                             width="14"
// //                                                             height="14"
// //                                                             viewBox="0 0 24 24"
// //                                                             fill="white"
// //                                                             stroke="white"
// //                                                             strokeWidth="1.5"
// //                                                         >
// //                                                             <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
// //                                                         </svg>
// //                                                     )}

// //                                                     {/* Show clear icon only when category IS selected */}
// //                                                     {selectedCategory && (
// //                                                         <span
// //                                                             onClick={(e) => {
// //                                                                 e.stopPropagation();
// //                                                                 clearCategoryFilter();
// //                                                             }}
// //                                                             style={{
// //                                                                 background: '#ff6b6b',
// //                                                                 color: 'white',
// //                                                                 borderRadius: '50%',
// //                                                                 width: '18px',
// //                                                                 height: '18px',
// //                                                                 display: 'flex',
// //                                                                 alignItems: 'center',
// //                                                                 justifyContent: 'center',
// //                                                                 fontSize: '12px',
// //                                                                 cursor: 'pointer',
// //                                                             }}
// //                                                             onMouseEnter={(e) => {
// //                                                                 e.currentTarget.style.backgroundColor = '#ff5252';
// //                                                                 e.currentTarget.style.transform = 'scale(1.1)';
// //                                                             }}
// //                                                             onMouseLeave={(e) => {
// //                                                                 e.currentTarget.style.backgroundColor = '#ff6b6b';
// //                                                                 e.currentTarget.style.transform = 'scale(1)';
// //                                                             }}
// //                                                         >
// //                                                             ×
// //                                                         </span>
// //                                                     )}
// //                                                 </div>
// //                                             </div>
// //                                         </th>
// //                                         <th style={{ ...tableHeaderStyle, width: '7%', textAlign: 'center' }}>Type</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '15%', textAlign: 'center' }}>Description</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>Image</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '7%', textAlign: 'center' }}>Price</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '6%', textAlign: 'center' }}>Gst(%)</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>
// //                                             Packing<br />(.Rs)
// //                                         </th>
// //                                         <th style={{ ...tableHeaderStyle, width: '10%', textAlign: 'center' }}>Chef Type</th> {/* NEW COLUMN */}
// //                                         <th style={{ ...tableHeaderStyle, width: '8%', textAlign: 'center' }}>Status</th>
// //                                         <th style={{ ...tableHeaderStyle, width: '10%', textAlign: 'center' }}>Actions</th>
// //                                     </tr>
// //                                 </thead>
// //                             </table>
// //                         </div>

// //                         {/* Scrollable Body */}
// //                         <div style={{
// //                             flex: 1,
// //                             overflowY: 'auto',
// //                             overflowX: window.innerWidth < 768 ? 'auto' : 'hidden',
// //                             scrollbarWidth: window.innerWidth < 768 ? 'thin' : 'none',
// //                             minWidth: window.innerWidth < 768 ? '900px' : '100%' // ← Increased min width
// //                         }}>
// //                             <table style={{
// //                                 width: '100%',
// //                                 borderCollapse: 'collapse',
// //                                 tableLayout: 'fixed',
// //                                 minWidth: window.innerWidth < 768 ? '900px' : '100%' // ← Increased min width
// //                             }}>
// //                                 <tbody>
// //                                     {filteredData.map((item, index) => (
// //                                         <React.Fragment key={index}>
// //                                             {/* Parent Category Row */}
// //                                             <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
// //                                                 <td style={{ ...tableCellStyle, width: '5%', textAlign: 'center' }}>{index + 1}</td>
// //                                                 <td style={{ ...tableCellStyle, width: '12%', fontWeight: "bold" }}>
// //                                                     {item.category}
// //                                                 </td>
// //                                                 <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>
// //                                                     {item.tag ? item.tag : '-'}
// //                                                 </td>
// //                                                 <td style={{ ...tableCellStyle, width: '15%', textAlign: 'center' }}>-</td>
// //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// //                                                     <label htmlFor={`fileInput-${index}`} style={{ cursor: 'pointer' }}>
// //                                                         <img
// //                                                             src={item.image}
// //                                                             alt="Dish"
// //                                                             style={{ width: '36px', height: '28px', borderRadius: '8px' }}
// //                                                         />
// //                                                     </label>
// //                                                     <input
// //                                                         id={`fileInput-${index}`}
// //                                                         type="file"
// //                                                         accept="image/*"
// //                                                         onChange={(e) => handleImageChange(e, index)}
// //                                                         style={{ display: 'none' }}
// //                                                     />
// //                                                 </td>
// //                                                 <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>-</td>
// //                                                 <td style={{ ...tableCellStyle, width: '6%', textAlign: 'center' }}>-</td>
// //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>-</td>
// //                                                 <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>-</td> {/* Chef Type for Category */}
// //                                                 <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// //                                                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
// //                                                         <label className="switch">
// //                                                             <input
// //                                                                 type="checkbox"
// //                                                                 checked={item.menuStatus === "Enable"}
// //                                                                 onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
// //                                                             />
// //                                                             <span className="slider round"></span>
// //                                                         </label>
// //                                                         <span style={{ marginTop: '3px', fontSize: '0.75rem', fontWeight: '600' }}>
// //                                                             {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
// //                                                         </span>
// //                                                     </div>
// //                                                 </td>
// //                                                 <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>
// //                                                     <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
// //                                                         <button
// //                                                             style={{
// //                                                                 backgroundColor: '#00b894',
// //                                                                 color: 'white',
// //                                                                 borderRadius: '4px',
// //                                                                 padding: '4px 6px',
// //                                                                 border: 'none',
// //                                                                 cursor: 'pointer',
// //                                                                 fontSize: '0.75rem',
// //                                                                 minWidth: '40px'
// //                                                             }}
// //                                                             onClick={() => handleAddSubCategory(item.dishId)}
// //                                                         >
// //                                                             Add
// //                                                         </button>
// //                                                         <button
// //                                                             style={{ ...addButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// //                                                             onClick={() => item.isAdded ? handleEdit(item.SNo) : handleSave(item, index)}
// //                                                         >
// //                                                             {item.isAdded ? <FaEdit /> : <FaSave />}
// //                                                         </button>
// //                                                         <button
// //                                                             style={{ ...deleteButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// //                                                             onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
// //                                                         >
// //                                                             <FaTrash />
// //                                                         </button>
// //                                                     </div>
// //                                                 </td>
// //                                             </tr>

// //                                             {/* Subcategories */}
// //                                             {item.subcategories && item.subcategories.length > 0 && item.subcategories.map((sub, subIndex) => (
// //                                                 <tr key={`sub-${sub.dishId}`} style={{ backgroundColor: '#f9f9f9' }}>
// //                                                     <td style={{ ...tableCellStyle, width: '5%', textAlign: 'center', fontSize: '0.8rem' }}>
// //                                                         {index + 1}.{subIndex + 1}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '12%', fontSize: '0.8rem', paddingLeft: '0px' }}>
// //                                                         ↳ {sub.subName}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center' }}>
// //                                                         {sub.tag === "Veg" ? (
// //                                                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
// //                                                                 <div style={{ width: '10px', height: '10px', border: '1px solid green', borderRadius: '1px' }}>
// //                                                                     <div style={{ width: '5px', height: '5px', backgroundColor: 'green', borderRadius: '50%', margin: '2px auto' }}></div>
// //                                                                 </div>
// //                                                                 <span style={{ color: 'green', fontSize: '0.7rem' }}>Veg</span>
// //                                                             </div>
// //                                                         ) : sub.tag === "Non_Veg" ? (
// //                                                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
// //                                                                 <div style={{ width: '10px', height: '10px', border: '1px solid red', borderRadius: '1px' }}>
// //                                                                     <div style={{ width: '5px', height: '5px', backgroundColor: 'red', borderRadius: '50%', margin: '2px auto' }}></div>
// //                                                                 </div>
// //                                                                 <span style={{ color: 'red', fontSize: '0.7rem' }}>Non-Veg</span>
// //                                                             </div>
// //                                                         ) : (sub.tag)}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '15%', fontSize: '0.75rem', padding: '4px 6px' }}>
// //                                                         {sub.description}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// //                                                         <img
// //                                                             src={sub.image}
// //                                                             alt="Sub Dish"
// //                                                             style={{ width: '36px', height: '28px', borderRadius: '8px' }}
// //                                                         />
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '7%', textAlign: 'center', fontSize: '0.8rem' }}>₹{sub.price}</td>
// //                                                     <td style={{ ...tableCellStyle, width: '6%', textAlign: 'center', fontSize: '0.8rem' }}>{sub.gst}</td>
// //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center', fontSize: '0.8rem' }}>{sub.packingCharges}</td>
// //                                                     <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center', fontSize: '0.8rem' }}>
// //                                                         {(() => {
// //                                                             if (!sub.chefType) return '-';

// //                                                             let displayType = sub.chefType;

// //                                                             // Remove "Chef_" prefix
// //                                                             if (displayType.startsWith('Chef_')) {
// //                                                                 displayType = displayType.substring(5); // Remove "Chef_"
// //                                                             }

// //                                                             // Handle specific cases
// //                                                             if (displayType === 'Tea_stall') {
// //                                                                 displayType = 'Tea Stall';
// //                                                             } else if (displayType === 'All') {
// //                                                                 displayType = 'All';
// //                                                             } else if (displayType === 'North') {
// //                                                                 displayType = 'North';
// //                                                             } else if (displayType === 'South') {
// //                                                                 displayType = 'South';
// //                                                             } else if (displayType === 'Chinese') {
// //                                                                 displayType = 'Chinese';
// //                                                             } else if (displayType === 'Continental') {
// //                                                                 displayType = 'Continental';
// //                                                             } else if (displayType === 'Snacks') {
// //                                                                 displayType = 'Snacks';
// //                                                             } else if (displayType === 'Bakery') {
// //                                                                 displayType = 'Bakery';
// //                                                             }

// //                                                             return displayType;
// //                                                         })()}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '8%', textAlign: 'center' }}>
// //                                                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
// //                                                             <label className="switch">
// //                                                                 <input
// //                                                                     type="checkbox"
// //                                                                     checked={sub.menuStatus === "Enable"}
// //                                                                     onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
// //                                                                     disabled={item.menuStatus === "Disable"}
// //                                                                 />
// //                                                                 <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
// //                                                             </label>
// //                                                             <span style={{
// //                                                                 marginTop: '3px',
// //                                                                 fontSize: '0.7rem',
// //                                                                 color: item.menuStatus === "Disable" ? '#999' : 'black',
// //                                                                 fontWeight: '500'
// //                                                             }}>
// //                                                                 {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
// //                                                             </span>
// //                                                         </div>
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, width: '10%', textAlign: 'center' }}>
// //                                                         <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
// //                                                             <button
// //                                                                 style={{ ...addButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// //                                                                 onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
// //                                                             >
// //                                                                 <FaEdit />
// //                                                             </button>
// //                                                             <button
// //                                                                 style={{ ...deleteButtonStyle, padding: '4px 6px', fontSize: '0.8rem' }}
// //                                                                 onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
// //                                                             >
// //                                                                 <FaTrash />
// //                                                             </button>
// //                                                         </div>
// //                                                     </td>
// //                                                 </tr>
// //                                             ))}
// //                                         </React.Fragment>
// //                                     ))}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </div>
// //                 )}
// //             </div>

// //             {showEditModal && editItem && (
// //                 <div style={modalStyle}>
// //                     <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
// //                         <span style={closeIconStyle}>×</span>
// //                     </div>
// //                     <br></br>
// //                     <div style={inputContainerStyle}>
// //                         <input
// //                             id="dishName"
// //                             type="text"
// //                             value={editItem.dishName}
// //                             onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
// //                             style={inputFieldStyle}
// //                         />
// //                     </div>

// //                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
// //                         <div style={imagePreviewStyle}>
// //                             <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
// //                                 <img
// //                                     src={editItem.image || 'https://via.placeholder.com/100x100'}
// //                                     alt="Preview"
// //                                     style={imageStyle}
// //                                 />
// //                             </label>

// //                             <input
// //                                 id="dishImage"
// //                                 type="file"
// //                                 accept="image/*"
// //                                 onChange={(e) => handleEditImageChange(e)}
// //                                 style={{ display: 'none' }}
// //                             />
// //                         </div>
// //                     </div>

// //                     <div style={buttonContainerStyle}>
// //                         <button onClick={submitEdit} style={buttonStyle}>Update</button>
// //                     </div>
// //                 </div>
// //             )}

// //             {showSubcategoryPopup && (
// //                 <div
// //                     style={{
// //                         position: 'fixed',
// //                         top: 63,
// //                         left: 0,
// //                         width: '100%',
// //                         height: '100%',
// //                         backgroundColor: 'rgba(0,0,0,0.6)',
// //                         display: 'flex',
// //                         justifyContent: 'center',
// //                         alignItems: 'center',
// //                         zIndex: 1000,
// //                         padding: '20px',
// //                         boxSizing: 'border-box',
// //                     }}
// //                 >
// //                     <div
// //                         style={{
// //                             height: "77vh",
// //                             overflow: "auto",
// //                             position: 'relative',
// //                             backgroundColor: '#fff',
// //                             padding: '30px 25px',
// //                             borderRadius: '12px',
// //                             width: '400px',
// //                             maxWidth: '95%',
// //                             boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
// //                             display: 'flex',
// //                             flexDirection: 'column',
// //                             gap: '15px',
// //                             fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// //                         }}
// //                     >
// //                         <div
// //                             onClick={() => setShowSubcategoryPopup(false)}
// //                             style={{
// //                                 position: 'absolute',
// //                                 top: '15px',
// //                                 right: '15px',
// //                                 fontSize: '22px',
// //                                 fontWeight: '700',
// //                                 color: '#999',
// //                                 cursor: 'pointer',
// //                                 userSelect: 'none',
// //                                 transition: 'color 0.3s',
// //                             }}
// //                             onMouseEnter={e => (e.currentTarget.style.color = '#00b894')}
// //                             onMouseLeave={e => (e.currentTarget.style.color = '#999')}
// //                         >
// //                             &times;
// //                         </div>

// //                         <h3 style={{ margin: 0, fontWeight: '600', fontSize: '1.3rem', color: '#333' }}>
// //                             Add Subcategory for : <span style={{ color: '#00b894' }}>{parentDishDetails?.dishName}</span>
// //                         </h3>

// //                         <input
// //                             type="text"
// //                             value={subDishName}
// //                             onChange={(e) => setSubDishName(e.target.value)}
// //                             placeholder="Subcategory Dish Name"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         />

// //                         <input
// //                             type="number"
// //                             value={price}
// //                             onChange={(e) => setPrice(e.target.value)}
// //                             placeholder="Price"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         />

// //                         <input
// //                             type="number"
// //                             value={gst}
// //                             onChange={(e) => setGst(e.target.value)}
// //                             placeholder="GST"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         />

// //                         {/* <input
// //                             type="number"
// //                             value={discount}
// //                             onChange={(e) => setdiscount(e.target.value)}
// //                             placeholder="Discount"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         /> */}

// //                         <input
// //                             type="number"
// //                             value={packingCharges}
// //                             onChange={(e) => setPackingCharges(e.target.value)}
// //                             placeholder="Packing Charges"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         />

// //                         <select
// //                             value={tag}
// //                             onChange={(e) => setTag(e.target.value)}
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                                 backgroundColor: '#fff',
// //                                 cursor: 'pointer',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         >
// //                             <option value="Veg">Veg</option>
// //                             <option value="Non_Veg">Non Veg</option>
// //                         </select>

// //                         <select
// //                             value={chefType}
// //                             onChange={(e) => setChefType(e.target.value)} style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                                 backgroundColor: '#fff',
// //                                 cursor: 'pointer',
// //                             }} >
// //                             <option value="Chef_All">Chef All</option>
// //                             <option value="Chef_North">Chef North</option>
// //                             <option value="Chef_South">Chef South</option>
// //                             <option value="Chef_Chinese">Chef Chinese</option>
// //                             <option value="Chef_Continental">Chef Continental</option>
// //                             <option value="Tea_stall">Tea Stall</option>
// //                             <option value="Snacks">Snacks</option>
// //                             <option value="Bakery">Bakery</option>
// //                         </select>

// //                         <input
// //                             type="text"
// //                             value={description}
// //                             onChange={(e) => setDescription(e.target.value)}
// //                             placeholder="Description"
// //                             style={{
// //                                 padding: '10px 12px',
// //                                 fontSize: '1rem',
// //                                 borderRadius: '6px',
// //                                 border: '1.8px solid #ccc',
// //                                 outline: 'none',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onFocus={e => e.target.style.borderColor = '#00b894'}
// //                             onBlur={e => e.target.style.borderColor = '#ccc'}
// //                         />



// //                         <div
// //                             style={{
// //                                 width: '100%',
// //                                 maxWidth: '175px',
// //                                 minHeight: '138px',
// //                                 border: '2px dashed #bbb',
// //                                 borderRadius: '10px',
// //                                 margin: '15px auto',
// //                                 display: 'flex',
// //                                 alignItems: 'center',
// //                                 justifyContent: 'center',
// //                                 cursor: 'pointer',
// //                                 backgroundColor: '#fafafa',
// //                                 overflow: 'visible',
// //                                 transition: 'border-color 0.3s',
// //                             }}
// //                             onClick={() => document.getElementById('hiddenFileInput').click()}
// //                             onMouseEnter={e => (e.currentTarget.style.borderColor = '#00b894')}
// //                             onMouseLeave={e => (e.currentTarget.style.borderColor = '#bbb')}
// //                         >
// //                             {image ? (
// //                                 <img
// //                                     src={image}
// //                                     alt="Preview"
// //                                     style={{
// //                                         width: '100%',
// //                                         height: '100%',
// //                                         objectFit: 'contain',
// //                                         borderRadius: '10px',
// //                                     }}
// //                                 />
// //                             ) : (
// //                                 <div
// //                                     style={{
// //                                         fontSize: '50px',
// //                                         color: '#ccc',
// //                                         fontWeight: 'bold',
// //                                         userSelect: 'none',
// //                                     }}
// //                                 >
// //                                     +
// //                                 </div>
// //                             )}
// //                         </div>

// //                         <input
// //                             id="hiddenFileInput"
// //                             type="file"
// //                             accept="image/*"
// //                             onChange={handleSubImageChange}
// //                             style={{ display: 'none' }}
// //                         />

// //                         <div
// //                             style={{
// //                                 display: 'flex',
// //                                 justifyContent: 'center',
// //                                 marginTop: '10px',
// //                             }}
// //                         >
// //                             <button
// //                                 onClick={handleSubcategorySubmit}
// //                                 style={{
// //                                     backgroundColor: '#00b894',
// //                                     color: 'white',
// //                                     padding: '10px 20px',
// //                                     border: 'none',
// //                                     borderRadius: '6px',
// //                                     fontWeight: '600',
// //                                     fontSize: '1rem',
// //                                     cursor: 'pointer',
// //                                     transition: 'background-color 0.3s',
// //                                 }}
// //                                 onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#019973')}
// //                                 onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#00b894')}
// //                             >
// //                                 Save
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {showSubEditModal && (
// //                 <div style={modalOverlayStyle}>
// //                     <div style={modalContentStyle}>
// //                         <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
// //                             <button
// //                                 onClick={() => setShowSubEditModal(false)}
// //                                 style={{
// //                                     background: 'transparent',
// //                                     border: 'none',
// //                                     fontSize: '20px',
// //                                     cursor: 'pointer',
// //                                     color: '#888',
// //                                 }}
// //                             >
// //                                 &times;
// //                             </button>
// //                         </div>

// //                         <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

// //                         {/* 1. Dish Name */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Dish Name :
// //                             </label>
// //                             <input
// //                                 type="text"
// //                                 value={editSubItem.subName}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                 }}
// //                             />
// //                         </div>

// //                         {/* 2. Price */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Price :
// //                             </label>
// //                             <input
// //                                 type="number"
// //                                 value={editSubItem.price}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                 }}
// //                             />
// //                         </div>

// //                         {/* 3. GST */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 GST :
// //                             </label>
// //                             <input
// //                                 type="number"
// //                                 value={editSubItem.gst}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                 }}
// //                             />
// //                         </div>

// //                         {/* 4. Packing Charges */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Packing Charges :
// //                             </label>
// //                             <input
// //                                 type="number"
// //                                 value={editSubItem.packingCharges}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                 }}
// //                             />
// //                         </div>

// //                         {/* 5. Dish Type */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Dish Type:
// //                             </label>
// //                             <select
// //                                 value={editSubItem.tag || 'Veg'}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                     backgroundColor: '#fff',
// //                                     cursor: 'pointer',
// //                                 }}
// //                             >
// //                                 <option value="Veg">Veg</option>
// //                                 <option value="Non_Veg">Non-Veg</option>
// //                             </select>
// //                         </div>

// //                         {/* 6. Chef Type */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Chef Type:
// //                             </label>
// //                             <select
// //                                 value={editSubItem.chefType || 'Chef_All'}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                     backgroundColor: '#fff',
// //                                     cursor: 'pointer',
// //                                 }}
// //                             >
// //                                 <option value="Chef_All">Chef All</option>
// //                                 <option value="Chef_North">Chef North</option>
// //                                 <option value="Chef_South">Chef South</option>
// //                                 <option value="Chef_Chinese">Chef Chinese</option>
// //                                 <option value="Chef_Continental">Chef Continental</option>
// //                                 <option value="Tea_stall">Tea Stall</option>
// //                                 <option value="Snacks">Snacks</option>
// //                                 <option value="Bakery">Bakery</option>
// //                             </select>
// //                         </div>

// //                         {/* 7. Description */}
// //                         <div style={{ marginBottom: '15px' }}>
// //                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
// //                                 Description :
// //                             </label>
// //                             <input
// //                                 type="text"
// //                                 value={editSubItem.description}
// //                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
// //                                 style={{
// //                                     width: '100%',
// //                                     padding: '10px',
// //                                     borderRadius: '6px',
// //                                     border: '1px solid #ccc',
// //                                     fontSize: '14px',
// //                                 }}
// //                             />
// //                         </div>

// //                         {/* 8. Image */}
// //                         <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
// //                             <div style={imagePreviewStyle}>
// //                                 <label htmlFor="subDishImage" style={{ cursor: 'pointer' }}>
// //                                     <img
// //                                         src={editSubItem.image || 'https://via.placeholder.com/100x100'}
// //                                         alt="Preview"
// //                                         style={{
// //                                             width: '100px',
// //                                             height: '100px',
// //                                             objectFit: 'cover',
// //                                             borderRadius: '10px',
// //                                             border: '1px solid #ccc',
// //                                         }}
// //                                     />
// //                                 </label>
// //                                 <input
// //                                     id="subDishImage"
// //                                     type="file"
// //                                     accept="image/*"
// //                                     onChange={(e) =>
// //                                         setEditSubItem({
// //                                             ...editSubItem,
// //                                             newImageFile: e.target.files[0],
// //                                             image: URL.createObjectURL(e.target.files[0]),
// //                                         })
// //                                     }
// //                                     style={{ display: 'none' }}
// //                                 />
// //                             </div>
// //                         </div>

// //                         <div style={{ display: 'flex', justifyContent: 'center' }}>
// //                             <button onClick={submitEditSubcategory} style={submitButtonStyle}>
// //                                 Update
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Category Search Popup */}
// //             {showCategorySearchPopup && (
// //                 <div style={{
// //                     position: 'fixed',
// //                     top: 0,
// //                     left: 0,
// //                     right: 0,
// //                     bottom: 0,
// //                     backgroundColor: 'rgba(0,0,0,0.5)',
// //                     display: 'flex',
// //                     justifyContent: 'center',
// //                     alignItems: 'center',
// //                     zIndex: 2000
// //                 }}>
// //                     <div style={{
// //                         backgroundColor: 'white',
// //                         borderRadius: '8px',
// //                         width: '300px',
// //                         maxWidth: '90vw',
// //                         maxHeight: '80vh',
// //                         overflow: 'hidden',
// //                         boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
// //                     }}>
// //                         {/* Header */}
// //                         <div style={{
// //                             padding: '15px',
// //                             borderBottom: '1px solid #eee',
// //                             display: 'flex',
// //                             justifyContent: 'space-between',
// //                             alignItems: 'center'
// //                         }}>
// //                             <h3 style={{ margin: 0, fontSize: '16px' }}>Search Categories</h3>
// //                             <button
// //                                 onClick={() => setShowCategorySearchPopup(false)}
// //                                 style={{
// //                                     background: 'none',
// //                                     border: 'none',
// //                                     fontSize: '20px',
// //                                     cursor: 'pointer',
// //                                     color: '#666'
// //                                 }}
// //                             >
// //                                 ×
// //                             </button>
// //                         </div>

// //                         {/* Search Input */}
// //                         <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
// //                             <div style={{ position: 'relative' }}>
// //                                 <FaSearch style={{
// //                                     position: 'absolute',
// //                                     left: '10px',
// //                                     top: '50%',
// //                                     transform: 'translateY(-50%)',
// //                                     color: '#999'
// //                                 }} />
// //                                 <input
// //                                     type="text"
// //                                     placeholder="Type to search categories..."
// //                                     value={categorySearchQuery}
// //                                     onChange={(e) => handleCategorySearch(e.target.value)}
// //                                     style={{
// //                                         width: '100%',
// //                                         padding: '8px 8px 8px 35px',
// //                                         borderRadius: '4px',
// //                                         border: '1px solid #ddd',
// //                                         fontSize: '14px',
// //                                         outline: 'none'
// //                                     }}
// //                                     autoFocus
// //                                 />
// //                                 {categorySearchQuery && (
// //                                     <FaTimes
// //                                         onClick={() => setCategorySearchQuery('')}
// //                                         style={{
// //                                             position: 'absolute',
// //                                             right: '10px',
// //                                             top: '50%',
// //                                             transform: 'translateY(-50%)',
// //                                             color: '#999',
// //                                             cursor: 'pointer'
// //                                         }}
// //                                     />
// //                                 )}
// //                             </div>
// //                         </div>

// //                         {/* Categories List */}
// //                         <div style={{
// //                             maxHeight: '300px',
// //                             overflowY: 'auto',
// //                             padding: '5px 0'
// //                         }}>
// //                             {/* Show All option */}
// //                             <div
// //                                 onClick={() => handleCategorySelect(null)}
// //                                 style={{
// //                                     padding: '10px 15px',
// //                                     cursor: 'pointer',
// //                                     borderBottom: '1px solid #f5f5f5',
// //                                     backgroundColor: selectedCategory === null ? '#f0f0f0' : 'white',
// //                                     display: 'flex',
// //                                     justifyContent: 'space-between',
// //                                     alignItems: 'center'
// //                                 }}
// //                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
// //                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === null ? '#f0f0f0' : 'white'}
// //                             >
// //                                 <span>Show All Categories</span>
// //                                 <span style={{
// //                                     color: '#666',
// //                                     fontSize: '12px',
// //                                     backgroundColor: '#e9ecef',
// //                                     padding: '2px 6px',
// //                                     borderRadius: '10px'
// //                                 }}>
// //                                     {data.length}
// //                                 </span>
// //                             </div>

// //                             {/* Categories */}
// //                             {filteredCategories.map((category, index) => (
// //                                 <div
// //                                     key={index}
// //                                     onClick={() => handleCategorySelect(category.name)}
// //                                     style={{
// //                                         padding: '10px 15px',
// //                                         cursor: 'pointer',
// //                                         borderBottom: '1px solid #f5f5f5',
// //                                         backgroundColor: selectedCategory === category.name ? '#f0f0f0' : 'white',
// //                                         display: 'flex',
// //                                         justifyContent: 'space-between',
// //                                         alignItems: 'center'
// //                                     }}
// //                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
// //                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === category.name ? '#f0f0f0' : 'white'}
// //                                 >
// //                                     <span>{category.name}</span>
// //                                     <span style={{
// //                                         color: '#666',
// //                                         fontSize: '12px',
// //                                         backgroundColor: '#e9ecef',
// //                                         padding: '2px 6px',
// //                                         borderRadius: '10px'
// //                                     }}>
// //                                         {category.count}
// //                                     </span>
// //                                 </div>
// //                             ))}

// //                             {filteredCategories.length === 0 && (
// //                                 <div style={{
// //                                     padding: '20px',
// //                                     textAlign: 'center',
// //                                     color: '#666'
// //                                 }}>
// //                                     No categories found
// //                                 </div>
// //                             )}
// //                         </div>

// //                         {/* Footer */}
// //                         <div style={{
// //                             padding: '10px 15px',
// //                             borderTop: '1px solid #eee',
// //                             textAlign: 'right'
// //                         }}>
// //                             <button
// //                                 onClick={() => setShowCategorySearchPopup(false)}
// //                                 style={{
// //                                     padding: '6px 15px',
// //                                     backgroundColor: '#6c757d',
// //                                     color: 'white',
// //                                     border: 'none',
// //                                     borderRadius: '4px',
// //                                     cursor: 'pointer',
// //                                     fontSize: '14px'
// //                                 }}
// //                             >
// //                                 Close
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}
// //             <style>
// //                 {`
// //                /* ItemUpdates-style toggle - Fixed direction */
// // .switch {
// //     position: relative;
// //     display: inline-block;
// //     width: 40px;
// //     height: 22px;
// // }

// // .switch input {
// //     opacity: 0;
// //     width: 0;
// //     height: 0;
// // }

// // .slider {
// //     position: absolute;
// //     cursor: pointer;
// //     top: 0;
// //     left: 0;
// //     right: 0;
// //     bottom: 0;
// //     background-color: #f44336; /* RED by default (Hide) */
// //     transition: .4s;
// //     border-radius: 34px;
// // }

// // .slider:before {
// //     position: absolute;
// //     content: "";
// //     height: 16px;
// //     width: 16px;
// //     left: 3px;  /* LEFT position by default */
// //     bottom: 3px;
// //     background-color: white;
// //     transition: .4s;
// //     border-radius: 50%;
// // }

// // /* CHECKED state - Show (GREEN) */
// // input:checked + .slider {
// //     background-color: #4CAF50; /* GREEN when Show */
// // }

// // input:checked + .slider:before {
// //     transform: translateX(18px); /* Move to RIGHT when Show */
// // }

// // .slider.round {
// //     border-radius: 34px;
// // }

// // /* Disabled state - Grayed out */
// // .slider.disabled {
// //     background-color: #cccccc !important;
// //     cursor: not-allowed;
// // }

// // .switch input:disabled + .slider {
// //     background-color: #cccccc !important;
// //     cursor: not-allowed;
// // }

// // .switch input:disabled + .slider:before {
// //     background-color: #999999 !important;
// // }
// //     @media (max-width: 768px) {
// //     .standard-table-data {
// //         overflow-x: auto !important;
// //         -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
// //         width: 93vw !important;

// //     }

// //     .standard-table-data table {
// //         min-width: 800px; /* Force horizontal scroll */
// //         width: 100%;
// //     }

// //     /* Make table cells more readable on mobile */
// //     .standard-table-data td,
// //     .standard-table-data th {
// //         min-width: 80px;
// //         // white-space: nowrap;
// //         padding: 4px !important;
// //         font-size: 0.8rem !important;
// //     }

// //     /* Adjust button sizes on mobile */
// //     .standard-table-data button {
// //         padding: 3px 5px !important;
// //         font-size: 0.7rem !important;
// //         min-width: 35px !important;
// //     }
// // }
// // `}
// //             </style>
// //         </div>
// //     );
// // };

// // const modalOverlayStyle = {
// //     position: 'fixed',
// //     top: 0, left: 0, right: 0, bottom: 0,
// //     backgroundColor: 'rgba(0,0,0,0.5)',
// //     display: 'flex',
// //     justifyContent: 'center',
// //     alignItems: 'center',
// //     zIndex: 1000,
// //     marginTop: "50px",
// // };

// // const modalContentStyle = {
// //     backgroundColor: 'white',
// //     borderRadius: '8px',
// //     padding: '20px',
// //     width: '300px',
// //     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
// //     height: "500px",
// //     overflow: "auto",
// // };

// // const cancelButtonStyle = {
// //     backgroundColor: '#ccc',
// //     border: 'none',
// //     padding: '8px 16px',
// //     borderRadius: '4px',
// //     cursor: 'pointer',
// // };

// // const submitButtonStyle = {
// //     backgroundColor: '#00b894',
// //     color: 'white',
// //     border: 'none',
// //     padding: '8px 16px',
// //     borderRadius: '4px',
// //     cursor: 'pointer',
// // };

// // const buttonStyle = {
// //     backgroundColor: '#b15cd6',
// //     color: 'white',
// //     border: 'none',
// //     cursor: 'pointer',
// //     borderRadius: '5px',
// //     width: '100px',
// //     fontWeight: "bold"
// // };

// // const tableHeaderStyle = {
// //     border: '1px solid #ddd',
// //     textAlign: 'center',
// //     fontWeight: '500',
// //     backgroundColor: '#b15cd6',
// //     color: 'white',
// //     fontSize: "1rem",
// //     padding: "0.5rem",

// // };

// // const tableCellStyle = {
// //     border: '1px solid #ddd',
// //     textAlign: 'center',
// // };

// // const evenRowStyle = { backgroundColor: '#fff' };
// // const oddRowStyle = { backgroundColor: '#fff' };

// // const inputStyle = {
// //     border: 'none',
// //     backgroundColor: 'transparent',
// //     textAlign: 'center',
// // };

// // const addButtonStyle = {
// //     backgroundColor: '#fff',
// //     color: 'green',
// //     border: 'none',
// //     cursor: 'pointer',
// //     borderRadius: '5px',
// //     marginRight: '10px',
// //     fontSize: "20px"
// // };

// // const deleteButtonStyle = {
// //     backgroundColor: '#fff',
// //     color: 'red',
// //     border: 'none',
// //     cursor: 'pointer',
// //     borderRadius: '5px',
// //     fontSize: "20px"
// // };

// // const importExportButton = {
// //     height: window.innerWidth < 480 ? '32px' : '35px',
// //     marginTop: window.innerWidth <= 768 ? "0px" : "20px",
// //     borderRadius: "4px",
// //     border: "none",
// //     backgroundColor: "#b15cd6",
// //     color: "white",
// //     fontWeight: 'bold',
// //     fontSize: window.innerWidth < 480 ? "0.7rem" : "0.75rem",
// //     padding: window.innerWidth < 480 ? "0 12px" : "0 15px",
// //     cursor: "pointer",
// //     whiteSpace: "nowrap",
// //     minWidth: window.innerWidth < 480 ? "70px" : "80px"
// // };

// // export default StandardMenu;







// import axios from 'axios';
// import React, { useEffect, useRef, useState } from 'react';
// import { FaChevronDown, FaChevronRight, FaEdit, FaPlus, FaSave, FaSearch, FaTimes, FaTrash } from 'react-icons/fa';
// import * as XLSX from 'xlsx';
// // import ImageGuidelinesModal from '../../../../components/ImageGuidelinesModal.jsx';
// // import ValidatedImageUpload from '../../../../components/ValidatedImageUpload.jsx';
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// // import { imageValidationRules } from '../../../../utils/imageValidationConfig.js';
// import './Management2.css';

// import ItemDiscounts from './ItemDiscounts.jsx';
// const StandardMenu = () => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [addedItems, setAddedItems] = useState([]);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editItem, setEditItem] = useState(null);
//     const [showPopup, setShowPopup] = useState(false);
//     const [image, setImage] = useState(null);
//     const [text, setText] = useState('');
//     const [isVegSelected, setIsVegSelected] = useState(null);
//     const [dishId, setDishId] = useState(null);
//     const [chefType, setChefType] = useState("Chef_All");
//     const [imageFile, setImageFile] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     const [searchQuery, setSearchQuery] = useState("");
//     const [searchActive, setSearchActive] = useState(false);
//     const [showCategorySearchPopup, setShowCategorySearchPopup] = useState(false);
//     const [categorySearchQuery, setCategorySearchQuery] = useState('');
//     const [filteredCategories, setFilteredCategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState(null);
//     // Add this state variable near your other states
//     const [showImageGuidelines, setShowImageGuidelines] = useState(false);
//     const [showGuidelinesModal, setShowGuidelinesModal] = useState(false);
//     const [currentPreset, setCurrentPreset] = useState('PRODUCT_IMAGE');
//     const [categoryImageFile, setCategoryImageFile] = useState(null); // Changed from imageFile
//     // Add these state variables near your other states
//     const [allCategories, setAllCategories] = useState([]);
//     const [allDishes, setAllDishes] = useState([]);
//     const [categorySuggestions, setCategorySuggestions] = useState([]);
//     const [dishSuggestions, setDishSuggestions] = useState([]);
//     const [showCategorySuggestions, setShowCategorySuggestions] = useState(false);
//     const importFileInputRef = useRef(null);    // NEW: For import functionality
//     const [showDishSuggestions, setShowDishSuggestions] = useState(false);
//     // Add this state with your other useState declarations
//     // Add this state with your other useState declarations
//     const [expandedCategories, setExpandedCategories] = useState({});
//     const [bulkMode, setBulkMode] = useState(false);
//     const [selectedItems, setSelectedItems] = useState({});
//     const [bulkQuantity, setBulkQuantity] = useState('');

//     // Load expanded state from localStorage on mount
//     useEffect(() => {
//         const savedExpanded = localStorage.getItem('expandedCategories');
//         if (savedExpanded) {
//             try {
//                 const parsed = JSON.parse(savedExpanded);
//                 setExpandedCategories(parsed);
//                 console.log("Loaded expanded categories:", parsed); // Debug
//             } catch (e) {
//                 console.error("Error parsing expanded categories:", e);
//             }
//         }
//     }, []);

//     // Save to localStorage whenever expandedCategories changes
//     useEffect(() => {
//         if (Object.keys(expandedCategories).length > 0) {
//             localStorage.setItem('expandedCategories', JSON.stringify(expandedCategories));
//             console.log("Saved expanded categories:", expandedCategories); // Debug
//         }
//     }, [expandedCategories]);

//     // Toggle function for category expansion
//     const toggleCategory = (categoryId, event) => {
//         event.stopPropagation(); // Prevent any row click events
//         setExpandedCategories(prev => ({
//             ...prev,
//             [categoryId]: !prev[categoryId]
//         }));
//     };

//     // Add these functions to fetch category and dish data
//     const fetchAllCategories = async () => {
//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 "https://backend.maamaas.com/food/api/getall/catageory-dish",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );
//             setAllCategories(response.data || []);
//         } catch (error) {
//             console.error("Error fetching categories:", error);
//             setAllCategories([]);
//         }
//     };

//     const fetchAllDishes = async () => {
//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 "https://backend.maamaas.com/food/api/getall/dish",
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );
//             setAllDishes(response.data || []);
//         } catch (error) {
//             console.error("Error fetching dishes:", error);
//             setAllDishes([]);
//         }
//     };

//     // Call these in useEffect
//     useEffect(() => {
//         fetchData();
//         fetchAllCategories();
//         fetchAllDishes();
//     }, []);
//     // Add these functions for auto-suggestions
//     const handleCategoryInputChange = (e) => {
//         const value = e.target.value;
//         setText(value);

//         if (value.trim().length > 0) {
//             const filtered = allCategories
//                 .filter(category =>
//                     category.catageoryName.toLowerCase().includes(value.toLowerCase())
//                 )
//                 .slice(0, 5); // Show only top 5 suggestions

//             setCategorySuggestions(filtered);
//             setShowCategorySuggestions(filtered.length > 0);
//         } else {
//             setCategorySuggestions([]);
//             setShowCategorySuggestions(false);
//         }
//     };

//     const handleDishInputChange = (e) => {
//         const value = e.target.value;
//         setSubDishName(value);

//         if (value.trim().length > 0) {
//             const filtered = allDishes
//                 .filter(dish =>
//                     dish.name.toLowerCase().includes(value.toLowerCase())
//                 )
//                 .slice(0, 5); // Show only top 5 suggestions

//             setDishSuggestions(filtered);
//             setShowDishSuggestions(filtered.length > 0);
//         } else {
//             setDishSuggestions([]);
//             setShowDishSuggestions(false);
//         }
//     };

//     // Function to select a category suggestion
//     const selectCategorySuggestion = (categoryName) => {
//         setText(categoryName);
//         setCategorySuggestions([]);
//         setShowCategorySuggestions(false);
//     };

//     // Function to select a dish suggestion
//     const selectDishSuggestion = (dishName) => {
//         setSubDishName(dishName);
//         setDishSuggestions([]);
//         setShowDishSuggestions(false);
//     };

//     const normalizeForSearch = (text) => {
//         if (!text) return '';

//         // Convert to lowercase and replace multiple separators with space
//         return text
//             .toLowerCase()
//             .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
//             .trim();
//     };
//     // Add these near your other state declarations
//     const [showErrorModal, setShowErrorModal] = useState(false);
//     const [errorModalDetails, setErrorModalDetails] = useState({
//         title: '',
//         message: '',
//         type: 'error', // 'error', 'warning', 'success'
//         showGuidelinesButton: false,
//         presetName: 'PRODUCT_IMAGE'
//     });

//     const handleSearch = (query) => {
//         const searchTerm = normalizeForSearch(query);
//         setSearchQuery(query);

//         if (!searchTerm) {
//             setSearchActive(false);
//             applyFilter(data, isVegSelected);
//             return;
//         }

//         setSearchActive(true);

//         // Create search patterns:
//         // 1. Exact match (with spaces normalized)
//         // 2. Without spaces (for "vegmeals")
//         // 3. Individual words
//         const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
//         const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

//         const searchResults = data.map(category => {
//             // Normalize category
//             const normalizedCategory = normalizeForSearch(category.category);
//             const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

//             // Check category matches
//             const categoryMatches =
//                 normalizedCategory.includes(searchTerm) ||
//                 categoryWithoutSpaces.includes(searchWithoutSpaces) ||
//                 searchWords.every(word => normalizedCategory.includes(word));

//             // Filter subcategories
//             const filteredSubcategories = category.subcategories?.filter(sub => {
//                 // Normalize subcategory fields
//                 const normalizedSubName = normalizeForSearch(sub.subName);
//                 const normalizedDescription = normalizeForSearch(sub.description);
//                 const normalizedTag = normalizeForSearch(sub.tag);

//                 const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
//                 const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

//                 // Multiple matching strategies
//                 const nameMatches =
//                     normalizedSubName.includes(searchTerm) ||
//                     subNameWithoutSpaces.includes(searchWithoutSpaces) ||
//                     searchWords.every(word => normalizedSubName.includes(word));

//                 const descMatches =
//                     normalizedDescription.includes(searchTerm) ||
//                     descWithoutSpaces.includes(searchWithoutSpaces) ||
//                     searchWords.every(word => normalizedDescription.includes(word));

//                 const tagMatches =
//                     normalizedTag.includes(searchTerm) ||
//                     normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

//                 return nameMatches || descMatches || tagMatches;
//             });

//             // Include category if it matches or has matching subcategories
//             if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
//                 return {
//                     ...category,
//                     subcategories: categoryMatches ? category.subcategories : filteredSubcategories
//                 };
//             }

//             return null;
//         }).filter(category => category !== null);

//         setFilteredData(searchResults);
//     };


//     const handleFilterClick = (tag) => {
//         const vegSelected = tag === 'Veg';
//         setIsVegSelected(vegSelected);
//         setSearchActive(false);
//         setSearchQuery("");
//         applyFilter(data, vegSelected);
//     };

//     const fileInputRef = useRef(null);
//     const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
//     const [subDishName, setSubDishName] = useState('');
//     const [price, setPrice] = useState('');
//     const [description, setDescription] = useState('');
//     const [stockQuantity, setStockQuantity] = useState('');
//     // Add this with your other state declarations
//     const [categoryQuantities, setCategoryQuantities] = useState({});
//     const [gst, setGst] = useState('');
//     const [discount, setdiscount] = useState('');
//     const [packingCharges, setPackingCharges] = useState('');
//     const [tag, setTag] = useState('Veg');
//     const [stock, setStock] = useState('In Stock');
//     const [menuStatus, setMenuStatus] = useState(true);
//     const [parentDishDetails, setParentDishDetails] = useState(null);
//     const [filteredData, setFilteredData] = useState([]);
//     const [showSubEditModal, setShowSubEditModal] = React.useState(false);
//     const [editSubItem, setEditSubItem] = React.useState({
//         dishId: '',
//         subName: '',
//         discount: '',
//         price: '',
//         // stockQuantity: '',
//         gst: '',
//         packingCharges: '',
//         image: '',
//         tag: 'Veg', // Add this line
//         chefType: '',
//         parentIndex: null,
//         subIndex: null,
//         description: '',
//     });
//     // Add this function for category image upload


//     const [subCategoryData, setSubCategoryData] = React.useState({
//         dishImage: '',
//     });

//     // const applyFilter = (allData, vegOnly) => {
//     //     if (vegOnly === null) {
//     //         setFilteredData(allData);
//     //         return;
//     //     }

//     //     const filtered = allData.map(category => {
//     //         const filteredSubcategories = category.subcategories.filter(
//     //             sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
//     //         );

//     //         return {
//     //             ...category,
//     //             subcategories: filteredSubcategories
//     //         };
//     //     }).filter(cat => cat.subcategories.length > 0);

//     //     setFilteredData(filtered);
//     // };
//     const applyFilter = (allData, vegOnly) => {
//         let filtered = allData;

//         // Apply category filter if selected
//         if (selectedCategory) {
//             filtered = filtered.filter(item => item.category === selectedCategory);
//         }

//         // Apply veg filter if selected
//         if (vegOnly !== null) {
//             filtered = filtered.map(category => {
//                 const filteredSubcategories = category.subcategories.filter(
//                     sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
//                 );
//                 return {
//                     ...category,
//                     subcategories: filteredSubcategories
//                 };
//             }).filter(cat => cat.subcategories.length > 0);
//         }

//         // Apply search if active
//         if (searchActive && searchQuery) {
//             filtered = filtered.map(category => {
//                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
//                 const filteredSubcategories = category.subcategories.filter(sub =>
//                     sub.subName?.toLowerCase().includes(searchQuery) ||
//                     sub.description?.toLowerCase().includes(searchQuery)
//                 );

//                 if (categoryMatches || filteredSubcategories.length > 0) {
//                     return {
//                         ...category,
//                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
//                     };
//                 }
//                 return null;
//             }).filter(category => category !== null);
//         }

//         setFilteredData(filtered);
//     };


//     const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
//         try {
//             setDishId(subDishId);
//             const token = localStorage.getItem("authToken");

//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             const subDish = response.data;

//             setEditSubItem({
//                 dishId: subDish.dishId,
//                 subName: subDish.dishName || '',
//                 price: subDish.price || '',
//                 discount: subDish.discount || '',
//                 // stockQuantity: subDish.stockQuantity || '',
//                 gst: subDish.gst || '',
//                 packingCharges: subDish.packingCharges || '',
//                 image: subDish.dishImage || '',
//                 chefType: subDish.chefType || '',
//                 chefType: subDish.chefType || 'Chef_All', // Add this line
//                 tag: subDish.tag || 'Veg', // Add this line
//                 parentIndex,
//                 subIndex,
//                 description: subDish.description || '',
//                 stockQuantity: subDish.stockQuantity || 0,
//                 consumedQuantity: subDish.consumedQuantity || 0,
//                 balanceQuantity: subDish.balanceQuantity || 0,
//             });

//             setShowSubEditModal(true);
//         } catch (error) {
//             alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
//             console.error(error);
//         }
//     };
//     // Function to apply category quantity to all subcategories
//     const handleApplyQuantityToSubcategories = async (categoryId, quantity) => {


//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication failed. Please login again.");
//             return;
//         }

//         showLoader();
//         let successCount = 0;
//         let failCount = 0;

//         try {
//             // Find the category and its subcategories
//             const category = data.find(item => item.dishId === categoryId);

//             if (!category || !category.subcategories || category.subcategories.length === 0) {
//                 alert("No subcategories found under this category.");
//                 hideLoader();
//                 return;
//             }

//             // Update each subcategory's stockQuantity
//             for (const sub of category.subcategories) {
//                 try {
//                     const url = `https://backend.maamaas.com/food/api/dish/edit/${sub.dishId}`;

//                     const formData = new FormData();
//                     const dishData = {
//                         dishName: sub.subName,
//                         price: sub.price,
//                         stockQuantity: quantity, // Set the quantity here
//                         gst: sub.gst || 0,
//                         packingCharges: sub.packingCharges || 0,
//                         discount: sub.discount || 0,
//                         tag: sub.tag || 'Veg',
//                         chefType: sub.chefType || 'Chef_All',
//                         description: sub.description || '',
//                     };

//                     formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//                     const response = await axios.put(url, formData, {
//                         headers: {
//                             "Authorization": `Bearer ${token}`,
//                             "Content-Type": "multipart/form-data",
//                         },
//                     });

//                     if (response.status === 200) {
//                         successCount++;

//                         // Update local state immediately
//                         setData(prevData => {
//                             return prevData.map(cat => {
//                                 if (cat.dishId === categoryId) {
//                                     return {
//                                         ...cat,
//                                         subcategories: cat.subcategories.map(subItem => {
//                                             if (subItem.dishId === sub.dishId) {
//                                                 return { ...subItem, stockQuantity: quantity };
//                                             }
//                                             return subItem;
//                                         })
//                                     };
//                                 }
//                                 return cat;
//                             });
//                         });

//                         // Also update filteredData
//                         setFilteredData(prevData => {
//                             return prevData.map(cat => {
//                                 if (cat.dishId === categoryId) {
//                                     return {
//                                         ...cat,
//                                         subcategories: cat.subcategories.map(subItem => {
//                                             if (subItem.dishId === sub.dishId) {
//                                                 return { ...subItem, stockQuantity: quantity };
//                                             }
//                                             return subItem;
//                                         })
//                                     };
//                                 }
//                                 return cat;
//                             });
//                         });
//                     } else {
//                         failCount++;
//                     }
//                 } catch (error) {
//                     console.error(`Failed to update subcategory ${sub.subName}:`, error);
//                     failCount++;
//                 }
//             }

//             // Show result
//             if (successCount > 0) {
//                 showSuccessMessage(
//                     'Update Complete',
//                     ``
//                 );
//             } else {
//                 alert(`Failed to update any subcategories. Please try again.`);
//             }

//         } catch (error) {
//             console.error("Error applying quantity to subcategories:", error);
//             alert("An error occurred while updating subcategories.");
//         } finally {
//             hideLoader();
//         }
//     };


//     // Add this function to handle image validation
//     // const validateImage = async (file) => {
//     //     try {
//     //         const result = await imageValidationRules.validateImage(file, 'PRODUCT_IMAGE');
//     //         console.log(result);
//     //         return result;
//     //     } catch (error) {
//     //         console.error('Validation error:', error);
//     //         return {
//     //             isValid: false,
//     //             errors: ['Image upload failed. Please try a different image.'],
//     //             warnings: []
//     //         };
//     //     }
//     // };


//     // Update the handleSubImageChange function (around line 170-200):
//     const handleSubImageChange = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         setImageFile(file);
//         const reader = new FileReader();
//         reader.onloadend = () => setImage(reader.result);
//         reader.readAsDataURL(file);
//     };

//     const handleImageUpload = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         setCategoryImageFile(file);
//         const reader = new FileReader();
//         reader.onloadend = () => setImage(reader.result);
//         reader.readAsDataURL(file);
//     };

//     // Update the handleSave function (around line 220-290):
//     const handleSave = async () => {
//         // Check categoryImageFile instead of imageFile
//         // if (!categoryImageFile) {
//         //     showErrorModalMessage(
//         //         'Image Required',
//         //         'Please upload an image for the category.',
//         //         'error',
//         //         true,
//         //         'PRODUCT_IMAGE'
//         //     );
//         //     return;
//         // }

//         if (!text.trim()) {
//             showErrorModalMessage(
//                 'Category Name Required',
//                 'Please enter a name for the category.',
//                 'error'
//             );
//             return;
//         }

//         showLoader();
//         try {
//             // Validate the category image
//             // const validationResult = await validateImage(categoryImageFile);
//             // if (!validationResult.isValid) {
//             //     validationResult.errors.forEach(error => {
//             //         showImageError(error, 'PRODUCT_IMAGE');
//             //     });
//             //     return;
//             // }

//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!vendorId) {
//                 alert("🔐 Please log in again. Your session may have expired.");
//                 return;
//             }

//             if (!token) {
//                 alert("🔐 Please log in again. Your session may have expired.");
//                 return;
//             }

//             const formData = new FormData();
//             const dishData = {
//                 dishId: 0,
//                 price: 0,
//                 dishName: text.trim(),
//                 parentId: 0,
//                 stockQuantity: 0,
//                 gst: 0,
//                 packingCharges: 0,
//             };

//             formData.append(
//                 "dishData",
//                 new Blob([JSON.stringify(dishData)], { type: "application/json" })
//             );

//             formData.append("image", categoryImageFile);

//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             showSuccessMessage(
//                 'Dish Added',
//                 'Dish has been added successfully!'
//             );
//             setShowPopup(false);
//             setText("");
//             setImage(null);
//             setCategoryImageFile(null);

//             // Reset file input
//             if (fileInputRef.current) {
//                 fileInputRef.current.value = '';
//             }
//             window.location.reload();
//         } catch (error) {
//             console.error("Upload failed:", error.response?.data || error.message);

//             // Friendly error messages for common API errors
//             let userMessage = "Failed to add category. ";

//             if (error.response?.status === 401) {
//                 userMessage += "Your session has expired. Please log in again.";
//             } else if (error.response?.status === 400) {
//                 userMessage += "Please check the image format and try again.";
//             } else if (error.response?.data?.message?.includes("image")) {
//                 userMessage += "The image format may not be supported. Please try a JPG or PNG file.";
//             } else if (!navigator.onLine) {
//                 userMessage += "No internet connection. Please check your network.";
//             } else {
//                 userMessage += "Please try again.";
//             }

//             showErrorModalMessage('Upload Failed', userMessage, 'error');
//         } finally {
//             hideLoader();
//         }
//     };


//     const handleEditImageChange = async (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setEditItem(prev => ({
//                 ...prev,
//                 newImageFile: file,
//                 image: URL.createObjectURL(file)
//             }));
//         }
//     };



//     // Update the handleSubcategorySubmit function (around line 340-440):
//     const handleSubcategorySubmit = async () => {


//         // if (!imageFile) {
//         //     showErrorModalMessage(
//         //         'Image Required',
//         //         'Please select an image for the dish.',
//         //         'error',
//         //         true,
//         //         'PRODUCT_IMAGE'
//         //     );
//         //     return;
//         // }

//         showLoader();
//         setShowSubcategoryPopup(false);
//         try {
//             // Validate image
//             // const validationResult = await validateImage(imageFile);
//             // if (!validationResult.isValid) {
//             //     validationResult.errors.forEach(error => {
//             //         showImageError(error, 'PRODUCT_IMAGE');
//             //     });
//             //     return;
//             // }

//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");

//             if (!vendorId) {
//                 alert("🔐 Please log in again. Your session may have expired.");
//                 return;
//             }

//             if (!token) {
//                 alert("🔐 Please log in again. Your session may have expired.");
//                 return;
//             }

//             const formData = new FormData();
//             const dishData = {
//                 dishId: 0,
//                 price: parseFloat(price) || 0,
//                 dishName: subDishName.trim() || "Unnamed Dish",
//                 parentId: Number(parentDishDetails?.dishId) || 1,
//                 stockQuantity: stockQuantity || 0,
//                 gst: gst || 0,
//                 packingCharges: packingCharges || 0,
//                 discount: discount || 0,
//                 tag: tag || "Veg",
//                 stock: stock ? "In_Stock" : "Out_of_Stock",
//                 menuStatus: menuStatus ? "Enable" : "Disable",
//                 description: description?.trim() || "",
//                 consumedQuantity: 0,
//                 balanceQuantity: 0,
//                 effectivePrice: 0,
//                 chefType: chefType || "Chef_All"
//             };

//             formData.append(
//                 "dishData",
//                 new Blob([JSON.stringify(dishData)], { type: "application/json" })
//             );

//             formData.append("image", imageFile);

//             const res = await axios.post(
//                 `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
//                 formData,
//                 {
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                     },
//                 }
//             );

//             showSuccessMessage(
//                 'Dish Added',
//                 'Dish has been added successfully!'
//             );
//             // window.location.reload();

//             setSubDishName('');
//             setPrice('');
//             setGst('');
//             setPackingCharges('');
//             setTag('Veg');
//             setStock('In Stock');
//             setMenuStatus(true);
//             setSubCategoryData({ dishImage: '' });
//             setdiscount('');
//             setImage(null);
//             setImageFile(null);

//             fetchData();
//         } catch (error) {
//             console.error("❌ Error response:", error.response?.data || error.message);

//             // Friendly error messages
//             let userMessage = "Failed to add dish. ";

//             if (error.response?.status === 401) {
//                 userMessage = "Your session has expired. Please log in again.";
//             } else if (error.response?.status === 400) {
//                 userMessage = "Please check all fields and try again.";
//             } else if (error.message.includes("Network Error")) {
//                 userMessage = "No internet connection. Please check your network.";
//             } else if (error.response?.data?.error?.includes("price") || error.response?.data?.error?.includes("Price")) {
//                 userMessage = "Please enter a valid price.";
//             } else {
//                 userMessage += "Please try again.";
//             }
//             showErrorModalMessage('Upload Failed', 'Failed to add dish. Please try again.', 'error');
//         } finally {
//             hideLoader();
//         }
//     };


//     // Update the submitEditSubcategory function (around line 450-520):
//     const submitEditSubcategory = async () => {
//         if (!editSubItem || !editSubItem.dishId) {
//             alert("❌ Unable to update. Please refresh the page and try again.");
//             return;
//         }

//         showLoader();
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 alert("🔐 Please log in again. Your session may have expired.");
//                 return;
//             }

//             // Validate new image if provided
//             // if (editSubItem.newImageFile) {
//             //     const validationResult = await validateImage(editSubItem.newImageFile);
//             //     if (!validationResult.isValid) {
//             //         const errorMessage = validationResult.errors[0]?.includes('Portrait image rejected')
//             //             ? "Please upload a landscape image (wider than tall)."
//             //             : "Please upload a valid image (JPG/PNG, landscape, under 5MB).";

//             //         alert(`⚠️ ${errorMessage}`);
//             //         return;
//             //     }
//             // }

//             const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

//             const formData = new FormData();
//             const dishData = {
//                 dishName: editSubItem.subName,
//                 price: editSubItem.price,
//                 stockQuantity: editSubItem.stockQuantity || 0, // Include stock quantity
//                 consumedQuantity: editSubItem.consumedQuantity || 0, // Include consumed quantity
//                 balanceQuantity: editSubItem.balanceQuantity || 0, // Include balance quantity

//                 gst: editSubItem.gst,
//                 packingCharges: editSubItem.packingCharges,
//                 discount: editSubItem.discount,
//                 tag: editSubItem.tag || 'Veg',
//                 chefType: editSubItem.chefType || 'Chef_All',
//                 description: editSubItem.description,
//             };

//             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//             if (editSubItem.newImageFile) {
//                 formData.append("image", editSubItem.newImageFile);
//             }

//             const response = await axios.put(url, formData, {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             alert("✅ Dish updated successfully!");
//             window.location.reload();
//         } catch (error) {
//             console.error("Error updating subcategory:", error);

//             let userMessage = "Failed to update dish. ";

//             if (error.response?.status === 401) {
//                 userMessage = "Your session has expired. Please log in again.";
//             } else if (error.response?.status === 400) {
//                 userMessage = "Please check all fields and try again.";
//             } else {
//                 userMessage += "Please try again.";
//             }

//             alert(`❌ ${userMessage}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Add this function for bulk updating selected subcategories
//     const handleBulkUpdate = async () => {
//         const selectedIds = Object.keys(selectedItems).filter(id => selectedItems[id]);

//         if (selectedIds.length === 0) {
//             alert("No items selected");
//             return;
//         }

//         if (!bulkQuantity || bulkQuantity === '') {
//             alert("Please enter a quantity");
//             return;
//         }

//         const quantity = parseInt(bulkQuantity);
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             alert("Authentication failed. Please login again.");
//             return;
//         }

//         if (!window.confirm(`Update ${selectedIds.length} items with quantity ${quantity}?`)) {
//             return;
//         }

//         showLoader();
//         let successCount = 0;
//         let failCount = 0;

//         try {
//             for (const dishId of selectedIds) {
//                 try {
//                     // Find the subcategory details
//                     let subDetails = null;
//                     for (const category of data) {
//                         const found = category.subcategories?.find(s => s.dishId == dishId);
//                         if (found) {
//                             subDetails = found;
//                             break;
//                         }
//                     }

//                     if (!subDetails) continue;

//                     const url = `https://backend.maamaas.com/food/api/dish/edit/${dishId}`;

//                     const formData = new FormData();
//                     const dishData = {
//                         dishName: subDetails.subName,
//                         price: subDetails.price,
//                         stockQuantity: quantity,
//                         gst: subDetails.gst || 0,
//                         packingCharges: subDetails.packingCharges || 0,
//                         discount: subDetails.discount || 0,
//                         tag: subDetails.tag || 'Veg',
//                         chefType: subDetails.chefType || 'Chef_All',
//                         description: subDetails.description || '',
//                     };

//                     formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//                     const response = await axios.put(url, formData, {
//                         headers: {
//                             "Authorization": `Bearer ${token}`,
//                             "Content-Type": "multipart/form-data",
//                         },
//                     });

//                     if (response.status === 200) {
//                         successCount++;

//                         // Update local state immediately
//                         setData(prevData => {
//                             return prevData.map(category => ({
//                                 ...category,
//                                 subcategories: category.subcategories.map(sub => {
//                                     if (sub.dishId == dishId) {
//                                         return { ...sub, stockQuantity: quantity };
//                                     }
//                                     return sub;
//                                 })
//                             }));
//                         });

//                         setFilteredData(prevData => {
//                             return prevData.map(category => ({
//                                 ...category,
//                                 subcategories: category.subcategories.map(sub => {
//                                     if (sub.dishId == dishId) {
//                                         return { ...sub, stockQuantity: quantity };
//                                     }
//                                     return sub;
//                                 })
//                             }));
//                         });
//                     } else {
//                         failCount++;
//                     }
//                 } catch (error) {
//                     console.error(`Failed to update dish ${dishId}:`, error);
//                     failCount++;
//                 }
//             }

//             // Show result
//             if (successCount > 0) {
//                 showSuccessMessage(
//                     '✅ Bulk Update Complete',
//                     `Successfully updated ${successCount} items.\n${failCount > 0 ? `Failed: ${failCount}` : ''}`
//                 );

//                 // Exit bulk mode after successful update
//                 setBulkMode(false);
//                 setSelectedItems({});
//                 setBulkQuantity('');
//             } else {
//                 alert(`Failed to update any items. Please try again.`);
//             }

//         } catch (error) {
//             console.error("Error in bulk update:", error);
//             alert("An error occurred during bulk update.");
//         } finally {
//             hideLoader();
//         }
//     };
//     // Get image requirements text
//     // const getImageRequirementsText = () => {
//     //     const rules = imageValidationRules.PRESETS.PRODUCT_IMAGE;
//     //     return `Required: Yes | Max Size: ${rules.maxSizeMB}MB | Formats: ${rules.recommendedFormats.join(', ')} | Min Dimensions: ${rules.minDimensions.width}×${rules.minDimensions.height}px`;
//     // };





//     // Update the handleAddSubCategory function (around line 550-590):
//     const handleAddSubCategory = async (dishId) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("🔐 Please log in again. Your session may have expired.");
//             return;
//         }

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/get/${dishId}`,
//                 {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const dishData = await response.json();
//             setParentDishDetails(dishData);

//             // Reset image states when opening subcategory modal
//             setImage(null);
//             setImageFile(null);
//             setShowSubcategoryPopup(true);

//         } catch (error) {
//             console.error("Failed to fetch dish data:", error);
//             alert("❌ Unable to load dish details. Please try again.");
//         } finally {
//             hideLoader();
//         }
//     };


//     const importExportButton = {
//         height: window.innerWidth < 480 ? '32px' : '35px',
//         borderRadius: "4px",
//         border: "none",
//         backgroundColor: "#b15cd6",
//         color: "white",
//         fontWeight: '500',
//         fontSize: window.innerWidth < 480 ? "0.7rem" : "0.75rem",
//         padding: window.innerWidth < 480 ? "0 12px" : "0 15px",
//         cursor: "pointer",
//         whiteSpace: "nowrap",
//         minWidth: window.innerWidth < 480 ? "70px" : "80px"
//     };

//     // Updated Export Function - Exports ALL data in import format
//     const handleExport = () => {
//         // Use original data, not filteredData
//         if (!data || data.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         try {
//             const exportData = [];

//             // Process all categories
//             data.forEach((category, index) => {
//                 // Category row
//                 exportData.push({
//                     "S.No": index + 1,
//                     "Category*": category.category || "",
//                     "Subcategory": "", // Empty for categories
//                     "Type": "", // Categories don't have type
//                     "Price*": "", // Categories don't have price
//                     "GST": "",
//                     "Packing": "",
//                     "Discount": "",
//                     "Chef Type": "", // Categories don't have chef type
//                     "Description": "",
//                     "Menu Status": category.menuStatus || "Enable",
//                     "Image URL": category.image || ""
//                 });

//                 // Subcategory rows
//                 if (category.subcategories && category.subcategories.length > 0) {
//                     category.subcategories.forEach((sub, subIndex) => {
//                         exportData.push({
//                             "S.No": `${index + 1}.${subIndex + 1}`,
//                             "Category*": category.category || "", // Same as parent
//                             "Subcategory": sub.subName || "",
//                             "Type": sub.tag || "Veg", // REQUIRED for import
//                             "Price*": sub.price || 0, // REQUIRED for import
//                             "GST": sub.gst || 0,
//                             "Packing": sub.packingCharges || 0,
//                             "Discount": sub.discount || 0,
//                             "Chef Type": sub.chefType || "Chef_All",
//                             "Description": sub.description || "",
//                             "Menu Status": sub.menuStatus || "Enable",
//                             "Image URL": sub.image || ""
//                         });
//                     });
//                 }
//             });

//             // Create worksheet
//             const worksheet = XLSX.utils.json_to_sheet(exportData);

//             // Auto-size columns
//             const colWidths = Object.keys(exportData[0]).map(key => ({
//                 wch: Math.max(
//                     key.length,
//                     ...exportData.map(row => String(row[key] || "").length)
//                 )
//             }));
//             worksheet["!cols"] = colWidths;

//             // Create workbook and export
//             const workbook = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

//             // Add instructions sheet
//             const instructions = [
//                 ["IMPORTANT INSTRUCTIONS FOR IMPORT:"],
//                 ["1. * indicates REQUIRED fields"],
//                 ["2. Do NOT modify S.No column - it's for reference only"],
//                 ["3. For Categories: Fill only Category* and Menu Status"],
//                 ["4. For Subcategories: Fill ALL fields except Image URL (optional)"],
//                 ["5. Type MUST be: Veg or Non_Veg (case-sensitive)"],
//                 ["6. Chef Type options: Chef_All, Chef_North, Chef_South, Chef_Chinese, Chef_Continental, Tea_stall, Snacks, Bakery"],
//                 ["7. Menu Status: Enable or Disable"],
//                 ["8. Price must be a number (no .Rs suffix)"],
//                 ["9. GST, Packing, Discount: Numbers only (no % suffix)"],
//                 ["10. Image URL: Optional, leave blank if no image"]
//             ];

//             const wsInstructions = XLSX.utils.aoa_to_sheet(instructions);
//             XLSX.utils.book_append_sheet(workbook, wsInstructions, "Instructions");

//             // Add date to filename
//             const dateStr = new Date().toISOString().split('T')[0];
//             XLSX.writeFile(workbook, `full_menu_export_${dateStr}.xlsx`);

//             alert(`✅ Menu exported successfully! ${exportData.length} items saved.`);
//         } catch (error) {
//             console.error("Export error:", error);
//             alert(`❌ Export failed. Please try again.`);
//         }
//     };

//     // Updated Import Function with Better Error Handling
//     const handleFileImport = async (e) => {
//         const file = e.target.files[0];
//         console.log("IMPORT - File selected:", file?.name, file?.type, file?.size);

//         if (!file) {
//             console.log("IMPORT - No file selected");
//             return;
//         }

//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         console.log("IMPORT - Vendor ID:", vendorId);
//         console.log("IMPORT - Auth Token exists:", !!authToken);

//         if (!vendorId || !authToken) {
//             alert("Authentication error. Please log in again.");
//             return;
//         }

//         showLoader();

//         try {
//             // Read and log the file content
//             const reader = new FileReader();
//             reader.onload = async (event) => {
//                 try {
//                     const data = new Uint8Array(event.target.result);
//                     const workbook = XLSX.read(data, { type: 'array' });
//                     const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//                     const jsonData = XLSX.utils.sheet_to_json(firstSheet);

//                     console.log("IMPORT - Parsed JSON data (first 3 rows):", jsonData.slice(0, 3));
//                     console.log("IMPORT - Total rows:", jsonData.length);

//                     if (!jsonData || jsonData.length === 0) {
//                         alert("The file is empty or couldn't be read.");
//                         hideLoader();
//                         return;
//                     }

//                     // Log column headers
//                     console.log("IMPORT - Column headers:", Object.keys(jsonData[0]));

//                     // Create FormData and log it
//                     const formData = new FormData();
//                     formData.append("file", file);

//                     // Log FormData contents (can't directly log FormData)
//                     console.log("IMPORT - Sending to backend...");

//                     const response = await axios.post(
//                         `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
//                         formData,
//                         {
//                             headers: {
//                                 "Content-Type": "multipart/form-data",
//                                 Authorization: `Bearer ${authToken}`,
//                             },
//                             timeout: 30000,
//                         }
//                     );

//                     console.log("IMPORT - Response:", response.data);
//                     alert(`✅ Successfully imported ${jsonData.length} items!`);
//                     fetchData();

//                 } catch (error) {
//                     console.error("IMPORT - Error details:", {
//                         message: error.message,
//                         response: error.response?.data,
//                         status: error.response?.status,
//                         headers: error.response?.headers
//                     });

//                     // Show more detailed error message
//                     const errorMsg = error.response?.data?.message || error.message;
//                     alert(`Error processing file: ${errorMsg}\n\nStatus: ${error.response?.status}`);
//                 } finally {
//                     hideLoader();
//                     e.target.value = '';
//                 }
//             };

//             reader.onerror = () => {
//                 console.error("IMPORT - FileReader error");
//                 alert("Error reading file. Please try again.");
//                 hideLoader();
//                 e.target.value = '';
//             };

//             reader.readAsArrayBuffer(file);

//         } catch (error) {
//             console.error("IMPORT - Outer catch:", error);
//             alert(`Import failed: ${error.message}`);
//             hideLoader();
//             e.target.value = '';
//         }
//     };


//     const handleEdit = async (id) => {
//         try {
//             setDishId(id);
//             const token = localStorage.getItem("authToken");
//             const vendorId = localStorage.getItem("vendorId");
//             if (!token) {
//                 alert("Authentication token missing. Please log in again.");
//                 return;
//             }
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                 {
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );


//             const dishes = Array.isArray(response.data)
//                 ? response.data
//                 : response.data.data || [];

//             const dish = dishes.find((d) => d.dishId == id);

//             if (!dish) {
//                 alert(`Dish with ID ${id} not found`);
//                 return;
//             }

//             setEditItem({
//                 dishId: dish.dishId,
//                 dishName: dish.dishName || "",
//                 image: dish.dishImage || "",
//             });

//             setShowEditModal(true);
//         } catch (error) {
//             console.error("Error fetching dish details:", error);
//             alert(
//                 "Error fetching dish details:\n" +
//                 (error.response?.data?.message || error.message)
//             );
//         }
//     };

//     const submitEdit = async () => {
//         if (!editItem.dishId) {
//             alert("Dish ID is missing!");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token missing. Please log in again.");
//             return;
//         }

//         try {
//             showLoader();
//             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

//             const formData = new FormData();
//             const dishData = {
//                 dishName: editItem.dishName,
//             };
//             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//             if (editItem.newImageFile) {
//                 formData.append("image", editItem.newImageFile);
//             }

//             const response = await axios.put(url, formData, {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             // Don't reload or close modal here - let the calling function handle it
//             return response;

//         } catch (error) {
//             console.error("Error updating dish:", error);
//             if (error.response) {
//                 alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
//             } else {
//                 alert(`Failed to update dish: ${error.message}`);
//             }
//             throw error; // Re-throw so the calling function knows it failed
//         } finally {
//             hideLoader();
//         }
//     };



//     const fetchData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId) {
//             console.warn("⚠️ vendorId not found in localStorage");
//             setError(new Error("vendorId missing"));
//             setLoading(false);
//             return;
//         }

//         if (!token) {
//             console.warn("⚠️ authToken not found in localStorage");
//             setError(new Error("authToken missing"));
//             setLoading(false);
//             return;
//         }

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`
//                     }
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const dishData = await response.json();

//             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

//             const formattedData = parentCategories.map(category => {
//                 const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

//                 return {
//                     dishId: category.dishId,
//                     SNo: category.dishId,
//                     category: category.dishName,
//                     image: category.dishImage || '',
//                     isChecked: false,
//                     parentId: category.parentId,
//                     id: category.dishId,
//                     isAdded: true,
//                     menuStatus: category.menuStatus || "Enable", // Ensure this exists
//                     // Categories should NOT have tag/type and description
//                     subcategories: subcategories.map(sub => ({
//                         dishId: sub.dishId,
//                         subName: sub.subName || sub.dishName,
//                         price: sub.price || 0,
//                         deliveryPrice: sub.deliveryPrice || 0,
//                         description: sub.description || "",
//                         image: sub.dishImage,
//                         tag: sub.tag || "Veg", // Type only for subcategories
//                         gst: sub.gst || 0,
//                         packingCharges: sub.packingCharges || 0,
//                         discount: sub.discount || 0,
//                         chefType: sub.chefType || 0,
//                         menuStatus: sub.menuStatus || "Enable", // ADD THIS
//                         stockQuantity: sub.stockQuantity || 0,
//                         consumedQuantity: sub.consumedQuantity || 0,
//                         balanceQuantity: sub.balanceQuantity || 0,
//                     }))
//                 };
//             });

//             setData(formattedData);
//             applyFilter(formattedData, isVegSelected);

//             setData(formattedData);
//             setSearchQuery(""); // Clear search
//             setSearchActive(false); // Reset search state
//             applyFilter(formattedData, isVegSelected);

//         } catch (error) {
//             setError(error);
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, []);

//     const handleCheckboxChange = (e, index) => {
//         const { checked } = e.target;
//         setData(prevData => {
//             const updatedData = [...prevData];
//             updatedData[index].isChecked = checked;
//             return updatedData;
//         });
//     };

//     const handleSelectAll = (e) => {
//         const checked = e.target.checked;
//         const newSelected = {};

//         if (checked) {
//             // Select all items (categories and subcategories)
//             filteredData.forEach(category => {
//                 newSelected[category.dishId] = true;
//                 category.subcategories?.forEach(sub => {
//                     newSelected[sub.dishId] = true;
//                 });
//             });
//         }

//         setSelectedItems(newSelected);
//     };
//     const totalItemsCount = filteredData.reduce((count, category) => {
//         return count + 1 + (category.subcategories?.length || 0);
//     }, 0);

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 setImage(reader.result);
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     // In StandardMenu.jsx, update the handleToggleStatus function:
//     const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !authToken) {
//             alert("Authentication failed. Please login again.");
//             return;
//         }

//         const isCategory = (subIndex === null || subIndex === undefined);
//         const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

//         // ✅ FIX: Update local state IMMEDIATELY
//         if (isCategory) {
//             // For category: Update category and all its subcategories
//             setData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index] = {
//                     ...updatedData[index],
//                     menuStatus: newStatus,
//                     subcategories: updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         menuStatus: newStatus
//                     }))
//                 };
//                 return updatedData;
//             });

//             // Also update filteredData immediately
//             setFilteredData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index] = {
//                     ...updatedData[index],
//                     menuStatus: newStatus,
//                     subcategories: updatedData[index].subcategories.map(sub => ({
//                         ...sub,
//                         menuStatus: newStatus
//                     }))
//                 };
//                 return updatedData;
//             });
//         } else {
//             // For subcategory
//             setData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index].subcategories[subIndex] = {
//                     ...updatedData[index].subcategories[subIndex],
//                     menuStatus: newStatus
//                 };
//                 return updatedData;
//             });

//             setFilteredData(prevData => {
//                 const updatedData = [...prevData];
//                 updatedData[index].subcategories[subIndex] = {
//                     ...updatedData[index].subcategories[subIndex],
//                     menuStatus: newStatus
//                 };
//                 return updatedData;
//             });
//         }

//         // Make API call
//         try {
//             const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
//             const payload = { menuStatus: newStatus };

//             await axios.put(url, payload, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${authToken}`,
//                 },
//             });


//             // If category, update all subcategories too
//             if (isCategory) {
//                 const category = data[index];
//                 if (category.subcategories && category.subcategories.length > 0) {
//                     for (const sub of category.subcategories) {
//                         const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
//                         const subPayload = { menuStatus: newStatus };

//                         await axios.put(subUrl, subPayload, {
//                             headers: {
//                                 'Content-Type': 'application/json',
//                                 'Authorization': `Bearer ${authToken}`,
//                             },
//                         });
//                     }
//                 }
//             }

//             localStorage.setItem(`menuStatus-${dishId}`, newStatus);

//         } catch (error) {
//             console.error('❌ Failed to toggle menu visibility:', error);
//             alert('Failed to update menu visibility. Please refresh the page.');

//             // Revert on error
//             if (isCategory) {
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     updatedData[index] = {
//                         ...updatedData[index],
//                         menuStatus: currentStatus,
//                         subcategories: updatedData[index].subcategories.map(sub => ({
//                             ...sub,
//                             menuStatus: sub.menuStatus
//                         }))
//                     };
//                     return updatedData;
//                 });
//             }
//         }
//     };


//     const handleDeleteRow = async (index, dishId) => {
//         if (!window.confirm("Are you sure you want to delete this dish?")) return;

//         const token = localStorage.getItem("authToken");

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
//                 {
//                     method: "DELETE",
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (response.ok) {
//                 alert("Dish deleted successfully!");
//                 const newData = data.filter(item => item.SNo !== dishId);
//                 setData(newData);
//             } else {
//                 const result = await response.json();
//                 alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
//             }
//         } catch (error) {
//             alert("An error occurred while deleting.");
//             console.error(error);
//         } finally {
//             hideLoader();
//         }
//     };

//     const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
//         if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

//         const token = localStorage.getItem("authToken");

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
//                 {
//                     method: "DELETE",
//                     headers: {
//                         "Authorization": `Bearer ${token}`,
//                     },
//                 }
//             );

//             if (response.ok) {
//                 alert("Subcategory deleted successfully!");

//                 setData(prevData => {
//                     const newData = [...prevData];
//                     const updatedSubcategories = [...newData[parentIndex].subcategories];
//                     updatedSubcategories.splice(subIndex, 1);
//                     newData[parentIndex] = {
//                         ...newData[parentIndex],
//                         subcategories: updatedSubcategories,
//                     };
//                     return newData;
//                 });
//             } else {
//                 const result = await response.json();
//                 alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
//             }
//         } catch (error) {
//             alert("An error occurred while deleting the subcategory.");
//             console.error(error);
//         } finally {
//             hideLoader();
//         }
//     };
//     // Add this function near your other handlers
//     const showErrorModalMessage = (title, message, type = 'error', showGuidelinesButton = false, presetName = 'PRODUCT_IMAGE') => {
//         setErrorModalDetails({
//             title,
//             message,
//             type,
//             showGuidelinesButton,
//             presetName
//         });
//         setShowErrorModal(true);
//     };

//     // Specialized functions for common errors
//     const showImageError = (validationError, presetName = 'PRODUCT_IMAGE') => {
//         let title = 'Image Issue';
//         let message = '';
//         let type = 'error';
//         let showGuidelinesButton = false;
//         let icon = '❌';

//         if (validationError.includes('Portrait image rejected')) {
//             title = 'Orientation Issue';
//             icon = '📱';
//             message = `We need a landscape (horizontal) image for better display.\n\n` +
//                 `**What to do:**\n` +
//                 `• Rotate your phone sideways before taking the photo\n` +
//                 `• Or crop/edit the image to make it wider\n` +
//                 `• Ideal ratio: 16:9 (like widescreen TV)\n\n` +
//                 `**Why?** Landscape images fit better in menus and look more professional.`;
//             type = 'warning';
//             showGuidelinesButton = true;

//         } else if (validationError.includes('not wide enough')) {
//             title = 'Image Dimensions';
//             icon = '📐';
//             message = `This image is too narrow for our menu display.\n\n` +
//                 `**Quick fix:**\n` +
//                 `• Use photo editing app to adjust aspect ratio\n` +
//                 `• Aim for width that's 1.5× height\n` +
//                 `• Example sizes: 1200×800px or 900×600px\n\n` +
//                 `**Good to know:** Wider images showcase food better!`;
//             type = 'warning';
//             showGuidelinesButton = true;

//         } else if (validationError.includes('File size')) {
//             title = 'Large File Size';
//             icon = '💾';
//             message = `This image file is too large (max: 5MB).\n\n` +
//                 `**Easy solutions:**\n` +
//                 `1. **Compress online:** Use tinypng.com (free)\n` +
//                 `2. **Reduce quality:** Save as JPG at 80% quality\n` +
//                 `3. **Resize:** Reduce to 1200px width\n` +
//                 `4. **Use mobile:** Photos from phones are often smaller\n\n` +
//                 `**Tip:** Smaller files load faster for your customers!`;

//         } else if (validationError.includes('format not allowed')) {
//             title = 'File Format';
//             icon = '🖼️';
//             message = `We accept these image formats:\n\n` +
//                 `✅ **Recommended:** JPG or PNG\n` +
//                 `✅ **Also works:** JPEG, WebP\n` +
//                 `❌ **Not supported:** PDF, PSD, BMP, TIFF\n\n` +
//                 `**How to convert:**\n` +
//                 `• iPhone/Android: Edit & "Save As" JPG\n` +
//                 `• Computer: Open in Paint & Save As JPG\n` +
//                 `• Online: Convertio.co (free tool)`;

//         } else {
//             // Generic error - make it friendly
//             title = 'Upload Issue';
//             icon = '🔄';
//             message = `We couldn't process this image.\n\n` +
//                 `**Please try:**\n` +
//                 `• A different image file\n` +
//                 `• Checking file format (JPG/PNG)\n` +
//                 `• Ensuring file size < 5MB\n` +
//                 `• Taking a new photo if needed\n\n` +
//                 `Still having trouble? View our image guidelines.`;
//             showGuidelinesButton = true;
//         }

//         // Add icon to title for visual appeal
//         const finalTitle = `${icon}  ${title}`;

//         // Show the modal
//         showErrorModalMessage(finalTitle, message, type, showGuidelinesButton, presetName);
//     };

//     const showSuccessMessage = (title, message, autoClose = true) => {
//         showErrorModalMessage(
//             title,
//             message,
//             'success',
//             false
//         );

//         if (autoClose) {
//             setTimeout(() => {
//                 setShowErrorModal(false);
//             }, 3000); // Auto-close after 3 seconds
//         }
//     };

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         setData(prevData => {
//             const updatedData = [...prevData];
//             updatedData[index][name] = value;
//             return updatedData;
//         });
//     };
//     useEffect(() => {
//         const handleGlobalKeyDown = (e) => {
//             const isTypingInInput =
//                 e.target.tagName === 'INPUT' ||
//                 e.target.tagName === 'TEXTAREA' ||
//                 e.target.isContentEditable;

//             // Focus search when '/' is pressed
//             if (e.key === '/' && !isTypingInInput) {
//                 e.preventDefault();
//                 const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
//                 if (searchInput) {
//                     searchInput.focus();
//                     searchInput.select();
//                 }
//             }

//             // Clear search with Escape
//             if (e.key === 'Escape' && searchQuery) {
//                 e.preventDefault();
//                 setSearchQuery("");
//                 setSearchActive(false);
//                 applyFilter(data, isVegSelected);
//             }
//         };

//         window.addEventListener('keydown', handleGlobalKeyDown);
//         return () => {
//             window.removeEventListener('keydown', handleGlobalKeyDown);
//         };
//     }, [searchQuery, data, isVegSelected]);
//     // Responsive styles
//     const getResponsiveValue = (mobile, tablet, desktop) => {
//         const width = window.innerWidth;
//         if (width < 768) return mobile;
//         if (width < 1024) return tablet;
//         return desktop;
//     };

//     // Function to handle category column click
//     const handleCategoryColumnClick = () => {
//         // Extract all unique categories from data
//         const categories = Array.from(new Set(data.map(item => item.category)))
//             .filter(Boolean)
//             .map(category => ({
//                 name: category,
//                 count: data.filter(item => item.category === category).length
//             }));

//         setFilteredCategories(categories);
//         setShowCategorySearchPopup(true);
//         setCategorySearchQuery('');
//     };

//     // Function to filter categories based on search
//     const handleCategorySearch = (query) => {
//         setCategorySearchQuery(query);
//         const allCategories = Array.from(new Set(data.map(item => item.category)))
//             .filter(Boolean)
//             .map(category => ({
//                 name: category,
//                 count: data.filter(item => item.category === category).length
//             }));

//         if (!query.trim()) {
//             setFilteredCategories(allCategories);
//             return;
//         }

//         const filtered = allCategories.filter(category =>
//             category.name.toLowerCase().includes(query.toLowerCase())
//         );
//         setFilteredCategories(filtered);
//     };

//     // Function to select a category
//     // Function to select a category
//     const handleCategorySelect = (categoryName) => {
//         setSelectedCategory(categoryName);

//         let filtered = data;

//         // Apply category filter if selected
//         if (categoryName) {
//             filtered = filtered.filter(item => item.category === categoryName);
//         }

//         // Apply veg filter if selected
//         if (isVegSelected !== null) {
//             filtered = filtered.map(category => {
//                 const filteredSubcategories = category.subcategories.filter(
//                     sub => isVegSelected ? sub.tag === "Veg" : sub.tag === "Non_Veg"
//                 );
//                 return {
//                     ...category,
//                     subcategories: filteredSubcategories
//                 };
//             }).filter(cat => cat.subcategories.length > 0);
//         }

//         // Apply search if active
//         if (searchActive && searchQuery) {
//             filtered = filtered.map(category => {
//                 const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
//                 const filteredSubcategories = category.subcategories.filter(sub =>
//                     sub.subName?.toLowerCase().includes(searchQuery) ||
//                     sub.description?.toLowerCase().includes(searchQuery)
//                 );

//                 if (categoryMatches || filteredSubcategories.length > 0) {
//                     return {
//                         ...category,
//                         subcategories: categoryMatches ? category.subcategories : filteredSubcategories
//                     };
//                 }
//                 return null;
//             }).filter(category => category !== null);
//         }

//         applyFilter(data, isVegSelected);
//         setFilteredData(filtered);
//         setShowCategorySearchPopup(false);
//         setCategorySearchQuery('');
//     };

//     // Add this useEffect to your component
//     useEffect(() => {
//         // This will run whenever selectedCategory changes
//         applyFilter(data, isVegSelected);
//     }, [selectedCategory, data, isVegSelected]);

//     // Update clearCategoryFilter to just set state
//     const clearCategoryFilter = () => {
//         setSelectedCategory(null);
//         // Remove search query too
//         setSearchQuery("");
//         setSearchActive(false);
//         // The useEffect above will handle the re-filtering
//     };

//     // const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

//     const modalStyle = {
//         position: 'fixed',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         padding: '20px',
//         borderRadius: '10px',
//         boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//         zIndex: 1001,
//         width: '100vw',
//         height: "100vh",
//         backdropFilter: "blur(2px)",
//     };

//     const inputContainerStyle = {
//         marginBottom: '15px',
//     };

//     const inputFieldStyle = {
//         width: '100%',
//         padding: '8px',
//         fontSize: '14px',
//         borderRadius: '5px',
//         border: '1px solid #ddd',
//     };

//     const imagePreviewStyle = {
//         cursor: 'pointer',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         width: '100px',
//         height: '100px',
//         margin: '10px 0',
//         borderRadius: '10px',
//         border: '1px solid #ccc',
//         overflow: 'hidden',
//     };

//     const imageStyle = {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     };

//     const buttonContainerStyle = {
//         display: 'flex',
//         justifyContent: 'center',
//         marginTop: '20px',
//         textAlign: "center"
//     };

//     const closeButtonStyle = {
//         position: 'absolute',
//         top: '10px',
//         right: '10px',
//         cursor: 'pointer',
//     };

//     const closeIconStyle = {
//         fontSize: '24px',
//         fontWeight: 'bold',
//         marginBottom: '30px',
//         color: '#888',
//     };

//     const buttonStyle = {
//         backgroundColor: '#b15cd6',
//         color: 'white',
//         border: 'none',
//         borderRadius: '5px',
//         cursor: 'pointer',
//         fontSize: '14px',
//         fontWeight: "bold",
//         padding: "10px",
//     };

//     const styles = {
//         overlay: {
//             position: 'fixed',
//             top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             zIndex: 1001,
//             padding: '10px',
//         },
//         popup: {
//             background: '#fff',
//             padding: '20px',
//             borderRadius: '8px',
//             width: '300px',
//             maxWidth: '95vw',
//             boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//             textAlign: 'center',
//             position: 'relative',
//         },
//         image: {
//             width: '100%',
//             marginTop: '10px',
//             borderRadius: '5px',
//         },
//         input: {
//             marginTop: '10px',
//             padding: '8px',
//             width: '100%',
//             borderRadius: '5px',
//             border: '1px solid #ccc',
//             fontSize: '14px',
//             boxSizing: 'border-box',
//         },
//         buttons: {
//             marginTop: '15px',
//             display: 'flex',
//             justifyContent: 'center'
//         },
//         saveBtn: {
//             padding: '8px 12px',
//             backgroundColor: '#b15cd6',
//             color: 'white',
//             border: 'none',
//             borderRadius: '5px',
//             cursor: 'pointer',
//             fontSize: '14px',
//         },
//         cancelBtn: {
//             padding: '8px 12px',
//             backgroundColor: '#f44336',
//             color: 'white',
//             border: 'none',
//             borderRadius: '5px',
//         }
//     };


//     const containerHeight = window.innerWidth < 768
//         ? '50vh'
//         : window.innerWidth < 850
//             ? '60vh'
//             : window.innerWidth < 1350
//                 ? '50vh'
//                 : '510px';

//     return (
//         <div style={{ marginTop: "0px" }}>
//             <style>
//                 {`
//                .custom-switch {
//             position: relative;
//             display: inline-block;
//             width: 100px;
//             height: 35px;
//             margin-top:11px;
//           }

//           .custom-switch input {
//             opacity: 0;
//             width: 0;
//             height: 0;
//           }

//           .custom-slider {
//             position: absolute;
//             cursor: pointer;
//             transition: 0.4s;
//             margin-left:-315px;
//             font-weight: bold;
//             font-size: 14px;
//             color: #000;
//             textAlign: center;
//             line-height: 35px;
//             width: 100px;
//             height: 40px;
//             border-radius:5px;
//             background-color: rgb(217, 217, 217);
//           }

//    .custom-slider::before {
//   content: "";
//   position: absolute;
//   height: 16px;
//   width: 16px;
//   left: 3px;
//   top: 10px;
//   background-color: #000; /* default */
//   transition: 0.4s;
//   border-radius: 50%;
// }

// .custom-slider.veg::before {
//   background-color: green;
// }

// .custom-slider.non-veg::before {
//   background-color: red;
// }
//   .scrollbar-w-auto::-webkit-scrollbar {
//     width: 16px !important;
//     height: 16px !important;
// }
//         `}
//             </style>




//             <div style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 marginBottom: '0px',
//                 width: '100%',
//                 padding: window.innerWidth < 768 ? '0px' : '0'
//             }}>
//                 {showPopup && (
//                     <div style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100%',
//                         height: '100%',
//                         backgroundColor: 'rgba(0,0,0,0.6)',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         zIndex: 1001,
//                         padding: '20px',
//                         boxSizing: 'border-box',
//                         backdropFilter: 'blur(3px)'
//                     }}>
//                         <div style={{
//                             position: 'relative',
//                             backgroundColor: '#fff',
//                             padding: '30px 25px',
//                             borderRadius: '12px',
//                             width: '400px',
//                             maxWidth: '95%',
//                             boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: '15px',
//                             maxHeight: '90vh',
//                             overflowY: 'auto',
//                             scrollbarWidth: "none",
//                         }}>
//                             {/* Close Button */}
//                             <div
//                                 onClick={() => setShowPopup(false)}
//                                 style={{
//                                     position: 'absolute',
//                                     top: '15px',
//                                     right: '15px',
//                                     fontSize: '22px',
//                                     fontWeight: '700',
//                                     color: '#999',
//                                     cursor: 'pointer',
//                                     userSelect: 'none',
//                                     transition: 'color 0.3s',
//                                 }}
//                                 onMouseEnter={e => (e.currentTarget.style.color = '#b15cd6')}
//                                 onMouseLeave={e => (e.currentTarget.style.color = '#999')}
//                             >
//                                 &times;
//                             </div>

//                             {/* Title */}
//                             <h3 style={{
//                                 margin: 0,
//                                 fontWeight: '600',
//                                 fontSize: '1.3rem',
//                                 color: '#333',
//                                 textAlign: 'center'
//                             }}>
//                                 Add New Category
//                             </h3>

//                             {/* Category Name Input with Auto-suggestions */}
//                             <div style={{ position: 'relative', marginTop: '10px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     color: '#333',
//                                     fontSize: '14px'
//                                 }}>
//                                     Category Name <span style={{ color: '#e74c3c' }}>*</span>
//                                 </label>

//                                 <input
//                                     type="text"
//                                     placeholder="Enter category name"
//                                     value={text}
//                                     onChange={handleCategoryInputChange}
//                                     onFocus={() => {
//                                         if (text.trim().length > 0 && categorySuggestions.length > 0) {
//                                             setShowCategorySuggestions(true);
//                                         }
//                                     }}
//                                     onBlur={() => {
//                                         setTimeout(() => setShowCategorySuggestions(false), 200);
//                                     }}
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px 15px',
//                                         fontSize: '1rem',
//                                         borderRadius: '8px',
//                                         border: '1.8px solid #ccc',
//                                         outline: 'none',
//                                         transition: 'all 0.3s',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 // onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                 // onBlur={e => e.target.style.borderColor = '#ccc'}
//                                 />


//                                 {/* Category Suggestions Dropdown */}
//                                 {showCategorySuggestions && (
//                                     <div style={{
//                                         position: 'absolute',
//                                         top: '100%',
//                                         left: 0,
//                                         right: 0,
//                                         backgroundColor: 'white',
//                                         border: '1px solid #ddd',
//                                         borderRadius: '8px',
//                                         boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//                                         zIndex: 1000,
//                                         maxHeight: '250px',
//                                         overflowY: 'auto',
//                                         marginTop: '5px'
//                                     }}>


//                                         {categorySuggestions.map((category, index) => (
//                                             <div
//                                                 key={index}
//                                                 onClick={() => selectCategorySuggestion(category.catageoryName)}
//                                                 style={{
//                                                     padding: '12px 15px',
//                                                     cursor: 'pointer',
//                                                     borderBottom: '1px solid #f5f5f5',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '12px',
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                             >
//                                                 <img
//                                                     src={category.image}
//                                                     alt={category.catageoryName}
//                                                     style={{
//                                                         width: '35px',
//                                                         height: '35px',
//                                                         borderRadius: '6px',
//                                                         objectFit: 'cover',
//                                                         border: '1px solid #eee'
//                                                     }}
//                                                     onError={(e) => {
//                                                         e.target.onerror = null;
//                                                         e.target.src = 'https://via.placeholder.com/35x35';
//                                                     }}
//                                                 />
//                                                 <div style={{ flex: 1 }}>
//                                                     <div style={{
//                                                         fontSize: '14px',
//                                                         fontWeight: '500',
//                                                         color: '#333'
//                                                     }}>
//                                                         {category.catageoryName}
//                                                     </div>
//                                                 </div>

//                                             </div>
//                                         ))}

//                                         {categorySuggestions.length === 0 && (
//                                             <div style={{
//                                                 padding: '20px',
//                                                 textAlign: 'center',
//                                                 color: '#666',
//                                                 fontSize: '14px',
//                                                 display: 'flex',
//                                                 flexDirection: 'column',
//                                                 alignItems: 'center',
//                                                 gap: '10px'
//                                             }}>
//                                                 <div style={{ fontSize: '40px', opacity: 0.5 }}>🔍</div>
//                                                 <div>No matching categories found</div>
//                                                 <div style={{ fontSize: '12px', color: '#999' }}>
//                                                     Type to create a new category
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Image Upload Section - Modern Design */}
//                             <div style={{ marginTop: '15px' }}>
//                                 {/* <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between',
//                                     marginBottom: '15px',
//                                     backgroundColor: '#f8f9fa',
//                                     padding: '12px 15px',
//                                     borderRadius: '8px',
//                                     borderLeft: '4px solid #b15cd6'
//                                 }}>
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                         <div style={{
//                                             width: '40px',
//                                             height: '40px',
//                                             backgroundColor: '#e8f5e9',
//                                             borderRadius: '8px',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center'
//                                         }}>
//                                             <span style={{ fontSize: '20px', color: '#b15cd6' }}>🖼️</span>
//                                         </div>
//                                         <div>
//                                             <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
//                                                 Category Image
//                                                 <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
//                                             </h3>
//                                             <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#7f8c8d' }}>
//                                                 JPG, PNG • Max 5MB • Landscape recommended
//                                             </p>
//                                         </div>
//                                     </div>

//                                     <button
//                                         type="button"
//                                         onClick={() => {
//                                             setCurrentPreset('PRODUCT_IMAGE');
//                                             setShowGuidelinesModal(true);
//                                         }}
//                                         style={{
//                                             background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                             border: 'none',
//                                             color: 'white',
//                                             cursor: 'pointer',
//                                             fontSize: '13px',
//                                             fontWeight: '600',
//                                             padding: '8px 16px',
//                                             borderRadius: '6px',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '6px',
//                                             transition: 'all 0.2s'
//                                         }}
//                                         onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                         onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                     >
//                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                             <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
//                                         </svg>
//                                         Guidelines
//                                     </button>
//                                 </div> */}

//                                 {/* Upload Area */}
//                                 <div
//                                     style={{
//                                         border: image ? "2px solid #e0e0e0" : '2px dashed #ccc',
//                                         borderRadius: '12px',
//                                         backgroundColor: '#fafafa',
//                                         padding: image ? '0' : '40px 20px',
//                                         textAlign: 'center',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.3s',
//                                         minHeight: '200px',
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         justifyContent: 'center',
//                                         alignItems: 'center'
//                                     }}
//                                     onClick={() => document.getElementById('categoryFileInput')?.click()}
//                                     onDragOver={(e) => {
//                                         e.preventDefault();
//                                         e.currentTarget.style.borderColor = '#b15cd6';
//                                         e.currentTarget.style.backgroundColor = '#f0f0ff';
//                                     }}
//                                     onDragLeave={(e) => {
//                                         e.preventDefault();
//                                         e.currentTarget.style.borderColor = image ? '#e0e0e0' : '#ccc';
//                                         e.currentTarget.style.backgroundColor = '#fafafa';
//                                     }}
//                                     onDrop={(e) => {
//                                         e.preventDefault();
//                                         e.currentTarget.style.borderColor = image ? '#e0e0e0' : '#ccc';
//                                         e.currentTarget.style.backgroundColor = '#fafafa';
//                                         if (e.dataTransfer.files[0]) {
//                                             const file = e.dataTransfer.files[0];
//                                             const event = { target: { files: [file] } };
//                                             handleImageUpload(event);
//                                         }
//                                     }}
//                                 >
//                                     {image ? (
//                                         <div style={{ position: 'relative', width: '100%' }}>
//                                             <img
//                                                 src={image}
//                                                 alt="Preview"
//                                                 style={{
//                                                     width: '100%',
//                                                     maxHeight: '250px',
//                                                     objectFit: 'contain',
//                                                     borderRadius: '10px',
//                                                     display: 'block'
//                                                 }}
//                                             />
//                                             <button
//                                                 onClick={(e) => {
//                                                     e.stopPropagation();
//                                                     setImage(null);
//                                                     setCategoryImageFile(null);
//                                                     if (fileInputRef.current) {
//                                                         fileInputRef.current.value = '';
//                                                     }
//                                                 }}
//                                                 style={{
//                                                     position: 'absolute',
//                                                     top: '10px',
//                                                     right: '10px',
//                                                     backgroundColor: 'rgba(255, 107, 107, 0.9)',
//                                                     color: 'white',
//                                                     border: 'none',
//                                                     width: '30px',
//                                                     height: '30px',
//                                                     borderRadius: '50%',
//                                                     cursor: 'pointer',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                     fontSize: '16px',
//                                                     fontWeight: 'bold',
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                                 onMouseEnter={e => e.currentTarget.style.backgroundColor = '#ff5252'}
//                                                 onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255, 107, 107, 0.9)'}
//                                             >
//                                                 ×
//                                             </button>
//                                         </div>
//                                     ) : (
//                                         <>
//                                             <div style={{
//                                                 width: '70px',
//                                                 height: '70px',
//                                                 backgroundColor: '#e8f5e9',
//                                                 borderRadius: '50%',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 marginBottom: '20px',
//                                                 border: '2px solid #c8e6c9'
//                                             }}>
//                                                 <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
//                                                     <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                 </svg>
//                                             </div>
//                                             <div style={{ marginBottom: '15px' }}>
//                                                 <p style={{
//                                                     fontSize: '16px',
//                                                     fontWeight: '600',
//                                                     color: '#2c3e50',
//                                                     margin: '0 0 8px'
//                                                 }}>
//                                                     Drop image here or click to upload
//                                                 </p>
//                                                 <p style={{
//                                                     fontSize: '13px',
//                                                     color: '#7f8c8d',
//                                                     margin: 0
//                                                 }}>
//                                                     Supports JPG, PNG, WebP • Max 5MB
//                                                 </p>
//                                             </div>
//                                             <button
//                                                 style={{
//                                                     background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                                     border: 'none',
//                                                     color: 'white',
//                                                     cursor: 'pointer',
//                                                     fontSize: '14px',
//                                                     fontWeight: '600',
//                                                     padding: '10px 24px',
//                                                     borderRadius: '8px',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '8px',
//                                                     marginTop: '10px',
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                                 onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                                 onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                             >
//                                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                                     <polyline points="17 8 12 3 7 8" />
//                                                     <line x1="12" y1="3" x2="12" y2="15" />
//                                                 </svg>
//                                                 Select Image
//                                             </button>
//                                         </>
//                                     )}
//                                 </div>

//                                 {/* Hidden File Input */}
//                                 <input
//                                     id="categoryFileInput"
//                                     ref={fileInputRef}
//                                     type="file"
//                                     accept="image/*,.jpg,.jpeg,.png,.webp"
//                                     style={{ display: "none" }}
//                                     onChange={handleImageUpload}
//                                 />

//                                 {/* File Info */}
//                                 {categoryImageFile && (
//                                     <div style={{
//                                         marginTop: '15px',
//                                         padding: '12px 15px',
//                                         backgroundColor: '#f0f8ff',
//                                         borderRadius: '8px',
//                                         border: '1px solid #d1ecff',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'space-between'
//                                     }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                                             <div style={{
//                                                 width: '40px',
//                                                 height: '40px',
//                                                 borderRadius: '6px',
//                                                 overflow: 'hidden'
//                                             }}>
//                                                 <img
//                                                     src={image}
//                                                     alt="Thumbnail"
//                                                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                                                 />
//                                             </div>
//                                             <div>
//                                                 <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px' }}>
//                                                     {categoryImageFile.name.length > 25
//                                                         ? categoryImageFile.name.substring(0, 25) + '...'
//                                                         : categoryImageFile.name}
//                                                 </div>
//                                                 <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                                     {(categoryImageFile.size / 1024 / 1024).toFixed(2)} MB
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div style={{
//                                             fontSize: '11px',
//                                             backgroundColor: '#e8f5e9',
//                                             color: '#2e7d32',
//                                             padding: '4px 10px',
//                                             borderRadius: '10px',
//                                             fontWeight: '500'
//                                         }}>
//                                             Ready to upload
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Action Buttons */}
//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'center',
//                                 gap: '15px',
//                                 marginTop: '20px',
//                                 paddingTop: '20px',
//                                 borderTop: '1px solid #eee'
//                             }}>
//                                 <button
//                                     onClick={() => setShowPopup(false)}
//                                     style={{
//                                         backgroundColor: '#f8f9fa',
//                                         color: '#666',
//                                         border: '1px solid #ddd',
//                                         padding: '12px 25px',
//                                         borderRadius: '8px',
//                                         fontWeight: '600',
//                                         fontSize: '14px',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.2s',
//                                         minWidth: '100px'
//                                     }}
//                                     onMouseEnter={e => {
//                                         e.currentTarget.style.backgroundColor = '#e9ecef';
//                                         e.currentTarget.style.borderColor = '#ccc';
//                                     }}
//                                     onMouseLeave={e => {
//                                         e.currentTarget.style.backgroundColor = '#f8f9fa';
//                                         e.currentTarget.style.borderColor = '#ddd';
//                                     }}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={handleSave}
//                                     style={{
//                                         background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                         color: 'white',
//                                         border: 'none',
//                                         padding: '12px 25px',
//                                         borderRadius: '8px',
//                                         fontWeight: '600',
//                                         fontSize: '14px',
//                                         cursor: 'pointer',
//                                         transition: 'all 0.2s',
//                                         minWidth: '100px'
//                                     }}
//                                     onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                     onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                     disabled={!text.trim() || !categoryImageFile}
//                                 >
//                                     Save Category
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Main Controls Container */}
//                 <div style={{
//                     display: 'flex',
//                     flexDirection: window.innerWidth < 768 ? 'column-reverse' : 'row',
//                     justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
//                     alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
//                     marginBottom: window.innerWidth < 768 ? '15px' : '0px',
//                     gap: window.innerWidth < 768 ? '10px' : '10px',
//                     width: '100%',
//                     padding: window.innerWidth < 768 ? '0' : '0px',
//                     marginBottom: window.innerWidth < 768 ? "18px" : "6px",
//                 }}>
//                     {/* Buttons Group */}
//                     {/* Buttons Group */}
//                     <div style={{
//                         display: 'flex',
//                         flexDirection: 'row',
//                         gap: '10px',
//                         justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
//                         alignItems: 'center',
//                         flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
//                         width: window.innerWidth < 768 ? '100%' : 'auto',
//                         marginTop: window.innerWidth < 768 ? '0' : '0px'
//                     }}>
//                         <input
//                             type="file"
//                             accept=".xlsx, .xls"
//                             ref={importFileInputRef}
//                             onChange={handleFileImport}
//                             style={{ display: 'none' }}
//                         />

//                         <button
//                             style={{
//                                 ...importExportButton,
//                                 height: window.innerWidth < 480 ? '32px' : '35px',
//                                 padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//                                 fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
//                                 whiteSpace: 'nowrap'
//                             }}
//                             onClick={() => importFileInputRef.current.click()}
//                         >
//                             Import
//                         </button>

//                         <button style={{
//                             ...importExportButton,
//                             height: window.innerWidth < 480 ? '32px' : '35px',
//                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
//                             whiteSpace: 'nowrap'
//                         }} onClick={handleExport}>
//                             Export
//                         </button>

//                         <button style={{
//                             ...importExportButton,
//                             height: window.innerWidth < 480 ? '32px' : '35px',
//                             padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//                             fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
//                             whiteSpace: 'nowrap'
//                         }}
//                             onClick={() => setShowPopup(true)}
//                         >
//                             Add Category
//                         </button>

//                         {/* Conditional rendering - Show Bulk Edit button OR Input + Save */}
//                         {!bulkMode ? (
//                             <button
//                                 style={{
//                                     ...importExportButton,
//                                     height: window.innerWidth < 480 ? '32px' : '35px',
//                                     padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
//                                     fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
//                                     whiteSpace: 'nowrap',
//                                     backgroundColor: '#ff9800',
//                                 }}
//                                 onClick={() => {
//                                     setBulkMode(true);
//                                     setSelectedItems({});
//                                     setBulkQuantity('');
//                                 }}
//                             >
//                                 Bulk Edit
//                             </button>
//                         ) : (
//                             <div style={{
//                                 display: 'flex',
//                                 gap: '8px',
//                                 alignItems: 'center',
//                                 backgroundColor: '#fff3e0',
//                                 padding: '4px 12px',
//                                 borderRadius: '6px',
//                                 border: '2px solid #ff9800'
//                             }}>


//                                 <input
//                                     type="number"
//                                     min="0"
//                                     value={bulkQuantity}
//                                     onChange={(e) => setBulkQuantity(e.target.value)}
//                                     placeholder="Enter quantity"
//                                     style={{
//                                         padding: '6px 10px',
//                                         borderRadius: '4px',
//                                         border: '1px solid #ccc',
//                                         width: '130px',
//                                         fontSize: '13px',
//                                         outline: 'none'
//                                     }}
//                                     onWheel={(e) => e.target.blur()}
//                                 />

//                                 <button
//                                     onClick={handleBulkUpdate}
//                                     disabled={!bulkQuantity || Object.keys(selectedItems).filter(id => selectedItems[id]).length === 0}
//                                     style={{
//                                         backgroundColor: Object.keys(selectedItems).filter(id => selectedItems[id]).length > 0 && bulkQuantity ? '#28a745' : '#ccc',
//                                         color: 'white',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         padding: '6px 12px',
//                                         cursor: Object.keys(selectedItems).filter(id => selectedItems[id]).length > 0 && bulkQuantity ? 'pointer' : 'not-allowed',
//                                         fontSize: '13px',
//                                         fontWeight: 'bold'
//                                     }}
//                                 >
//                                     Update
//                                 </button>

//                                 <button
//                                     onClick={() => {
//                                         setBulkMode(false);
//                                         setSelectedItems({});
//                                         setBulkQuantity('');
//                                     }}
//                                     style={{
//                                         backgroundColor: '#dc3545',
//                                         color: 'white',
//                                         border: 'none',
//                                         borderRadius: '4px',
//                                         padding: '6px 10px',
//                                         cursor: 'pointer',
//                                         fontSize: '12px'
//                                     }}
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                     {/* Search Bar */}
//                     <div style={{
//                         position: 'relative',
//                         width: window.innerWidth < 768 ? '100%' : 'auto',
//                         minWidth: window.innerWidth < 480 ? '150px' : '200px',
//                         maxWidth: window.innerWidth < 768 ? '100%' : '300px',
//                         marginTop: window.innerWidth < 768 ? '0' : '0px',
//                         marginRight: window.innerWidth < 768 ? '0' : '10px',
//                         order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
//                         zIndex: 1 // Ensure it's above other elements
//                     }}>
//                         <input
//                             type="text"
//                             placeholder="Search dishes or categories..."
//                             value={searchQuery}
//                             onChange={(e) => {
//                                 setSearchQuery(e.target.value);
//                                 // Optional: Add debounced search here
//                             }}
//                             onKeyDown={(e) => {
//                                 // Allow all key presses including space
//                                 if (e.key === 'Enter') {
//                                     handleSearch(searchQuery);
//                                 }
//                                 // Prevent any default behavior that might block typing
//                             }}
//                             onKeyUp={(e) => {
//                                 // Update search on every keyup (real-time search)
//                                 if (e.key !== 'Enter' && e.key !== 'Tab') {
//                                     handleSearch(searchQuery);
//                                 }
//                             }}
//                             style={{
//                                 width: '100%',
//                                 padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
//                                 borderRadius: '20px',
//                                 border: '2px solid #b15cd6',
//                                 fontSize: window.innerWidth < 480 ? '13px' : '14px',
//                                 outline: 'none',
//                                 transition: 'all 0.3s ease',
//                                 backgroundColor: '#fff',
//                                 height: window.innerWidth < 480 ? '32px' : '35px',
//                                 boxSizing: 'border-box',
//                                 fontFamily: 'inherit', // Ensure consistent font
//                             }}
//                             onFocus={(e) => {
//                                 e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
//                             }}
//                             onBlur={(e) => {
//                                 e.target.style.boxShadow = 'none';
//                             }}
//                         />
//                         <button
//                             onClick={() => handleSearch(searchQuery)}
//                             style={{
//                                 position: 'absolute',
//                                 right: window.innerWidth < 480 ? '6px' : '8px',
//                                 top: '50%',
//                                 transform: 'translateY(-50%)',
//                                 background: 'transparent',
//                                 border: 'none',
//                                 cursor: 'pointer',
//                                 padding: '4px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 zIndex: 2
//                             }}
//                             type="button"
//                             aria-label="Search"
//                         >
//                             <svg
//                                 width={window.innerWidth < 480 ? "16" : "18"}
//                                 height={window.innerWidth < 480 ? "16" : "18"}
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="#b15cd6"
//                                 strokeWidth="2"
//                             >
//                                 <circle cx="11" cy="11" r="8" />
//                                 <path d="m21 21-4.3-4.3" />
//                             </svg>
//                         </button>

//                         {/* Add a clear button */}
//                         {/* {searchQuery && (
//                             <button
//                                 onClick={() => {
//                                     setSearchQuery("");
//                                     handleSearch("");
//                                 }}
//                                 style={{
//                                     position: 'absolute',
//                                     right: window.innerWidth < 480 ? '28px' : '32px',
//                                     top: '50%',
//                                     transform: 'translateY(-50%)',
//                                     background: 'transparent',
//                                     border: 'none',
//                                     cursor: 'pointer',
//                                     padding: '2px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: '#888',
//                                     fontSize: '16px',
//                                     fontWeight: 'bold',
//                                     zIndex: 2
//                                 }}
//                                 type="button"
//                                 aria-label="Clear search"
//                             >
//                                 ×
//                             </button>
//                         )} */}
//                     </div>
//                 </div>
//             </div>

//             <div style={{
//                 height: window.innerHeight < 650 ? "auto" : containerHeight,
//                 maxHeight: window.innerHeight < 450 ? "50vh" : window.innerHeight < 500 ? "55vh" : window.innerHeight < 650 ? "60vh" : window.innerHeight < 700 ? "65vh" : "70vh",
//                 border: '0px solid #ddd',
//                 borderRadius: '0.375rem',
//                 backgroundColor: '#fff',
//                 width: '100%',
//                 maxWidth: '100%',
//                 boxSizing: 'border-box',
//                 overflow: 'auto',
//                 display: 'flex',
//                 flexDirection: 'column'
//             }} className="standard-table-data">

//                 {loading ? (
//                     <p>Loading data...</p>
//                 ) : error ? (
//                     <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
//                 ) : (
//                     <div style={{
//                         minWidth: '1600px',
//                         overflow: 'visible',
//                         height: '100%',
//                         display: 'flex',
//                         flexDirection: 'column'
//                     }}>
//                         {/* Fixed Header */}
//                         <div style={{
//                             flexShrink: 0,
//                             backgroundColor: '#f2f2f2',
//                             borderBottom: '1px solid #ddd',
//                         }}>
//                             <table style={{
//                                 width: '100%',
//                                 borderCollapse: 'collapse',
//                                 tableLayout: 'fixed',
//                             }}>
//                                 <colgroup>
//                                     <col style={{ width: '100px' }} /> {/* S.No */}
//                                     <col style={{ width: '150px' }} /> {/* Category */}
//                                     <col style={{ width: '80px' }} />  {/* Type */}
//                                     <col style={{ width: '200px' }} /> {/* Description */}
//                                     <col style={{ width: '100px' }} /> {/* Image */}
//                                     <col style={{ width: '80px' }} />  {/* Price */}
//                                     <col style={{ width: '80px' }} />  {/* Delivery */}
//                                     <col style={{ width: '70px' }} />  {/* GST */}
//                                     <col style={{ width: '80px' }} />  {/* Packing */}
//                                     <col style={{ width: '80px' }} />  {/* Stock Qty */}
//                                     <col style={{ width: '80px' }} />  {/* Consumed */}
//                                     <col style={{ width: '80px' }} />  {/* Balanced */}
//                                     <col style={{ width: '100px' }} /> {/* Chef Type */}
//                                     <col style={{ width: '80px' }} />  {/* Status */}
//                                     <col style={{ width: '150px' }} /> {/* Actions */}
//                                 </colgroup>
//                                 <thead>
//                                     <tr>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
//                                             <div style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 gap: '8px',
//                                             }}>
//                                                 {/* Add header checkbox for bulk mode */}
//                                                 {bulkMode && (
//                                                     <input
//                                                         type="checkbox"
//                                                         checked={Object.keys(selectedItems).length === totalItemsCount} // You'd need to calculate total
//                                                         onChange={handleSelectAll} // You'd need to create this function
//                                                         style={{ margin: 0, cursor: 'pointer', width: '16px', height: '16px' }}
//                                                     />
//                                                 )}
//                                                 <span>S.No</span>
//                                             </div>
//                                         </th>
//                                         <th
//                                             style={{
//                                                 ...tableHeaderStyle,
//                                                 textAlign: 'center',
//                                                 cursor: 'pointer',
//                                                 position: 'relative',
//                                             }}
//                                             onClick={handleCategoryColumnClick}
//                                         >
//                                             <div style={{
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 gap: '8px',
//                                                 position: 'relative',
//                                             }}>
//                                                 <span>Category</span>
//                                                 <div style={{
//                                                     width: '20px',
//                                                     height: '20px',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     justifyContent: 'center',
//                                                 }}>
//                                                     {!selectedCategory && (
//                                                         <svg
//                                                             width="14"
//                                                             height="14"
//                                                             viewBox="0 0 24 24"
//                                                             fill="white"
//                                                             stroke="white"
//                                                             strokeWidth="1.5"
//                                                         >
//                                                             <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
//                                                         </svg>
//                                                     )}
//                                                     {selectedCategory && (
//                                                         <span
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 clearCategoryFilter();
//                                                             }}
//                                                             style={{
//                                                                 background: '#ff6b6b',
//                                                                 color: 'white',
//                                                                 borderRadius: '50%',
//                                                                 width: '18px',
//                                                                 height: '18px',
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'center',
//                                                                 fontSize: '12px',
//                                                                 cursor: 'pointer',
//                                                             }}
//                                                         >
//                                                             ×
//                                                         </span>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Type</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Description</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Image</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Price</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Delivery</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Gst(%)</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
//                                             Packing(.Rs)
//                                         </th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
//                                             Quantity
//                                         </th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
//                                             Consumed
//                                         </th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
//                                             Balanced
//                                         </th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Chef Type</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Status</th>
//                                         <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>Actions</th>
//                                     </tr>
//                                 </thead>
//                             </table>
//                         </div>

//                         {/* Scrollable Body */}
//                         <div style={{
//                             flex: 1,
//                             overflow: 'auto',
//                             scrollbarWidth: "none",
//                         }}>
//                             <table style={{
//                                 width: '100%',
//                                 borderCollapse: 'collapse',
//                                 tableLayout: 'fixed',
//                             }}>
//                                 <colgroup>
//                                     <col style={{ width: '100px' }} />
//                                     <col style={{ width: '150px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '200px' }} />
//                                     <col style={{ width: '100px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '70px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '100px' }} />
//                                     <col style={{ width: '80px' }} />
//                                     <col style={{ width: '150px' }} />
//                                 </colgroup>
//                                 <tbody>
//                                     {filteredData.map((item, index) => (
//                                         <React.Fragment key={item.dishId || index}>
//                                             {/* Parent Category Row */}
//                                             <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
//                                                 <td style={{
//                                                     ...tableCellStyle,
//                                                     textAlign: 'center',
//                                                     backgroundColor: "#f0f0f0",
//                                                     padding: '8px 4px',
//                                                 }}>
//                                                     <div style={{
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         justifyContent: 'center',
//                                                         gap: '8px',
//                                                         flexWrap: 'nowrap',
//                                                     }}>
//                                                         {/* Category Checkbox - ONLY IN BULK MODE */}
//                                                         {bulkMode && (
//                                                             <input
//                                                                 type="checkbox"
//                                                                 checked={selectedItems[item.dishId] || false}
//                                                                 onChange={(e) => {
//                                                                     const checked = e.target.checked;
//                                                                     setSelectedItems(prevSelected => {
//                                                                         const newSelected = { ...prevSelected };

//                                                                         if (checked) {
//                                                                             newSelected[item.dishId] = true;
//                                                                             if (item.subcategories && item.subcategories.length > 0) {
//                                                                                 item.subcategories.forEach(sub => {
//                                                                                     newSelected[sub.dishId] = true;
//                                                                                 });
//                                                                             }
//                                                                         } else {
//                                                                             delete newSelected[item.dishId];
//                                                                             if (item.subcategories && item.subcategories.length > 0) {
//                                                                                 item.subcategories.forEach(sub => {
//                                                                                     delete newSelected[sub.dishId];
//                                                                                 });
//                                                                             }
//                                                                         }
//                                                                         return newSelected;
//                                                                     });
//                                                                 }}
//                                                                 style={{ margin: 0, cursor: 'pointer', width: '16px', height: '16px' }}
//                                                             />
//                                                         )}

//                                                         <button
//                                                             onClick={(e) => toggleCategory(item.dishId, e)}
//                                                             style={{
//                                                                 background: 'none',
//                                                                 border: 'none',
//                                                                 cursor: 'pointer',
//                                                                 color: '#666',
//                                                                 padding: '2px 6px',
//                                                                 borderRadius: '4px',
//                                                                 display: 'flex',
//                                                                 alignItems: 'center',
//                                                                 justifyContent: 'center',
//                                                                 width: '24px',
//                                                                 height: '24px',
//                                                                 backgroundColor: expandedCategories[item.dishId] ? '#e0e0e0' : 'transparent'
//                                                             }}
//                                                         >
//                                                             {expandedCategories[item.dishId] ?
//                                                                 <FaChevronDown size={12} /> :
//                                                                 <FaChevronRight size={12} />
//                                                             }
//                                                         </button>
//                                                         <span>{index + 1}</span>
//                                                     </div>
//                                                 </td>

//                                                 <td style={{ ...tableCellStyle, fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
//                                                     {item.category}
//                                                 </td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
//                                                     {item.tag ? item.tag : '-'}
//                                                 </td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
//                                                     <img src={item.image} alt="Dish" style={{ width: '36px', height: '28px', borderRadius: '8px' }} />
//                                                 </td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>

//                                                 {/* Stock, Consumed, Balanced - Category level */}
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>

//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
//                                                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                                                         <label className="switch">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 checked={item.menuStatus === "Enable"}
//                                                                 onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
//                                                             />
//                                                             <span className="slider round"></span>
//                                                         </label>
//                                                         <span style={{ marginTop: '3px', fontSize: '0.75rem', fontWeight: '600' }}>
//                                                             {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
//                                                         </span>
//                                                     </div>
//                                                 </td>

//                                                 <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
//                                                     <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
//                                                         <button
//                                                             style={{
//                                                                 backgroundColor: '#b15cd6',
//                                                                 color: 'white',
//                                                                 borderRadius: '4px',
//                                                                 padding: '4px 6px',
//                                                                 border: 'none',
//                                                                 cursor: 'pointer',
//                                                                 fontSize: '0.75rem',
//                                                                 minWidth: '45px'
//                                                             }}
//                                                             onClick={() => handleAddSubCategory(item.dishId)}
//                                                         >
//                                                             Add
//                                                         </button>
//                                                         <button
//                                                             style={{ ...addButtonStyle, backgroundColor: "#f9f9f9", padding: '4px 6px', fontSize: '0.8rem' }}
//                                                             onClick={() => {
//                                                                 if (item.isAdded) {
//                                                                     handleEdit(item.SNo);
//                                                                 } else {
//                                                                     handleSave(item, index);
//                                                                 }
//                                                             }}
//                                                         >
//                                                             {item.isAdded ? <FaEdit /> : <FaSave />}
//                                                         </button>
//                                                         <button
//                                                             style={{ ...deleteButtonStyle, backgroundColor: "#f9f9f9", padding: '4px 6px', fontSize: '0.8rem' }}
//                                                             onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
//                                                         >
//                                                             <FaTrash />
//                                                         </button>
//                                                     </div>
//                                                 </td>
//                                             </tr>

//                                             {/* Subcategories */}
//                                             {expandedCategories[item.dishId] && item.subcategories && item.subcategories.length > 0 && (
//                                                 <React.Fragment>
//                                                     {item.subcategories.map((sub, subIndex) => (
//                                                         <tr
//                                                             key={`sub-${sub.dishId}`}
//                                                             style={{
//                                                                 backgroundColor: '#f9f9f9',
//                                                                 animation: 'slideDown 0.3s ease-out forwards'
//                                                             }}
//                                                             className="slide-down"
//                                                         >
//                                                             <td style={{
//                                                                 ...tableCellStyle,
//                                                                 textAlign: 'center',
//                                                                 fontSize: '0.9rem',
//                                                                 padding: '8px 4px',
//                                                             }}>
//                                                                 <div style={{
//                                                                     display: 'flex',
//                                                                     alignItems: 'center',
//                                                                     justifyContent: 'center',
//                                                                     gap: '8px',
//                                                                     flexWrap: 'nowrap',
//                                                                 }}>
//                                                                     {/* Subcategory Checkbox - ONLY IN BULK MODE */}
//                                                                     {bulkMode && (
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             checked={selectedItems[sub.dishId] || false}
//                                                                             onChange={(e) => {
//                                                                                 const checked = e.target.checked;
//                                                                                 setSelectedItems(prevSelected => ({
//                                                                                     ...prevSelected,
//                                                                                     [sub.dishId]: checked
//                                                                                 }));
//                                                                             }}
//                                                                             style={{
//                                                                                 margin: 0,
//                                                                                 cursor: 'pointer',
//                                                                                 width: '16px',
//                                                                                 height: '16px'
//                                                                             }}
//                                                                         />
//                                                                     )}
//                                                                     <span>{index + 1}.{subIndex + 1}</span>
//                                                                 </div>
//                                                             </td>

//                                                             <td style={{ ...tableCellStyle, fontSize: '0.9rem', paddingLeft: '40px' }}>
//                                                                 <span style={{ marginRight: '8px', opacity: 0.5 }}>↳</span> {sub.subName}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
//                                                                 {sub.tag === "Veg" ? (
//                                                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
//                                                                         <div style={{ width: '10px', height: '10px', border: '1px solid green', borderRadius: '1px' }}>
//                                                                             <div style={{ width: '5px', height: '5px', backgroundColor: 'green', borderRadius: '50%', margin: '2px auto' }}></div>
//                                                                         </div>
//                                                                         <span style={{ color: 'green', fontSize: '0.7rem' }}>Veg</span>
//                                                                     </div>
//                                                                 ) : sub.tag === "Non_Veg" ? (
//                                                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
//                                                                         <div style={{ width: '10px', height: '10px', border: '1px solid red', borderRadius: '1px' }}>
//                                                                             <div style={{ width: '5px', height: '5px', backgroundColor: 'red', borderRadius: '50%', margin: '2px auto' }}></div>
//                                                                         </div>
//                                                                         <span style={{ color: 'red', fontSize: '0.7rem' }}>Non-Veg</span>
//                                                                     </div>
//                                                                 ) : (sub.tag)}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, fontSize: '0.85rem', padding: '4px 6px' }}>
//                                                                 {sub.description}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
//                                                                 <img
//                                                                     src={sub.image}
//                                                                     alt="Sub Dish"
//                                                                     style={{ width: '36px', height: '28px', borderRadius: '8px' }}
//                                                                 />
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>₹{sub.price}</td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>
//                                                                 {sub.deliveryPrice ? `₹${sub.deliveryPrice}` : '-'}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>{sub.gst || 0}</td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>{sub.packingCharges || 0}</td>

//                                                             {/* ACTUAL VALUES from API response */}
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', fontWeight: '500' }}>
//                                                                 {sub.stockQuantity !== undefined ? sub.stockQuantity : 0}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', color: '#dc3545' }}>
//                                                                 {sub.consumedQuantity !== undefined ? sub.consumedQuantity : 0}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', color: '#28a745', fontWeight: '500' }}>
//                                                                 {sub.balanceQuantity !== undefined ? sub.balanceQuantity : 0}
//                                                             </td>

//                                                             <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>
//                                                                 {(() => {
//                                                                     if (!sub.chefType) return '-';
//                                                                     let displayType = sub.chefType;
//                                                                     if (displayType.startsWith('Chef_')) {
//                                                                         displayType = displayType.substring(5);
//                                                                     }
//                                                                     return displayType;
//                                                                 })()}
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
//                                                                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
//                                                                     <label className="switch">
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             checked={sub.menuStatus === "Enable"}
//                                                                             onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
//                                                                             disabled={item.menuStatus === "Disable"}
//                                                                         />
//                                                                         <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
//                                                                     </label>
//                                                                     <span style={{
//                                                                         marginTop: '3px',
//                                                                         fontSize: '0.8rem',
//                                                                         color: item.menuStatus === "Disable" ? '#999' : 'black',
//                                                                         fontWeight: '500'
//                                                                     }}>
//                                                                         {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
//                                                                     </span>
//                                                                 </div>
//                                                             </td>
//                                                             <td style={{ ...tableCellStyle, textAlign: 'center' }}>
//                                                                 <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
//                                                                     <button
//                                                                         style={{ ...addButtonStyle, backgroundColor: "#f0f0f0", padding: '4px 6px', fontSize: '0.9rem' }}
//                                                                         onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
//                                                                     >
//                                                                         <FaEdit />
//                                                                     </button>
//                                                                     <button
//                                                                         style={{ ...deleteButtonStyle, backgroundColor: "#f0f0f0", padding: '4px 6px', fontSize: '0.9rem' }}
//                                                                         onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
//                                                                     >
//                                                                         <FaTrash />
//                                                                     </button>
//                                                                 </div>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </React.Fragment>
//                                             )}
//                                         </React.Fragment>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>
//             {showEditModal && editItem && (
//                 <div style={modalStyle}>
//                     <div style={{
//                         position: 'fixed',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         border: "0px solid red",
//                         boxShadow: "rgba(0, 0, 0, 0.3) 0px 2px 10px",
//                         backgroundColor: "white",
//                         width: "400px",
//                         padding: "30px",
//                         borderRadius: "10px",
//                     }}>
//                         <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
//                             <span style={closeIconStyle}>×</span>
//                         </div>
//                         <br></br>

//                         {/* Category Name */}
//                         <div style={inputContainerStyle}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '5px' }}>
//                                 Category Name
//                             </label>
//                             <input
//                                 id="dishName"
//                                 type="text"
//                                 value={editItem.dishName}
//                                 onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
//                                 style={inputFieldStyle}
//                             />
//                         </div>

//                         {/* Quantity Field for Category */}
//                         <div style={inputContainerStyle}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '5px' }}>
//                                 Quantity

//                             </label>
//                             <input
//                                 type="number"
//                                 min="0"
//                                 value={categoryQuantities[editItem.dishId] || ''}
//                                 onChange={(e) => {
//                                     const value = e.target.value === '' ? '' : parseInt(e.target.value);
//                                     setCategoryQuantities(prev => ({
//                                         ...prev,
//                                         [editItem.dishId]: value
//                                     }));
//                                 }}
//                                 placeholder="Enter quantity"
//                                 style={{
//                                     ...inputFieldStyle,
//                                     borderColor: categoryQuantities[editItem.dishId] ? '#b15cd6' : '#ccc'
//                                 }}
//                                 onWheel={(e) => e.target.blur()}
//                             />

//                         </div>

//                         {/* Image Upload Section */}
//                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
//                             <div style={imagePreviewStyle}>
//                                 <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
//                                     <img
//                                         src={editItem.image || 'https://via.placeholder.com/100x100'}
//                                         alt="Preview"
//                                         style={imageStyle}
//                                     />
//                                 </label>
//                                 <input
//                                     id="dishImage"
//                                     type="file"
//                                     accept="image/*"
//                                     onChange={(e) => handleEditImageChange(e)}
//                                     style={{ display: 'none' }}
//                                 />
//                             </div>
//                         </div>

//                         {/* Single Update Button */}
//                         <div style={buttonContainerStyle}>
//                             <button
//                                 onClick={async () => {
//                                     // First update the category
//                                     await submitEdit();

//                                     // Then if quantity is set, apply to subcategories
//                                     if (categoryQuantities[editItem.dishId] !== undefined &&
//                                         categoryQuantities[editItem.dishId] !== '') {
//                                         await handleApplyQuantityToSubcategories(
//                                             editItem.dishId,
//                                             categoryQuantities[editItem.dishId]
//                                         );
//                                     }

//                                     setShowEditModal(false);
//                                 }}
//                                 style={buttonStyle}
//                             >
//                                 Update
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}


//             {showSubcategoryPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     width: '100%',
//                     height: '100%',
//                     backgroundColor: 'rgba(0,0,0,0.6)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 1001,
//                     padding: '20px',
//                     boxSizing: 'border-box',
//                     backdropFilter: 'blur(3px)'
//                 }}>
//                     <div style={{
//                         position: 'relative',
//                         backgroundColor: '#fff',
//                         padding: '30px 25px',
//                         borderRadius: '12px',
//                         width: '450px',
//                         maxWidth: '95%',
//                         maxHeight: '90vh',
//                         overflowY: 'auto',
//                         boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         gap: '15px',
//                         scrollbarWidth: "none",
//                     }}>
//                         {/* Close Button */}
//                         <div
//                             onClick={() => setShowSubcategoryPopup(false)}
//                             style={{
//                                 position: 'absolute',
//                                 top: '15px',
//                                 right: '15px',
//                                 fontSize: '22px',
//                                 fontWeight: '700',
//                                 color: '#999',
//                                 cursor: 'pointer',
//                                 userSelect: 'none',
//                                 transition: 'color 0.3s',
//                             }}
//                             onMouseEnter={e => (e.currentTarget.style.color = '#b15cd6')}
//                             onMouseLeave={e => (e.currentTarget.style.color = '#999')}
//                         >
//                             &times;
//                         </div>

//                         {/* Title with Parent Category */}
//                         <div style={{ textAlign: 'center', marginBottom: '10px' }}>
//                             <h3 style={{
//                                 margin: 0,
//                                 fontWeight: '600',
//                                 fontSize: '1.3rem',
//                                 color: '#333'
//                             }}>
//                                 Add New Dish
//                             </h3>
//                             {/* <p style={{ 
//                     margin: '5px 0 0', 
//                     color: '#666', 
//                     fontSize: '14px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     gap: '5px'
//                 }}>
//                     Under category: 
//                     <span style={{ 
//                         color: '#b15cd6', 
//                         fontWeight: '600',
//                         backgroundColor: '#f3e5f5',
//                         padding: '2px 8px',
//                         borderRadius: '4px'
//                     }}>
//                         {parentDishDetails?.dishName || 'Unknown Category'}
//                     </span>
//                 </p> */}
//                         </div>

//                         {/* Dish Name Input with Auto-suggestions */}
//                         <div style={{ position: 'relative' }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: '8px',
//                                 fontWeight: '500',
//                                 color: '#333',
//                                 fontSize: '14px'
//                             }}>
//                                 Dish Name <span style={{ color: '#e74c3c' }}>*</span>
//                             </label>

//                             <input
//                                 type="text"
//                                 value={subDishName}
//                                 onChange={handleDishInputChange}
//                                 onFocus={() => {
//                                     if (subDishName.trim().length > 0 && dishSuggestions.length > 0) {
//                                         setShowDishSuggestions(true);
//                                     }
//                                 }}
//                                 onBlur={() => {
//                                     setTimeout(() => setShowDishSuggestions(false), 200);
//                                 }}
//                                 placeholder="Enter dish name"
//                                 style={{
//                                     width: '100%',
//                                     padding: '12px 15px',
//                                     fontSize: '1rem',
//                                     borderRadius: '8px',
//                                     border: '1.8px solid #ccc',
//                                     outline: 'none',
//                                     transition: 'all 0.3s',
//                                     boxSizing: 'border-box'
//                                 }}
//                             // onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                             // onBlur={e => e.target.style.borderColor = '#ccc'}
//                             />


//                             {/* Dish Suggestions Dropdown */}
//                             {showDishSuggestions && (
//                                 <div style={{
//                                     position: 'absolute',
//                                     top: '100%',
//                                     left: 0,
//                                     right: 0,
//                                     backgroundColor: 'white',
//                                     border: '1px solid #ddd',
//                                     borderRadius: '8px',
//                                     boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//                                     zIndex: 1000,
//                                     maxHeight: '300px',
//                                     overflowY: 'auto',
//                                     marginTop: '5px'
//                                 }}>


//                                     {dishSuggestions.map((dish, index) => (
//                                         <div
//                                             key={index}
//                                             onClick={() => selectDishSuggestion(dish.name)}
//                                             style={{
//                                                 padding: '12px 15px',
//                                                 cursor: 'pointer',
//                                                 borderBottom: '1px solid #f5f5f5',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '12px',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <img
//                                                 src={dish.image}
//                                                 alt={dish.name}
//                                                 style={{
//                                                     width: '40px',
//                                                     height: '40px',
//                                                     borderRadius: '6px',
//                                                     objectFit: 'cover',
//                                                     border: '1px solid #eee'
//                                                 }}
//                                                 onError={(e) => {
//                                                     e.target.onerror = null;
//                                                     e.target.src = 'https://via.placeholder.com/40x40';
//                                                 }}
//                                             />
//                                             <div style={{ flex: 1 }}>
//                                                 <div style={{
//                                                     fontSize: '14px',
//                                                     fontWeight: '500',
//                                                     color: '#333',
//                                                     marginBottom: '3px'
//                                                 }}>
//                                                     {dish.name}
//                                                 </div>
//                                                 <div style={{
//                                                     fontSize: '12px',
//                                                     color: '#666',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '8px'
//                                                 }}>
//                                                     <span style={{
//                                                         display: 'inline-flex',
//                                                         alignItems: 'center',
//                                                         gap: '3px'
//                                                     }}>
//                                                         <span style={{
//                                                             width: '8px',
//                                                             height: '8px',
//                                                             borderRadius: '50%',
//                                                             backgroundColor: dish.category ? '#4CAF50' : '#999'
//                                                         }}></span>
//                                                         {dish.category?.catageoryName || 'No Category'}
//                                                     </span>

//                                                 </div>
//                                             </div>
//                                             <div style={{
//                                                 fontSize: '12px',
//                                                 color: '#b15cd6',
//                                                 backgroundColor: '#f3e5f5',
//                                                 padding: '4px 10px',
//                                                 borderRadius: '4px',
//                                                 fontWeight: '500'
//                                             }}>
//                                                 Select
//                                             </div>
//                                         </div>
//                                     ))}

//                                     {dishSuggestions.length === 0 && (
//                                         <div style={{
//                                             padding: '20px',
//                                             textAlign: 'center',
//                                             color: '#666',
//                                             fontSize: '14px',
//                                             display: 'flex',
//                                             flexDirection: 'column',
//                                             alignItems: 'center',
//                                             gap: '10px'
//                                         }}>
//                                             <div style={{ fontSize: '40px', opacity: 0.5 }}>🍽️</div>
//                                             <div>No matching dishes found</div>
//                                             <div style={{ fontSize: '12px', color: '#999' }}>
//                                                 Type to create a new dish
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Form Fields Grid */}
//                         <div style={{
//                             display: 'grid',
//                             gridTemplateColumns: '1fr 1fr',
//                             gap: '15px',
//                             marginTop: '10px'
//                         }}>
//                             {/* Price */}
//                             <div>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     color: '#333',
//                                     fontSize: '14px'
//                                 }}>
//                                     Price (₹) <span style={{ color: '#e74c3c' }}>*</span>
//                                 </label>
//                                 <input
//                                     type="number"
//                                     value={price}
//                                     onChange={(e) => setPrice(e.target.value)}
//                                     placeholder="0.00"
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px 15px',
//                                         fontSize: '1rem',
//                                         borderRadius: '8px',
//                                         border: '1.8px solid #ccc',
//                                         outline: 'none',
//                                         transition: 'border-color 0.3s',
//                                         boxSizing: 'border-box'
//                                     }}
//                                     onWheel={(e) => e.target.blur()}
//                                     onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                     onBlur={e => e.target.style.borderColor = '#ccc'}
//                                 />
//                             </div>

//                             {/* GST */}
//                             <div>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     color: '#333',
//                                     fontSize: '14px'
//                                 }}>
//                                     GST (%)
//                                 </label>
//                                 <input
//                                     type="number"
//                                     value={gst}
//                                     onChange={(e) => setGst(e.target.value)}
//                                     placeholder="0"
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px 15px',
//                                         fontSize: '1rem',
//                                         borderRadius: '8px',
//                                         border: '1.8px solid #ccc',
//                                         outline: 'none',
//                                         transition: 'border-color 0.3s',
//                                         boxSizing: 'border-box'
//                                     }}
//                                     onWheel={(e) => e.target.blur()}
//                                     onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                     onBlur={e => e.target.style.borderColor = '#ccc'}
//                                 />
//                             </div>
//                         </div>

//                         {/* Single Column Fields */}
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                             {/* Packing Charges */}
//                             <div>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     color: '#333',
//                                     fontSize: '14px'
//                                 }}>
//                                     Packing Charges (₹)
//                                 </label>
//                                 <input
//                                     type="number"
//                                     value={packingCharges}
//                                     onChange={(e) => setPackingCharges(e.target.value)}
//                                     placeholder="0.00"
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px 15px',
//                                         fontSize: '1rem',
//                                         borderRadius: '8px',
//                                         border: '1.8px solid #ccc',
//                                         outline: 'none',
//                                         transition: 'border-color 0.3s',
//                                         boxSizing: 'border-box'
//                                     }}
//                                     onWheel={(e) => e.target.blur()}
//                                     onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                     onBlur={e => e.target.style.borderColor = '#ccc'}
//                                 />
//                             </div>

//                             {/* Dish Type and Chef Type in Row */}
//                             <div style={{
//                                 display: 'grid',
//                                 gridTemplateColumns: '1fr 1fr',
//                                 gap: '15px'
//                             }}>
//                                 {/* Dish Type */}
//                                 <div>
//                                     <label style={{
//                                         display: 'block',
//                                         marginBottom: '8px',
//                                         fontWeight: '500',
//                                         color: '#333',
//                                         fontSize: '14px'
//                                     }}>
//                                         Dish Type
//                                     </label>
//                                     <select
//                                         value={tag}
//                                         onChange={(e) => setTag(e.target.value)}
//                                         style={{
//                                             width: '100%',
//                                             padding: '12px 15px',
//                                             fontSize: '1rem',
//                                             borderRadius: '8px',
//                                             border: '1.8px solid #ccc',
//                                             outline: 'none',
//                                             transition: 'border-color 0.3s',
//                                             backgroundColor: '#fff',
//                                             cursor: 'pointer',
//                                             appearance: 'none',
//                                             backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E")`,
//                                             backgroundRepeat: 'no-repeat',
//                                             backgroundPosition: 'right 15px center',
//                                             backgroundSize: '12px'
//                                         }}
//                                         onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                         onBlur={e => e.target.style.borderColor = '#ccc'}
//                                     >
//                                         <option value="Veg"> Veg</option>
//                                         <option value="Non_Veg"> Non-Veg</option>
//                                     </select>
//                                 </div>

//                                 {/* Chef Type */}
//                                 <div>
//                                     <label style={{
//                                         display: 'block',
//                                         marginBottom: '8px',
//                                         fontWeight: '500',
//                                         color: '#333',
//                                         fontSize: '14px'
//                                     }}>
//                                         Chef Type
//                                     </label>
//                                     <select
//                                         value={chefType}
//                                         onChange={(e) => setChefType(e.target.value)}
//                                         style={{
//                                             width: '100%',
//                                             padding: '12px 15px',
//                                             fontSize: '1rem',
//                                             borderRadius: '8px',
//                                             border: '1.8px solid #ccc',
//                                             outline: 'none',
//                                             transition: 'border-color 0.3s',
//                                             backgroundColor: '#fff',
//                                             cursor: 'pointer',
//                                             appearance: 'none',
//                                             backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E")`,
//                                             backgroundRepeat: 'no-repeat',
//                                             backgroundPosition: 'right 15px center',
//                                             backgroundSize: '12px'
//                                         }}
//                                         onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                         onBlur={e => e.target.style.borderColor = '#ccc'}
//                                     >
//                                         <option value="Chef_All"> All Chefs</option>
//                                         <option value="Chef_North"> North Indian</option>
//                                         <option value="Chef_South"> South Indian</option>
//                                         <option value="Chef_Chinese"> Chinese</option>
//                                         <option value="Chef_Continental"> Continental</option>
//                                         <option value="Tea_stall">Tea Stall</option>
//                                         <option value="Snacks"> Snacks</option>
//                                         <option value="Bakery"> Bakery</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Description */}
//                             <div>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     color: '#333',
//                                     fontSize: '14px'
//                                 }}>
//                                     Description
//                                 </label>
//                                 <textarea
//                                     value={description}
//                                     onChange={(e) => setDescription(e.target.value)}
//                                     placeholder="Enter dish description..."
//                                     rows="3"
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px 15px',
//                                         fontSize: '1rem',
//                                         borderRadius: '8px',
//                                         border: '1.8px solid #ccc',
//                                         outline: 'none',
//                                         transition: 'border-color 0.3s',
//                                         boxSizing: 'border-box',
//                                         resize: 'vertical',
//                                         fontFamily: 'inherit',
//                                         minHeight: '80px'
//                                     }}
//                                     onFocus={e => e.target.style.borderColor = '#b15cd6'}
//                                     onBlur={e => e.target.style.borderColor = '#ccc'}
//                                 />
//                             </div>
//                         </div>

//                         {/* Image Upload Section */}
//                         <div style={{ marginTop: '10px' }}>
//                             {/* <div style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'space-between',
//                                 marginBottom: '15px',
//                                 backgroundColor: '#f8f9fa',
//                                 padding: '12px 15px',
//                                 borderRadius: '8px',
//                                 borderLeft: '4px solid #b15cd6'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                     <div style={{
//                                         width: '40px',
//                                         height: '40px',
//                                         backgroundColor: '#e8f5e9',
//                                         borderRadius: '8px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center'
//                                     }}>
//                                         <span style={{ fontSize: '20px', color: '#b15cd6' }}>📸</span>
//                                     </div>
//                                     <div>
//                                         <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
//                                             Dish Image
//                                             <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
//                                         </h3>
//                                         <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#7f8c8d' }}>
//                                             JPG, PNG • Max 5MB • Landscape recommended
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setCurrentPreset('PRODUCT_IMAGE');
//                                         setShowGuidelinesModal(true);
//                                     }}
//                                     style={{
//                                         background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                         border: 'none',
//                                         color: 'white',
//                                         cursor: 'pointer',
//                                         fontSize: '13px',
//                                         fontWeight: '600',
//                                         padding: '8px 16px',
//                                         borderRadius: '6px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '6px',
//                                         transition: 'all 0.2s'
//                                     }}
//                                     onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                     onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                 >
//                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                         <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
//                                     </svg>
//                                     Guidelines
//                                 </button>
//                             </div> */}

//                             {/* Upload Area */}
//                             <div
//                                 style={{
//                                     border: image ? "2px solid #e0e0e0" : '2px dashed #ccc',
//                                     borderRadius: '12px',
//                                     backgroundColor: '#fafafa',
//                                     padding: image ? '0' : '30px 20px',
//                                     textAlign: 'center',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.3s',
//                                     minHeight: '180px',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     justifyContent: 'center',
//                                     alignItems: 'center'
//                                 }}
//                                 onClick={() => document.getElementById('subcategoryFileInput')?.click()}
//                             >
//                                 {image ? (
//                                     <div style={{ position: 'relative', width: '100%' }}>
//                                         <img
//                                             src={image}
//                                             alt="Preview"
//                                             style={{
//                                                 width: '100%',
//                                                 maxHeight: '220px',
//                                                 objectFit: 'contain',
//                                                 borderRadius: '10px',
//                                                 display: 'block'
//                                             }}
//                                         />
//                                         <button
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 setImage(null);
//                                                 setImageFile(null);
//                                             }}
//                                             style={{
//                                                 position: 'absolute',
//                                                 top: '10px',
//                                                 right: '10px',
//                                                 backgroundColor: 'rgba(255, 107, 107, 0.9)',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 width: '30px',
//                                                 height: '30px',
//                                                 borderRadius: '50%',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 fontSize: '16px',
//                                                 fontWeight: 'bold',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={e => e.currentTarget.style.backgroundColor = '#ff5252'}
//                                             onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255, 107, 107, 0.9)'}
//                                         >
//                                             ×
//                                         </button>
//                                     </div>
//                                 ) : (
//                                     <>
//                                         <div style={{
//                                             width: '60px',
//                                             height: '60px',
//                                             backgroundColor: '#e8f5e9',
//                                             borderRadius: '50%',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             marginBottom: '15px',
//                                             border: '2px solid #c8e6c9'
//                                         }}>
//                                             <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
//                                                 <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                 <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                 <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                             </svg>
//                                         </div>
//                                         <div style={{ marginBottom: '15px' }}>
//                                             <p style={{
//                                                 fontSize: '15px',
//                                                 fontWeight: '600',
//                                                 color: '#2c3e50',
//                                                 margin: '0 0 8px'
//                                             }}>
//                                                 Drop dish image here or click to upload
//                                             </p>
//                                             <p style={{
//                                                 fontSize: '13px',
//                                                 color: '#7f8c8d',
//                                                 margin: 0
//                                             }}>
//                                                 Supports JPG, PNG • Max 5MB
//                                             </p>
//                                         </div>
//                                         <button
//                                             style={{
//                                                 background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                                 border: 'none',
//                                                 color: 'white',
//                                                 cursor: 'pointer',
//                                                 fontSize: '14px',
//                                                 fontWeight: '600',
//                                                 padding: '10px 24px',
//                                                 borderRadius: '8px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '8px',
//                                                 marginTop: '10px',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                             onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                         >
//                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                                 <polyline points="17 8 12 3 7 8" />
//                                                 <line x1="12" y1="3" x2="12" y2="15" />
//                                             </svg>
//                                             Select Image
//                                         </button>
//                                     </>
//                                 )}
//                             </div>

//                             {/* Hidden File Input */}
//                             <input
//                                 id="subcategoryFileInput"
//                                 type="file"
//                                 accept="image/*,.jpg,.jpeg,.png,.webp"
//                                 style={{ display: "none" }}
//                                 onChange={handleSubImageChange}
//                             />

//                             {/* File Info */}
//                             {imageFile && (
//                                 <div style={{
//                                     marginTop: '15px',
//                                     padding: '12px 15px',
//                                     backgroundColor: '#f0f8ff',
//                                     borderRadius: '8px',
//                                     border: '1px solid #d1ecff',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between'
//                                 }}>
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                                         <div style={{
//                                             width: '40px',
//                                             height: '40px',
//                                             borderRadius: '6px',
//                                             overflow: 'hidden'
//                                         }}>
//                                             <img
//                                                 src={image}
//                                                 alt="Thumbnail"
//                                                 style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                                             />
//                                         </div>
//                                         <div>
//                                             <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px' }}>
//                                                 {imageFile.name.length > 25
//                                                     ? imageFile.name.substring(0, 25) + '...'
//                                                     : imageFile.name}
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
//                                                 {(imageFile.size / 1024 / 1024).toFixed(2)} MB
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div style={{
//                                         fontSize: '11px',
//                                         backgroundColor: '#e8f5e9',
//                                         color: '#2e7d32',
//                                         padding: '4px 10px',
//                                         borderRadius: '10px',
//                                         fontWeight: '500'
//                                     }}>
//                                         Ready to upload
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         {/* Action Buttons */}
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             gap: '15px',
//                             marginTop: '25px',
//                             paddingTop: '20px',
//                             borderTop: '1px solid #eee'
//                         }}>
//                             <button
//                                 onClick={() => setShowSubcategoryPopup(false)}
//                                 style={{
//                                     backgroundColor: '#f8f9fa',
//                                     color: '#666',
//                                     border: '1px solid #ddd',
//                                     padding: '12px 25px',
//                                     borderRadius: '8px',
//                                     fontWeight: '600',
//                                     fontSize: '14px',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.2s',
//                                     minWidth: '100px'
//                                 }}
//                                 onMouseEnter={e => {
//                                     e.currentTarget.style.backgroundColor = '#e9ecef';
//                                     e.currentTarget.style.borderColor = '#ccc';
//                                 }}
//                                 onMouseLeave={e => {
//                                     e.currentTarget.style.backgroundColor = '#f8f9fa';
//                                     e.currentTarget.style.borderColor = '#ddd';
//                                 }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleSubcategorySubmit}
//                                 style={{
//                                     background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '12px 25px',
//                                     borderRadius: '8px',
//                                     fontWeight: '600',
//                                     fontSize: '14px',
//                                     cursor: 'pointer',
//                                     transition: 'all 0.2s',
//                                     minWidth: '100px'
//                                 }}
//                                 onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                 onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                 disabled={!subDishName.trim() || !imageFile}
//                             >
//                                 Save Dish
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}




//             {showSubEditModal && (
//                 <div style={modalOverlayStyle}>
//                     <div style={modalContentStyle}>

//                         <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                             <button
//                                 onClick={() => setShowSubEditModal(false)}
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#888',
//                                 }}
//                             >
//                                 &times;
//                             </button>
//                         </div>

//                         <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

//                         {/* 1. Dish Name */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Dish Name :
//                             </label>
//                             <input
//                                 type="text"
//                                 value={editSubItem.subName}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                 }}

//                             />
//                         </div>

//                         {/* 2. Price */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Price :
//                             </label>
//                             <input
//                                 type="number"
//                                 value={editSubItem.price}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                 }}
//                                 onWheel={(e) => e.target.blur()}
//                             />
//                         </div>



//                         {/* 3. GST */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 GST :
//                             </label>
//                             <input
//                                 type="number"
//                                 value={editSubItem.gst}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                 }}
//                                 onWheel={(e) => e.target.blur()}
//                             />
//                         </div>

//                         {/* 4. Packing Charges */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Packing Charges :
//                             </label>
//                             <input
//                                 type="number"
//                                 value={editSubItem.packingCharges}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                 }}
//                                 onWheel={(e) => e.target.blur()}
//                             />
//                         </div>

//                         {/* 5. Dish Type */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Dish Type:
//                             </label>
//                             <select
//                                 value={editSubItem.tag || 'Veg'}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                     backgroundColor: '#fff',
//                                     cursor: 'pointer',
//                                 }}
//                             >
//                                 <option value="Veg">Veg</option>
//                                 <option value="Non_Veg">Non-Veg</option>
//                             </select>
//                         </div>

//                         {/* 6. Chef Type */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Chef Type:
//                             </label>
//                             <select
//                                 value={editSubItem.chefType || 'Chef_All'}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                     backgroundColor: '#fff',
//                                     cursor: 'pointer',
//                                 }}
//                             >
//                                 <option value="Chef_All">Chef All</option>
//                                 <option value="Chef_North">Chef North</option>
//                                 <option value="Chef_South">Chef South</option>
//                                 <option value="Chef_Chinese">Chef Chinese</option>
//                                 <option value="Chef_Continental">Chef Continental</option>
//                                 <option value="Tea_stall">Tea Stall</option>
//                                 <option value="Snacks">Snacks</option>
//                                 <option value="Bakery">Bakery</option>
//                             </select>
//                         </div>

//                         {/* 7. Description */}
//                         <div style={{ marginBottom: '15px' }}>
//                             <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
//                                 Description :
//                             </label>
//                             <input
//                                 type="text"
//                                 value={editSubItem.description}
//                                 onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
//                                 style={{
//                                     width: '100%',
//                                     padding: '10px',
//                                     borderRadius: '6px',
//                                     border: '1px solid #ccc',
//                                     fontSize: '14px',
//                                 }}
//                             />
//                         </div>

//                         {/* 8. Image - Modern Redesign */}
//                         <div style={{ marginTop: '20px' }}>
//                             <div style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'space-between',
//                                 marginBottom: '15px',
//                                 backgroundColor: '#f8f9fa',
//                                 padding: '12px 15px',
//                                 borderRadius: '8px',
//                                 borderLeft: '4px solid #b15cd6'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                     <div>
//                                         <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
//                                             Product Image
//                                             <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
//                                         </h3>
//                                     </div>
//                                 </div>

//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setCurrentPreset('PRODUCT_IMAGE'); // Or use 'SUB_ITEM_IMAGE' if you have a preset
//                                         setShowGuidelinesModal(true);
//                                     }}
//                                     style={{
//                                         background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                         border: 'none',
//                                         color: 'white',
//                                         cursor: 'pointer',
//                                         fontSize: '13px',
//                                         fontWeight: '600',
//                                         padding: '8px 16px',
//                                         borderRadius: '6px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '6px',
//                                         transition: 'all 0.2s',
//                                         boxShadow: '0 2px 5px rgba(0, 184, 148, 0.2)'
//                                     }}
//                                     onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                     onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                 >
//                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                         <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
//                                     </svg>
//                                     View Guidelines
//                                 </button>
//                             </div>

//                             {/* Modern Image Upload Card */}
//                             <div style={{
//                                 border: '1px solid #e0e0e0',
//                                 borderRadius: '12px',
//                                 overflow: 'hidden',
//                                 backgroundColor: 'white',
//                                 boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
//                             }}>
//                                 {/* Upload Zone */}
//                                 <div
//                                     style={{
//                                         padding: editSubItem.image ? "0px 0px" : '30px 0px',
//                                         textAlign: 'center',
//                                         cursor: 'pointer',
//                                         backgroundColor: '#fafafa',
//                                         borderBottom: '1px dashed #e0e0e0',
//                                         transition: 'all 0.3s',
//                                     }}
//                                     onClick={() => document.getElementById('subItemImageInput').click()}
//                                 // onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
//                                 // onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fafafa'}
//                                 >
//                                     {editSubItem.image && !editSubItem.image.includes('via.placeholder.com') ? (
//                                         <div style={{ position: 'relative' }}>
//                                             <img
//                                                 src={editSubItem.image}
//                                                 alt="Preview"
//                                                 style={{
//                                                     width: '100%',
//                                                     height: '100%',
//                                                     objectFit: 'cover', // Changed from 'contain' to 'cover' for better preview
//                                                     borderRadius: '8px',
//                                                     margin: '0 auto',
//                                                     border: '1px solid #e0e0e0'
//                                                 }}
//                                             />

//                                         </div>
//                                     ) : (
//                                         <>
//                                             <div style={{
//                                                 width: '80px',
//                                                 height: '80px',
//                                                 backgroundColor: '#e8f5e9',
//                                                 borderRadius: '50%',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 margin: '0 auto 20px',
//                                                 border: '2px solid #c8e6c9'
//                                             }}>
//                                                 <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
//                                                     <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                                 </svg>
//                                             </div>
//                                             <div style={{ marginBottom: '15px' }}>
//                                                 <p style={{
//                                                     fontSize: '16px',
//                                                     fontWeight: '600',
//                                                     color: '#2c3e50',
//                                                     margin: '0 0 8px'
//                                                 }}>
//                                                     Drop sub item image here, or click to browse
//                                                 </p>
//                                                 <p style={{
//                                                     fontSize: '13px',
//                                                     color: '#7f8c8d',
//                                                     margin: 0
//                                                 }}>
//                                                     Supports JPG, PNG • Max 3MB
//                                                 </p>
//                                             </div>
//                                             <button
//                                                 style={{
//                                                     background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
//                                                     border: 'none',
//                                                     color: 'white',
//                                                     cursor: 'pointer',
//                                                     fontSize: '14px',
//                                                     fontWeight: '600',
//                                                     padding: '10px 24px',
//                                                     borderRadius: '8px',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '8px',
//                                                     margin: '0 auto',
//                                                     transition: 'all 0.2s'
//                                                 }}
//                                                 onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
//                                                 onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
//                                             >
//                                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                                     <polyline points="17 8 12 3 7 8" />
//                                                     <line x1="12" y1="3" x2="12" y2="15" />
//                                                 </svg>
//                                                 Select Image
//                                             </button>
//                                         </>
//                                     )}
//                                 </div>


//                                 {editSubItem.newImageFile && (
//                                     <div style={{
//                                         backgroundColor: '#e8f5e9',
//                                         padding: '4px 12px',
//                                         borderRadius: '4px',
//                                         color: '#2e7d32',
//                                         fontWeight: '500'
//                                     }}>
//                                         ✓ {editSubItem.newImageFile.name.substring(0, 20)}{editSubItem.newImageFile.name.length > 20 ? '...' : ''}
//                                     </div>
//                                 )}

//                             </div>

//                             {/* File Info after upload */}
//                             {editSubItem.newImageFile && (
//                                 <div style={{
//                                     marginTop: '15px',
//                                     marginBottom: "15px",
//                                     padding: '12px 15px',
//                                     backgroundColor: '#f0f8ff',
//                                     borderRadius: '8px',
//                                     border: '1px solid #d1ecff'
//                                 }}>
//                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                                         <div>
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
//                                                 <span style={{ fontWeight: '600', color: '#2c3e50' }}>✓ Image Selected</span>
//                                                 <span style={{
//                                                     fontSize: '11px',
//                                                     backgroundColor: '#e8f5e9',
//                                                     color: '#2e7d32',
//                                                     padding: '2px 8px',
//                                                     borderRadius: '10px'
//                                                 }}>
//                                                     {(editSubItem.newImageFile.size / 1024 / 1024).toFixed(2)} MB
//                                                 </span>
//                                             </div>

//                                         </div>

//                                         <button
//                                             style={{
//                                                 background: 'none',
//                                                 border: '1px solid #ff6b6b',
//                                                 color: '#ff6b6b',
//                                                 padding: '6px 12px',
//                                                 borderRadius: '6px',
//                                                 fontSize: '12px',
//                                                 cursor: 'pointer',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 gap: '5px',
//                                                 transition: 'all 0.2s'
//                                             }}
//                                             onClick={(e) => {
//                                                 e.preventDefault();
//                                                 setEditSubItem({
//                                                     ...editSubItem,
//                                                     newImageFile: null,
//                                                     image: 'https://via.placeholder.com/100x100'
//                                                 });
//                                                 setCategoryImageFile(null);
//                                             }}
//                                             onMouseEnter={e => {
//                                                 e.currentTarget.style.backgroundColor = '#ff6b6b';
//                                                 e.currentTarget.style.color = 'white';
//                                             }}
//                                             onMouseLeave={e => {
//                                                 e.currentTarget.style.backgroundColor = 'transparent';
//                                                 e.currentTarget.style.color = '#ff6b6b';
//                                             }}
//                                         >
//                                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                 <line x1="18" y1="6" x2="6" y2="18" />
//                                                 <line x1="6" y1="6" x2="18" y2="18" />
//                                             </svg>
//                                             Remove
//                                         </button>
//                                     </div>

//                                     {editSubItem.newImageFile.size > 3 * 1024 * 1024 && ( // 3MB check
//                                         <div style={{
//                                             marginTop: '10px',
//                                             padding: '8px 12px',
//                                             backgroundColor: '#ffebee',
//                                             color: '#c62828',
//                                             borderRadius: '6px',
//                                             fontSize: '12px',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '8px'
//                                         }}>
//                                             <svg width="14" height="14" viewBox="0 0 24 24" fill="#c62828">
//                                                 <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 4v6h2v-6h-2zm0 8v2h2v-2h-2z" />
//                                             </svg>
//                                             Image exceeds maximum size of 3MB
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Hidden File Input */}
//                             <input
//                                 id="subItemImageInput"
//                                 type="file"
//                                 accept="image/*"
//                                 onChange={(e) => {
//                                     const file = e.target.files[0];
//                                     setEditSubItem({
//                                         ...editSubItem,
//                                         newImageFile: file,
//                                         image: file ? URL.createObjectURL(file) : editSubItem.image
//                                     });
//                                 }}
//                                 style={{ display: 'none' }}
//                             />
//                         </div>

//                         <div style={{ display: 'flex', justifyContent: 'center', marginTop: "10px" }}>
//                             <button onClick={submitEditSubcategory} style={submitButtonStyle}>
//                                 Update
//                             </button>
//                         </div>

//                     </div>
//                 </div>
//             )}

//             {/* Error Modal - Replaces window.alert() */}
//             {showErrorModal && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0, 0, 0, 0.7)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 9999,
//                     padding: '20px',
//                     backdropFilter: 'blur(3px)'
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         borderRadius: '12px',
//                         padding: '25px',
//                         width: '450px',
//                         maxWidth: '95vw',
//                         maxHeight: '90vh',
//                         overflowY: 'auto',
//                         boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
//                         animation: 'fadeIn 0.3s ease-out'
//                     }}>
//                         {/* Header with icon */}
//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             marginBottom: '20px',
//                             paddingBottom: '15px',
//                             borderBottom: '1px solid #eee'
//                         }}>
//                             <div style={{
//                                 width: '50px',
//                                 height: '50px',
//                                 borderRadius: '50%',
//                                 backgroundColor: errorModalDetails.type === 'error' ? '#fee' :
//                                     errorModalDetails.type === 'warning' ? '#ffedd5' : '#f0fdf4',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 marginRight: '15px',
//                                 flexShrink: 0
//                             }}>
//                                 {errorModalDetails.type === 'error' ? (
//                                     <span style={{ fontSize: '24px', color: '#dc2626' }}>⚠️</span>
//                                 ) : errorModalDetails.type === 'warning' ? (
//                                     <span style={{ fontSize: '24px', color: '#f59e0b' }}>ℹ️</span>
//                                 ) : (
//                                     <span style={{ fontSize: '24px', color: '#10b981' }}>✅</span>
//                                 )}
//                             </div>
//                             <div>
//                                 <h3 style={{
//                                     margin: 0,
//                                     color: errorModalDetails.type === 'error' ? '#dc2626' :
//                                         errorModalDetails.type === 'warning' ? '#f59e0b' : '#10b981',
//                                     fontSize: '20px'
//                                 }}>
//                                     {errorModalDetails.title}
//                                 </h3>
//                                 <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>
//                                     {errorModalDetails.type === 'error' ? 'Please fix this issue' :
//                                         errorModalDetails.type === 'warning' ? 'Recommendation' : 'Success'}
//                                 </p>
//                             </div>
//                         </div>

//                         {/* Message */}
//                         <div style={{
//                             marginBottom: '25px',
//                             lineHeight: '1.6',
//                             color: '#333'
//                         }}>
//                             {errorModalDetails.message.split('\n').map((line, index) => (
//                                 <p key={index} style={{ margin: line.startsWith('•') ? '5px 0 5px 15px' : '10px 0' }}>
//                                     {line.startsWith('•') ? '• ' + line.substring(1) : line}
//                                 </p>
//                             ))}
//                         </div>

//                         {/* Quick Tips (if applicable) */}
//                         {errorModalDetails.type === 'error' && (
//                             <div style={{
//                                 backgroundColor: '#f8fafc',
//                                 padding: '15px',
//                                 borderRadius: '8px',
//                                 marginBottom: '25px',
//                                 borderLeft: '4px solid #3b82f6'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
//                                     <span style={{ fontSize: '18px', marginRight: '8px' }}>💡</span>
//                                     <strong style={{ color: '#1e40af' }}>Quick Tips:</strong>
//                                 </div>
//                                 <ul style={{ margin: '8px 0 0 25px', padding: 0 }}>
//                                     <li>Use landscape mode on your phone</li>
//                                     <li>Ensure good lighting</li>
//                                     <li>Use JPG or PNG format</li>
//                                     <li>Keep file size under 5MB</li>
//                                 </ul>
//                             </div>
//                         )}

//                         {/* Action Buttons */}
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'flex-end',
//                             gap: '12px',
//                             marginTop: '20px'
//                         }}>
//                             {errorModalDetails.showGuidelinesButton && (
//                                 <button
//                                     onClick={() => {
//                                         setShowErrorModal(false);
//                                         setCurrentPreset(errorModalDetails.presetName);
//                                         setShowGuidelinesModal(true);
//                                     }}
//                                     style={{
//                                         backgroundColor: '#3b82f6',
//                                         color: 'white',
//                                         border: 'none',
//                                         padding: '12px 20px',
//                                         borderRadius: '8px',
//                                         cursor: 'pointer',
//                                         fontSize: '15px',
//                                         fontWeight: '600',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: '8px',
//                                         transition: 'all 0.2s'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
//                                 >
//                                     📋 View Guidelines
//                                 </button>
//                             )}

//                             <button
//                                 onClick={() => setShowErrorModal(false)}
//                                 style={{
//                                     backgroundColor: errorModalDetails.type === 'error' ? '#dc2626' :
//                                         errorModalDetails.type === 'warning' ? '#f59e0b' : '#10b981',
//                                     color: 'white',
//                                     border: 'none',
//                                     padding: '12px 25px',
//                                     borderRadius: '8px',
//                                     cursor: 'pointer',
//                                     fontSize: '15px',
//                                     fontWeight: '600',
//                                     transition: 'all 0.2s'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
//                                 onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
//                             >
//                                 {errorModalDetails.type === 'error' ? 'Try Again' :
//                                     errorModalDetails.type === 'warning' ? 'Continue' : 'OK'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Category Search Popup */}
//             {showCategorySearchPopup && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 2000
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         borderRadius: '8px',
//                         width: '300px',
//                         maxWidth: '90vw',
//                         maxHeight: '80vh',
//                         overflow: 'hidden',
//                         boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
//                     }}>
//                         {/* Header */}
//                         <div style={{
//                             padding: '15px',
//                             borderBottom: '1px solid #eee',
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center'
//                         }}>
//                             <h3 style={{ margin: 0, fontSize: '16px' }}>Search Categories</h3>
//                             <button
//                                 onClick={() => setShowCategorySearchPopup(false)}
//                                 style={{
//                                     background: 'none',
//                                     border: 'none',
//                                     fontSize: '20px',
//                                     cursor: 'pointer',
//                                     color: '#666'
//                                 }}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         {/* Search Input */}
//                         <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
//                             <div style={{ position: 'relative' }}>
//                                 <FaSearch style={{
//                                     position: 'absolute',
//                                     left: '10px',
//                                     top: '50%',
//                                     transform: 'translateY(-50%)',
//                                     color: '#999'
//                                 }} />
//                                 <input
//                                     type="text"
//                                     placeholder="Type to search categories..."
//                                     value={categorySearchQuery}
//                                     onChange={(e) => handleCategorySearch(e.target.value)}
//                                     style={{
//                                         width: '100%',
//                                         padding: '8px 8px 8px 35px',
//                                         borderRadius: '4px',
//                                         border: '1px solid #ddd',
//                                         fontSize: '14px',
//                                         outline: 'none'
//                                     }}
//                                     autoFocus
//                                 />
//                                 {categorySearchQuery && (
//                                     <FaTimes
//                                         onClick={() => setCategorySearchQuery('')}
//                                         style={{
//                                             position: 'absolute',
//                                             right: '10px',
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             color: '#999',
//                                             cursor: 'pointer'
//                                         }}
//                                     />
//                                 )}
//                             </div>
//                         </div>

//                         {/* Categories List */}
//                         <div style={{
//                             maxHeight: '300px',
//                             overflowY: 'auto',
//                             padding: '5px 0'
//                         }}>
//                             {/* Show All option */}
//                             <div
//                                 onClick={() => handleCategorySelect(null)}
//                                 style={{
//                                     padding: '10px 15px',
//                                     cursor: 'pointer',
//                                     borderBottom: '1px solid #f5f5f5',
//                                     backgroundColor: selectedCategory === null ? '#f0f0f0' : 'white',
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === null ? '#f0f0f0' : 'white'}
//                             >
//                                 <span>Show All Categories</span>
//                                 <span style={{
//                                     color: '#666',
//                                     fontSize: '12px',
//                                     backgroundColor: '#e9ecef',
//                                     padding: '2px 6px',
//                                     borderRadius: '10px'
//                                 }}>
//                                     {data.length}
//                                 </span>
//                             </div>

//                             {/* Categories */}
//                             {filteredCategories.map((category, index) => (
//                                 <div
//                                     key={index}
//                                     onClick={() => handleCategorySelect(category.name)}
//                                     style={{
//                                         padding: '10px 15px',
//                                         cursor: 'pointer',
//                                         borderBottom: '1px solid #f5f5f5',
//                                         backgroundColor: selectedCategory === category.name ? '#f0f0f0' : 'white',
//                                         display: 'flex',
//                                         justifyContent: 'space-between',
//                                         alignItems: 'center'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === category.name ? '#f0f0f0' : 'white'}
//                                 >
//                                     <span>{category.name}</span>
//                                     <span style={{
//                                         color: '#666',
//                                         fontSize: '12px',
//                                         backgroundColor: '#e9ecef',
//                                         padding: '2px 6px',
//                                         borderRadius: '10px'
//                                     }}>
//                                         {category.count}
//                                     </span>
//                                 </div>
//                             ))}

//                             {filteredCategories.length === 0 && (
//                                 <div style={{
//                                     padding: '20px',
//                                     textAlign: 'center',
//                                     color: '#666'
//                                 }}>
//                                     No categories found
//                                 </div>
//                             )}
//                         </div>

//                         {/* Footer */}
//                         <div style={{
//                             padding: '10px 15px',
//                             borderTop: '1px solid #eee',
//                             textAlign: 'right'
//                         }}>
//                             <button
//                                 onClick={() => setShowCategorySearchPopup(false)}
//                                 style={{
//                                     padding: '6px 15px',
//                                     backgroundColor: '#6c757d',
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '4px',
//                                     cursor: 'pointer',
//                                     fontSize: '14px'
//                                 }}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Image Guidelines Modal */}
//             {/* <ImageGuidelinesModal
//                 preset={currentPreset}
//                 isOpen={showGuidelinesModal}
//                 onClose={() => setShowGuidelinesModal(false)}
//             /> */}
//             <style>
//                 {`
//                /* ItemUpdates-style toggle - Fixed direction */
// .switch {
//     position: relative;
//     display: inline-block;
//     width: 45px;
//     height: 22px;
// }

// .switch input {
//     opacity: 0;
//     width: 0;
//     height: 0;
// }

// .slider {
//     position: absolute;
//     cursor: pointer;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     background-color: #f44336; /* RED by default (Hide) */
//     transition: .4s;
//     border-radius: 34px;
// }

// .slider:before {
//     position: absolute;
//     content: "";
//     height: 16px;
//     width: 16px;
//     left: 3px;  /* LEFT position by default */
//     bottom: 3px;
//     background-color: white;
//     transition: .4s;
//     border-radius: 50%;
// }

// /* CHECKED state - Show (GREEN) */
// input:checked + .slider {
//     background-color: #4CAF50; /* GREEN when Show */
// }

// input:checked + .slider:before {
//     transform: translateX(18px); /* Move to RIGHT when Show */
// }

// .slider.round {
//     border-radius: 34px;
// }

// /* Disabled state - Grayed out */
// .slider.disabled {
//     background-color: #cccccc !important;
//     cursor: not-allowed;
// }

// .switch input:disabled + .slider {
//     background-color: #cccccc !important;
//     cursor: not-allowed;
// }

// .switch input:disabled + .slider:before {
//     background-color: #999999 !important;
// }
//     @media (max-width: 768px) {
//     .standard-table-data {
//         overflow-x: auto !important;
//         -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
//         width: 93vw !important;

//     }

//     .standard-table-data table {
//         min-width: 800px; /* Force horizontal scroll */
//         width: 100%;
//     }

//     /* Make table cells more readable on mobile */
//     .standard-table-data td,
//     .standard-table-data th {
//         min-width: 80px;
//         // white-space: nowrap;
//         padding: 4px !important;
//         font-size: 0.8rem !important;
//     }

//     /* Adjust button sizes on mobile */
//     .standard-table-data button {
//         padding: 3px 5px !important;
//         font-size: 0.7rem !important;
//         min-width: 35px !important;
//     }
// }
//      @keyframes fadeIn {
//         from {
//             opacity: 0;
//             transform: translateY(-20px);
//         }
//         to {
//             opacity: 1;
//             transform: translateY(0);
//         }
//     }
// `}
//             </style>
//             <style>{`
//     .no-scrollbar { scrollbar-width: none; }
//     .no-scrollbar::-webkit-scrollbar { display: none; }
//     .veg-icon { color: #22c55e; }
//     .nonveg-icon { color: #ef4444; }
//     .tag { font-size: 12px; padding: 2px 6px; border-radius: 999px; }
//     .tag-veg { background:#e8f7ec; color:#1f7a3a; border:1px solid #bfe8cb; }
//     .tag-nonveg { background:#ffecec; color:#b00020; border:1px solid #ffc5c5; }
//     .btn { padding:8px 12px; border:none; border-radius:6px; cursor:pointer; font-weight:600; font-size:14px; }
//     .btn-primary { background:#b15dc6; color:#fff; }
//     .btn-secondary { background:#6c757d; color:#fff; }
//     .btn-success { background:#28a745; color:#fff; }

//     @keyframes slideDown {
//         0% {
//             opacity: 0;
//             transform: translateY(-10px);
//         }
//         100% {
//             opacity: 1;
//             transform: translateY(0);
//         }
//     }

//     .slide-down {
//         animation: slideDown 0.3s ease-out forwards;
//     }
// `}</style>
//         </div>
//     );
// };

// const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0, left: 0, right: 0, bottom: 0,
//     backgroundColor: 'rgba(0,0,0,0.5)',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: 1001,
//     marginTop: "0px",
// };

// const modalContentStyle = {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     padding: '20px',
//     width: '350px',
//     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//     height: "500px",
//     overflow: "auto",
//     scrollbarWidth: "none",
// };

// const cancelButtonStyle = {
//     backgroundColor: '#ccc',
//     border: 'none',
//     padding: '8px 16px',
//     borderRadius: '4px',
//     cursor: 'pointer',
// };

// const submitButtonStyle = {
//     backgroundColor: '#b15cd6',
//     color: 'white',
//     border: 'none',
//     padding: '8px 16px',
//     borderRadius: '4px',
//     cursor: 'pointer',
// };

// const buttonStyle = {
//     backgroundColor: '#b15cd6',
//     color: 'white',
//     border: 'none',
//     cursor: 'pointer',
//     borderRadius: '5px',
//     width: '100px',
//     fontWeight: "bold"
// };

// const tableHeaderStyle = {
//     border: '1px solid #ddd',
//     textAlign: 'center',
//     fontWeight: '500',
//     backgroundColor: '#b15cd6',
//     color: 'white',
//     fontSize: "1rem",
//     padding: "0.5rem",

// };

// const tableCellStyle = {
//     border: '1px solid #ddd',
//     textAlign: 'center',
// };

// const evenRowStyle = { backgroundColor: '#fff' };
// const oddRowStyle = { backgroundColor: '#fff' };

// const inputStyle = {
//     border: 'none',
//     backgroundColor: 'transparent',
//     textAlign: 'center',
// };

// const addButtonStyle = {
//     backgroundColor: '#b15cd6',
//     color: 'green',
//     border: 'none',
//     cursor: 'pointer',
//     borderRadius: '5px',
//     // marginRight: '10px',
//     fontSize: "20px"
// };

// const deleteButtonStyle = {
//     backgroundColor: '#fff',
//     color: 'red',
//     border: 'none',
//     cursor: 'pointer',
//     borderRadius: '5px',
//     fontSize: "20px"
// };


// export default StandardMenu;




// // background color as #00b894



import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { FaChevronDown, FaChevronRight, FaEdit, FaPlus, FaSave, FaSearch, FaTimes, FaTrash } from 'react-icons/fa';
import * as XLSX from 'xlsx';
// import ImageGuidelinesModal from '../../../../components/ImageGuidelinesModal.jsx';
// import ValidatedImageUpload from '../../../../components/ValidatedImageUpload.jsx';
import { useLoader } from "../../../../context/LoaderProvider.jsx";
// import { imageValidationRules } from '../../../../utils/imageValidationConfig.js';
import './Management2.css';

import ItemDiscounts from './ItemDiscounts.jsx';
const StandardMenu = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addedItems, setAddedItems] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [image, setImage] = useState(null);
    const [text, setText] = useState('');
    const [isVegSelected, setIsVegSelected] = useState(null);
    const [dishId, setDishId] = useState(null);
    const [chefType, setChefType] = useState("Chef_All");
    const [imageFile, setImageFile] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);
    const [showCategorySearchPopup, setShowCategorySearchPopup] = useState(false);
    const [categorySearchQuery, setCategorySearchQuery] = useState('');
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    // Add this state variable near your other states
    const [showImageGuidelines, setShowImageGuidelines] = useState(false);
    const [showGuidelinesModal, setShowGuidelinesModal] = useState(false);
    const [currentPreset, setCurrentPreset] = useState('PRODUCT_IMAGE');
    const [categoryImageFile, setCategoryImageFile] = useState(null); // Changed from imageFile
    // Add these state variables near your other states
    const [allCategories, setAllCategories] = useState([]);
    const [allDishes, setAllDishes] = useState([]);
    const [categorySuggestions, setCategorySuggestions] = useState([]);
    const [dishSuggestions, setDishSuggestions] = useState([]);
    const [showCategorySuggestions, setShowCategorySuggestions] = useState(false);
    const importFileInputRef = useRef(null);    // NEW: For import functionality
    const [showDishSuggestions, setShowDishSuggestions] = useState(false);
    // Add this state with your other useState declarations
    // Add this state with your other useState declarations
    const [expandedCategories, setExpandedCategories] = useState({});
    const [bulkMode, setBulkMode] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});
    const [bulkQuantity, setBulkQuantity] = useState('');

    // Load expanded state from localStorage on mount
    useEffect(() => {
        const savedExpanded = localStorage.getItem('expandedCategories');
        if (savedExpanded) {
            try {
                const parsed = JSON.parse(savedExpanded);
                setExpandedCategories(parsed);
                console.log("Loaded expanded categories:", parsed); // Debug
            } catch (e) {
                console.error("Error parsing expanded categories:", e);
            }
        }
    }, []);

    // Save to localStorage whenever expandedCategories changes
    useEffect(() => {
        if (Object.keys(expandedCategories).length > 0) {
            localStorage.setItem('expandedCategories', JSON.stringify(expandedCategories));
            console.log("Saved expanded categories:", expandedCategories); // Debug
        }
    }, [expandedCategories]);

    // Toggle function for category expansion
    const toggleCategory = (categoryId, event) => {
        event.stopPropagation(); // Prevent any row click events
        setExpandedCategories(prev => ({
            ...prev,
            [categoryId]: !prev[categoryId]
        }));
    };

    // Add these functions to fetch category and dish data
    const fetchAllCategories = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                "https://backend.maamaas.com/food/api/getall/catageory-dish",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setAllCategories(response.data || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
            setAllCategories([]);
        }
    };

    const fetchAllDishes = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                "https://backend.maamaas.com/food/api/getall/dish",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setAllDishes(response.data || []);
        } catch (error) {
            console.error("Error fetching dishes:", error);
            setAllDishes([]);
        }
    };

    // Call these in useEffect
    useEffect(() => {
        fetchData();
        fetchAllCategories();
        fetchAllDishes();
    }, []);
    // Add these functions for auto-suggestions
    const handleCategoryInputChange = (e) => {
        const value = e.target.value;
        setText(value);

        if (value.trim().length > 0) {
            const filtered = allCategories
                .filter(category =>
                    category.catageoryName.toLowerCase().includes(value.toLowerCase())
                )
                .slice(0, 5); // Show only top 5 suggestions

            setCategorySuggestions(filtered);
            setShowCategorySuggestions(filtered.length > 0);
        } else {
            setCategorySuggestions([]);
            setShowCategorySuggestions(false);
        }
    };

    const handleDishInputChange = (e) => {
        const value = e.target.value;
        setSubDishName(value);

        if (value.trim().length > 0) {
            const filtered = allDishes
                .filter(dish =>
                    dish.name.toLowerCase().includes(value.toLowerCase())
                )
                .slice(0, 5); // Show only top 5 suggestions

            setDishSuggestions(filtered);
            setShowDishSuggestions(filtered.length > 0);
        } else {
            setDishSuggestions([]);
            setShowDishSuggestions(false);
        }
    };

    // Function to select a category suggestion
    const selectCategorySuggestion = (categoryName) => {
        setText(categoryName);
        setCategorySuggestions([]);
        setShowCategorySuggestions(false);
    };

    // Function to select a dish suggestion
    const selectDishSuggestion = (dishName) => {
        setSubDishName(dishName);
        setDishSuggestions([]);
        setShowDishSuggestions(false);
    };

    const normalizeForSearch = (text) => {
        if (!text) return '';

        // Convert to lowercase and replace multiple separators with space
        return text
            .toLowerCase()
            .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
            .trim();
    };
    // Add these near your other state declarations
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorModalDetails, setErrorModalDetails] = useState({
        title: '',
        message: '',
        type: 'error', // 'error', 'warning', 'success'
        showGuidelinesButton: false,
        presetName: 'PRODUCT_IMAGE'
    });

    const handleSearch = (query) => {
        const searchTerm = normalizeForSearch(query);
        setSearchQuery(query);

        if (!searchTerm) {
            setSearchActive(false);
            applyFilter(data, isVegSelected);
            return;
        }

        setSearchActive(true);

        // Create search patterns:
        // 1. Exact match (with spaces normalized)
        // 2. Without spaces (for "vegmeals")
        // 3. Individual words
        const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
        const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

        const searchResults = data.map(category => {
            // Normalize category
            const normalizedCategory = normalizeForSearch(category.category);
            const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

            // Check category matches
            const categoryMatches =
                normalizedCategory.includes(searchTerm) ||
                categoryWithoutSpaces.includes(searchWithoutSpaces) ||
                searchWords.every(word => normalizedCategory.includes(word));

            // Filter subcategories
            const filteredSubcategories = category.subcategories?.filter(sub => {
                // Normalize subcategory fields
                const normalizedSubName = normalizeForSearch(sub.subName);
                const normalizedDescription = normalizeForSearch(sub.description);
                const normalizedTag = normalizeForSearch(sub.tag);

                const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
                const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

                // Multiple matching strategies
                const nameMatches =
                    normalizedSubName.includes(searchTerm) ||
                    subNameWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedSubName.includes(word));

                const descMatches =
                    normalizedDescription.includes(searchTerm) ||
                    descWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedDescription.includes(word));

                const tagMatches =
                    normalizedTag.includes(searchTerm) ||
                    normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

                return nameMatches || descMatches || tagMatches;
            });

            // Include category if it matches or has matching subcategories
            if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
                return {
                    ...category,
                    subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                };
            }

            return null;
        }).filter(category => category !== null);

        setFilteredData(searchResults);
    };


    const handleFilterClick = (tag) => {
        const vegSelected = tag === 'Veg';
        setIsVegSelected(vegSelected);
        setSearchActive(false);
        setSearchQuery("");
        applyFilter(data, vegSelected);
    };

    const fileInputRef = useRef(null);
    const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
    const [subDishName, setSubDishName] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState('');
    const [stockQuantity, setStockQuantity] = useState('');
    // Add this with your other state declarations
    const [categoryQuantities, setCategoryQuantities] = useState({});
    const [gst, setGst] = useState('');
    const [discount, setdiscount] = useState('');
    const [packingCharges, setPackingCharges] = useState('');
    const [tag, setTag] = useState('Veg');
    const [stock, setStock] = useState('In Stock');
    const [menuStatus, setMenuStatus] = useState(true);
    const [parentDishDetails, setParentDishDetails] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [showSubEditModal, setShowSubEditModal] = React.useState(false);
    const [editSubItem, setEditSubItem] = React.useState({
        dishId: '',
        subName: '',
        discount: '',
        price: '',
        // stockQuantity: '',
        gst: '',
        packingCharges: '',
        image: '',
        tag: 'Veg', // Add this line
        chefType: '',
        parentIndex: null,
        subIndex: null,
        description: '',
    });
    // Add this function for category image upload


    const [subCategoryData, setSubCategoryData] = React.useState({
        dishImage: '',
    });

    // const applyFilter = (allData, vegOnly) => {
    //     if (vegOnly === null) {
    //         setFilteredData(allData);
    //         return;
    //     }

    //     const filtered = allData.map(category => {
    //         const filteredSubcategories = category.subcategories.filter(
    //             sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
    //         );

    //         return {
    //             ...category,
    //             subcategories: filteredSubcategories
    //         };
    //     }).filter(cat => cat.subcategories.length > 0);

    //     setFilteredData(filtered);
    // };
    const applyFilter = (allData, vegOnly) => {
        let filtered = allData;

        // Apply category filter if selected
        if (selectedCategory) {
            filtered = filtered.filter(item => item.category === selectedCategory);
        }

        // Apply veg filter if selected
        if (vegOnly !== null) {
            filtered = filtered.map(category => {
                const filteredSubcategories = category.subcategories.filter(
                    sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
                );
                return {
                    ...category,
                    subcategories: filteredSubcategories
                };
            }).filter(cat => cat.subcategories.length > 0);
        }

        // Apply search if active
        if (searchActive && searchQuery) {
            filtered = filtered.map(category => {
                const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
                const filteredSubcategories = category.subcategories.filter(sub =>
                    sub.subName?.toLowerCase().includes(searchQuery) ||
                    sub.description?.toLowerCase().includes(searchQuery)
                );

                if (categoryMatches || filteredSubcategories.length > 0) {
                    return {
                        ...category,
                        subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                    };
                }
                return null;
            }).filter(category => category !== null);
        }

        setFilteredData(filtered);
    };


    const handleEditSubcategory = async (subDishId, subIndex, parentIndex) => {
        try {
            setDishId(subDishId);
            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                `https://backend.maamaas.com/food/api/dish/get/${subDishId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const subDish = response.data;

            setEditSubItem({
                dishId: subDish.dishId,
                subName: subDish.dishName || '',
                price: subDish.price || '',
                discount: subDish.discount || '',
                // stockQuantity: subDish.stockQuantity || '',
                gst: subDish.gst || '',
                packingCharges: subDish.packingCharges || '',
                image: subDish.dishImage || '',
                chefType: subDish.chefType || '',
                chefType: subDish.chefType || 'Chef_All', // Add this line
                tag: subDish.tag || 'Veg', // Add this line
                parentIndex,
                subIndex,
                description: subDish.description || '',
                stockQuantity: subDish.stockQuantity || 0,
                consumedQuantity: subDish.consumedQuantity || 0,
                balanceQuantity: subDish.balanceQuantity || 0,
            });

            setShowSubEditModal(true);
        } catch (error) {
            alert('Error fetching subcategory details:\n' + (error.response?.data?.message || error.message));
            console.error(error);
        }
    };
    // Function to apply category quantity to all subcategories
    const handleApplyQuantityToSubcategories = async (categoryId, quantity) => {


        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication failed. Please login again.");
            return;
        }

        showLoader();
        let successCount = 0;
        let failCount = 0;

        try {
            // Find the category and its subcategories
            const category = data.find(item => item.dishId === categoryId);

            if (!category || !category.subcategories || category.subcategories.length === 0) {
                alert("No subcategories found under this category.");
                hideLoader();
                return;
            }

            // Update each subcategory's stockQuantity
            for (const sub of category.subcategories) {
                try {
                    const url = `https://backend.maamaas.com/food/api/dish/edit/${sub.dishId}`;

                    const formData = new FormData();
                    const dishData = {
                        dishName: sub.subName,
                        price: sub.price,
                        stockQuantity: quantity, // Set the quantity here
                        gst: sub.gst || 0,
                        packingCharges: sub.packingCharges || 0,
                        discount: sub.discount || 0,
                        tag: sub.tag || 'Veg',
                        chefType: sub.chefType || 'Chef_All',
                        description: sub.description || '',
                    };

                    formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

                    const response = await axios.put(url, formData, {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    if (response.status === 200) {
                        successCount++;

                        // Update local state immediately
                        setData(prevData => {
                            return prevData.map(cat => {
                                if (cat.dishId === categoryId) {
                                    return {
                                        ...cat,
                                        subcategories: cat.subcategories.map(subItem => {
                                            if (subItem.dishId === sub.dishId) {
                                                return { ...subItem, stockQuantity: quantity };
                                            }
                                            return subItem;
                                        })
                                    };
                                }
                                return cat;
                            });
                        });

                        // Also update filteredData
                        setFilteredData(prevData => {
                            return prevData.map(cat => {
                                if (cat.dishId === categoryId) {
                                    return {
                                        ...cat,
                                        subcategories: cat.subcategories.map(subItem => {
                                            if (subItem.dishId === sub.dishId) {
                                                return { ...subItem, stockQuantity: quantity };
                                            }
                                            return subItem;
                                        })
                                    };
                                }
                                return cat;
                            });
                        });
                    } else {
                        failCount++;
                    }
                } catch (error) {
                    console.error(`Failed to update subcategory ${sub.subName}:`, error);
                    failCount++;
                }
            }

            // Show result
            if (successCount > 0) {
                showSuccessMessage(
                    'Update Complete',
                    ``
                );
            } else {
                alert(`Failed to update any subcategories. Please try again.`);
            }

        } catch (error) {
            console.error("Error applying quantity to subcategories:", error);
            alert("An error occurred while updating subcategories.");
        } finally {
            hideLoader();
        }
    };


    // Add this function to handle image validation
    // const validateImage = async (file) => {
    //     try {
    //         const result = await imageValidationRules.validateImage(file, 'PRODUCT_IMAGE');
    //         console.log(result);
    //         return result;
    //     } catch (error) {
    //         console.error('Validation error:', error);
    //         return {
    //             isValid: false,
    //             errors: ['Image upload failed. Please try a different image.'],
    //             warnings: []
    //         };
    //     }
    // };


    // Update the handleSubImageChange function (around line 170-200):
    const handleSubImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setImageFile(file);
        const reader = new FileReader();
        reader.onloadend = () => setImage(reader.result);
        reader.readAsDataURL(file);
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setCategoryImageFile(file);
        const reader = new FileReader();
        reader.onloadend = () => setImage(reader.result);
        reader.readAsDataURL(file);
    };

    // Update the handleSave function (around line 220-290):
    const handleSave = async () => {
        // Check categoryImageFile instead of imageFile
        // if (!categoryImageFile) {
        //     showErrorModalMessage(
        //         'Image Required',
        //         'Please upload an image for the category.',
        //         'error',
        //         true,
        //         'PRODUCT_IMAGE'
        //     );
        //     return;
        // }

        if (!text.trim()) {
            showErrorModalMessage(
                'Category Name Required',
                'Please enter a name for the category.',
                'error'
            );
            return;
        }

        showLoader();
        try {
            // Validate the category image
            // const validationResult = await validateImage(categoryImageFile);
            // if (!validationResult.isValid) {
            //     validationResult.errors.forEach(error => {
            //         showImageError(error, 'PRODUCT_IMAGE');
            //     });
            //     return;
            // }

            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId) {
                alert("🔐 Please log in again. Your session may have expired.");
                return;
            }

            if (!token) {
                alert("🔐 Please log in again. Your session may have expired.");
                return;
            }

            const formData = new FormData();
            const dishData = {
                dishId: 0,
                price: 0,
                dishName: text.trim(),
                parentId: 0,
                stockQuantity: 0,
                gst: 0,
                packingCharges: 0,
            };

            formData.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            formData.append("image", categoryImageFile);

            const response = await axios.post(
                `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // showSuccessMessage(
            //     'Dish Added',
            //     'Dish has been added successfully!'
            // );
            setShowPopup(false);
            setText("");
            setImage(null);
            setCategoryImageFile(null);

            // Reset file input
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            window.location.reload();
        } catch (error) {
            console.error("Upload failed:", error.response?.data || error.message);

            // Friendly error messages for common API errors
            let userMessage = "Failed to add category. ";

            if (error.response?.status === 401) {
                userMessage += "Your session has expired. Please log in again.";
            } else if (error.response?.status === 400) {
                userMessage += "Please check the image format and try again.";
            } else if (error.response?.data?.message?.includes("image")) {
                userMessage += "The image format may not be supported. Please try a JPG or PNG file.";
            } else if (!navigator.onLine) {
                userMessage += "No internet connection. Please check your network.";
            } else {
                userMessage += "Please try again.";
            }

            showErrorModalMessage('Upload Failed', userMessage, 'error');
        } finally {
            hideLoader();
        }
    };


    const handleEditImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setEditItem(prev => ({
                ...prev,
                newImageFile: file,
                image: URL.createObjectURL(file)
            }));
        }
    };



    // Update the handleSubcategorySubmit function (around line 340-440):
    const handleSubcategorySubmit = async () => {


        // if (!imageFile) {
        //     showErrorModalMessage(
        //         'Image Required',
        //         'Please select an image for the dish.',
        //         'error',
        //         true,
        //         'PRODUCT_IMAGE'
        //     );
        //     return;
        // }

        showLoader();
        setShowSubcategoryPopup(false);
        try {
            // Validate image
            // const validationResult = await validateImage(imageFile);
            // if (!validationResult.isValid) {
            //     validationResult.errors.forEach(error => {
            //         showImageError(error, 'PRODUCT_IMAGE');
            //     });
            //     return;
            // }

            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId) {
                alert("🔐 Please log in again. Your session may have expired.");
                return;
            }

            if (!token) {
                alert("🔐 Please log in again. Your session may have expired.");
                return;
            }

            const formData = new FormData();
            const dishData = {
                dishId: 0,
                price: parseFloat(price) || 0,
                dishName: subDishName.trim() || "Unnamed Dish",
                parentId: Number(parentDishDetails?.dishId) || 1,
                stockQuantity: stockQuantity || 0,
                gst: gst || 0,
                packingCharges: packingCharges || 0,
                discount: discount || 0,
                tag: tag || "Veg",
                stock: stock ? "In_Stock" : "Out_of_Stock",
                menuStatus: menuStatus ? "Enable" : "Disable",
                description: description?.trim() || "",
                consumedQuantity: 0,
                balanceQuantity: 0,
                effectivePrice: 0,
                chefType: chefType || "Chef_All"
            };

            formData.append(
                "dishData",
                new Blob([JSON.stringify(dishData)], { type: "application/json" })
            );

            formData.append("image", imageFile);

            const res = await axios.post(
                `https://backend.maamaas.com/food/api/dish/add/${vendorId}`,
                formData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            // showSuccessMessage(
            //     'Dish Added',
            //     'Dish has been added successfully!'
            // );
            // window.location.reload();

            setSubDishName('');
            setPrice('');
            setGst('');
            setPackingCharges('');
            setTag('Veg');
            setStock('In Stock');
            setMenuStatus(true);
            setSubCategoryData({ dishImage: '' });
            setdiscount('');
            setImage(null);
            setImageFile(null);

            fetchData();
        } catch (error) {
            console.error("❌ Error response:", error.response?.data || error.message);

            // Friendly error messages
            let userMessage = "Failed to add dish. ";

            if (error.response?.status === 401) {
                userMessage = "Your session has expired. Please log in again.";
            } else if (error.response?.status === 400) {
                userMessage = "Please check all fields and try again.";
            } else if (error.message.includes("Network Error")) {
                userMessage = "No internet connection. Please check your network.";
            } else if (error.response?.data?.error?.includes("price") || error.response?.data?.error?.includes("Price")) {
                userMessage = "Please enter a valid price.";
            } else {
                userMessage += "Please try again.";
            }
            showErrorModalMessage('Upload Failed', 'Failed to add dish. Please try again.', 'error');
        } finally {
            hideLoader();
        }
    };


    // Update the submitEditSubcategory function (around line 450-520):
    const submitEditSubcategory = async () => {
        if (!editSubItem || !editSubItem.dishId) {
            alert("❌ Unable to update. Please refresh the page and try again.");
            return;
        }

        showLoader();
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("🔐 Please log in again. Your session may have expired.");
                return;
            }

            // Validate new image if provided
            // if (editSubItem.newImageFile) {
            //     const validationResult = await validateImage(editSubItem.newImageFile);
            //     if (!validationResult.isValid) {
            //         const errorMessage = validationResult.errors[0]?.includes('Portrait image rejected')
            //             ? "Please upload a landscape image (wider than tall)."
            //             : "Please upload a valid image (JPG/PNG, landscape, under 5MB).";

            //         alert(`⚠️ ${errorMessage}`);
            //         return;
            //     }
            // }

            const url = `https://backend.maamaas.com/food/api/dish/edit/${editSubItem.dishId}`;

            const formData = new FormData();
            const dishData = {
                dishName: editSubItem.subName,
                price: editSubItem.price,
                stockQuantity: editSubItem.stockQuantity || 0, // Include stock quantity
                consumedQuantity: editSubItem.consumedQuantity || 0, // Include consumed quantity
                balanceQuantity: editSubItem.balanceQuantity || 0, // Include balance quantity

                gst: editSubItem.gst,
                packingCharges: editSubItem.packingCharges,
                discount: editSubItem.discount,
                tag: editSubItem.tag || 'Veg',
                chefType: editSubItem.chefType || 'Chef_All',
                description: editSubItem.description,
            };

            formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

            if (editSubItem.newImageFile) {
                formData.append("image", editSubItem.newImageFile);
            }

            const response = await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            alert("✅ Dish updated successfully!");
            window.location.reload();
        } catch (error) {
            console.error("Error updating subcategory:", error);

            let userMessage = "Failed to update dish. ";

            if (error.response?.status === 401) {
                userMessage = "Your session has expired. Please log in again.";
            } else if (error.response?.status === 400) {
                userMessage = "Please check all fields and try again.";
            } else {
                userMessage += "Please try again.";
            }

            alert(`❌ ${userMessage}`);
        } finally {
            hideLoader();
        }
    };

    // Add this function for bulk updating selected subcategories
    const handleBulkUpdate = async () => {
        const selectedIds = Object.keys(selectedItems).filter(id => selectedItems[id]);

        if (selectedIds.length === 0) {
            alert("No items selected");
            return;
        }

        if (!bulkQuantity || bulkQuantity === '') {
            alert("Please enter a quantity");
            return;
        }

        const quantity = parseInt(bulkQuantity);
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("Authentication failed. Please login again.");
            return;
        }

        if (!window.confirm(`Update ${selectedIds.length} items with quantity ${quantity}?`)) {
            return;
        }

        showLoader();
        let successCount = 0;
        let failCount = 0;

        try {
            for (const dishId of selectedIds) {
                try {
                    // Find the subcategory details
                    let subDetails = null;
                    for (const category of data) {
                        const found = category.subcategories?.find(s => s.dishId == dishId);
                        if (found) {
                            subDetails = found;
                            break;
                        }
                    }

                    if (!subDetails) continue;

                    const url = `https://backend.maamaas.com/food/api/dish/edit/${dishId}`;

                    const formData = new FormData();
                    const dishData = {
                        dishName: subDetails.subName,
                        price: subDetails.price,
                        stockQuantity: quantity,
                        gst: subDetails.gst || 0,
                        packingCharges: subDetails.packingCharges || 0,
                        discount: subDetails.discount || 0,
                        tag: subDetails.tag || 'Veg',
                        chefType: subDetails.chefType || 'Chef_All',
                        description: subDetails.description || '',
                    };

                    formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

                    const response = await axios.put(url, formData, {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    if (response.status === 200) {
                        successCount++;

                        // Update local state immediately
                        setData(prevData => {
                            return prevData.map(category => ({
                                ...category,
                                subcategories: category.subcategories.map(sub => {
                                    if (sub.dishId == dishId) {
                                        return { ...sub, stockQuantity: quantity };
                                    }
                                    return sub;
                                })
                            }));
                        });

                        setFilteredData(prevData => {
                            return prevData.map(category => ({
                                ...category,
                                subcategories: category.subcategories.map(sub => {
                                    if (sub.dishId == dishId) {
                                        return { ...sub, stockQuantity: quantity };
                                    }
                                    return sub;
                                })
                            }));
                        });
                    } else {
                        failCount++;
                    }
                } catch (error) {
                    console.error(`Failed to update dish ${dishId}:`, error);
                    failCount++;
                }
            }

            // Show result
            if (successCount > 0) {
                showSuccessMessage(
                    '✅ Bulk Update Complete',
                    `Successfully updated ${successCount} items.\n${failCount > 0 ? `Failed: ${failCount}` : ''}`
                );

                // Exit bulk mode after successful update
                setBulkMode(false);
                setSelectedItems({});
                setBulkQuantity('');
            } else {
                alert(`Failed to update any items. Please try again.`);
            }

        } catch (error) {
            console.error("Error in bulk update:", error);
            alert("An error occurred during bulk update.");
        } finally {
            hideLoader();
        }
    };
    // Get image requirements text
    // const getImageRequirementsText = () => {
    //     const rules = imageValidationRules.PRESETS.PRODUCT_IMAGE;
    //     return `Required: Yes | Max Size: ${rules.maxSizeMB}MB | Formats: ${rules.recommendedFormats.join(', ')} | Min Dimensions: ${rules.minDimensions.width}×${rules.minDimensions.height}px`;
    // };





    // Update the handleAddSubCategory function (around line 550-590):
    const handleAddSubCategory = async (dishId) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("🔐 Please log in again. Your session may have expired.");
            return;
        }

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/get/${dishId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();
            setParentDishDetails(dishData);

            // Reset image states when opening subcategory modal
            setImage(null);
            setImageFile(null);
            setShowSubcategoryPopup(true);

        } catch (error) {
            console.error("Failed to fetch dish data:", error);
            alert("❌ Unable to load dish details. Please try again.");
        } finally {
            hideLoader();
        }
    };


    const importExportButton = {
        height: window.innerWidth < 480 ? '32px' : '35px',
        borderRadius: "4px",
        border: "none",
        backgroundColor: "#b15cd6",
        color: "white",
        fontWeight: '500',
        fontSize: window.innerWidth < 480 ? "0.7rem" : "0.75rem",
        padding: window.innerWidth < 480 ? "0 12px" : "0 15px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        minWidth: window.innerWidth < 480 ? "70px" : "80px"
    };

    // Updated Export Function - Exports ALL data in import format
    const handleExport = () => {
        // Use original data, not filteredData
        if (!data || data.length === 0) {
            alert("No data available to export.");
            return;
        }

        try {
            const exportData = [];

            // Process all categories
            data.forEach((category, index) => {
                // Category row
                exportData.push({
                    "S.No": index + 1,
                    "Category*": category.category || "",
                    "Subcategory": "", // Empty for categories
                    "Type": "", // Categories don't have type
                    "Price*": "", // Categories don't have price
                    "GST": "",
                    "Packing": "",
                    "Discount": "",
                    "Chef Type": "", // Categories don't have chef type
                    "Description": "",
                    "Menu Status": category.menuStatus || "Enable",
                    "Image URL": category.image || ""
                });

                // Subcategory rows
                if (category.subcategories && category.subcategories.length > 0) {
                    category.subcategories.forEach((sub, subIndex) => {
                        exportData.push({
                            "S.No": `${index + 1}.${subIndex + 1}`,
                            "Category*": category.category || "", // Same as parent
                            "Subcategory": sub.subName || "",
                            "Type": sub.tag || "Veg", // REQUIRED for import
                            "Price*": sub.price || 0, // REQUIRED for import
                            "GST": sub.gst || 0,
                            "Packing": sub.packingCharges || 0,
                            "Discount": sub.discount || 0,
                            "Chef Type": sub.chefType || "Chef_All",
                            "Description": sub.description || "",
                            "Menu Status": sub.menuStatus || "Enable",
                            "Image URL": sub.image || ""
                        });
                    });
                }
            });

            // Create worksheet
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            // Auto-size columns
            const colWidths = Object.keys(exportData[0]).map(key => ({
                wch: Math.max(
                    key.length,
                    ...exportData.map(row => String(row[key] || "").length)
                )
            }));
            worksheet["!cols"] = colWidths;

            // Create workbook and export
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Menu Data");

            // Add instructions sheet
            const instructions = [
                ["IMPORTANT INSTRUCTIONS FOR IMPORT:"],
                ["1. * indicates REQUIRED fields"],
                ["2. Do NOT modify S.No column - it's for reference only"],
                ["3. For Categories: Fill only Category* and Menu Status"],
                ["4. For Subcategories: Fill ALL fields except Image URL (optional)"],
                ["5. Type MUST be: Veg or Non_Veg (case-sensitive)"],
                ["6. Chef Type options: Chef_All, Chef_North, Chef_South, Chef_Chinese, Chef_Continental, Tea_stall, Snacks, Bakery"],
                ["7. Menu Status: Enable or Disable"],
                ["8. Price must be a number (no .Rs suffix)"],
                ["9. GST, Packing, Discount: Numbers only (no % suffix)"],
                ["10. Image URL: Optional, leave blank if no image"]
            ];

            const wsInstructions = XLSX.utils.aoa_to_sheet(instructions);
            XLSX.utils.book_append_sheet(workbook, wsInstructions, "Instructions");

            // Add date to filename
            const dateStr = new Date().toISOString().split('T')[0];
            XLSX.writeFile(workbook, `full_menu_export_${dateStr}.xlsx`);

            alert(`✅ Menu exported successfully! ${exportData.length} items saved.`);
        } catch (error) {
            console.error("Export error:", error);
            alert(`❌ Export failed. Please try again.`);
        }
    };

    // Updated Import Function with Better Error Handling
    const handleFileImport = async (e) => {
        const file = e.target.files[0];
        console.log("IMPORT - File selected:", file?.name, file?.type, file?.size);

        if (!file) {
            console.log("IMPORT - No file selected");
            return;
        }

        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        console.log("IMPORT - Vendor ID:", vendorId);
        console.log("IMPORT - Auth Token exists:", !!authToken);

        if (!vendorId || !authToken) {
            alert("Authentication error. Please log in again.");
            return;
        }

        showLoader();

        try {
            // Read and log the file content
            const reader = new FileReader();
            reader.onload = async (event) => {
                try {
                    const data = new Uint8Array(event.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                    const jsonData = XLSX.utils.sheet_to_json(firstSheet);

                    console.log("IMPORT - Parsed JSON data (first 3 rows):", jsonData.slice(0, 3));
                    console.log("IMPORT - Total rows:", jsonData.length);

                    if (!jsonData || jsonData.length === 0) {
                        alert("The file is empty or couldn't be read.");
                        hideLoader();
                        return;
                    }

                    // Log column headers
                    console.log("IMPORT - Column headers:", Object.keys(jsonData[0]));

                    // Create FormData and log it
                    const formData = new FormData();
                    formData.append("file", file);

                    // Log FormData contents (can't directly log FormData)
                    console.log("IMPORT - Sending to backend...");

                    const response = await axios.post(
                        `https://backend.maamaas.com/food/api/dish/import/${vendorId}`,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${authToken}`,
                            },
                            timeout: 30000,
                        }
                    );

                    console.log("IMPORT - Response:", response.data);
                    alert(`✅ Successfully imported ${jsonData.length} items!`);
                    fetchData();

                } catch (error) {
                    console.error("IMPORT - Error details:", {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status,
                        headers: error.response?.headers
                    });

                    // Show more detailed error message
                    const errorMsg = error.response?.data?.message || error.message;
                    alert(`Error processing file: ${errorMsg}\n\nStatus: ${error.response?.status}`);
                } finally {
                    hideLoader();
                    e.target.value = '';
                }
            };

            reader.onerror = () => {
                console.error("IMPORT - FileReader error");
                alert("Error reading file. Please try again.");
                hideLoader();
                e.target.value = '';
            };

            reader.readAsArrayBuffer(file);

        } catch (error) {
            console.error("IMPORT - Outer catch:", error);
            alert(`Import failed: ${error.message}`);
            hideLoader();
            e.target.value = '';
        }
    };


    const handleEdit = async (id) => {
        try {
            setDishId(id);
            const token = localStorage.getItem("authToken");
            const vendorId = localStorage.getItem("vendorId");
            if (!token) {
                alert("Authentication token missing. Please log in again.");
                return;
            }
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );


            const dishes = Array.isArray(response.data)
                ? response.data
                : response.data.data || [];

            const dish = dishes.find((d) => d.dishId == id);

            if (!dish) {
                alert(`Dish with ID ${id} not found`);
                return;
            }

            setEditItem({
                dishId: dish.dishId,
                dishName: dish.dishName || "",
                image: dish.dishImage || "",
            });

            setShowEditModal(true);
        } catch (error) {
            console.error("Error fetching dish details:", error);
            alert(
                "Error fetching dish details:\n" +
                (error.response?.data?.message || error.message)
            );
        }
    };

    const submitEdit = async () => {
        if (!editItem.dishId) {
            alert("Dish ID is missing!");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            showLoader();
            const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

            const formData = new FormData();
            const dishData = {
                dishName: editItem.dishName,
            };
            formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

            if (editItem.newImageFile) {
                formData.append("image", editItem.newImageFile);
            }

            const response = await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            // Don't reload or close modal here - let the calling function handle it
            return response;

        } catch (error) {
            console.error("Error updating dish:", error);
            if (error.response) {
                alert(`Failed to update dish: ${error.response.data.message || error.response.data}`);
            } else {
                alert(`Failed to update dish: ${error.message}`);
            }
            throw error; // Re-throw so the calling function knows it failed
        } finally {
            hideLoader();
        }
    };



    const fetchData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId) {
            console.warn("⚠️ vendorId not found in localStorage");
            setError(new Error("vendorId missing"));
            setLoading(false);
            return;
        }

        if (!token) {
            console.warn("⚠️ authToken not found in localStorage");
            setError(new Error("authToken missing"));
            setLoading(false);
            return;
        }

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();

            const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

            const formattedData = parentCategories.map(category => {
                const subcategories = dishData.filter(sub => sub.parentId === category.dishId);

                return {
                    dishId: category.dishId,
                    SNo: category.dishId,
                    category: category.dishName,
                    image: category.dishImage || '',
                    isChecked: false,
                    parentId: category.parentId,
                    id: category.dishId,
                    isAdded: true,
                    menuStatus: category.menuStatus || "Enable", // Ensure this exists
                    // Categories should NOT have tag/type and description
                    subcategories: subcategories.map(sub => ({
                        dishId: sub.dishId,
                        subName: sub.subName || sub.dishName,
                        price: sub.price || 0,
                        deliveryPrice: sub.deliveryPrice || 0,
                        description: sub.description || "",
                        image: sub.dishImage,
                        tag: sub.tag || "Veg", // Type only for subcategories
                        gst: sub.gst || 0,
                        packingCharges: sub.packingCharges || 0,
                        discount: sub.discount || 0,
                        chefType: sub.chefType || 0,
                        menuStatus: sub.menuStatus || "Enable", // ADD THIS
                        stockQuantity: sub.stockQuantity || 0,
                        consumedQuantity: sub.consumedQuantity || 0,
                        balanceQuantity: sub.balanceQuantity || 0,
                    }))
                };
            });

            setData(formattedData);
            applyFilter(formattedData, isVegSelected);

            setData(formattedData);
            setSearchQuery(""); // Clear search
            setSearchActive(false); // Reset search state
            applyFilter(formattedData, isVegSelected);

        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleCheckboxChange = (e, index) => {
        const { checked } = e.target;
        setData(prevData => {
            const updatedData = [...prevData];
            updatedData[index].isChecked = checked;
            return updatedData;
        });
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        const newSelected = {};

        if (checked) {
            // Select all items (categories and subcategories)
            filteredData.forEach(category => {
                newSelected[category.dishId] = true;
                category.subcategories?.forEach(sub => {
                    newSelected[sub.dishId] = true;
                });
            });
        }

        setSelectedItems(newSelected);
    };
    const totalItemsCount = filteredData.reduce((count, category) => {
        return count + 1 + (category.subcategories?.length || 0);
    }, 0);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // In StandardMenu.jsx, update the handleToggleStatus function:
    const handleToggleStatus = async (index, subIndex, dishId, currentStatus) => {

        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("Authentication failed. Please login again.");
            return;
        }

        const isCategory = (subIndex === null || subIndex === undefined);
        const newStatus = currentStatus === "Enable" ? "Disable" : "Enable";

        // ✅ FIX: Update local state IMMEDIATELY
        if (isCategory) {
            // For category: Update category and all its subcategories
            setData(prevData => {
                const updatedData = [...prevData];
                updatedData[index] = {
                    ...updatedData[index],
                    menuStatus: newStatus,
                    subcategories: updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        menuStatus: newStatus
                    }))
                };
                return updatedData;
            });

            // Also update filteredData immediately
            setFilteredData(prevData => {
                const updatedData = [...prevData];
                updatedData[index] = {
                    ...updatedData[index],
                    menuStatus: newStatus,
                    subcategories: updatedData[index].subcategories.map(sub => ({
                        ...sub,
                        menuStatus: newStatus
                    }))
                };
                return updatedData;
            });
        } else {
            // For subcategory
            setData(prevData => {
                const updatedData = [...prevData];
                updatedData[index].subcategories[subIndex] = {
                    ...updatedData[index].subcategories[subIndex],
                    menuStatus: newStatus
                };
                return updatedData;
            });

            setFilteredData(prevData => {
                const updatedData = [...prevData];
                updatedData[index].subcategories[subIndex] = {
                    ...updatedData[index].subcategories[subIndex],
                    menuStatus: newStatus
                };
                return updatedData;
            });
        }

        // Make API call
        try {
            const url = `https://backend.maamaas.com/food/api/dish/editmenu/${dishId}`;
            const payload = { menuStatus: newStatus };

            await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                },
            });


            // If category, update all subcategories too
            if (isCategory) {
                const category = data[index];
                if (category.subcategories && category.subcategories.length > 0) {
                    for (const sub of category.subcategories) {
                        const subUrl = `https://backend.maamaas.com/food/api/dish/editmenu/${sub.dishId}`;
                        const subPayload = { menuStatus: newStatus };

                        await axios.put(subUrl, subPayload, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${authToken}`,
                            },
                        });
                    }
                }
            }

            localStorage.setItem(`menuStatus-${dishId}`, newStatus);

        } catch (error) {
            console.error('❌ Failed to toggle menu visibility:', error);
            alert('Failed to update menu visibility. Please refresh the page.');

            // Revert on error
            if (isCategory) {
                setData(prevData => {
                    const updatedData = [...prevData];
                    updatedData[index] = {
                        ...updatedData[index],
                        menuStatus: currentStatus,
                        subcategories: updatedData[index].subcategories.map(sub => ({
                            ...sub,
                            menuStatus: sub.menuStatus
                        }))
                    };
                    return updatedData;
                });
            }
        }
    };


    const handleDeleteRow = async (index, dishId) => {
        if (!window.confirm("Are you sure you want to delete this dish?")) return;

        const token = localStorage.getItem("authToken");

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/delete/${dishId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                alert("Dish deleted successfully!");
                const newData = data.filter(item => item.SNo !== dishId);
                setData(newData);
            } else {
                const result = await response.json();
                alert(`Failed to delete dish. Error: ${result.message || "Unknown error"}`);
            }
        } catch (error) {
            alert("An error occurred while deleting.");
            console.error(error);
        } finally {
            hideLoader();
        }
    };

    const handleDeleteSubcategory = async (subDishId, subIndex, parentIndex) => {
        if (!window.confirm("Are you sure you want to delete this subcategory?")) return;

        const token = localStorage.getItem("authToken");

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/delete/${subDishId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                alert("Subcategory deleted successfully!");

                setData(prevData => {
                    const newData = [...prevData];
                    const updatedSubcategories = [...newData[parentIndex].subcategories];
                    updatedSubcategories.splice(subIndex, 1);
                    newData[parentIndex] = {
                        ...newData[parentIndex],
                        subcategories: updatedSubcategories,
                    };
                    return newData;
                });
            } else {
                const result = await response.json();
                alert(`Failed to delete subcategory. Error: ${result.message || "Unknown error"}`);
            }
        } catch (error) {
            alert("An error occurred while deleting the subcategory.");
            console.error(error);
        } finally {
            hideLoader();
        }
    };
    // Add this function near your other handlers
    const showErrorModalMessage = (title, message, type = 'error', showGuidelinesButton = false, presetName = 'PRODUCT_IMAGE') => {
        setErrorModalDetails({
            title,
            message,
            type,
            showGuidelinesButton,
            presetName
        });
        setShowErrorModal(true);
    };

    // Specialized functions for common errors
    const showImageError = (validationError, presetName = 'PRODUCT_IMAGE') => {
        let title = 'Image Issue';
        let message = '';
        let type = 'error';
        let showGuidelinesButton = false;
        let icon = '❌';

        if (validationError.includes('Portrait image rejected')) {
            title = 'Orientation Issue';
            icon = '📱';
            message = `We need a landscape (horizontal) image for better display.\n\n` +
                `**What to do:**\n` +
                `• Rotate your phone sideways before taking the photo\n` +
                `• Or crop/edit the image to make it wider\n` +
                `• Ideal ratio: 16:9 (like widescreen TV)\n\n` +
                `**Why?** Landscape images fit better in menus and look more professional.`;
            type = 'warning';
            showGuidelinesButton = true;

        } else if (validationError.includes('not wide enough')) {
            title = 'Image Dimensions';
            icon = '📐';
            message = `This image is too narrow for our menu display.\n\n` +
                `**Quick fix:**\n` +
                `• Use photo editing app to adjust aspect ratio\n` +
                `• Aim for width that's 1.5× height\n` +
                `• Example sizes: 1200×800px or 900×600px\n\n` +
                `**Good to know:** Wider images showcase food better!`;
            type = 'warning';
            showGuidelinesButton = true;

        } else if (validationError.includes('File size')) {
            title = 'Large File Size';
            icon = '💾';
            message = `This image file is too large (max: 5MB).\n\n` +
                `**Easy solutions:**\n` +
                `1. **Compress online:** Use tinypng.com (free)\n` +
                `2. **Reduce quality:** Save as JPG at 80% quality\n` +
                `3. **Resize:** Reduce to 1200px width\n` +
                `4. **Use mobile:** Photos from phones are often smaller\n\n` +
                `**Tip:** Smaller files load faster for your customers!`;

        } else if (validationError.includes('format not allowed')) {
            title = 'File Format';
            icon = '🖼️';
            message = `We accept these image formats:\n\n` +
                `✅ **Recommended:** JPG or PNG\n` +
                `✅ **Also works:** JPEG, WebP\n` +
                `❌ **Not supported:** PDF, PSD, BMP, TIFF\n\n` +
                `**How to convert:**\n` +
                `• iPhone/Android: Edit & "Save As" JPG\n` +
                `• Computer: Open in Paint & Save As JPG\n` +
                `• Online: Convertio.co (free tool)`;

        } else {
            // Generic error - make it friendly
            title = 'Upload Issue';
            icon = '🔄';
            message = `We couldn't process this image.\n\n` +
                `**Please try:**\n` +
                `• A different image file\n` +
                `• Checking file format (JPG/PNG)\n` +
                `• Ensuring file size < 5MB\n` +
                `• Taking a new photo if needed\n\n` +
                `Still having trouble? View our image guidelines.`;
            showGuidelinesButton = true;
        }

        // Add icon to title for visual appeal
        const finalTitle = `${icon}  ${title}`;

        // Show the modal
        showErrorModalMessage(finalTitle, message, type, showGuidelinesButton, presetName);
    };

    const showSuccessMessage = (title, message, autoClose = true) => {
        showErrorModalMessage(
            title,
            message,
            'success',
            false
        );

        if (autoClose) {
            setTimeout(() => {
                setShowErrorModal(false);
            }, 3000); // Auto-close after 3 seconds
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setData(prevData => {
            const updatedData = [...prevData];
            updatedData[index][name] = value;
            return updatedData;
        });
    };
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            const isTypingInInput =
                e.target.tagName === 'INPUT' ||
                e.target.tagName === 'TEXTAREA' ||
                e.target.isContentEditable;

            // Focus search when '/' is pressed
            if (e.key === '/' && !isTypingInInput) {
                e.preventDefault();
                const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
                if (searchInput) {
                    searchInput.focus();
                    searchInput.select();
                }
            }

            // Clear search with Escape
            if (e.key === 'Escape' && searchQuery) {
                e.preventDefault();
                setSearchQuery("");
                setSearchActive(false);
                applyFilter(data, isVegSelected);
            }
        };

        window.addEventListener('keydown', handleGlobalKeyDown);
        return () => {
            window.removeEventListener('keydown', handleGlobalKeyDown);
        };
    }, [searchQuery, data, isVegSelected]);
    // Responsive styles
    const getResponsiveValue = (mobile, tablet, desktop) => {
        const width = window.innerWidth;
        if (width < 768) return mobile;
        if (width < 1024) return tablet;
        return desktop;
    };

    // Function to handle category column click
    const handleCategoryColumnClick = () => {
        // Extract all unique categories from data
        const categories = Array.from(new Set(data.map(item => item.category)))
            .filter(Boolean)
            .map(category => ({
                name: category,
                count: data.filter(item => item.category === category).length
            }));

        setFilteredCategories(categories);
        setShowCategorySearchPopup(true);
        setCategorySearchQuery('');
    };

    // Function to filter categories based on search
    const handleCategorySearch = (query) => {
        setCategorySearchQuery(query);
        const allCategories = Array.from(new Set(data.map(item => item.category)))
            .filter(Boolean)
            .map(category => ({
                name: category,
                count: data.filter(item => item.category === category).length
            }));

        if (!query.trim()) {
            setFilteredCategories(allCategories);
            return;
        }

        const filtered = allCategories.filter(category =>
            category.name.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredCategories(filtered);
    };

    // Function to select a category
    // Function to select a category
    const handleCategorySelect = (categoryName) => {
        setSelectedCategory(categoryName);

        let filtered = data;

        // Apply category filter if selected
        if (categoryName) {
            filtered = filtered.filter(item => item.category === categoryName);
        }

        // Apply veg filter if selected
        if (isVegSelected !== null) {
            filtered = filtered.map(category => {
                const filteredSubcategories = category.subcategories.filter(
                    sub => isVegSelected ? sub.tag === "Veg" : sub.tag === "Non_Veg"
                );
                return {
                    ...category,
                    subcategories: filteredSubcategories
                };
            }).filter(cat => cat.subcategories.length > 0);
        }

        // Apply search if active
        if (searchActive && searchQuery) {
            filtered = filtered.map(category => {
                const categoryMatches = category.category?.toLowerCase().includes(searchQuery);
                const filteredSubcategories = category.subcategories.filter(sub =>
                    sub.subName?.toLowerCase().includes(searchQuery) ||
                    sub.description?.toLowerCase().includes(searchQuery)
                );

                if (categoryMatches || filteredSubcategories.length > 0) {
                    return {
                        ...category,
                        subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                    };
                }
                return null;
            }).filter(category => category !== null);
        }

        applyFilter(data, isVegSelected);
        setFilteredData(filtered);
        setShowCategorySearchPopup(false);
        setCategorySearchQuery('');
    };

    // Add this useEffect to your component
    useEffect(() => {
        // This will run whenever selectedCategory changes
        applyFilter(data, isVegSelected);
    }, [selectedCategory, data, isVegSelected]);

    // Update clearCategoryFilter to just set state
    const clearCategoryFilter = () => {
        setSelectedCategory(null);
        // Remove search query too
        setSearchQuery("");
        setSearchActive(false);
        // The useEffect above will handle the re-filtering
    };

    // const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

    const modalStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 1001,
        width: '100vw',
        height: "100vh",
        backdropFilter: "blur(2px)",
    };

    const inputContainerStyle = {
        marginBottom: '15px',
    };

    const inputFieldStyle = {
        width: '100%',
        padding: '8px',
        fontSize: '14px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    };

    const imagePreviewStyle = {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100px',
        height: '100px',
        margin: '10px 0',
        borderRadius: '10px',
        border: '1px solid #ccc',
        overflow: 'hidden',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    };

    const buttonContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
        textAlign: "center"
    };

    const closeButtonStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
    };

    const closeIconStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '30px',
        color: '#888',
    };

    const buttonStyle = {
        backgroundColor: '#b15cd6',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: "bold",
        padding: "10px",
    };

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1001,
            padding: '10px',
        },
        popup: {
            background: '#fff',
            padding: '20px',
            borderRadius: '8px',
            width: '300px',
            maxWidth: '95vw',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            position: 'relative',
        },
        image: {
            width: '100%',
            marginTop: '10px',
            borderRadius: '5px',
        },
        input: {
            marginTop: '10px',
            padding: '8px',
            width: '100%',
            borderRadius: '5px',
            border: '1px solid #ccc',
            fontSize: '14px',
            boxSizing: 'border-box',
        },
        buttons: {
            marginTop: '15px',
            display: 'flex',
            justifyContent: 'center'
        },
        saveBtn: {
            padding: '8px 12px',
            backgroundColor: '#b15cd6',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '14px',
        },
        cancelBtn: {
            padding: '8px 12px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
        }
    };


    const containerHeight = window.innerWidth < 768
        ? '50vh'
        : window.innerWidth < 850
            ? '60vh'
            : window.innerWidth < 1350
                ? '50vh'
                : '510px';

    return (
        <div style={{ marginTop: "0px" }}>
            <style>
                {`
               .custom-switch {
            position: relative;
            display: inline-block;
            width: 100px;
            height: 35px;
            margin-top:11px;
          }

          .custom-switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .custom-slider {
            position: absolute;
            cursor: pointer;
            transition: 0.4s;
            margin-left:-315px;
            font-weight: bold;
            font-size: 14px;
            color: #000;
            textAlign: center;
            line-height: 35px;
            width: 100px;
            height: 40px;
            border-radius:5px;
            background-color: rgb(217, 217, 217);
          }

   .custom-slider::before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  top: 10px;
  background-color: #000; /* default */
  transition: 0.4s;
  border-radius: 50%;
}

.custom-slider.veg::before {
  background-color: green;
}

.custom-slider.non-veg::before {
  background-color: red;
}
  .scrollbar-w-auto::-webkit-scrollbar {
    width: 16px !important;
    height: 16px !important;
}
        `}
            </style>




            <div style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '0px',
                width: '100%',
                padding: window.innerWidth < 768 ? '0px' : '0'
            }}>
                {showPopup && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1001,
                        padding: '20px',
                        boxSizing: 'border-box',
                        backdropFilter: 'blur(3px)'
                    }}>
                        <div style={{
                            position: 'relative',
                            backgroundColor: '#fff',
                            padding: '30px 25px',
                            borderRadius: '12px',
                            width: '400px',
                            maxWidth: '95%',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            scrollbarWidth: "none",
                        }}>
                            {/* Close Button */}
                            <div
                                onClick={() => setShowPopup(false)}
                                style={{
                                    position: 'absolute',
                                    top: '15px',
                                    right: '15px',
                                    fontSize: '22px',
                                    fontWeight: '700',
                                    color: '#999',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    transition: 'color 0.3s',
                                }}
                                onMouseEnter={e => (e.currentTarget.style.color = '#b15cd6')}
                                onMouseLeave={e => (e.currentTarget.style.color = '#999')}
                            >
                                &times;
                            </div>

                            {/* Title */}
                            <h3 style={{
                                margin: 0,
                                fontWeight: '600',
                                fontSize: '1.3rem',
                                color: '#333',
                                textAlign: 'center'
                            }}>
                                Add New Category
                            </h3>

                            {/* Category Name Input with Auto-suggestions */}
                            <div style={{ position: 'relative', marginTop: '10px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Category Name <span style={{ color: '#e74c3c' }}>*</span>
                                </label>

                                <input
                                    type="text"
                                    placeholder="Enter category name"
                                    value={text}
                                    onChange={handleCategoryInputChange}
                                    onFocus={() => {
                                        if (text.trim().length > 0 && categorySuggestions.length > 0) {
                                            setShowCategorySuggestions(true);
                                        }
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => setShowCategorySuggestions(false), 200);
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '12px 15px',
                                        fontSize: '1rem',
                                        borderRadius: '8px',
                                        border: '1.8px solid #ccc',
                                        outline: 'none',
                                        transition: 'all 0.3s',
                                        boxSizing: 'border-box'
                                    }}
                                // onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                // onBlur={e => e.target.style.borderColor = '#ccc'}
                                />


                                {/* Category Suggestions Dropdown */}
                                {showCategorySuggestions && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        backgroundColor: 'white',
                                        border: '1px solid #ddd',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                        zIndex: 1000,
                                        maxHeight: '250px',
                                        overflowY: 'auto',
                                        marginTop: '5px'
                                    }}>


                                        {categorySuggestions.map((category, index) => (
                                            <div
                                                key={index}
                                                onClick={() => selectCategorySuggestion(category.catageoryName)}
                                                style={{
                                                    padding: '12px 15px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f5f5f5',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                            >
                                                <img
                                                    src={category.image}
                                                    alt={category.catageoryName}
                                                    style={{
                                                        width: '35px',
                                                        height: '35px',
                                                        borderRadius: '6px',
                                                        objectFit: 'cover',
                                                        border: '1px solid #eee'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'https://via.placeholder.com/35x35';
                                                    }}
                                                />
                                                <div style={{ flex: 1 }}>
                                                    <div style={{
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#333'
                                                    }}>
                                                        {category.catageoryName}
                                                    </div>
                                                </div>

                                            </div>
                                        ))}

                                        {categorySuggestions.length === 0 && (
                                            <div style={{
                                                padding: '20px',
                                                textAlign: 'center',
                                                color: '#666',
                                                fontSize: '14px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}>
                                                <div style={{ fontSize: '40px', opacity: 0.5 }}>🔍</div>
                                                <div>No matching categories found</div>
                                                <div style={{ fontSize: '12px', color: '#999' }}>
                                                    Type to create a new category
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Image Upload Section - Modern Design */}
                            <div style={{ marginTop: '15px' }}>
                                {/* <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: '15px',
                                    backgroundColor: '#f8f9fa',
                                    padding: '12px 15px',
                                    borderRadius: '8px',
                                    borderLeft: '4px solid #b15cd6'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            backgroundColor: '#e8f5e9',
                                            borderRadius: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <span style={{ fontSize: '20px', color: '#b15cd6' }}>🖼️</span>
                                        </div>
                                        <div>
                                            <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
                                                Category Image
                                                <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                                            </h3>
                                            <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#7f8c8d' }}>
                                                JPG, PNG • Max 5MB • Landscape recommended
                                            </p>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => {
                                            setCurrentPreset('PRODUCT_IMAGE');
                                            setShowGuidelinesModal(true);
                                        }}
                                        style={{
                                            background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            padding: '8px 16px',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
                                        </svg>
                                        Guidelines
                                    </button>
                                </div> */}

                                {/* Upload Area */}
                                <div
                                    style={{
                                        border: image ? "2px solid #e0e0e0" : '2px dashed #ccc',
                                        borderRadius: '12px',
                                        backgroundColor: '#fafafa',
                                        padding: image ? '0' : '40px 20px',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s',
                                        minHeight: '200px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => document.getElementById('categoryFileInput')?.click()}
                                    onDragOver={(e) => {
                                        e.preventDefault();
                                        e.currentTarget.style.borderColor = '#b15cd6';
                                        e.currentTarget.style.backgroundColor = '#f0f0ff';
                                    }}
                                    onDragLeave={(e) => {
                                        e.preventDefault();
                                        e.currentTarget.style.borderColor = image ? '#e0e0e0' : '#ccc';
                                        e.currentTarget.style.backgroundColor = '#fafafa';
                                    }}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        e.currentTarget.style.borderColor = image ? '#e0e0e0' : '#ccc';
                                        e.currentTarget.style.backgroundColor = '#fafafa';
                                        if (e.dataTransfer.files[0]) {
                                            const file = e.dataTransfer.files[0];
                                            const event = { target: { files: [file] } };
                                            handleImageUpload(event);
                                        }
                                    }}
                                >
                                    {image ? (
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <img
                                                src={image}
                                                alt="Preview"
                                                style={{
                                                    width: '100%',
                                                    maxHeight: '250px',
                                                    objectFit: 'contain',
                                                    borderRadius: '10px',
                                                    display: 'block'
                                                }}
                                            />
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setImage(null);
                                                    setCategoryImageFile(null);
                                                    if (fileInputRef.current) {
                                                        fileInputRef.current.value = '';
                                                    }
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    backgroundColor: 'rgba(255, 107, 107, 0.9)',
                                                    color: 'white',
                                                    border: 'none',
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#ff5252'}
                                                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255, 107, 107, 0.9)'}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <div style={{
                                                width: '70px',
                                                height: '70px',
                                                backgroundColor: '#e8f5e9',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '20px',
                                                border: '2px solid #c8e6c9'
                                            }}>
                                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <p style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#2c3e50',
                                                    margin: '0 0 8px'
                                                }}>
                                                    Drop image here or click to upload
                                                </p>
                                                <p style={{
                                                    fontSize: '13px',
                                                    color: '#7f8c8d',
                                                    margin: 0
                                                }}>
                                                    Supports JPG, PNG, WebP • Max 5MB
                                                </p>
                                            </div>
                                            <button
                                                style={{
                                                    background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                                    border: 'none',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    padding: '10px 24px',
                                                    borderRadius: '8px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    marginTop: '10px',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                    <polyline points="17 8 12 3 7 8" />
                                                    <line x1="12" y1="3" x2="12" y2="15" />
                                                </svg>
                                                Select Image
                                            </button>
                                        </>
                                    )}
                                </div>

                                {/* Hidden File Input */}
                                <input
                                    id="categoryFileInput"
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*,.jpg,.jpeg,.png,.webp"
                                    style={{ display: "none" }}
                                    onChange={handleImageUpload}
                                />

                                {/* File Info */}
                                {categoryImageFile && (
                                    <div style={{
                                        marginTop: '15px',
                                        padding: '12px 15px',
                                        backgroundColor: '#f0f8ff',
                                        borderRadius: '8px',
                                        border: '1px solid #d1ecff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '6px',
                                                overflow: 'hidden'
                                            }}>
                                                <img
                                                    src={image}
                                                    alt="Thumbnail"
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <div>
                                                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px' }}>
                                                    {categoryImageFile.name.length > 25
                                                        ? categoryImageFile.name.substring(0, 25) + '...'
                                                        : categoryImageFile.name}
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                                    {(categoryImageFile.size / 1024 / 1024).toFixed(2)} MB
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{
                                            fontSize: '11px',
                                            backgroundColor: '#e8f5e9',
                                            color: '#2e7d32',
                                            padding: '4px 10px',
                                            borderRadius: '10px',
                                            fontWeight: '500'
                                        }}>
                                            Ready to upload
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Action Buttons */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginTop: '20px',
                                paddingTop: '20px',
                                borderTop: '1px solid #eee'
                            }}>
                                <button
                                    onClick={() => setShowPopup(false)}
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        color: '#666',
                                        border: '1px solid #ddd',
                                        padding: '12px 25px',
                                        borderRadius: '8px',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        minWidth: '100px'
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.backgroundColor = '#e9ecef';
                                        e.currentTarget.style.borderColor = '#ccc';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.backgroundColor = '#f8f9fa';
                                        e.currentTarget.style.borderColor = '#ddd';
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSave}
                                    style={{
                                        background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 25px',
                                        borderRadius: '8px',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        minWidth: '100px'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    disabled={!text.trim()}
                                >
                                    Save Category
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Main Controls Container */}
                <div style={{
                    display: 'flex',
                    flexDirection: window.innerWidth < 768 ? 'column-reverse' : 'row',
                    justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
                    alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
                    marginBottom: window.innerWidth < 768 ? '15px' : '0px',
                    gap: window.innerWidth < 768 ? '10px' : '10px',
                    width: '100%',
                    padding: window.innerWidth < 768 ? '0' : '0px',
                    marginBottom: window.innerWidth < 768 ? "18px" : "6px",
                }}>
                    {/* Buttons Group */}
                    {/* Buttons Group */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
                        alignItems: 'center',
                        flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap',
                        width: window.innerWidth < 768 ? '100%' : 'auto',
                        marginTop: window.innerWidth < 768 ? '0' : '0px'
                    }}>
                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            ref={importFileInputRef}
                            onChange={handleFileImport}
                            style={{ display: 'none' }}
                        />

                        <button
                            style={{
                                ...importExportButton,
                                height: window.innerWidth < 480 ? '32px' : '35px',
                                padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
                                fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
                                whiteSpace: 'nowrap'
                            }}
                            onClick={() => importFileInputRef.current.click()}
                        >
                            Import
                        </button>

                        <button style={{
                            ...importExportButton,
                            height: window.innerWidth < 480 ? '32px' : '35px',
                            padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
                            fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
                            whiteSpace: 'nowrap'
                        }} onClick={handleExport}>
                            Export
                        </button>

                        <button style={{
                            ...importExportButton,
                            height: window.innerWidth < 480 ? '32px' : '35px',
                            padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
                            fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
                            whiteSpace: 'nowrap'
                        }}
                            onClick={() => setShowPopup(true)}
                        >
                            Add Category
                        </button>

                        {/* Conditional rendering - Show Bulk Edit button OR Input + Save */}
                        {!bulkMode ? (
                            <button
                                style={{
                                    ...importExportButton,
                                    height: window.innerWidth < 480 ? '32px' : '35px',
                                    padding: window.innerWidth < 480 ? '0 12px' : '0 15px',
                                    fontSize: window.innerWidth < 480 ? '0.7rem' : window.innerWidth < 1450 ? "0.8rem" : '1rem',
                                    whiteSpace: 'nowrap',
                                    backgroundColor: '#ff9800',
                                }}
                                onClick={() => {
                                    setBulkMode(true);
                                    setSelectedItems({});
                                    setBulkQuantity('');
                                }}
                            >
                                Bulk Edit
                            </button>
                        ) : (
                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                backgroundColor: '#fff3e0',
                                padding: '4px 12px',
                                borderRadius: '6px',
                                border: '2px solid #ff9800'
                            }}>


                                <input
                                    type="number"
                                    min="0"
                                    value={bulkQuantity}
                                    onChange={(e) => setBulkQuantity(e.target.value)}
                                    placeholder="Enter quantity"
                                    style={{
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                        width: '130px',
                                        fontSize: '13px',
                                        outline: 'none'
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                />

                                <button
                                    onClick={handleBulkUpdate}
                                    disabled={!bulkQuantity || Object.keys(selectedItems).filter(id => selectedItems[id]).length === 0}
                                    style={{
                                        backgroundColor: Object.keys(selectedItems).filter(id => selectedItems[id]).length > 0 && bulkQuantity ? '#28a745' : '#ccc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '6px 12px',
                                        cursor: Object.keys(selectedItems).filter(id => selectedItems[id]).length > 0 && bulkQuantity ? 'pointer' : 'not-allowed',
                                        fontSize: '13px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Update
                                </button>

                                <button
                                    onClick={() => {
                                        setBulkMode(false);
                                        setSelectedItems({});
                                        setBulkQuantity('');
                                    }}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '6px 10px',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                    {/* Search Bar */}
                    <div style={{
                        position: 'relative',
                        width: window.innerWidth < 768 ? '100%' : 'auto',
                        minWidth: window.innerWidth < 480 ? '150px' : '200px',
                        maxWidth: window.innerWidth < 768 ? '100%' : '300px',
                        marginTop: window.innerWidth < 768 ? '0' : '0px',
                        marginRight: window.innerWidth < 768 ? '0' : '10px',
                        order: window.innerWidth < 768 ? -1 : 0, // Search first on mobile
                        zIndex: 1 // Ensure it's above other elements
                    }}>
                        <input
                            type="text"
                            placeholder="Search dishes or categories..."
                            value={searchQuery}
                            onChange={(e) => {
                                setSearchQuery(e.target.value);
                                // Optional: Add debounced search here
                            }}
                            onKeyDown={(e) => {
                                // Allow all key presses including space
                                if (e.key === 'Enter') {
                                    handleSearch(searchQuery);
                                }
                                // Prevent any default behavior that might block typing
                            }}
                            onKeyUp={(e) => {
                                // Update search on every keyup (real-time search)
                                if (e.key !== 'Enter' && e.key !== 'Tab') {
                                    handleSearch(searchQuery);
                                }
                            }}
                            style={{
                                width: '100%',
                                padding: window.innerWidth < 480 ? '6px 35px 6px 10px' : '8px 35px 8px 12px',
                                borderRadius: '20px',
                                border: '2px solid #b15cd6',
                                fontSize: window.innerWidth < 480 ? '13px' : '14px',
                                outline: 'none',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#fff',
                                height: window.innerWidth < 480 ? '32px' : '35px',
                                boxSizing: 'border-box',
                                fontFamily: 'inherit', // Ensure consistent font
                            }}
                            onFocus={(e) => {
                                e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <button
                            onClick={() => handleSearch(searchQuery)}
                            style={{
                                position: 'absolute',
                                right: window.innerWidth < 480 ? '6px' : '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 2
                            }}
                            type="button"
                            aria-label="Search"
                        >
                            <svg
                                width={window.innerWidth < 480 ? "16" : "18"}
                                height={window.innerWidth < 480 ? "16" : "18"}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#b15cd6"
                                strokeWidth="2"
                            >
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                        </button>

                        {/* Add a clear button */}
                        {/* {searchQuery && (
                            <button
                                onClick={() => {
                                    setSearchQuery("");
                                    handleSearch("");
                                }}
                                style={{
                                    position: 'absolute',
                                    right: window.innerWidth < 480 ? '28px' : '32px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#888',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    zIndex: 2
                                }}
                                type="button"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        )} */}
                    </div>
                </div>
            </div>

            <div style={{
                height: window.innerHeight < 650 ? "auto" : containerHeight,
                maxHeight: window.innerHeight < 450 ? "50vh" : window.innerHeight < 500 ? "55vh" : window.innerHeight < 650 ? "60vh" : window.innerHeight < 700 ? "65vh" : "70vh",
                border: '0px solid #ddd',
                borderRadius: '0.375rem',
                backgroundColor: '#fff',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                overflow: 'auto', /* This enables both horizontal and vertical scrolling */
                position: 'relative'
            }} className="standard-table-data">

                {loading ? (
                    <p>Loading data...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>Error fetching data: {error.message}</p>
                ) : (
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed',
                        minWidth: '1600px' /* Forces horizontal scroll */
                    }}>
                        <colgroup>
                            <col style={{ width: '100px' }} /> {/* S.No */}
                            <col style={{ width: '150px' }} /> {/* Category */}
                            <col style={{ width: '80px' }} />  {/* Type */}
                            <col style={{ width: '200px' }} /> {/* Description */}
                            <col style={{ width: '100px' }} /> {/* Image */}
                            <col style={{ width: '80px' }} />  {/* Price */}
                            <col style={{ width: '80px' }} />  {/* Delivery */}
                            <col style={{ width: '70px' }} />  {/* GST */}
                            <col style={{ width: '80px' }} />  {/* Packing */}
                            <col style={{ width: '80px' }} />  {/* Stock Qty */}
                            <col style={{ width: '80px' }} />  {/* Consumed */}
                            <col style={{ width: '80px' }} />  {/* Balanced */}
                            <col style={{ width: '100px' }} /> {/* Chef Type */}
                            <col style={{ width: '80px' }} />  {/* Status */}
                            <col style={{ width: '150px' }} /> {/* Actions */}
                        </colgroup>

                        {/* THEAD - Sticky top */}
                        <thead style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 30,
                        }}>
                            <tr>
                                {/* S.No Header - Sticky left AND sticky top */}
                                <th style={{
                                    ...tableHeaderStyle,
                                    textAlign: 'center',
                                    position: 'sticky',
                                    left: 0,
                                    top: 0,
                                    zIndex: 40,
                                    backgroundColor: '#b15cd6'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                    }}>
                                        {bulkMode && (
                                            <input
                                                type="checkbox"
                                                checked={Object.keys(selectedItems).length === totalItemsCount}
                                                onChange={handleSelectAll}
                                                style={{ margin: 0, cursor: 'pointer', width: '16px', height: '16px' }}
                                            />
                                        )}
                                        <span>S.No</span>
                                    </div>
                                </th>

                                {/* Category Header - Sticky left AND sticky top */}
                                <th style={{
                                    ...tableHeaderStyle,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    position: 'sticky',
                                    left: '100px',
                                    top: 0,
                                    zIndex: 40,
                                    backgroundColor: '#b15cd6'
                                }}
                                    onClick={handleCategoryColumnClick}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                    }}>
                                        <span>Category</span>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                            {!selectedCategory && (
                                                <svg
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 24 24"
                                                    fill="white"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                >
                                                    <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
                                                </svg>
                                            )}
                                            {selectedCategory && (
                                                <span
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        clearCategoryFilter();
                                                    }}
                                                    style={{
                                                        background: '#ff6b6b',
                                                        color: 'white',
                                                        borderRadius: '50%',
                                                        width: '18px',
                                                        height: '18px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    ×
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </th>

                                {/* Rest of headers - Only sticky top, NOT sticky left */}
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Type</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Description</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Image</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Price</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Delivery</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Gst(%)</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Packing(.Rs)</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Quantity</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Consumed</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Balanced</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Chef Type</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Status</th>
                                <th style={{ ...tableHeaderStyle, textAlign: 'center', position: 'sticky', top: 0, zIndex: 30 }}>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.map((item, index) => (
                                <React.Fragment key={item.dishId || index}>
                                    {/* Parent Category Row */}
                                    <tr style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                        {/* S.No Cell - Sticky left */}
                                        <td style={{
                                            ...tableCellStyle,
                                            textAlign: 'center',
                                            backgroundColor: "#f0f0f0",
                                            padding: '8px 4px',
                                            position: 'sticky',
                                            left: 0,
                                            zIndex: 15,
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px',
                                                flexWrap: 'nowrap',
                                            }}>
                                                {bulkMode && (
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedItems[item.dishId] || false}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSelectedItems(prevSelected => {
                                                                const newSelected = { ...prevSelected };

                                                                if (checked) {
                                                                    newSelected[item.dishId] = true;
                                                                    if (item.subcategories && item.subcategories.length > 0) {
                                                                        item.subcategories.forEach(sub => {
                                                                            newSelected[sub.dishId] = true;
                                                                        });
                                                                    }
                                                                } else {
                                                                    delete newSelected[item.dishId];
                                                                    if (item.subcategories && item.subcategories.length > 0) {
                                                                        item.subcategories.forEach(sub => {
                                                                            delete newSelected[sub.dishId];
                                                                        });
                                                                    }
                                                                }
                                                                return newSelected;
                                                            });
                                                        }}
                                                        style={{ margin: 0, cursor: 'pointer', width: '16px', height: '16px' }}
                                                    />
                                                )}

                                                <button
                                                    onClick={(e) => toggleCategory(item.dishId, e)}
                                                    style={{
                                                        background: 'none',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        color: '#666',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '24px',
                                                        height: '24px',
                                                        backgroundColor: expandedCategories[item.dishId] ? '#e0e0e0' : 'transparent'
                                                    }}
                                                >
                                                    {expandedCategories[item.dishId] ?
                                                        <FaChevronDown size={12} /> :
                                                        <FaChevronRight size={12} />
                                                    }
                                                </button>
                                                <span>{index + 1}</span>
                                            </div>
                                        </td>

                                        {/* Category Cell - Sticky left */}
                                        <td style={{
                                            ...tableCellStyle,
                                            fontWeight: "bold",
                                            backgroundColor: "#f0f0f0",
                                            position: 'sticky',
                                            left: '100px',
                                            zIndex: 15
                                        }}>
                                            {item.category}
                                        </td>

                                        {/* Rest of cells - NOT sticky */}
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
                                            {item.tag ? item.tag : '-'}
                                        </td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
                                            <img src={item.image} alt="Dish" style={{ width: '36px', height: '28px', borderRadius: '8px' }} />
                                        </td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>-</td>
                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={item.menuStatus === "Enable"}
                                                        onChange={() => handleToggleStatus(index, null, item.dishId, item.menuStatus || "Enable")}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                <span style={{ marginTop: '3px', fontSize: '0.75rem', fontWeight: '600' }}>
                                                    {item.menuStatus === "Enable" ? 'Show' : 'Hide'}
                                                </span>
                                            </div>
                                        </td>

                                        <td style={{ ...tableCellStyle, textAlign: 'center', backgroundColor: "#f0f0f0" }}>
                                            <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                <button
                                                    style={{
                                                        backgroundColor: '#b15cd6',
                                                        color: 'white',
                                                        borderRadius: '4px',
                                                        padding: '4px 6px',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        fontSize: '0.75rem',
                                                        minWidth: '45px'
                                                    }}
                                                    onClick={() => handleAddSubCategory(item.dishId)}
                                                >
                                                    Add
                                                </button>
                                                <button
                                                    style={{ ...addButtonStyle, backgroundColor: "#f9f9f9", padding: '4px 6px', fontSize: '0.8rem' }}
                                                    onClick={() => {
                                                        if (item.isAdded) {
                                                            handleEdit(item.SNo);
                                                        } else {
                                                            handleSave(item, index);
                                                        }
                                                    }}
                                                >
                                                    {item.isAdded ? <FaEdit /> : <FaSave />}
                                                </button>
                                                <button
                                                    style={{ ...deleteButtonStyle, backgroundColor: "#f9f9f9", padding: '4px 6px', fontSize: '0.8rem' }}
                                                    onClick={() => handleDeleteRow(index, item.SNo, item.parentId)}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* Subcategories */}
                                    {expandedCategories[item.dishId] && item.subcategories && item.subcategories.length > 0 && (
                                        <React.Fragment>
                                            {item.subcategories.map((sub, subIndex) => (
                                                <tr
                                                    key={`sub-${sub.dishId}`}
                                                    style={{
                                                        backgroundColor: '#f9f9f9',
                                                    }}
                                                >
                                                    {/* Subcategory S.No Cell - Sticky left */}
                                                    <td style={{
                                                        ...tableCellStyle,
                                                        textAlign: 'center',
                                                        fontSize: '0.9rem',
                                                        padding: '8px 4px',
                                                        position: 'sticky',
                                                        left: 0,
                                                        zIndex: 10,
                                                        backgroundColor: '#f9f9f9'
                                                    }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '8px',
                                                            flexWrap: 'nowrap',
                                                        }}>
                                                            {bulkMode && (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedItems[sub.dishId] || false}
                                                                    onChange={(e) => {
                                                                        const checked = e.target.checked;
                                                                        setSelectedItems(prevSelected => ({
                                                                            ...prevSelected,
                                                                            [sub.dishId]: checked
                                                                        }));
                                                                    }}
                                                                    style={{
                                                                        margin: 0,
                                                                        cursor: 'pointer',
                                                                        width: '16px',
                                                                        height: '16px'
                                                                    }}
                                                                />
                                                            )}
                                                            <span>{index + 1}.{subIndex + 1}</span>
                                                        </div>
                                                    </td>

                                                    {/* Subcategory Name Cell - Sticky left */}
                                                    <td style={{
                                                        ...tableCellStyle,
                                                        fontSize: '0.9rem',
                                                        paddingLeft: '40px',
                                                        position: 'sticky',
                                                        left: '100px',
                                                        zIndex: 10,
                                                        backgroundColor: '#f9f9f9'
                                                    }}>
                                                        <span style={{ marginRight: '8px', opacity: 0.5 }}>↳</span> {sub.subName}
                                                    </td>

                                                    {/* Rest of cells - NOT sticky */}
                                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                                        {sub.tag === "Veg" ? (
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
                                                                <div style={{ width: '10px', height: '10px', border: '1px solid green', borderRadius: '1px' }}>
                                                                    <div style={{ width: '5px', height: '5px', backgroundColor: 'green', borderRadius: '50%', margin: '2px auto' }}></div>
                                                                </div>
                                                                <span style={{ color: 'green', fontSize: '0.7rem' }}>Veg</span>
                                                            </div>
                                                        ) : sub.tag === "Non_Veg" ? (
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px' }}>
                                                                <div style={{ width: '10px', height: '10px', border: '1px solid red', borderRadius: '1px' }}>
                                                                    <div style={{ width: '5px', height: '5px', backgroundColor: 'red', borderRadius: '50%', margin: '2px auto' }}></div>
                                                                </div>
                                                                <span style={{ color: 'red', fontSize: '0.7rem' }}>Non-Veg</span>
                                                            </div>
                                                        ) : (sub.tag)}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, fontSize: '0.85rem', padding: '4px 6px' }}>
                                                        {sub.description}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                                        <img
                                                            src={sub.image}
                                                            alt="Sub Dish"
                                                            style={{ width: '36px', height: '28px', borderRadius: '8px' }}
                                                        />
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>₹{sub.price}</td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>
                                                        {sub.deliveryPrice ? `₹${sub.deliveryPrice}` : '-'}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>{sub.gst || 0}</td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>{sub.packingCharges || 0}</td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', fontWeight: '500' }}>
                                                        {sub.stockQuantity !== undefined ? sub.stockQuantity : 0}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', color: '#dc3545' }}>
                                                        {sub.consumedQuantity !== undefined ? sub.consumedQuantity : 0}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem', color: '#28a745', fontWeight: '500' }}>
                                                        {sub.balanceQuantity !== undefined ? sub.balanceQuantity : 0}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center', fontSize: '0.9rem' }}>
                                                        {(() => {
                                                            if (!sub.chefType) return '-';
                                                            let displayType = sub.chefType;
                                                            if (displayType.startsWith('Chef_')) {
                                                                displayType = displayType.substring(5);
                                                            }
                                                            return displayType;
                                                        })()}
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2px 0' }}>
                                                            <label className="switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={sub.menuStatus === "Enable"}
                                                                    onChange={() => handleToggleStatus(index, subIndex, sub.dishId, sub.menuStatus || "Enable")}
                                                                    disabled={item.menuStatus === "Disable"}
                                                                />
                                                                <span className={`slider round ${item.menuStatus === "Disable" ? 'disabled' : ''}`}></span>
                                                            </label>
                                                            <span style={{
                                                                marginTop: '3px',
                                                                fontSize: '0.8rem',
                                                                color: item.menuStatus === "Disable" ? '#999' : 'black',
                                                                fontWeight: '500'
                                                            }}>
                                                                {item.menuStatus === "Disable" ? 'Hide' : (sub.menuStatus === "Enable" ? 'Show' : 'Hide')}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                                                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                                            <button
                                                                style={{ ...addButtonStyle, backgroundColor: "#f0f0f0", padding: '4px 6px', fontSize: '0.9rem' }}
                                                                onClick={() => handleEditSubcategory(sub.dishId, subIndex, index)}
                                                            >
                                                                <FaEdit />
                                                            </button>
                                                            <button
                                                                style={{ ...deleteButtonStyle, backgroundColor: "#f0f0f0", padding: '4px 6px', fontSize: '0.9rem' }}
                                                                onClick={() => handleDeleteSubcategory(sub.dishId, subIndex, index)}
                                                            >
                                                                <FaTrash />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* Add this CSS to ensure sticky positioning works */}
            <style>
                {`
    .standard-table-data {
        position: relative;
        overflow: auto !important;
    }
    
    .standard-table-data table {
        border-collapse: collapse;
    }
    
    /* Ensure sticky cells maintain their background when scrolling */
    .standard-table-data th[style*="position: sticky"],
    .standard-table-data td[style*="position: sticky"] {
        background-color: inherit;
    }
    
    /* Fix for iOS */
    @supports (-webkit-touch-callout: none) {
        .standard-table-data th[style*="position: sticky"],
        .standard-table-data td[style*="position: sticky"] {
            -webkit-transform: translateZ(0);
        }
    }
    `}
            </style>


            {showEditModal && editItem && (
                <div style={modalStyle}>
                    <div style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        border: "0px solid red",
                        boxShadow: "rgba(0, 0, 0, 0.3) 0px 2px 10px",
                        backgroundColor: "white",
                        width: "400px",
                        padding: "30px",
                        borderRadius: "10px",
                    }}>
                        <div style={closeButtonStyle} onClick={() => setShowEditModal(false)}>
                            <span style={closeIconStyle}>×</span>
                        </div>
                        <br></br>

                        {/* Category Name */}
                        <div style={inputContainerStyle}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '5px' }}>
                                Category Name
                            </label>
                            <input
                                id="dishName"
                                type="text"
                                value={editItem.dishName}
                                onChange={(e) => setEditItem({ ...editItem, dishName: e.target.value })}
                                style={inputFieldStyle}
                            />
                        </div>

                        {/* Quantity Field for Category */}
                        <div style={inputContainerStyle}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '5px' }}>
                                Quantity

                            </label>
                            <input
                                type="number"
                                min="0"
                                value={categoryQuantities[editItem.dishId] || ''}
                                onChange={(e) => {
                                    const value = e.target.value === '' ? '' : parseInt(e.target.value);
                                    setCategoryQuantities(prev => ({
                                        ...prev,
                                        [editItem.dishId]: value
                                    }));
                                }}
                                placeholder="Enter quantity"
                                style={{
                                    ...inputFieldStyle,
                                    borderColor: categoryQuantities[editItem.dishId] ? '#b15cd6' : '#ccc'
                                }}
                                onWheel={(e) => e.target.blur()}
                            />

                        </div>

                        {/* Image Upload Section */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' }}>
                            <div style={imagePreviewStyle}>
                                <label htmlFor="dishImage" style={{ cursor: 'pointer' }}>
                                    <img
                                        src={editItem.image || 'https://via.placeholder.com/100x100'}
                                        alt="Preview"
                                        style={imageStyle}
                                    />
                                </label>
                                <input
                                    id="dishImage"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleEditImageChange(e)}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </div>

                        {/* Single Update Button */}
                        <div style={buttonContainerStyle}>
                            <button
                                onClick={async () => {
                                    // First update the category
                                    await submitEdit();

                                    // Then if quantity is set, apply to subcategories
                                    if (categoryQuantities[editItem.dishId] !== undefined &&
                                        categoryQuantities[editItem.dishId] !== '') {
                                        await handleApplyQuantityToSubcategories(
                                            editItem.dishId,
                                            categoryQuantities[editItem.dishId]
                                        );
                                    }

                                    setShowEditModal(false);
                                }}
                                style={buttonStyle}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showSubcategoryPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1001,
                    padding: '20px',
                    boxSizing: 'border-box',
                    backdropFilter: 'blur(3px)'
                }}>
                    <div style={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        padding: '30px 25px',
                        borderRadius: '12px',
                        width: '450px',
                        maxWidth: '95%',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                        scrollbarWidth: "none",
                    }}>
                        {/* Close Button */}
                        <div
                            onClick={() => setShowSubcategoryPopup(false)}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                fontSize: '22px',
                                fontWeight: '700',
                                color: '#999',
                                cursor: 'pointer',
                                userSelect: 'none',
                                transition: 'color 0.3s',
                            }}
                            onMouseEnter={e => (e.currentTarget.style.color = '#b15cd6')}
                            onMouseLeave={e => (e.currentTarget.style.color = '#999')}
                        >
                            &times;
                        </div>

                        {/* Title with Parent Category */}
                        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                            <h3 style={{
                                margin: 0,
                                fontWeight: '600',
                                fontSize: '1.3rem',
                                color: '#333'
                            }}>
                                Add New Dish
                            </h3>
                            {/* <p style={{ 
                    margin: '5px 0 0', 
                    color: '#666', 
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px'
                }}>
                    Under category: 
                    <span style={{ 
                        color: '#b15cd6', 
                        fontWeight: '600',
                        backgroundColor: '#f3e5f5',
                        padding: '2px 8px',
                        borderRadius: '4px'
                    }}>
                        {parentDishDetails?.dishName || 'Unknown Category'}
                    </span>
                </p> */}
                        </div>

                        {/* Dish Name Input with Auto-suggestions */}
                        <div style={{ position: 'relative' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                fontWeight: '500',
                                color: '#333',
                                fontSize: '14px'
                            }}>
                                Dish Name <span style={{ color: '#e74c3c' }}>*</span>
                            </label>

                            <input
                                type="text"
                                value={subDishName}
                                onChange={handleDishInputChange}
                                onFocus={() => {
                                    if (subDishName.trim().length > 0 && dishSuggestions.length > 0) {
                                        setShowDishSuggestions(true);
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowDishSuggestions(false), 200);
                                }}
                                placeholder="Enter dish name"
                                style={{
                                    width: '100%',
                                    padding: '12px 15px',
                                    fontSize: '1rem',
                                    borderRadius: '8px',
                                    border: '1.8px solid #ccc',
                                    outline: 'none',
                                    transition: 'all 0.3s',
                                    boxSizing: 'border-box'
                                }}
                            // onFocus={e => e.target.style.borderColor = '#b15cd6'}
                            // onBlur={e => e.target.style.borderColor = '#ccc'}
                            />


                            {/* Dish Suggestions Dropdown */}
                            {showDishSuggestions && (
                                <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: 'white',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                    zIndex: 1000,
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    marginTop: '5px'
                                }}>


                                    {dishSuggestions.map((dish, index) => (
                                        <div
                                            key={index}
                                            onClick={() => selectDishSuggestion(dish.name)}
                                            style={{
                                                padding: '12px 15px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f5f5f5',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                transition: 'all 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                        >
                                            <img
                                                src={dish.image}
                                                alt={dish.name}
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '6px',
                                                    objectFit: 'cover',
                                                    border: '1px solid #eee'
                                                }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = 'https://via.placeholder.com/40x40';
                                                }}
                                            />
                                            <div style={{ flex: 1 }}>
                                                <div style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#333',
                                                    marginBottom: '3px'
                                                }}>
                                                    {dish.name}
                                                </div>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                }}>
                                                    <span style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '3px'
                                                    }}>
                                                        <span style={{
                                                            width: '8px',
                                                            height: '8px',
                                                            borderRadius: '50%',
                                                            backgroundColor: dish.category ? '#4CAF50' : '#999'
                                                        }}></span>
                                                        {dish.category?.catageoryName || 'No Category'}
                                                    </span>

                                                </div>
                                            </div>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#b15cd6',
                                                backgroundColor: '#f3e5f5',
                                                padding: '4px 10px',
                                                borderRadius: '4px',
                                                fontWeight: '500'
                                            }}>
                                                Select
                                            </div>
                                        </div>
                                    ))}

                                    {dishSuggestions.length === 0 && (
                                        <div style={{
                                            padding: '20px',
                                            textAlign: 'center',
                                            color: '#666',
                                            fontSize: '14px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div style={{ fontSize: '40px', opacity: 0.5 }}>🍽️</div>
                                            <div>No matching dishes found</div>
                                            <div style={{ fontSize: '12px', color: '#999' }}>
                                                Type to create a new dish
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Form Fields Grid */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '15px',
                            marginTop: '10px'
                        }}>
                            {/* Price */}
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Price (₹) <span style={{ color: '#e74c3c' }}>*</span>
                                </label>
                                <input
                                    type="number"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                    placeholder="0.00"
                                    style={{
                                        width: '100%',
                                        padding: '12px 15px',
                                        fontSize: '1rem',
                                        borderRadius: '8px',
                                        border: '1.8px solid #ccc',
                                        outline: 'none',
                                        transition: 'border-color 0.3s',
                                        boxSizing: 'border-box'
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                    onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                    onBlur={e => e.target.style.borderColor = '#ccc'}
                                />
                            </div>

                            {/* GST */}
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    GST (%)
                                </label>
                                <input
                                    type="number"
                                    value={gst}
                                    onChange={(e) => setGst(e.target.value)}
                                    placeholder="0"
                                    style={{
                                        width: '100%',
                                        padding: '12px 15px',
                                        fontSize: '1rem',
                                        borderRadius: '8px',
                                        border: '1.8px solid #ccc',
                                        outline: 'none',
                                        transition: 'border-color 0.3s',
                                        boxSizing: 'border-box'
                                    }}
                                    onWheel={(e) => e.target.blur()}
                                    onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                    onBlur={e => e.target.style.borderColor = '#ccc'}
                                />
                            </div>
                        </div>

                        {/* Single Column Fields */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            {/* Packing Charges */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',  // Creates 2 equal columns
                                gap: '15px'                       // Space between the two fields
                            }}>
                                {/* Packing Charges */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Packing Charges (₹)
                                    </label>
                                    <input
                                        type="number"
                                        value={packingCharges}
                                        onChange={(e) => setPackingCharges(e.target.value)}
                                        placeholder="0.00"
                                        style={{
                                            width: '100%',
                                            padding: '12px 15px',
                                            fontSize: '1rem',
                                            borderRadius: '8px',
                                            border: '1.8px solid #ccc',
                                            outline: 'none',
                                            transition: 'border-color 0.3s',
                                            boxSizing: 'border-box'
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                        onBlur={e => e.target.style.borderColor = '#ccc'}
                                    />
                                </div>

                                {/* Stock Quantity */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Stock Quantity <span style={{ color: '#e74c3c' }}>*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={stockQuantity}
                                        onChange={(e) => setStockQuantity(e.target.value)}
                                        placeholder="Enter available quantity"
                                        style={{
                                            width: '100%',
                                            padding: '12px 15px',
                                            fontSize: '1rem',
                                            borderRadius: '8px',
                                            border: '1.8px solid #ccc',
                                            outline: 'none',
                                            transition: 'border-color 0.3s',
                                            boxSizing: 'border-box'
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                        onBlur={e => e.target.style.borderColor = '#ccc'}
                                    />
                                </div>
                            </div>

                            {/* Dish Type and Chef Type in Row */}
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: '15px'
                            }}>
                                {/* Dish Type */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Dish Type
                                    </label>
                                    <select
                                        value={tag}
                                        onChange={(e) => setTag(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '12px 15px',
                                            fontSize: '1rem',
                                            borderRadius: '8px',
                                            border: '1.8px solid #ccc',
                                            outline: 'none',
                                            transition: 'border-color 0.3s',
                                            backgroundColor: '#fff',
                                            cursor: 'pointer',
                                            appearance: 'none',
                                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E")`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'right 15px center',
                                            backgroundSize: '12px'
                                        }}
                                        onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                        onBlur={e => e.target.style.borderColor = '#ccc'}
                                    >
                                        <option value="Veg"> Veg</option>
                                        <option value="Non_Veg"> Non-Veg</option>
                                    </select>
                                </div>

                                {/* Chef Type */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontWeight: '500',
                                        color: '#333',
                                        fontSize: '14px'
                                    }}>
                                        Chef Type
                                    </label>
                                    <select
                                        value={chefType}
                                        onChange={(e) => setChefType(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '12px 15px',
                                            fontSize: '1rem',
                                            borderRadius: '8px',
                                            border: '1.8px solid #ccc',
                                            outline: 'none',
                                            transition: 'border-color 0.3s',
                                            backgroundColor: '#fff',
                                            cursor: 'pointer',
                                            appearance: 'none',
                                            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23666' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E")`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'right 15px center',
                                            backgroundSize: '12px'
                                        }}
                                        onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                        onBlur={e => e.target.style.borderColor = '#ccc'}
                                    >
                                        <option value="Chef_All"> All Chefs</option>
                                        <option value="Chef_North"> North Indian</option>
                                        <option value="Chef_South"> South Indian</option>
                                        <option value="Chef_Chinese"> Chinese</option>
                                        <option value="Chef_Continental"> Continental</option>
                                        <option value="Tea_stall">Tea Stall</option>
                                        <option value="Snacks"> Snacks</option>
                                        <option value="Bakery"> Bakery</option>
                                    </select>
                                </div>
                            </div>

                            {/* Description */}
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Description
                                </label>
                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter dish description..."
                                    rows="3"
                                    style={{
                                        width: '100%',
                                        padding: '12px 15px',
                                        fontSize: '1rem',
                                        borderRadius: '8px',
                                        border: '1.8px solid #ccc',
                                        outline: 'none',
                                        transition: 'border-color 0.3s',
                                        boxSizing: 'border-box',
                                        resize: 'vertical',
                                        fontFamily: 'inherit',
                                        minHeight: '80px'
                                    }}
                                    onFocus={e => e.target.style.borderColor = '#b15cd6'}
                                    onBlur={e => e.target.style.borderColor = '#ccc'}
                                />
                            </div>
                        </div>

                        {/* Image Upload Section */}
                        <div style={{ marginTop: '10px' }}>
                            {/* <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '15px',
                                backgroundColor: '#f8f9fa',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                borderLeft: '4px solid #b15cd6'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        backgroundColor: '#e8f5e9',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <span style={{ fontSize: '20px', color: '#b15cd6' }}>📸</span>
                                    </div>
                                    <div>
                                        <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
                                            Dish Image
                                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                                        </h3>
                                        <p style={{ margin: '3px 0 0', fontSize: '12px', color: '#7f8c8d' }}>
                                            JPG, PNG • Max 5MB • Landscape recommended
                                        </p>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => {
                                        setCurrentPreset('PRODUCT_IMAGE');
                                        setShowGuidelinesModal(true);
                                    }}
                                    style={{
                                        background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                        border: 'none',
                                        color: 'white',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
                                    </svg>
                                    Guidelines
                                </button>
                            </div> */}

                            {/* Upload Area */}
                            <div
                                style={{
                                    border: image ? "2px solid #e0e0e0" : '2px dashed #ccc',
                                    borderRadius: '12px',
                                    backgroundColor: '#fafafa',
                                    padding: image ? '0' : '30px 20px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s',
                                    minHeight: '180px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                onClick={() => document.getElementById('subcategoryFileInput')?.click()}
                            >
                                {image ? (
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <img
                                            src={image}
                                            alt="Preview"
                                            style={{
                                                width: '100%',
                                                maxHeight: '220px',
                                                objectFit: 'contain',
                                                borderRadius: '10px',
                                                display: 'block'
                                            }}
                                        />
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setImage(null);
                                                setImageFile(null);
                                            }}
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '10px',
                                                backgroundColor: 'rgba(255, 107, 107, 0.9)',
                                                color: 'white',
                                                border: 'none',
                                                width: '30px',
                                                height: '30px',
                                                borderRadius: '50%',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '16px',
                                                fontWeight: 'bold',
                                                transition: 'all 0.2s'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#ff5252'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255, 107, 107, 0.9)'}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <div style={{
                                            width: '60px',
                                            height: '60px',
                                            backgroundColor: '#e8f5e9',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '15px',
                                            border: '2px solid #c8e6c9'
                                        }}>
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div style={{ marginBottom: '15px' }}>
                                            <p style={{
                                                fontSize: '15px',
                                                fontWeight: '600',
                                                color: '#2c3e50',
                                                margin: '0 0 8px'
                                            }}>
                                                Drop dish image here or click to upload
                                            </p>
                                            <p style={{
                                                fontSize: '13px',
                                                color: '#7f8c8d',
                                                margin: 0
                                            }}>
                                                Supports JPG, PNG • Max 5MB
                                            </p>
                                        </div>
                                        <button
                                            style={{
                                                background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                                border: 'none',
                                                color: 'white',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                padding: '10px 24px',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginTop: '10px',
                                                transition: 'all 0.2s'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                <polyline points="17 8 12 3 7 8" />
                                                <line x1="12" y1="3" x2="12" y2="15" />
                                            </svg>
                                            Select Image
                                        </button>
                                    </>
                                )}
                            </div>

                            {/* Hidden File Input */}
                            <input
                                id="subcategoryFileInput"
                                type="file"
                                accept="image/*,.jpg,.jpeg,.png,.webp"
                                style={{ display: "none" }}
                                onChange={handleSubImageChange}
                            />

                            {/* File Info */}
                            {imageFile && (
                                <div style={{
                                    marginTop: '15px',
                                    padding: '12px 15px',
                                    backgroundColor: '#f0f8ff',
                                    borderRadius: '8px',
                                    border: '1px solid #d1ecff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={image}
                                                alt="Thumbnail"
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px' }}>
                                                {imageFile.name.length > 25
                                                    ? imageFile.name.substring(0, 25) + '...'
                                                    : imageFile.name}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                                {(imageFile.size / 1024 / 1024).toFixed(2)} MB
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        backgroundColor: '#e8f5e9',
                                        color: '#2e7d32',
                                        padding: '4px 10px',
                                        borderRadius: '10px',
                                        fontWeight: '500'
                                    }}>
                                        Ready to upload
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Action Buttons */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '15px',
                            marginTop: '25px',
                            paddingTop: '20px',
                            borderTop: '1px solid #eee'
                        }}>
                            <button
                                onClick={() => setShowSubcategoryPopup(false)}
                                style={{
                                    backgroundColor: '#f8f9fa',
                                    color: '#666',
                                    border: '1px solid #ddd',
                                    padding: '12px 25px',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    minWidth: '100px'
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.backgroundColor = '#e9ecef';
                                    e.currentTarget.style.borderColor = '#ccc';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                    e.currentTarget.style.borderColor = '#ddd';
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubcategorySubmit}
                                style={{
                                    background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 25px',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    minWidth: '100px'
                                }}
                                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                disabled={!subDishName.trim()}
                            >
                                Save Dish
                            </button>
                        </div>
                    </div>
                </div>
            )}




            {showSubEditModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                onClick={() => setShowSubEditModal(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#888',
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        <h2 style={{ textAlign: 'center', marginBottom: '20px', whiteSpace: "nowrap" }}>Edit Subcategory</h2>

                        {/* 1. Dish Name */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Dish Name :
                            </label>
                            <input
                                type="text"
                                value={editSubItem.subName}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, subName: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}

                            />
                        </div>

                        {/* 2. Price */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Price :
                            </label>
                            <input
                                type="number"
                                value={editSubItem.price}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, price: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>



                        {/* 3. GST */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                GST :
                            </label>
                            <input
                                type="number"
                                value={editSubItem.gst}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, gst: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        {/* 4. Packing Charges */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Packing Charges :
                            </label>
                            <input
                                type="number"
                                value={editSubItem.packingCharges}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, packingCharges: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>

                        {/* 5. Dish Type */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Dish Type:
                            </label>
                            <select
                                value={editSubItem.tag || 'Veg'}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, tag: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    backgroundColor: '#fff',
                                    cursor: 'pointer',
                                }}
                            >
                                <option value="Veg">Veg</option>
                                <option value="Non_Veg">Non-Veg</option>
                            </select>
                        </div>

                        {/* 6. Chef Type */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Chef Type:
                            </label>
                            <select
                                value={editSubItem.chefType || 'Chef_All'}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, chefType: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    backgroundColor: '#fff',
                                    cursor: 'pointer',
                                }}
                            >
                                <option value="Chef_All">Chef All</option>
                                <option value="Chef_North">Chef North</option>
                                <option value="Chef_South">Chef South</option>
                                <option value="Chef_Chinese">Chef Chinese</option>
                                <option value="Chef_Continental">Chef Continental</option>
                                <option value="Tea_stall">Tea Stall</option>
                                <option value="Snacks">Snacks</option>
                                <option value="Bakery">Bakery</option>
                            </select>
                        </div>

                        {/* 7. Description */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ fontWeight: '500', display: 'block', marginBottom: '1px' }}>
                                Description :
                            </label>
                            <input
                                type="text"
                                value={editSubItem.description}
                                onChange={(e) => setEditSubItem((prev) => ({ ...prev, description: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                }}
                            />
                        </div>

                        {/* 8. Image - Modern Redesign */}
                        <div style={{ marginTop: '20px' }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '15px',
                                backgroundColor: '#f8f9fa',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                borderLeft: '4px solid #b15cd6'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div>
                                        <h3 style={{ margin: 0, fontSize: '16px', color: '#2c3e50' }}>
                                            Product Image
                                            <span style={{ color: '#e74c3c', marginLeft: '4px' }}>*</span>
                                        </h3>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => {
                                        setCurrentPreset('PRODUCT_IMAGE'); // Or use 'SUB_ITEM_IMAGE' if you have a preset
                                        setShowGuidelinesModal(true);
                                    }}
                                    style={{
                                        background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                        border: 'none',
                                        color: 'white',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        padding: '8px 16px',
                                        borderRadius: '6px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        transition: 'all 0.2s',
                                        boxShadow: '0 2px 5px rgba(0, 184, 148, 0.2)'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 15l8.5-8.5M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
                                    </svg>
                                    View Guidelines
                                </button>
                            </div>

                            {/* Modern Image Upload Card */}
                            <div style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                backgroundColor: 'white',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                            }}>
                                {/* Upload Zone */}
                                <div
                                    style={{
                                        padding: editSubItem.image ? "0px 0px" : '30px 0px',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        backgroundColor: '#fafafa',
                                        borderBottom: '1px dashed #e0e0e0',
                                        transition: 'all 0.3s',
                                    }}
                                    onClick={() => document.getElementById('subItemImageInput').click()}
                                // onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                // onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fafafa'}
                                >
                                    {editSubItem.image && !editSubItem.image.includes('via.placeholder.com') ? (
                                        <div style={{ position: 'relative' }}>
                                            <img
                                                src={editSubItem.image}
                                                alt="Preview"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover', // Changed from 'contain' to 'cover' for better preview
                                                    borderRadius: '8px',
                                                    margin: '0 auto',
                                                    border: '1px solid #e0e0e0'
                                                }}
                                            />

                                        </div>
                                    ) : (
                                        <>
                                            <div style={{
                                                width: '80px',
                                                height: '80px',
                                                backgroundColor: '#e8f5e9',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: '0 auto 20px',
                                                border: '2px solid #c8e6c9'
                                            }}>
                                                <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M17 8L12 3L7 8" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M12 3V15" stroke="#b15cd6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div style={{ marginBottom: '15px' }}>
                                                <p style={{
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#2c3e50',
                                                    margin: '0 0 8px'
                                                }}>
                                                    Drop sub item image here, or click to browse
                                                </p>
                                                <p style={{
                                                    fontSize: '13px',
                                                    color: '#7f8c8d',
                                                    margin: 0
                                                }}>
                                                    Supports JPG, PNG • Max 3MB
                                                </p>
                                            </div>
                                            <button
                                                style={{
                                                    background: 'linear-gradient(135deg, #b15cd6, #b15cd6)',
                                                    border: 'none',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    padding: '10px 24px',
                                                    borderRadius: '8px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    margin: '0 auto',
                                                    transition: 'all 0.2s'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                    <polyline points="17 8 12 3 7 8" />
                                                    <line x1="12" y1="3" x2="12" y2="15" />
                                                </svg>
                                                Select Image
                                            </button>
                                        </>
                                    )}
                                </div>


                                {editSubItem.newImageFile && (
                                    <div style={{
                                        backgroundColor: '#e8f5e9',
                                        padding: '4px 12px',
                                        borderRadius: '4px',
                                        color: '#2e7d32',
                                        fontWeight: '500'
                                    }}>
                                        ✓ {editSubItem.newImageFile.name.substring(0, 20)}{editSubItem.newImageFile.name.length > 20 ? '...' : ''}
                                    </div>
                                )}

                            </div>

                            {/* File Info after upload */}
                            {editSubItem.newImageFile && (
                                <div style={{
                                    marginTop: '15px',
                                    marginBottom: "15px",
                                    padding: '12px 15px',
                                    backgroundColor: '#f0f8ff',
                                    borderRadius: '8px',
                                    border: '1px solid #d1ecff'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                                                <span style={{ fontWeight: '600', color: '#2c3e50' }}>✓ Image Selected</span>
                                                <span style={{
                                                    fontSize: '11px',
                                                    backgroundColor: '#e8f5e9',
                                                    color: '#2e7d32',
                                                    padding: '2px 8px',
                                                    borderRadius: '10px'
                                                }}>
                                                    {(editSubItem.newImageFile.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>

                                        </div>

                                        <button
                                            style={{
                                                background: 'none',
                                                border: '1px solid #ff6b6b',
                                                color: '#ff6b6b',
                                                padding: '6px 12px',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                transition: 'all 0.2s'
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setEditSubItem({
                                                    ...editSubItem,
                                                    newImageFile: null,
                                                    image: 'https://via.placeholder.com/100x100'
                                                });
                                                setCategoryImageFile(null);
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.backgroundColor = '#ff6b6b';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#ff6b6b';
                                            }}
                                        >
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <line x1="18" y1="6" x2="6" y2="18" />
                                                <line x1="6" y1="6" x2="18" y2="18" />
                                            </svg>
                                            Remove
                                        </button>
                                    </div>

                                    {editSubItem.newImageFile.size > 3 * 1024 * 1024 && ( // 3MB check
                                        <div style={{
                                            marginTop: '10px',
                                            padding: '8px 12px',
                                            backgroundColor: '#ffebee',
                                            color: '#c62828',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="#c62828">
                                                <path d="M12 2L1 21h22L12 2zm0 4l7.53 13H4.47L12 6zm-1 4v6h2v-6h-2zm0 8v2h2v-2h-2z" />
                                            </svg>
                                            Image exceeds maximum size of 3MB
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Hidden File Input */}
                            <input
                                id="subItemImageInput"
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setEditSubItem({
                                        ...editSubItem,
                                        newImageFile: file,
                                        image: file ? URL.createObjectURL(file) : editSubItem.image
                                    });
                                }}
                                style={{ display: 'none' }}
                            />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: "10px" }}>
                            <button onClick={submitEditSubcategory} style={submitButtonStyle}>
                                Update
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* Error Modal - Replaces window.alert() */}
            {showErrorModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    padding: '20px',
                    backdropFilter: 'blur(3px)'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '25px',
                        width: '450px',
                        maxWidth: '95vw',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
                        animation: 'fadeIn 0.3s ease-out'
                    }}>
                        {/* Header with icon */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '20px',
                            paddingBottom: '15px',
                            borderBottom: '1px solid #eee'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '50%',
                                backgroundColor: errorModalDetails.type === 'error' ? '#fee' :
                                    errorModalDetails.type === 'warning' ? '#ffedd5' : '#f0fdf4',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '15px',
                                flexShrink: 0
                            }}>
                                {errorModalDetails.type === 'error' ? (
                                    <span style={{ fontSize: '24px', color: '#dc2626' }}>⚠️</span>
                                ) : errorModalDetails.type === 'warning' ? (
                                    <span style={{ fontSize: '24px', color: '#f59e0b' }}>ℹ️</span>
                                ) : (
                                    <span style={{ fontSize: '24px', color: '#10b981' }}>✅</span>
                                )}
                            </div>
                            <div>
                                <h3 style={{
                                    margin: 0,
                                    color: errorModalDetails.type === 'error' ? '#dc2626' :
                                        errorModalDetails.type === 'warning' ? '#f59e0b' : '#10b981',
                                    fontSize: '20px'
                                }}>
                                    {errorModalDetails.title}
                                </h3>
                                <p style={{ margin: '5px 0 0', color: '#666', fontSize: '14px' }}>
                                    {errorModalDetails.type === 'error' ? 'Please fix this issue' :
                                        errorModalDetails.type === 'warning' ? 'Recommendation' : 'Success'}
                                </p>
                            </div>
                        </div>

                        {/* Message */}
                        <div style={{
                            marginBottom: '25px',
                            lineHeight: '1.6',
                            color: '#333'
                        }}>
                            {errorModalDetails.message.split('\n').map((line, index) => (
                                <p key={index} style={{ margin: line.startsWith('•') ? '5px 0 5px 15px' : '10px 0' }}>
                                    {line.startsWith('•') ? '• ' + line.substring(1) : line}
                                </p>
                            ))}
                        </div>

                        {/* Quick Tips (if applicable) */}
                        {errorModalDetails.type === 'error' && (
                            <div style={{
                                backgroundColor: '#f8fafc',
                                padding: '15px',
                                borderRadius: '8px',
                                marginBottom: '25px',
                                borderLeft: '4px solid #3b82f6'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <span style={{ fontSize: '18px', marginRight: '8px' }}>💡</span>
                                    <strong style={{ color: '#1e40af' }}>Quick Tips:</strong>
                                </div>
                                <ul style={{ margin: '8px 0 0 25px', padding: 0 }}>
                                    <li>Use landscape mode on your phone</li>
                                    <li>Ensure good lighting</li>
                                    <li>Use JPG or PNG format</li>
                                    <li>Keep file size under 5MB</li>
                                </ul>
                            </div>
                        )}

                        {/* Action Buttons */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            marginTop: '20px'
                        }}>
                            {errorModalDetails.showGuidelinesButton && (
                                <button
                                    onClick={() => {
                                        setShowErrorModal(false);
                                        setCurrentPreset(errorModalDetails.presetName);
                                        setShowGuidelinesModal(true);
                                    }}
                                    style={{
                                        backgroundColor: '#3b82f6',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 20px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
                                >
                                    📋 View Guidelines
                                </button>
                            )}

                            <button
                                onClick={() => setShowErrorModal(false)}
                                style={{
                                    backgroundColor: errorModalDetails.type === 'error' ? '#dc2626' :
                                        errorModalDetails.type === 'warning' ? '#f59e0b' : '#10b981',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 25px',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                            >
                                {errorModalDetails.type === 'error' ? 'Try Again' :
                                    errorModalDetails.type === 'warning' ? 'Continue' : 'OK'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Category Search Popup */}
            {showCategorySearchPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 2000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        width: '300px',
                        maxWidth: '90vw',
                        maxHeight: '80vh',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
                    }}>
                        {/* Header */}
                        <div style={{
                            padding: '15px',
                            borderBottom: '1px solid #eee',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h3 style={{ margin: 0, fontSize: '16px' }}>Search Categories</h3>
                            <button
                                onClick={() => setShowCategorySearchPopup(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    color: '#666'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Search Input */}
                        <div style={{ padding: '15px', borderBottom: '1px solid #eee' }}>
                            <div style={{ position: 'relative' }}>
                                <FaSearch style={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#999'
                                }} />
                                <input
                                    type="text"
                                    placeholder="Type to search categories..."
                                    value={categorySearchQuery}
                                    onChange={(e) => handleCategorySearch(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 8px 8px 35px',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd',
                                        fontSize: '14px',
                                        outline: 'none'
                                    }}
                                    autoFocus
                                />
                                {categorySearchQuery && (
                                    <FaTimes
                                        onClick={() => setCategorySearchQuery('')}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#999',
                                            cursor: 'pointer'
                                        }}
                                    />
                                )}
                            </div>
                        </div>

                        {/* Categories List */}
                        <div style={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                            padding: '5px 0'
                        }}>
                            {/* Show All option */}
                            <div
                                onClick={() => handleCategorySelect(null)}
                                style={{
                                    padding: '10px 15px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f5f5f5',
                                    backgroundColor: selectedCategory === null ? '#f0f0f0' : 'white',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === null ? '#f0f0f0' : 'white'}
                            >
                                <span>Show All Categories</span>
                                <span style={{
                                    color: '#666',
                                    fontSize: '12px',
                                    backgroundColor: '#e9ecef',
                                    padding: '2px 6px',
                                    borderRadius: '10px'
                                }}>
                                    {data.length}
                                </span>
                            </div>

                            {/* Categories */}
                            {filteredCategories.map((category, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleCategorySelect(category.name)}
                                    style={{
                                        padding: '10px 15px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #f5f5f5',
                                        backgroundColor: selectedCategory === category.name ? '#f0f0f0' : 'white',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCategory === category.name ? '#f0f0f0' : 'white'}
                                >
                                    <span>{category.name}</span>
                                    <span style={{
                                        color: '#666',
                                        fontSize: '12px',
                                        backgroundColor: '#e9ecef',
                                        padding: '2px 6px',
                                        borderRadius: '10px'
                                    }}>
                                        {category.count}
                                    </span>
                                </div>
                            ))}

                            {filteredCategories.length === 0 && (
                                <div style={{
                                    padding: '20px',
                                    textAlign: 'center',
                                    color: '#666'
                                }}>
                                    No categories found
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '10px 15px',
                            borderTop: '1px solid #eee',
                            textAlign: 'right'
                        }}>
                            <button
                                onClick={() => setShowCategorySearchPopup(false)}
                                style={{
                                    padding: '6px 15px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Image Guidelines Modal */}
            {/* <ImageGuidelinesModal
                preset={currentPreset}
                isOpen={showGuidelinesModal}
                onClose={() => setShowGuidelinesModal(false)}
            /> */}
            <style>
                {`
               /* ItemUpdates-style toggle - Fixed direction */
.switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 22px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f44336; /* RED by default (Hide) */
    transition: .4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 3px;  /* LEFT position by default */
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

/* CHECKED state - Show (GREEN) */
input:checked + .slider {
    background-color: #4CAF50; /* GREEN when Show */
}

input:checked + .slider:before {
    transform: translateX(18px); /* Move to RIGHT when Show */
}

.slider.round {
    border-radius: 34px;
}

/* Disabled state - Grayed out */
.slider.disabled {
    background-color: #cccccc !important;
    cursor: not-allowed;
}

.switch input:disabled + .slider {
    background-color: #cccccc !important;
    cursor: not-allowed;
}

.switch input:disabled + .slider:before {
    background-color: #999999 !important;
}
    @media (max-width: 768px) {
    .standard-table-data {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
        width: 93vw !important;

    }

    .standard-table-data table {
        min-width: 800px; /* Force horizontal scroll */
        width: 100%;
    }

    /* Make table cells more readable on mobile */
    .standard-table-data td,
    .standard-table-data th {
        min-width: 80px;
        // white-space: nowrap;
        padding: 4px !important;
        font-size: 0.8rem !important;
    }

    /* Adjust button sizes on mobile */
    .standard-table-data button {
        padding: 3px 5px !important;
        font-size: 0.7rem !important;
        min-width: 35px !important;
    }
}
     @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`}
            </style>
            <style>{`
    .no-scrollbar { scrollbar-width: none; }
    .no-scrollbar::-webkit-scrollbar { display: none; }
    .veg-icon { color: #22c55e; }
    .nonveg-icon { color: #ef4444; }
    .tag { font-size: 12px; padding: 2px 6px; border-radius: 999px; }
    .tag-veg { background:#e8f7ec; color:#1f7a3a; border:1px solid #bfe8cb; }
    .tag-nonveg { background:#ffecec; color:#b00020; border:1px solid #ffc5c5; }
    .btn { padding:8px 12px; border:none; border-radius:6px; cursor:pointer; font-weight:600; font-size:14px; }
    .btn-primary { background:#b15dc6; color:#fff; }
    .btn-secondary { background:#6c757d; color:#fff; }
    .btn-success { background:#28a745; color:#fff; }
    
    @keyframes slideDown {
        0% {
            opacity: 0;
            transform: translateY(-10px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .slide-down {
        animation: slideDown 0.3s ease-out forwards;
    }
`}</style>
        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1001,
    marginTop: "0px",
};

const modalContentStyle = {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '20px',
    width: '350px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
    height: "500px",
    overflow: "auto",
    scrollbarWidth: "none",
};

const cancelButtonStyle = {
    backgroundColor: '#ccc',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
};

const submitButtonStyle = {
    backgroundColor: '#b15cd6',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
};

const buttonStyle = {
    backgroundColor: '#b15cd6',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    width: '100px',
    fontWeight: "bold"
};

const tableHeaderStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: '500',
    backgroundColor: '#b15cd6',
    color: 'white',
    fontSize: "1rem",
    padding: "0.5rem",

};

const tableCellStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
};

const evenRowStyle = { backgroundColor: '#fff' };
const oddRowStyle = { backgroundColor: '#fff' };

const inputStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    textAlign: 'center',
};

const addButtonStyle = {
    backgroundColor: '#b15cd6',
    color: 'green',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    // marginRight: '10px',
    fontSize: "20px"
};

const deleteButtonStyle = {
    backgroundColor: '#fff',
    color: 'red',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '5px',
    fontSize: "20px"
};


export default StandardMenu;




// background color as #00b894

